/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An arbitrary-precision Decimal type */
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
};

export type AbutmentCharacteristics = CustomAbutmentCharacteristicsModel | StandardAbutmentCharacteristicsModel;

export enum AbutmentType {
  Custom = 'CUSTOM',
  Standard = 'STANDARD',
  StandardGeneric = 'STANDARD_GENERIC'
}

export enum AbutmentTypeV2 {
  Custom = 'CUSTOM',
  Standard = 'STANDARD',
  StandardGeneric = 'STANDARD_GENERIC'
}

export type Address = {
  __typename?: 'Address';
  _count: AddressCount;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMain: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Array<Order>>;
  postcode: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  streetName: Scalars['String']['output'];
  streetNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  userGroup?: Maybe<UserGroup>;
  userGroupId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AddressCount = {
  __typename?: 'AddressCount';
  order: Scalars['Int']['output'];
};

export type AddressCreateInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedManyWithoutAddressInput>;
  postcode: Scalars['String']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  streetName: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutAddressesInput>;
};

export type AddressCreateManyUserGroupInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  streetName: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateManyUserGroupInputEnvelope = {
  data: Array<AddressCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCreateManyUserInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  streetName: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateManyUserInputEnvelope = {
  data: Array<AddressCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<AddressCreateManyUserGroupInputEnvelope>;
};

export type AddressCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutUserInput>>;
  createMany?: InputMaybe<AddressCreateManyUserInputEnvelope>;
};

export type AddressCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<AddressCreateWithoutOrderInput>;
};

export type AddressCreateOrConnectWithoutOrderInput = {
  create: AddressCreateWithoutOrderInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutUserGroupInput = {
  create: AddressCreateWithoutUserGroupInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutUserInput = {
  create: AddressCreateWithoutUserInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutOrderInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  streetName: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutAddressesInput>;
};

export type AddressCreateWithoutUserGroupInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedManyWithoutAddressInput>;
  postcode: Scalars['String']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  streetName: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutAddressesInput>;
};

export type AddressCreateWithoutUserInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedManyWithoutAddressInput>;
  postcode: Scalars['String']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  streetName: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutAddressesInput>;
};

export type AddressListRelationFilter = {
  every?: InputMaybe<AddressWhereInput>;
  none?: InputMaybe<AddressWhereInput>;
  some?: InputMaybe<AddressWhereInput>;
};

export type AddressNullableScalarRelationFilter = {
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
};

export type AddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  details?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isMain?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByRelationAggregateInput>;
  postcode?: InputMaybe<SortOrder>;
  recipient?: InputMaybe<SortOrderInput>;
  streetName?: InputMaybe<SortOrder>;
  streetNumber?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userGroup?: InputMaybe<UserGroupOrderByWithRelationInput>;
  userGroupId?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum AddressScalarFieldEnum {
  City = 'city',
  Country = 'country',
  CreatedAt = 'createdAt',
  Details = 'details',
  Id = 'id',
  IsMain = 'isMain',
  Name = 'name',
  Postcode = 'postcode',
  Recipient = 'recipient',
  StreetName = 'streetName',
  StreetNumber = 'streetNumber',
  UpdatedAt = 'updatedAt',
  UserGroupId = 'userGroupId',
  UserId = 'userId'
}

export type AddressScalarWhereInput = {
  AND?: InputMaybe<Array<AddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereInput>>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isMain?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  postcode?: InputMaybe<StringFilter>;
  recipient?: InputMaybe<StringNullableFilter>;
  streetName?: InputMaybe<StringFilter>;
  streetNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateManyWithoutAddressNestedInput>;
  postcode?: InputMaybe<StringFieldUpdateOperationsInput>;
  recipient?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetName?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutAddressesNestedInput>;
};

export type AddressUpdateManyMutationInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  postcode?: InputMaybe<StringFieldUpdateOperationsInput>;
  recipient?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetName?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateManyWithWhereWithoutUserGroupInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithWhereWithoutUserInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<AddressCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type AddressUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutUserInput>>;
  createMany?: InputMaybe<AddressCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AddressUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<AddressCreateWithoutOrderInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<AddressUpsertWithoutOrderInput>;
};

export type AddressUpdateToOneWithWhereWithoutOrderInput = {
  data: AddressUpdateWithoutOrderInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: AddressUpdateWithoutUserGroupInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithWhereUniqueWithoutUserInput = {
  data: AddressUpdateWithoutUserInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithoutOrderInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  postcode?: InputMaybe<StringFieldUpdateOperationsInput>;
  recipient?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetName?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutAddressesNestedInput>;
};

export type AddressUpdateWithoutUserGroupInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateManyWithoutAddressNestedInput>;
  postcode?: InputMaybe<StringFieldUpdateOperationsInput>;
  recipient?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetName?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutAddressesNestedInput>;
};

export type AddressUpdateWithoutUserInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateManyWithoutAddressNestedInput>;
  postcode?: InputMaybe<StringFieldUpdateOperationsInput>;
  recipient?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetName?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutAddressesNestedInput>;
};

export type AddressUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: AddressCreateWithoutUserGroupInput;
  update: AddressUpdateWithoutUserGroupInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpsertWithWhereUniqueWithoutUserInput = {
  create: AddressCreateWithoutUserInput;
  update: AddressUpdateWithoutUserInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpsertWithoutOrderInput = {
  create: AddressCreateWithoutOrderInput;
  update: AddressUpdateWithoutOrderInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  isMain?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderListRelationFilter>;
  postcode?: InputMaybe<StringFilter>;
  recipient?: InputMaybe<StringNullableFilter>;
  streetName?: InputMaybe<StringFilter>;
  streetNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type AddressWhereUniqueInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMain?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderListRelationFilter>;
  postcode?: InputMaybe<StringFilter>;
  recipient?: InputMaybe<StringNullableFilter>;
  streetName?: InputMaybe<StringFilter>;
  streetNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type AnatomyItem = {
  __typename?: 'AnatomyItem';
  _count: AnatomyItemCount;
  bridgeType?: Maybe<BridgeType>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  inlayCoreHasClavette?: Maybe<Scalars['Boolean']['output']>;
  inlayCoreMaterial?: Maybe<ItemMaterial>;
  inlayCoreMaterialId?: Maybe<Scalars['String']['output']>;
  inlayCoreScanPost?: Maybe<Scalars['String']['output']>;
  isInlayCoreOnly: Scalars['Boolean']['output'];
  isRichmondCrown: Scalars['Boolean']['output'];
  itemBilling?: Maybe<Array<ItemBilling>>;
  itemMaterial?: Maybe<ItemMaterial>;
  itemMaterialId?: Maybe<Scalars['String']['output']>;
  itemShade?: Maybe<ItemShade>;
  itemShadeId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<ItemType>;
  multiShadeInfo?: Maybe<Array<MultiShadeInfo>>;
  product: Product;
  productId: Scalars['String']['output'];
  teeth?: Maybe<Scalars['JSON']['output']>;
  teethshadeType: TeethShadeType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type AnatomyItemCount = {
  __typename?: 'AnatomyItemCount';
  itemBilling: Scalars['Int']['output'];
  multiShadeInfo: Scalars['Int']['output'];
};

export type AnatomyItemCreateInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInlayCoreInput>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutAnatomyItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutAnatomyItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutAnatomyItemInput>;
  product: ProductCreateNestedOneWithoutAnatomyItemInput;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateManyInlayCoreMaterialInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemShadeId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  productId: Scalars['String']['input'];
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateManyInlayCoreMaterialInputEnvelope = {
  data: Array<AnatomyItemCreateManyInlayCoreMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnatomyItemCreateManyItemMaterialInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterialId?: InputMaybe<Scalars['String']['input']>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemShadeId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  productId: Scalars['String']['input'];
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateManyItemMaterialInputEnvelope = {
  data: Array<AnatomyItemCreateManyItemMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnatomyItemCreateManyItemShadeInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterialId?: InputMaybe<Scalars['String']['input']>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  productId: Scalars['String']['input'];
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateManyItemShadeInputEnvelope = {
  data: Array<AnatomyItemCreateManyItemShadeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnatomyItemCreateManyProductInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterialId?: InputMaybe<Scalars['String']['input']>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemShadeId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateManyProductInputEnvelope = {
  data: Array<AnatomyItemCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutInlayCoreMaterialInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutInlayCoreMaterialInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyInlayCoreMaterialInputEnvelope>;
};

export type AnatomyItemCreateNestedManyWithoutItemMaterialInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyItemMaterialInputEnvelope>;
};

export type AnatomyItemCreateNestedManyWithoutItemShadeInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutItemShadeInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutItemShadeInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyItemShadeInputEnvelope>;
};

export type AnatomyItemCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyProductInputEnvelope>;
};

export type AnatomyItemCreateNestedOneWithoutItemBillingInput = {
  connect?: InputMaybe<AnatomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnatomyItemCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<AnatomyItemCreateWithoutItemBillingInput>;
};

export type AnatomyItemCreateNestedOneWithoutMultiShadeInfoInput = {
  connect?: InputMaybe<AnatomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnatomyItemCreateOrConnectWithoutMultiShadeInfoInput>;
  create?: InputMaybe<AnatomyItemCreateWithoutMultiShadeInfoInput>;
};

export type AnatomyItemCreateOrConnectWithoutInlayCoreMaterialInput = {
  create: AnatomyItemCreateWithoutInlayCoreMaterialInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemCreateOrConnectWithoutItemBillingInput = {
  create: AnatomyItemCreateWithoutItemBillingInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemCreateOrConnectWithoutItemMaterialInput = {
  create: AnatomyItemCreateWithoutItemMaterialInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemCreateOrConnectWithoutItemShadeInput = {
  create: AnatomyItemCreateWithoutItemShadeInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemCreateOrConnectWithoutMultiShadeInfoInput = {
  create: AnatomyItemCreateWithoutMultiShadeInfoInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemCreateOrConnectWithoutProductInput = {
  create: AnatomyItemCreateWithoutProductInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemCreateWithoutInlayCoreMaterialInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutAnatomyItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutAnatomyItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutAnatomyItemInput>;
  product: ProductCreateNestedOneWithoutAnatomyItemInput;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateWithoutItemBillingInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInlayCoreInput>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutAnatomyItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutAnatomyItemInput>;
  product: ProductCreateNestedOneWithoutAnatomyItemInput;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateWithoutItemMaterialInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInlayCoreInput>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutAnatomyItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutAnatomyItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutAnatomyItemInput>;
  product: ProductCreateNestedOneWithoutAnatomyItemInput;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateWithoutItemShadeInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInlayCoreInput>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutAnatomyItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutAnatomyItemInput>;
  product: ProductCreateNestedOneWithoutAnatomyItemInput;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateWithoutMultiShadeInfoInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInlayCoreInput>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutAnatomyItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutAnatomyItemInput>;
  itemType?: InputMaybe<ItemType>;
  product: ProductCreateNestedOneWithoutAnatomyItemInput;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemCreateWithoutProductInput = {
  bridgeType?: InputMaybe<BridgeType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<Scalars['Boolean']['input']>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInlayCoreInput>;
  inlayCoreScanPost?: InputMaybe<Scalars['String']['input']>;
  isInlayCoreOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isRichmondCrown?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutAnatomyItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutAnatomyItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutAnatomyItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutAnatomyItemInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type AnatomyItemListRelationFilter = {
  every?: InputMaybe<AnatomyItemWhereInput>;
  none?: InputMaybe<AnatomyItemWhereInput>;
  some?: InputMaybe<AnatomyItemWhereInput>;
};

export type AnatomyItemNullableScalarRelationFilter = {
  is?: InputMaybe<AnatomyItemWhereInput>;
  isNot?: InputMaybe<AnatomyItemWhereInput>;
};

export type AnatomyItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnatomyItemOrderByWithRelationInput = {
  bridgeType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inlayCoreHasClavette?: InputMaybe<SortOrderInput>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialOrderByWithRelationInput>;
  inlayCoreMaterialId?: InputMaybe<SortOrderInput>;
  inlayCoreScanPost?: InputMaybe<SortOrderInput>;
  isInlayCoreOnly?: InputMaybe<SortOrder>;
  isRichmondCrown?: InputMaybe<SortOrder>;
  itemBilling?: InputMaybe<ItemBillingOrderByRelationAggregateInput>;
  itemMaterial?: InputMaybe<ItemMaterialOrderByWithRelationInput>;
  itemMaterialId?: InputMaybe<SortOrderInput>;
  itemShade?: InputMaybe<ItemShadeOrderByWithRelationInput>;
  itemShadeId?: InputMaybe<SortOrderInput>;
  itemType?: InputMaybe<SortOrderInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoOrderByRelationAggregateInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  teeth?: InputMaybe<SortOrderInput>;
  teethshadeType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AnatomyItemScalarFieldEnum {
  BridgeType = 'bridgeType',
  CreatedAt = 'createdAt',
  Id = 'id',
  InlayCoreHasClavette = 'inlayCoreHasClavette',
  InlayCoreMaterialId = 'inlayCoreMaterialId',
  InlayCoreScanPost = 'inlayCoreScanPost',
  IsInlayCoreOnly = 'isInlayCoreOnly',
  IsRichmondCrown = 'isRichmondCrown',
  ItemMaterialId = 'itemMaterialId',
  ItemShadeId = 'itemShadeId',
  ItemType = 'itemType',
  ProductId = 'productId',
  Teeth = 'teeth',
  TeethshadeType = 'teethshadeType',
  UpdatedAt = 'updatedAt'
}

export type AnatomyItemScalarWhereInput = {
  AND?: InputMaybe<Array<AnatomyItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnatomyItemScalarWhereInput>>;
  OR?: InputMaybe<Array<AnatomyItemScalarWhereInput>>;
  bridgeType?: InputMaybe<EnumBridgeTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  inlayCoreHasClavette?: InputMaybe<BoolNullableFilter>;
  inlayCoreMaterialId?: InputMaybe<StringNullableFilter>;
  inlayCoreScanPost?: InputMaybe<StringNullableFilter>;
  isInlayCoreOnly?: InputMaybe<BoolFilter>;
  isRichmondCrown?: InputMaybe<BoolFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemShadeId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  productId?: InputMaybe<UuidFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnatomyItemUpdateInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemInlayCoreNestedInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutAnatomyItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutAnatomyItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutAnatomyItemNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpdateManyMutationInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpdateManyWithWhereWithoutInlayCoreMaterialInput = {
  data: AnatomyItemUpdateManyMutationInput;
  where: AnatomyItemScalarWhereInput;
};

export type AnatomyItemUpdateManyWithWhereWithoutItemMaterialInput = {
  data: AnatomyItemUpdateManyMutationInput;
  where: AnatomyItemScalarWhereInput;
};

export type AnatomyItemUpdateManyWithWhereWithoutItemShadeInput = {
  data: AnatomyItemUpdateManyMutationInput;
  where: AnatomyItemScalarWhereInput;
};

export type AnatomyItemUpdateManyWithWhereWithoutProductInput = {
  data: AnatomyItemUpdateManyMutationInput;
  where: AnatomyItemScalarWhereInput;
};

export type AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutInlayCoreMaterialInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutInlayCoreMaterialInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyInlayCoreMaterialInputEnvelope>;
  delete?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnatomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<AnatomyItemUpdateWithWhereUniqueWithoutInlayCoreMaterialInput>>;
  updateMany?: InputMaybe<Array<AnatomyItemUpdateManyWithWhereWithoutInlayCoreMaterialInput>>;
  upsert?: InputMaybe<Array<AnatomyItemUpsertWithWhereUniqueWithoutInlayCoreMaterialInput>>;
};

export type AnatomyItemUpdateManyWithoutItemMaterialNestedInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyItemMaterialInputEnvelope>;
  delete?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnatomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<AnatomyItemUpdateWithWhereUniqueWithoutItemMaterialInput>>;
  updateMany?: InputMaybe<Array<AnatomyItemUpdateManyWithWhereWithoutItemMaterialInput>>;
  upsert?: InputMaybe<Array<AnatomyItemUpsertWithWhereUniqueWithoutItemMaterialInput>>;
};

export type AnatomyItemUpdateManyWithoutItemShadeNestedInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutItemShadeInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutItemShadeInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyItemShadeInputEnvelope>;
  delete?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnatomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<AnatomyItemUpdateWithWhereUniqueWithoutItemShadeInput>>;
  updateMany?: InputMaybe<Array<AnatomyItemUpdateManyWithWhereWithoutItemShadeInput>>;
  upsert?: InputMaybe<Array<AnatomyItemUpsertWithWhereUniqueWithoutItemShadeInput>>;
};

export type AnatomyItemUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnatomyItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<AnatomyItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<AnatomyItemCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnatomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<AnatomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<AnatomyItemUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<AnatomyItemUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<AnatomyItemUpsertWithWhereUniqueWithoutProductInput>>;
};

export type AnatomyItemUpdateOneWithoutItemBillingNestedInput = {
  connect?: InputMaybe<AnatomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnatomyItemCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<AnatomyItemCreateWithoutItemBillingInput>;
  delete?: InputMaybe<AnatomyItemWhereInput>;
  disconnect?: InputMaybe<AnatomyItemWhereInput>;
  update?: InputMaybe<AnatomyItemUpdateToOneWithWhereWithoutItemBillingInput>;
  upsert?: InputMaybe<AnatomyItemUpsertWithoutItemBillingInput>;
};

export type AnatomyItemUpdateOneWithoutMultiShadeInfoNestedInput = {
  connect?: InputMaybe<AnatomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnatomyItemCreateOrConnectWithoutMultiShadeInfoInput>;
  create?: InputMaybe<AnatomyItemCreateWithoutMultiShadeInfoInput>;
  delete?: InputMaybe<AnatomyItemWhereInput>;
  disconnect?: InputMaybe<AnatomyItemWhereInput>;
  update?: InputMaybe<AnatomyItemUpdateToOneWithWhereWithoutMultiShadeInfoInput>;
  upsert?: InputMaybe<AnatomyItemUpsertWithoutMultiShadeInfoInput>;
};

export type AnatomyItemUpdateToOneWithWhereWithoutItemBillingInput = {
  data: AnatomyItemUpdateWithoutItemBillingInput;
  where?: InputMaybe<AnatomyItemWhereInput>;
};

export type AnatomyItemUpdateToOneWithWhereWithoutMultiShadeInfoInput = {
  data: AnatomyItemUpdateWithoutMultiShadeInfoInput;
  where?: InputMaybe<AnatomyItemWhereInput>;
};

export type AnatomyItemUpdateWithWhereUniqueWithoutInlayCoreMaterialInput = {
  data: AnatomyItemUpdateWithoutInlayCoreMaterialInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpdateWithWhereUniqueWithoutItemMaterialInput = {
  data: AnatomyItemUpdateWithoutItemMaterialInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpdateWithWhereUniqueWithoutItemShadeInput = {
  data: AnatomyItemUpdateWithoutItemShadeInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpdateWithWhereUniqueWithoutProductInput = {
  data: AnatomyItemUpdateWithoutProductInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpdateWithoutInlayCoreMaterialInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutAnatomyItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutAnatomyItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutAnatomyItemNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpdateWithoutItemBillingInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemInlayCoreNestedInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutAnatomyItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutAnatomyItemNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpdateWithoutItemMaterialInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemInlayCoreNestedInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutAnatomyItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutAnatomyItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutAnatomyItemNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpdateWithoutItemShadeInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemInlayCoreNestedInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutAnatomyItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutAnatomyItemNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpdateWithoutMultiShadeInfoInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemInlayCoreNestedInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutAnatomyItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutAnatomyItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutAnatomyItemNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpdateWithoutProductInput = {
  bridgeType?: InputMaybe<NullableEnumBridgeTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  inlayCoreHasClavette?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemInlayCoreNestedInput>;
  inlayCoreScanPost?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isInlayCoreOnly?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRichmondCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutAnatomyItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutAnatomyItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutAnatomyItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnatomyItemUpsertWithWhereUniqueWithoutInlayCoreMaterialInput = {
  create: AnatomyItemCreateWithoutInlayCoreMaterialInput;
  update: AnatomyItemUpdateWithoutInlayCoreMaterialInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpsertWithWhereUniqueWithoutItemMaterialInput = {
  create: AnatomyItemCreateWithoutItemMaterialInput;
  update: AnatomyItemUpdateWithoutItemMaterialInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpsertWithWhereUniqueWithoutItemShadeInput = {
  create: AnatomyItemCreateWithoutItemShadeInput;
  update: AnatomyItemUpdateWithoutItemShadeInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpsertWithWhereUniqueWithoutProductInput = {
  create: AnatomyItemCreateWithoutProductInput;
  update: AnatomyItemUpdateWithoutProductInput;
  where: AnatomyItemWhereUniqueInput;
};

export type AnatomyItemUpsertWithoutItemBillingInput = {
  create: AnatomyItemCreateWithoutItemBillingInput;
  update: AnatomyItemUpdateWithoutItemBillingInput;
  where?: InputMaybe<AnatomyItemWhereInput>;
};

export type AnatomyItemUpsertWithoutMultiShadeInfoInput = {
  create: AnatomyItemCreateWithoutMultiShadeInfoInput;
  update: AnatomyItemUpdateWithoutMultiShadeInfoInput;
  where?: InputMaybe<AnatomyItemWhereInput>;
};

export type AnatomyItemWhereInput = {
  AND?: InputMaybe<Array<AnatomyItemWhereInput>>;
  NOT?: InputMaybe<Array<AnatomyItemWhereInput>>;
  OR?: InputMaybe<Array<AnatomyItemWhereInput>>;
  bridgeType?: InputMaybe<EnumBridgeTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  inlayCoreHasClavette?: InputMaybe<BoolNullableFilter>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  inlayCoreMaterialId?: InputMaybe<StringNullableFilter>;
  inlayCoreScanPost?: InputMaybe<StringNullableFilter>;
  isInlayCoreOnly?: InputMaybe<BoolFilter>;
  isRichmondCrown?: InputMaybe<BoolFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  itemShadeId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoListRelationFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<UuidFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AnatomyItemWhereUniqueInput = {
  AND?: InputMaybe<Array<AnatomyItemWhereInput>>;
  NOT?: InputMaybe<Array<AnatomyItemWhereInput>>;
  OR?: InputMaybe<Array<AnatomyItemWhereInput>>;
  bridgeType?: InputMaybe<EnumBridgeTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  inlayCoreHasClavette?: InputMaybe<BoolNullableFilter>;
  inlayCoreMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  inlayCoreMaterialId?: InputMaybe<StringNullableFilter>;
  inlayCoreScanPost?: InputMaybe<StringNullableFilter>;
  isInlayCoreOnly?: InputMaybe<BoolFilter>;
  isRichmondCrown?: InputMaybe<BoolFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  itemShadeId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoListRelationFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<UuidFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum AnteriorPosteriorPonticDesignV2 {
  FullRidgeLap = 'FULL_RIDGE_LAP',
  ModifiedRidgeLap = 'MODIFIED_RIDGE_LAP'
}

export enum Arch {
  Both = 'BOTH',
  Lower = 'LOWER',
  Upper = 'UPPER'
}

export type ArchScopedItemV2 = ItemV2 & {
  __typename?: 'ArchScopedItemV2';
  abutmentCharacteristics?: Maybe<AbutmentCharacteristics>;
  arch: TeethArchV2;
  id: Scalars['String']['output'];
  implantCharacteristics?: Maybe<ImplantCharacteristics>;
  implantedItemCharacteristics?: Maybe<ImplantedItemCharacteristicsModel>;
  inlayCoreCharacteristics?: Maybe<InlayCoreCharacteristicsModel>;
  materialCharacteristics?: Maybe<MaterialCharacteristicsModel>;
  product: ProductModel;
  scope: ItemScopeV2;
  type: ItemTypeV2;
  waxUpType?: Maybe<WaxUpTypeV2>;
};

export type BankHoliday = {
  __typename?: 'BankHoliday';
  beginDate: Scalars['Timestamp']['output'];
  endDate: Scalars['Timestamp']['output'];
  useCustomDelay: Scalars['Boolean']['output'];
};

export type BankHolidayOrderByWithRelationInput = {
  beginDate?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customDelay?: InputMaybe<SortOrderInput>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  useCustomDelay?: InputMaybe<SortOrder>;
};

export enum BankHolidayScalarFieldEnum {
  BeginDate = 'beginDate',
  CreatedAt = 'createdAt',
  CustomDelay = 'customDelay',
  EndDate = 'endDate',
  Id = 'id',
  Name = 'name',
  UseCustomDelay = 'useCustomDelay'
}

export type BankHolidayWhereInput = {
  AND?: InputMaybe<Array<BankHolidayWhereInput>>;
  NOT?: InputMaybe<Array<BankHolidayWhereInput>>;
  OR?: InputMaybe<Array<BankHolidayWhereInput>>;
  beginDate?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customDelay?: InputMaybe<IntNullableFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  useCustomDelay?: InputMaybe<BoolFilter>;
};

export type BankHolidayWhereUniqueInput = {
  AND?: InputMaybe<Array<BankHolidayWhereInput>>;
  NOT?: InputMaybe<Array<BankHolidayWhereInput>>;
  OR?: InputMaybe<Array<BankHolidayWhereInput>>;
  beginDate?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customDelay?: InputMaybe<IntNullableFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  useCustomDelay?: InputMaybe<BoolFilter>;
};

export type BankHolidaysModel = {
  __typename?: 'BankHolidaysModel';
  customDelay?: Maybe<Scalars['Int']['output']>;
  endDate: Scalars['Timestamp']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['Timestamp']['output'];
};

export enum BillingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export enum BridgeType {
  Cantilever = 'CANTILEVER',
  Conventional = 'CONVENTIONAL',
  Maryland = 'MARYLAND'
}

export enum CarrierType {
  Bip = 'BIP',
  Chronopost = 'CHRONOPOST',
  Ciblex = 'CIBLEX',
  FedexTnt = 'FEDEX_TNT',
  Sterne = 'STERNE',
  Ups = 'UPS'
}

export type Chat = {
  __typename?: 'Chat';
  _count: ChatCount;
  archivedForProvider: Scalars['Boolean']['output'];
  createdAt: Scalars['Timestamp']['output'];
  files?: Maybe<Array<File>>;
  id: Scalars['ID']['output'];
  isNotification: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  userGroup?: Maybe<UserGroup>;
  userGroupId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ChatCount = {
  __typename?: 'ChatCount';
  files: Scalars['Int']['output'];
};

export type ChatCreateInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutChatInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutChatInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutChatInput>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutChatInput>;
};

export type ChatCreateManyOrderInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatCreateManyOrderInputEnvelope = {
  data: Array<ChatCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatCreateManyUserGroupInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatCreateManyUserGroupInputEnvelope = {
  data: Array<ChatCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatCreateManyUserInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatCreateManyUserInputEnvelope = {
  data: Array<ChatCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ChatCreateManyOrderInputEnvelope>;
};

export type ChatCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ChatCreateManyUserGroupInputEnvelope>;
};

export type ChatCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutUserInput>>;
  createMany?: InputMaybe<ChatCreateManyUserInputEnvelope>;
};

export type ChatCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<ChatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<ChatCreateWithoutFilesInput>;
};

export type ChatCreateOrConnectWithoutFilesInput = {
  create: ChatCreateWithoutFilesInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateOrConnectWithoutOrderInput = {
  create: ChatCreateWithoutOrderInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateOrConnectWithoutUserGroupInput = {
  create: ChatCreateWithoutUserGroupInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateOrConnectWithoutUserInput = {
  create: ChatCreateWithoutUserInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateWithoutFilesInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutChatInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutChatInput>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutChatInput>;
};

export type ChatCreateWithoutOrderInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutChatInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutChatInput>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutChatInput>;
};

export type ChatCreateWithoutUserGroupInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutChatInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutChatInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutChatInput>;
};

export type ChatCreateWithoutUserInput = {
  archivedForProvider?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutChatInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedOneWithoutChatInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutChatInput>;
};

export type ChatInput = {
  onlyUnreadMessage?: InputMaybe<Scalars['Boolean']['input']>;
  searchInput: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type ChatListRelationFilter = {
  every?: InputMaybe<ChatWhereInput>;
  none?: InputMaybe<ChatWhereInput>;
  some?: InputMaybe<ChatWhereInput>;
};

export type ChatMarkAsUnread = {
  __typename?: 'ChatMarkAsUnread';
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  orderId: Scalars['String']['output'];
  userGroup?: Maybe<UserGroup>;
  userGroupId: Scalars['String']['output'];
};

export type ChatMarkAsUnreadCreateManyOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  userGroupId: Scalars['String']['input'];
};

export type ChatMarkAsUnreadCreateManyOrderInputEnvelope = {
  data: Array<ChatMarkAsUnreadCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMarkAsUnreadCreateManyUserGroupInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type ChatMarkAsUnreadCreateManyUserGroupInputEnvelope = {
  data: Array<ChatMarkAsUnreadCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatMarkAsUnreadCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMarkAsUnreadCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ChatMarkAsUnreadCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ChatMarkAsUnreadCreateManyOrderInputEnvelope>;
};

export type ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMarkAsUnreadCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ChatMarkAsUnreadCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ChatMarkAsUnreadCreateManyUserGroupInputEnvelope>;
};

export type ChatMarkAsUnreadCreateOrConnectWithoutOrderInput = {
  create: ChatMarkAsUnreadCreateWithoutOrderInput;
  where: ChatMarkAsUnreadWhereUniqueInput;
};

export type ChatMarkAsUnreadCreateOrConnectWithoutUserGroupInput = {
  create: ChatMarkAsUnreadCreateWithoutUserGroupInput;
  where: ChatMarkAsUnreadWhereUniqueInput;
};

export type ChatMarkAsUnreadCreateWithoutOrderInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutChatMarkAsUnreadInput>;
};

export type ChatMarkAsUnreadCreateWithoutUserGroupInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutChatMarkAsUnreadInput>;
};

export type ChatMarkAsUnreadListRelationFilter = {
  every?: InputMaybe<ChatMarkAsUnreadWhereInput>;
  none?: InputMaybe<ChatMarkAsUnreadWhereInput>;
  some?: InputMaybe<ChatMarkAsUnreadWhereInput>;
};

export type ChatMarkAsUnreadOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChatMarkAsUnreadScalarWhereInput = {
  AND?: InputMaybe<Array<ChatMarkAsUnreadScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChatMarkAsUnreadScalarWhereInput>>;
  OR?: InputMaybe<Array<ChatMarkAsUnreadScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type ChatMarkAsUnreadUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ChatMarkAsUnreadUpdateManyWithWhereWithoutOrderInput = {
  data: ChatMarkAsUnreadUpdateManyMutationInput;
  where: ChatMarkAsUnreadScalarWhereInput;
};

export type ChatMarkAsUnreadUpdateManyWithWhereWithoutUserGroupInput = {
  data: ChatMarkAsUnreadUpdateManyMutationInput;
  where: ChatMarkAsUnreadScalarWhereInput;
};

export type ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMarkAsUnreadCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ChatMarkAsUnreadCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ChatMarkAsUnreadCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMarkAsUnreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMarkAsUnreadUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ChatMarkAsUnreadUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ChatMarkAsUnreadUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMarkAsUnreadCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ChatMarkAsUnreadCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ChatMarkAsUnreadCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMarkAsUnreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMarkAsUnreadWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMarkAsUnreadUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<ChatMarkAsUnreadUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<ChatMarkAsUnreadUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type ChatMarkAsUnreadUpdateWithWhereUniqueWithoutOrderInput = {
  data: ChatMarkAsUnreadUpdateWithoutOrderInput;
  where: ChatMarkAsUnreadWhereUniqueInput;
};

export type ChatMarkAsUnreadUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: ChatMarkAsUnreadUpdateWithoutUserGroupInput;
  where: ChatMarkAsUnreadWhereUniqueInput;
};

export type ChatMarkAsUnreadUpdateWithoutOrderInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutChatMarkAsUnreadNestedInput>;
};

export type ChatMarkAsUnreadUpdateWithoutUserGroupInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutChatMarkAsUnreadNestedInput>;
};

export type ChatMarkAsUnreadUpsertWithWhereUniqueWithoutOrderInput = {
  create: ChatMarkAsUnreadCreateWithoutOrderInput;
  update: ChatMarkAsUnreadUpdateWithoutOrderInput;
  where: ChatMarkAsUnreadWhereUniqueInput;
};

export type ChatMarkAsUnreadUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: ChatMarkAsUnreadCreateWithoutUserGroupInput;
  update: ChatMarkAsUnreadUpdateWithoutUserGroupInput;
  where: ChatMarkAsUnreadWhereUniqueInput;
};

export type ChatMarkAsUnreadWhereInput = {
  AND?: InputMaybe<Array<ChatMarkAsUnreadWhereInput>>;
  NOT?: InputMaybe<Array<ChatMarkAsUnreadWhereInput>>;
  OR?: InputMaybe<Array<ChatMarkAsUnreadWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type ChatMarkAsUnreadWhereUniqueInput = {
  AND?: InputMaybe<Array<ChatMarkAsUnreadWhereInput>>;
  NOT?: InputMaybe<Array<ChatMarkAsUnreadWhereInput>>;
  OR?: InputMaybe<Array<ChatMarkAsUnreadWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type ChatNullableScalarRelationFilter = {
  is?: InputMaybe<ChatWhereInput>;
  isNot?: InputMaybe<ChatWhereInput>;
};

export type ChatOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChatOrderByWithRelationInput = {
  archivedForProvider?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isNotification?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userGroup?: InputMaybe<UserGroupOrderByWithRelationInput>;
  userGroupId?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export type ChatResponse = {
  __typename?: 'ChatResponse';
  count: Scalars['Int']['output'];
  notification: Array<Chat>;
};

export enum ChatScalarFieldEnum {
  ArchivedForProvider = 'archivedForProvider',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsNotification = 'isNotification',
  Message = 'message',
  OrderId = 'orderId',
  Read = 'read',
  UpdatedAt = 'updatedAt',
  UserGroupId = 'userGroupId',
  UserId = 'userId'
}

export type ChatScalarWhereInput = {
  AND?: InputMaybe<Array<ChatScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChatScalarWhereInput>>;
  OR?: InputMaybe<Array<ChatScalarWhereInput>>;
  archivedForProvider?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  isNotification?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<UuidFilter>;
  read?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ChatUpdateManyMutationInput = {
  archivedForProvider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ChatUpdateManyWithWhereWithoutOrderInput = {
  data: ChatUpdateManyMutationInput;
  where: ChatScalarWhereInput;
};

export type ChatUpdateManyWithWhereWithoutUserGroupInput = {
  data: ChatUpdateManyMutationInput;
  where: ChatScalarWhereInput;
};

export type ChatUpdateManyWithWhereWithoutUserInput = {
  data: ChatUpdateManyMutationInput;
  where: ChatScalarWhereInput;
};

export type ChatUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ChatCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ChatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ChatUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ChatUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ChatUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ChatCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<ChatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<ChatUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<ChatUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type ChatUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutUserInput>>;
  createMany?: InputMaybe<ChatCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ChatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ChatUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ChatUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChatUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<ChatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<ChatCreateWithoutFilesInput>;
  delete?: InputMaybe<ChatWhereInput>;
  disconnect?: InputMaybe<ChatWhereInput>;
  update?: InputMaybe<ChatUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<ChatUpsertWithoutFilesInput>;
};

export type ChatUpdateToOneWithWhereWithoutFilesInput = {
  data: ChatUpdateWithoutFilesInput;
  where?: InputMaybe<ChatWhereInput>;
};

export type ChatUpdateWithWhereUniqueWithoutOrderInput = {
  data: ChatUpdateWithoutOrderInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: ChatUpdateWithoutUserGroupInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpdateWithWhereUniqueWithoutUserInput = {
  data: ChatUpdateWithoutUserInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpdateWithoutFilesInput = {
  archivedForProvider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutChatNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutChatNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutChatNestedInput>;
};

export type ChatUpdateWithoutOrderInput = {
  archivedForProvider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutChatNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutChatNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutChatNestedInput>;
};

export type ChatUpdateWithoutUserGroupInput = {
  archivedForProvider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutChatNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutChatNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutChatNestedInput>;
};

export type ChatUpdateWithoutUserInput = {
  archivedForProvider?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutChatNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutChatNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutChatNestedInput>;
};

export type ChatUpsertWithWhereUniqueWithoutOrderInput = {
  create: ChatCreateWithoutOrderInput;
  update: ChatUpdateWithoutOrderInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: ChatCreateWithoutUserGroupInput;
  update: ChatUpdateWithoutUserGroupInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpsertWithWhereUniqueWithoutUserInput = {
  create: ChatCreateWithoutUserInput;
  update: ChatUpdateWithoutUserInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpsertWithoutFilesInput = {
  create: ChatCreateWithoutFilesInput;
  update: ChatUpdateWithoutFilesInput;
  where?: InputMaybe<ChatWhereInput>;
};

export type ChatWhereInput = {
  AND?: InputMaybe<Array<ChatWhereInput>>;
  NOT?: InputMaybe<Array<ChatWhereInput>>;
  OR?: InputMaybe<Array<ChatWhereInput>>;
  archivedForProvider?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  isNotification?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  read?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ChatWhereUniqueInput = {
  AND?: InputMaybe<Array<ChatWhereInput>>;
  NOT?: InputMaybe<Array<ChatWhereInput>>;
  OR?: InputMaybe<Array<ChatWhereInput>>;
  archivedForProvider?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isNotification?: InputMaybe<BoolFilter>;
  message?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  read?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ClientBilling = {
  __typename?: 'ClientBilling';
  _count: ClientBillingCount;
  computerReference?: Maybe<Scalars['String']['output']>;
  computerSerialNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  currentPeriodBalance: Scalars['Decimal']['output'];
  dongleReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  numberOfDiscoveryPricingMonths: Scalars['Int']['output'];
  pricingType: PricingType;
  scannerReference: ScannerReference;
  scannerSerialNumber?: Maybe<Scalars['String']['output']>;
  subscriptionAmount: Scalars['Decimal']['output'];
  subscriptionFrequence: SubscriptionFrequence;
  subscriptionStartDate: Scalars['Timestamp']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  user?: Maybe<Array<User>>;
  userGroup?: Maybe<Array<UserGroup>>;
};

export type ClientBillingCount = {
  __typename?: 'ClientBillingCount';
  user: Scalars['Int']['output'];
  userGroup: Scalars['Int']['output'];
};

export type ClientBillingCreateInput = {
  computerReference?: InputMaybe<Scalars['String']['input']>;
  computerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  currentPeriodBalance?: InputMaybe<Scalars['Decimal']['input']>;
  dongleReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  numberOfDiscoveryPricingMonths?: InputMaybe<Scalars['Int']['input']>;
  pricingType?: InputMaybe<PricingType>;
  scannerReference?: InputMaybe<ScannerReference>;
  scannerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  subscriptionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  subscriptionFrequence?: InputMaybe<SubscriptionFrequence>;
  subscriptionStartDate?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedManyWithoutClientBillingInput>;
  userGroup?: InputMaybe<UserGroupCreateNestedManyWithoutClientBillingInput>;
};

export type ClientBillingCreateNestedOneWithoutUserGroupInput = {
  connect?: InputMaybe<ClientBillingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientBillingCreateOrConnectWithoutUserGroupInput>;
  create?: InputMaybe<ClientBillingCreateWithoutUserGroupInput>;
};

export type ClientBillingCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<ClientBillingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientBillingCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<ClientBillingCreateWithoutUserInput>;
};

export type ClientBillingCreateOrConnectWithoutUserGroupInput = {
  create: ClientBillingCreateWithoutUserGroupInput;
  where: ClientBillingWhereUniqueInput;
};

export type ClientBillingCreateOrConnectWithoutUserInput = {
  create: ClientBillingCreateWithoutUserInput;
  where: ClientBillingWhereUniqueInput;
};

export type ClientBillingCreateWithoutUserGroupInput = {
  computerReference?: InputMaybe<Scalars['String']['input']>;
  computerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  currentPeriodBalance?: InputMaybe<Scalars['Decimal']['input']>;
  dongleReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  numberOfDiscoveryPricingMonths?: InputMaybe<Scalars['Int']['input']>;
  pricingType?: InputMaybe<PricingType>;
  scannerReference?: InputMaybe<ScannerReference>;
  scannerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  subscriptionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  subscriptionFrequence?: InputMaybe<SubscriptionFrequence>;
  subscriptionStartDate?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedManyWithoutClientBillingInput>;
};

export type ClientBillingCreateWithoutUserInput = {
  computerReference?: InputMaybe<Scalars['String']['input']>;
  computerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  currentPeriodBalance?: InputMaybe<Scalars['Decimal']['input']>;
  dongleReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  numberOfDiscoveryPricingMonths?: InputMaybe<Scalars['Int']['input']>;
  pricingType?: InputMaybe<PricingType>;
  scannerReference?: InputMaybe<ScannerReference>;
  scannerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  subscriptionAmount?: InputMaybe<Scalars['Decimal']['input']>;
  subscriptionFrequence?: InputMaybe<SubscriptionFrequence>;
  subscriptionStartDate?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedManyWithoutClientBillingInput>;
};

export type ClientBillingNullableScalarRelationFilter = {
  is?: InputMaybe<ClientBillingWhereInput>;
  isNot?: InputMaybe<ClientBillingWhereInput>;
};

export type ClientBillingOrderByWithRelationInput = {
  computerReference?: InputMaybe<SortOrderInput>;
  computerSerialNumber?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  currentPeriodBalance?: InputMaybe<SortOrder>;
  dongleReference?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  numberOfDiscoveryPricingMonths?: InputMaybe<SortOrder>;
  pricingType?: InputMaybe<SortOrder>;
  scannerReference?: InputMaybe<SortOrder>;
  scannerSerialNumber?: InputMaybe<SortOrderInput>;
  subscriptionAmount?: InputMaybe<SortOrder>;
  subscriptionFrequence?: InputMaybe<SortOrder>;
  subscriptionStartDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByRelationAggregateInput>;
  userGroup?: InputMaybe<UserGroupOrderByRelationAggregateInput>;
};

export enum ClientBillingScalarFieldEnum {
  ComputerReference = 'computerReference',
  ComputerSerialNumber = 'computerSerialNumber',
  CreatedAt = 'createdAt',
  CurrentPeriodBalance = 'currentPeriodBalance',
  DongleReference = 'dongleReference',
  Id = 'id',
  NumberOfDiscoveryPricingMonths = 'numberOfDiscoveryPricingMonths',
  PricingType = 'pricingType',
  ScannerReference = 'scannerReference',
  ScannerSerialNumber = 'scannerSerialNumber',
  SubscriptionAmount = 'subscriptionAmount',
  SubscriptionFrequence = 'subscriptionFrequence',
  SubscriptionStartDate = 'subscriptionStartDate',
  UpdatedAt = 'updatedAt'
}

export type ClientBillingUpdateInput = {
  computerReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  computerSerialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currentPeriodBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  dongleReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  numberOfDiscoveryPricingMonths?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  scannerReference?: InputMaybe<EnumScannerReferenceFieldUpdateOperationsInput>;
  scannerSerialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  subscriptionFrequence?: InputMaybe<EnumSubscriptionFrequenceFieldUpdateOperationsInput>;
  subscriptionStartDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateManyWithoutClientBillingNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateManyWithoutClientBillingNestedInput>;
};

export type ClientBillingUpdateOneWithoutUserGroupNestedInput = {
  connect?: InputMaybe<ClientBillingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientBillingCreateOrConnectWithoutUserGroupInput>;
  create?: InputMaybe<ClientBillingCreateWithoutUserGroupInput>;
  delete?: InputMaybe<ClientBillingWhereInput>;
  disconnect?: InputMaybe<ClientBillingWhereInput>;
  update?: InputMaybe<ClientBillingUpdateToOneWithWhereWithoutUserGroupInput>;
  upsert?: InputMaybe<ClientBillingUpsertWithoutUserGroupInput>;
};

export type ClientBillingUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<ClientBillingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ClientBillingCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<ClientBillingCreateWithoutUserInput>;
  delete?: InputMaybe<ClientBillingWhereInput>;
  disconnect?: InputMaybe<ClientBillingWhereInput>;
  update?: InputMaybe<ClientBillingUpdateToOneWithWhereWithoutUserInput>;
  upsert?: InputMaybe<ClientBillingUpsertWithoutUserInput>;
};

export type ClientBillingUpdateToOneWithWhereWithoutUserGroupInput = {
  data: ClientBillingUpdateWithoutUserGroupInput;
  where?: InputMaybe<ClientBillingWhereInput>;
};

export type ClientBillingUpdateToOneWithWhereWithoutUserInput = {
  data: ClientBillingUpdateWithoutUserInput;
  where?: InputMaybe<ClientBillingWhereInput>;
};

export type ClientBillingUpdateWithoutUserGroupInput = {
  computerReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  computerSerialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currentPeriodBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  dongleReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  numberOfDiscoveryPricingMonths?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  scannerReference?: InputMaybe<EnumScannerReferenceFieldUpdateOperationsInput>;
  scannerSerialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  subscriptionFrequence?: InputMaybe<EnumSubscriptionFrequenceFieldUpdateOperationsInput>;
  subscriptionStartDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateManyWithoutClientBillingNestedInput>;
};

export type ClientBillingUpdateWithoutUserInput = {
  computerReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  computerSerialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currentPeriodBalance?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  dongleReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  numberOfDiscoveryPricingMonths?: InputMaybe<IntFieldUpdateOperationsInput>;
  pricingType?: InputMaybe<EnumPricingTypeFieldUpdateOperationsInput>;
  scannerReference?: InputMaybe<EnumScannerReferenceFieldUpdateOperationsInput>;
  scannerSerialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  subscriptionAmount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  subscriptionFrequence?: InputMaybe<EnumSubscriptionFrequenceFieldUpdateOperationsInput>;
  subscriptionStartDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateManyWithoutClientBillingNestedInput>;
};

export type ClientBillingUpsertWithoutUserGroupInput = {
  create: ClientBillingCreateWithoutUserGroupInput;
  update: ClientBillingUpdateWithoutUserGroupInput;
  where?: InputMaybe<ClientBillingWhereInput>;
};

export type ClientBillingUpsertWithoutUserInput = {
  create: ClientBillingCreateWithoutUserInput;
  update: ClientBillingUpdateWithoutUserInput;
  where?: InputMaybe<ClientBillingWhereInput>;
};

export type ClientBillingWhereInput = {
  AND?: InputMaybe<Array<ClientBillingWhereInput>>;
  NOT?: InputMaybe<Array<ClientBillingWhereInput>>;
  OR?: InputMaybe<Array<ClientBillingWhereInput>>;
  computerReference?: InputMaybe<StringNullableFilter>;
  computerSerialNumber?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentPeriodBalance?: InputMaybe<DecimalFilter>;
  dongleReference?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  numberOfDiscoveryPricingMonths?: InputMaybe<IntFilter>;
  pricingType?: InputMaybe<EnumPricingTypeFilter>;
  scannerReference?: InputMaybe<EnumScannerReferenceFilter>;
  scannerSerialNumber?: InputMaybe<StringNullableFilter>;
  subscriptionAmount?: InputMaybe<DecimalFilter>;
  subscriptionFrequence?: InputMaybe<EnumSubscriptionFrequenceFilter>;
  subscriptionStartDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserListRelationFilter>;
  userGroup?: InputMaybe<UserGroupListRelationFilter>;
};

export type ClientBillingWhereUniqueInput = {
  AND?: InputMaybe<Array<ClientBillingWhereInput>>;
  NOT?: InputMaybe<Array<ClientBillingWhereInput>>;
  OR?: InputMaybe<Array<ClientBillingWhereInput>>;
  computerReference?: InputMaybe<StringNullableFilter>;
  computerSerialNumber?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currentPeriodBalance?: InputMaybe<DecimalFilter>;
  dongleReference?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  numberOfDiscoveryPricingMonths?: InputMaybe<IntFilter>;
  pricingType?: InputMaybe<EnumPricingTypeFilter>;
  scannerReference?: InputMaybe<EnumScannerReferenceFilter>;
  scannerSerialNumber?: InputMaybe<StringNullableFilter>;
  subscriptionAmount?: InputMaybe<DecimalFilter>;
  subscriptionFrequence?: InputMaybe<EnumSubscriptionFrequenceFilter>;
  subscriptionStartDate?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserListRelationFilter>;
  userGroup?: InputMaybe<UserGroupListRelationFilter>;
};

export type ClinicProviderAccess = {
  __typename?: 'ClinicProviderAccess';
  clinic: UserGroup;
  clinicGroupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  provider: UserGroup;
  providerGroupId: Scalars['String']['output'];
};

export type ClinicProviderAccessCreateManyClinicInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  providerGroupId: Scalars['String']['input'];
};

export type ClinicProviderAccessCreateManyClinicInputEnvelope = {
  data: Array<ClinicProviderAccessCreateManyClinicInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicProviderAccessCreateManyProviderInput = {
  clinicGroupId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicProviderAccessCreateManyProviderInputEnvelope = {
  data: Array<ClinicProviderAccessCreateManyProviderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClinicProviderAccessCreateNestedManyWithoutClinicInput = {
  connect?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClinicProviderAccessCreateOrConnectWithoutClinicInput>>;
  create?: InputMaybe<Array<ClinicProviderAccessCreateWithoutClinicInput>>;
  createMany?: InputMaybe<ClinicProviderAccessCreateManyClinicInputEnvelope>;
};

export type ClinicProviderAccessCreateNestedManyWithoutProviderInput = {
  connect?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClinicProviderAccessCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<ClinicProviderAccessCreateWithoutProviderInput>>;
  createMany?: InputMaybe<ClinicProviderAccessCreateManyProviderInputEnvelope>;
};

export type ClinicProviderAccessCreateOrConnectWithoutClinicInput = {
  create: ClinicProviderAccessCreateWithoutClinicInput;
  where: ClinicProviderAccessWhereUniqueInput;
};

export type ClinicProviderAccessCreateOrConnectWithoutProviderInput = {
  create: ClinicProviderAccessCreateWithoutProviderInput;
  where: ClinicProviderAccessWhereUniqueInput;
};

export type ClinicProviderAccessCreateWithoutClinicInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  provider: UserGroupCreateNestedOneWithoutAvailableClinicInput;
};

export type ClinicProviderAccessCreateWithoutProviderInput = {
  clinic: UserGroupCreateNestedOneWithoutAvailableProviderInput;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicProviderAccessListRelationFilter = {
  every?: InputMaybe<ClinicProviderAccessWhereInput>;
  none?: InputMaybe<ClinicProviderAccessWhereInput>;
  some?: InputMaybe<ClinicProviderAccessWhereInput>;
};

export type ClinicProviderAccessOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ClinicProviderAccessProviderGroupIdClinicGroupIdCompoundUniqueInput = {
  clinicGroupId: Scalars['String']['input'];
  providerGroupId: Scalars['String']['input'];
};

export type ClinicProviderAccessScalarWhereInput = {
  AND?: InputMaybe<Array<ClinicProviderAccessScalarWhereInput>>;
  NOT?: InputMaybe<Array<ClinicProviderAccessScalarWhereInput>>;
  OR?: InputMaybe<Array<ClinicProviderAccessScalarWhereInput>>;
  clinicGroupId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  providerGroupId?: InputMaybe<UuidFilter>;
};

export type ClinicProviderAccessUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ClinicProviderAccessUpdateManyWithWhereWithoutClinicInput = {
  data: ClinicProviderAccessUpdateManyMutationInput;
  where: ClinicProviderAccessScalarWhereInput;
};

export type ClinicProviderAccessUpdateManyWithWhereWithoutProviderInput = {
  data: ClinicProviderAccessUpdateManyMutationInput;
  where: ClinicProviderAccessScalarWhereInput;
};

export type ClinicProviderAccessUpdateManyWithoutClinicNestedInput = {
  connect?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClinicProviderAccessCreateOrConnectWithoutClinicInput>>;
  create?: InputMaybe<Array<ClinicProviderAccessCreateWithoutClinicInput>>;
  createMany?: InputMaybe<ClinicProviderAccessCreateManyClinicInputEnvelope>;
  delete?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClinicProviderAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<ClinicProviderAccessUpdateWithWhereUniqueWithoutClinicInput>>;
  updateMany?: InputMaybe<Array<ClinicProviderAccessUpdateManyWithWhereWithoutClinicInput>>;
  upsert?: InputMaybe<Array<ClinicProviderAccessUpsertWithWhereUniqueWithoutClinicInput>>;
};

export type ClinicProviderAccessUpdateManyWithoutProviderNestedInput = {
  connect?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ClinicProviderAccessCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<ClinicProviderAccessCreateWithoutProviderInput>>;
  createMany?: InputMaybe<ClinicProviderAccessCreateManyProviderInputEnvelope>;
  delete?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ClinicProviderAccessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  set?: InputMaybe<Array<ClinicProviderAccessWhereUniqueInput>>;
  update?: InputMaybe<Array<ClinicProviderAccessUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: InputMaybe<Array<ClinicProviderAccessUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: InputMaybe<Array<ClinicProviderAccessUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type ClinicProviderAccessUpdateWithWhereUniqueWithoutClinicInput = {
  data: ClinicProviderAccessUpdateWithoutClinicInput;
  where: ClinicProviderAccessWhereUniqueInput;
};

export type ClinicProviderAccessUpdateWithWhereUniqueWithoutProviderInput = {
  data: ClinicProviderAccessUpdateWithoutProviderInput;
  where: ClinicProviderAccessWhereUniqueInput;
};

export type ClinicProviderAccessUpdateWithoutClinicInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  provider?: InputMaybe<UserGroupUpdateOneRequiredWithoutAvailableClinicNestedInput>;
};

export type ClinicProviderAccessUpdateWithoutProviderInput = {
  clinic?: InputMaybe<UserGroupUpdateOneRequiredWithoutAvailableProviderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ClinicProviderAccessUpsertWithWhereUniqueWithoutClinicInput = {
  create: ClinicProviderAccessCreateWithoutClinicInput;
  update: ClinicProviderAccessUpdateWithoutClinicInput;
  where: ClinicProviderAccessWhereUniqueInput;
};

export type ClinicProviderAccessUpsertWithWhereUniqueWithoutProviderInput = {
  create: ClinicProviderAccessCreateWithoutProviderInput;
  update: ClinicProviderAccessUpdateWithoutProviderInput;
  where: ClinicProviderAccessWhereUniqueInput;
};

export type ClinicProviderAccessWhereInput = {
  AND?: InputMaybe<Array<ClinicProviderAccessWhereInput>>;
  NOT?: InputMaybe<Array<ClinicProviderAccessWhereInput>>;
  OR?: InputMaybe<Array<ClinicProviderAccessWhereInput>>;
  clinic?: InputMaybe<UserGroupScalarRelationFilter>;
  clinicGroupId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  provider?: InputMaybe<UserGroupScalarRelationFilter>;
  providerGroupId?: InputMaybe<UuidFilter>;
};

export type ClinicProviderAccessWhereUniqueInput = {
  AND?: InputMaybe<Array<ClinicProviderAccessWhereInput>>;
  NOT?: InputMaybe<Array<ClinicProviderAccessWhereInput>>;
  OR?: InputMaybe<Array<ClinicProviderAccessWhereInput>>;
  clinic?: InputMaybe<UserGroupScalarRelationFilter>;
  clinicGroupId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<UserGroupScalarRelationFilter>;
  providerGroupId?: InputMaybe<UuidFilter>;
  providerGroupId_clinicGroupId?: InputMaybe<ClinicProviderAccessProviderGroupIdClinicGroupIdCompoundUniqueInput>;
};

export enum CommentType {
  Help = 'HELP',
  ImportFrom_3Shape = 'IMPORT_FROM_3SHAPE',
  Order = 'ORDER',
  PartialDenture = 'PARTIAL_DENTURE',
  Redo = 'REDO'
}

export type CreateCustomAbutmentCharacteristicsInput = {
  abutmentType: AbutmentTypeV2;
};

export type CreateImplantedItemCharacteristicsInput = {
  retentionType: RetentionTypeV2;
};

export type CreateInlayCoreCharacteristicsInput = {
  hasClavette: Scalars['Boolean']['input'];
  scanPost: Scalars['String']['input'];
};

export type CreateItemInput = {
  arch?: InputMaybe<TeethArchV2>;
  customAbutmentCharacteristics?: InputMaybe<CreateCustomAbutmentCharacteristicsInput>;
  implantedItemCharacteristics?: InputMaybe<CreateImplantedItemCharacteristicsInput>;
  inlayCoreCharacteristics?: InputMaybe<CreateInlayCoreCharacteristicsInput>;
  materialCharacteristics?: InputMaybe<CreateMaterialCharacteristicsInput>;
  referencedImplantCharacteristics?: InputMaybe<CreateReferencedImplantCharacteristicsInput>;
  standardAbutmentCharacteristics?: InputMaybe<CreateStandardAbutmentCharacteristicsInput>;
  tooth?: InputMaybe<Scalars['Int']['input']>;
  type: ItemTypeV2;
  unreferencedImplantCharacteristics?: InputMaybe<CreateUnreferencedImplantCharacteristicsInput>;
  waxUpType?: InputMaybe<WaxUpTypeV2>;
};

export type CreateMaterialCharacteristicsInput = {
  materialId: Scalars['String']['input'];
  multiShadeCharacteristics?: InputMaybe<CreateMultiShadeCharacteristicsInput>;
  shadeCharacteristics?: InputMaybe<CreateSingleShadeCharacteristicsInput>;
};

export type CreateMultiShadeCharacteristicsInput = {
  baseShadeId: Scalars['String']['input'];
  gingivalShadeId: Scalars['String']['input'];
  incisalShadeId: Scalars['String']['input'];
};

export type CreateOrderForm = {
  colorNames?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  isImplantBridge?: InputMaybe<Scalars['Boolean']['input']>;
  isMultiplesBridges?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  materialNames?: InputMaybe<Scalars['String']['input']>;
  orderDirectId?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  patientBirthdate?: InputMaybe<Scalars['String']['input']>;
  patientDirectId?: InputMaybe<Scalars['String']['input']>;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientGender?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  patientSsn?: InputMaybe<Scalars['String']['input']>;
  ponticTeeth?: InputMaybe<Scalars['String']['input']>;
  productInfo: Scalars['String']['input'];
  screwRetainedCrown?: InputMaybe<Scalars['String']['input']>;
  shouldPopupWindow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrderInput = {
  dentistId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePatientInput = {
  birthDate?: InputMaybe<Scalars['Timestamp']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  sex?: InputMaybe<SexV2>;
};

export type CreateProductInput = {
  items: Array<CreateItemInput>;
  teeth: Array<Scalars['Float']['input']>;
  type: ProductTypeV2;
};

export type CreateReferencedImplantCharacteristicsInput = {
  implantPlatform: Scalars['String']['input'];
  implantReferenceId: Scalars['String']['input'];
  scanBodyReference: Scalars['String']['input'];
};

export type CreateSingleShadeCharacteristicsInput = {
  shadeId: Scalars['String']['input'];
};

export type CreateStandardAbutmentCharacteristicsInput = {
  abutmentPreferences?: InputMaybe<Scalars['String']['input']>;
  abutmentType: AbutmentTypeV2;
};

export type CreateUnreferencedImplantCharacteristicsInput = {
  implantBrand: Scalars['String']['input'];
  implantPlatform: Scalars['String']['input'];
  implantSystem: Scalars['String']['input'];
  scanBodyReference: Scalars['String']['input'];
};

export type CustomAbutmentCharacteristicsModel = {
  __typename?: 'CustomAbutmentCharacteristicsModel';
  abutmentType: AbutmentTypeV2;
};

export type CustomBillingEntry = {
  __typename?: 'CustomBillingEntry';
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designation: Scalars['String']['output'];
  discount: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  orderBilling: OrderBilling;
  orderBillingId: Scalars['String']['output'];
  priceExcludingVat: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  totalPrice: Scalars['Decimal']['output'];
  totalVat: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
  unitVat: Scalars['Decimal']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type CustomBillingEntryCreateManyOrderBillingInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type CustomBillingEntryCreateManyOrderBillingInputEnvelope = {
  data: Array<CustomBillingEntryCreateManyOrderBillingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomBillingEntryCreateNestedManyWithoutOrderBillingInput = {
  connect?: InputMaybe<Array<CustomBillingEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomBillingEntryCreateOrConnectWithoutOrderBillingInput>>;
  create?: InputMaybe<Array<CustomBillingEntryCreateWithoutOrderBillingInput>>;
  createMany?: InputMaybe<CustomBillingEntryCreateManyOrderBillingInputEnvelope>;
};

export type CustomBillingEntryCreateOrConnectWithoutOrderBillingInput = {
  create: CustomBillingEntryCreateWithoutOrderBillingInput;
  where: CustomBillingEntryWhereUniqueInput;
};

export type CustomBillingEntryCreateWithoutOrderBillingInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type CustomBillingEntryListRelationFilter = {
  every?: InputMaybe<CustomBillingEntryWhereInput>;
  none?: InputMaybe<CustomBillingEntryWhereInput>;
  some?: InputMaybe<CustomBillingEntryWhereInput>;
};

export type CustomBillingEntryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CustomBillingEntryScalarWhereInput = {
  AND?: InputMaybe<Array<CustomBillingEntryScalarWhereInput>>;
  NOT?: InputMaybe<Array<CustomBillingEntryScalarWhereInput>>;
  OR?: InputMaybe<Array<CustomBillingEntryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designation?: InputMaybe<StringFilter>;
  discount?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<UuidFilter>;
  orderBillingId?: InputMaybe<UuidFilter>;
  priceExcludingVat?: InputMaybe<DecimalFilter>;
  quantity?: InputMaybe<DecimalFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitVat?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomBillingEntryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<StringFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomBillingEntryUpdateManyWithWhereWithoutOrderBillingInput = {
  data: CustomBillingEntryUpdateManyMutationInput;
  where: CustomBillingEntryScalarWhereInput;
};

export type CustomBillingEntryUpdateManyWithoutOrderBillingNestedInput = {
  connect?: InputMaybe<Array<CustomBillingEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CustomBillingEntryCreateOrConnectWithoutOrderBillingInput>>;
  create?: InputMaybe<Array<CustomBillingEntryCreateWithoutOrderBillingInput>>;
  createMany?: InputMaybe<CustomBillingEntryCreateManyOrderBillingInputEnvelope>;
  delete?: InputMaybe<Array<CustomBillingEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CustomBillingEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CustomBillingEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<CustomBillingEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<CustomBillingEntryUpdateWithWhereUniqueWithoutOrderBillingInput>>;
  updateMany?: InputMaybe<Array<CustomBillingEntryUpdateManyWithWhereWithoutOrderBillingInput>>;
  upsert?: InputMaybe<Array<CustomBillingEntryUpsertWithWhereUniqueWithoutOrderBillingInput>>;
};

export type CustomBillingEntryUpdateWithWhereUniqueWithoutOrderBillingInput = {
  data: CustomBillingEntryUpdateWithoutOrderBillingInput;
  where: CustomBillingEntryWhereUniqueInput;
};

export type CustomBillingEntryUpdateWithoutOrderBillingInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designation?: InputMaybe<StringFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomBillingEntryUpsertWithWhereUniqueWithoutOrderBillingInput = {
  create: CustomBillingEntryCreateWithoutOrderBillingInput;
  update: CustomBillingEntryUpdateWithoutOrderBillingInput;
  where: CustomBillingEntryWhereUniqueInput;
};

export type CustomBillingEntryWhereInput = {
  AND?: InputMaybe<Array<CustomBillingEntryWhereInput>>;
  NOT?: InputMaybe<Array<CustomBillingEntryWhereInput>>;
  OR?: InputMaybe<Array<CustomBillingEntryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designation?: InputMaybe<StringFilter>;
  discount?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<UuidFilter>;
  orderBilling?: InputMaybe<OrderBillingScalarRelationFilter>;
  orderBillingId?: InputMaybe<UuidFilter>;
  priceExcludingVat?: InputMaybe<DecimalFilter>;
  quantity?: InputMaybe<DecimalFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitVat?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomBillingEntryWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomBillingEntryWhereInput>>;
  NOT?: InputMaybe<Array<CustomBillingEntryWhereInput>>;
  OR?: InputMaybe<Array<CustomBillingEntryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designation?: InputMaybe<StringFilter>;
  discount?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderBilling?: InputMaybe<OrderBillingScalarRelationFilter>;
  orderBillingId?: InputMaybe<UuidFilter>;
  priceExcludingVat?: InputMaybe<DecimalFilter>;
  quantity?: InputMaybe<DecimalFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitVat?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DateFilterInput = {
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type DecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export enum DeliveryCarrierV2 {
  Bip = 'BIP',
  Chronopost = 'CHRONOPOST',
  Ciblex = 'CIBLEX',
  FedexTnt = 'FEDEX_TNT',
  Sterne = 'STERNE',
  Ups = 'UPS'
}

export type DentalOffice = {
  __typename?: 'DentalOffice';
  clinicNumber: Scalars['String']['output'];
  deliveryCarrier?: Maybe<DeliveryCarrierV2>;
  dentists: Array<Dentist>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pickupCarrier?: Maybe<PickupCarrierV2>;
  pricePlan?: Maybe<PricePlanV2>;
  type: UserGroupTypeV2;
  users: Array<UserV2>;
};

export type Dentist = {
  __typename?: 'Dentist';
  dentalOffice?: Maybe<DentalOffice>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role: UserRoleV2;
  type: UserTypeV2;
  userGroup?: Maybe<UserGroupV2>;
};

export type DentistsV2Paginated = {
  __typename?: 'DentistsV2Paginated';
  nodes: Array<Dentist>;
  pageInfo: PageInfo;
};

export type DesignReviewNotification = {
  __typename?: 'DesignReviewNotification';
  createdAt: Scalars['Timestamp']['output'];
  doctorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  orderDesignId: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  orderReference?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DesignReviewNotificationsResponse = {
  __typename?: 'DesignReviewNotificationsResponse';
  notifications: Array<DesignReviewNotification>;
  totalCount: Scalars['Int']['output'];
};

export type DesignUploadPresignedLink = {
  __typename?: 'DesignUploadPresignedLink';
  fields: Scalars['JSONObject']['output'];
  url: Scalars['String']['output'];
};

export type EnumAbutmentTypeNullableFilter = {
  equals?: InputMaybe<AbutmentType>;
  in?: InputMaybe<Array<AbutmentType>>;
  not?: InputMaybe<NestedEnumAbutmentTypeNullableFilter>;
  notIn?: InputMaybe<Array<AbutmentType>>;
};

export type EnumArchNullableFilter = {
  equals?: InputMaybe<Arch>;
  in?: InputMaybe<Array<Arch>>;
  not?: InputMaybe<NestedEnumArchNullableFilter>;
  notIn?: InputMaybe<Array<Arch>>;
};

export type EnumBillingStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<BillingStatus>;
};

export type EnumBillingStatusFilter = {
  equals?: InputMaybe<BillingStatus>;
  in?: InputMaybe<Array<BillingStatus>>;
  not?: InputMaybe<NestedEnumBillingStatusFilter>;
  notIn?: InputMaybe<Array<BillingStatus>>;
};

export type EnumBridgeTypeNullableFilter = {
  equals?: InputMaybe<BridgeType>;
  in?: InputMaybe<Array<BridgeType>>;
  not?: InputMaybe<NestedEnumBridgeTypeNullableFilter>;
  notIn?: InputMaybe<Array<BridgeType>>;
};

export type EnumCarrierTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CarrierType>;
};

export type EnumCarrierTypeFilter = {
  equals?: InputMaybe<CarrierType>;
  in?: InputMaybe<Array<CarrierType>>;
  not?: InputMaybe<NestedEnumCarrierTypeFilter>;
  notIn?: InputMaybe<Array<CarrierType>>;
};

export type EnumCommentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CommentType>;
};

export type EnumCommentTypeFilter = {
  equals?: InputMaybe<CommentType>;
  in?: InputMaybe<Array<CommentType>>;
  not?: InputMaybe<NestedEnumCommentTypeFilter>;
  notIn?: InputMaybe<Array<CommentType>>;
};

export type EnumFileStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<FileStatus>;
};

export type EnumFileStatusFilter = {
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  not?: InputMaybe<NestedEnumFileStatusFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type EnumFileTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<FileType>;
};

export type EnumFileTypeFilter = {
  equals?: InputMaybe<FileType>;
  in?: InputMaybe<Array<FileType>>;
  not?: InputMaybe<NestedEnumFileTypeFilter>;
  notIn?: InputMaybe<Array<FileType>>;
};

export type EnumImprintTypeNullableFilter = {
  equals?: InputMaybe<ImprintType>;
  in?: InputMaybe<Array<ImprintType>>;
  not?: InputMaybe<NestedEnumImprintTypeNullableFilter>;
  notIn?: InputMaybe<Array<ImprintType>>;
};

export type EnumIntegrationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<IntegrationType>;
};

export type EnumIntegrationTypeFilter = {
  equals?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  not?: InputMaybe<NestedEnumIntegrationTypeFilter>;
  notIn?: InputMaybe<Array<IntegrationType>>;
};

export type EnumIntegrationTypeNullableFilter = {
  equals?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  not?: InputMaybe<NestedEnumIntegrationTypeNullableFilter>;
  notIn?: InputMaybe<Array<IntegrationType>>;
};

export type EnumItemPriceTypeNullableFilter = {
  equals?: InputMaybe<ItemPriceType>;
  in?: InputMaybe<Array<ItemPriceType>>;
  not?: InputMaybe<NestedEnumItemPriceTypeNullableFilter>;
  notIn?: InputMaybe<Array<ItemPriceType>>;
};

export type EnumItemShadeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ItemShadeType>;
};

export type EnumItemShadeTypeFilter = {
  equals?: InputMaybe<ItemShadeType>;
  in?: InputMaybe<Array<ItemShadeType>>;
  not?: InputMaybe<NestedEnumItemShadeTypeFilter>;
  notIn?: InputMaybe<Array<ItemShadeType>>;
};

export type EnumItemShadeTypeNullableFilter = {
  equals?: InputMaybe<ItemShadeType>;
  in?: InputMaybe<Array<ItemShadeType>>;
  not?: InputMaybe<NestedEnumItemShadeTypeNullableFilter>;
  notIn?: InputMaybe<Array<ItemShadeType>>;
};

export type EnumItemTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ItemType>;
};

export type EnumItemTypeFilter = {
  equals?: InputMaybe<ItemType>;
  in?: InputMaybe<Array<ItemType>>;
  not?: InputMaybe<NestedEnumItemTypeFilter>;
  notIn?: InputMaybe<Array<ItemType>>;
};

export type EnumItemTypeNullableFilter = {
  equals?: InputMaybe<ItemType>;
  in?: InputMaybe<Array<ItemType>>;
  not?: InputMaybe<NestedEnumItemTypeNullableFilter>;
  notIn?: InputMaybe<Array<ItemType>>;
};

export type EnumNotificationEntityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationEntityType>;
};

export type EnumNotificationEntityTypeFilter = {
  equals?: InputMaybe<NotificationEntityType>;
  in?: InputMaybe<Array<NotificationEntityType>>;
  not?: InputMaybe<NestedEnumNotificationEntityTypeFilter>;
  notIn?: InputMaybe<Array<NotificationEntityType>>;
};

export type EnumNotificationEventFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationEvent>;
};

export type EnumNotificationEventFilter = {
  equals?: InputMaybe<NotificationEvent>;
  in?: InputMaybe<Array<NotificationEvent>>;
  not?: InputMaybe<NestedEnumNotificationEventFilter>;
  notIn?: InputMaybe<Array<NotificationEvent>>;
};

export type EnumOrderBillingTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderBillingType>;
};

export type EnumOrderBillingTypeFilter = {
  equals?: InputMaybe<OrderBillingType>;
  in?: InputMaybe<Array<OrderBillingType>>;
  not?: InputMaybe<NestedEnumOrderBillingTypeFilter>;
  notIn?: InputMaybe<Array<OrderBillingType>>;
};

export type EnumOrderStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderStatus>;
};

export type EnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumOrderStatusNullableFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusNullableFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumPartialDentureRedoPartLengthNullableFilter = {
  equals?: InputMaybe<PartialDentureRedoPartLength>;
  in?: InputMaybe<Array<PartialDentureRedoPartLength>>;
  not?: InputMaybe<NestedEnumPartialDentureRedoPartLengthNullableFilter>;
  notIn?: InputMaybe<Array<PartialDentureRedoPartLength>>;
};

export type EnumPartialDentureRedoPartProximalContactNullableFilter = {
  equals?: InputMaybe<PartialDentureRedoPartProximalContact>;
  in?: InputMaybe<Array<PartialDentureRedoPartProximalContact>>;
  not?: InputMaybe<NestedEnumPartialDentureRedoPartProximalContactNullableFilter>;
  notIn?: InputMaybe<Array<PartialDentureRedoPartProximalContact>>;
};

export type EnumPartialDentureRedoPartShapeNullableFilter = {
  equals?: InputMaybe<PartialDentureRedoPartShape>;
  in?: InputMaybe<Array<PartialDentureRedoPartShape>>;
  not?: InputMaybe<NestedEnumPartialDentureRedoPartShapeNullableFilter>;
  notIn?: InputMaybe<Array<PartialDentureRedoPartShape>>;
};

export type EnumPickupStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PickupStatus>;
};

export type EnumPickupStatusFilter = {
  equals?: InputMaybe<PickupStatus>;
  in?: InputMaybe<Array<PickupStatus>>;
  not?: InputMaybe<NestedEnumPickupStatusFilter>;
  notIn?: InputMaybe<Array<PickupStatus>>;
};

export type EnumPricingTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PricingType>;
};

export type EnumPricingTypeFilter = {
  equals?: InputMaybe<PricingType>;
  in?: InputMaybe<Array<PricingType>>;
  not?: InputMaybe<NestedEnumPricingTypeFilter>;
  notIn?: InputMaybe<Array<PricingType>>;
};

export type EnumProductPreferenceTypeEnumFieldUpdateOperationsInput = {
  set?: InputMaybe<ProductPreferenceTypeEnum>;
};

export type EnumProductPreferenceTypeEnumFilter = {
  equals?: InputMaybe<ProductPreferenceTypeEnum>;
  in?: InputMaybe<Array<ProductPreferenceTypeEnum>>;
  not?: InputMaybe<NestedEnumProductPreferenceTypeEnumFilter>;
  notIn?: InputMaybe<Array<ProductPreferenceTypeEnum>>;
};

export type EnumRemovableItemOrderTypeNullableFilter = {
  equals?: InputMaybe<RemovableItemOrderType>;
  in?: InputMaybe<Array<RemovableItemOrderType>>;
  not?: InputMaybe<NestedEnumRemovableItemOrderTypeNullableFilter>;
  notIn?: InputMaybe<Array<RemovableItemOrderType>>;
};

export type EnumRetentionTypeNullableFilter = {
  equals?: InputMaybe<RetentionType>;
  in?: InputMaybe<Array<RetentionType>>;
  not?: InputMaybe<NestedEnumRetentionTypeNullableFilter>;
  notIn?: InputMaybe<Array<RetentionType>>;
};

export type EnumScannerReferenceFieldUpdateOperationsInput = {
  set?: InputMaybe<ScannerReference>;
};

export type EnumScannerReferenceFilter = {
  equals?: InputMaybe<ScannerReference>;
  in?: InputMaybe<Array<ScannerReference>>;
  not?: InputMaybe<NestedEnumScannerReferenceFilter>;
  notIn?: InputMaybe<Array<ScannerReference>>;
};

export type EnumSexNullableFilter = {
  equals?: InputMaybe<Sex>;
  in?: InputMaybe<Array<Sex>>;
  not?: InputMaybe<NestedEnumSexNullableFilter>;
  notIn?: InputMaybe<Array<Sex>>;
};

export type EnumShippingTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ShippingType>;
};

export type EnumShippingTypeFilter = {
  equals?: InputMaybe<ShippingType>;
  in?: InputMaybe<Array<ShippingType>>;
  not?: InputMaybe<NestedEnumShippingTypeFilter>;
  notIn?: InputMaybe<Array<ShippingType>>;
};

export type EnumSubscriptionFrequenceFieldUpdateOperationsInput = {
  set?: InputMaybe<SubscriptionFrequence>;
};

export type EnumSubscriptionFrequenceFilter = {
  equals?: InputMaybe<SubscriptionFrequence>;
  in?: InputMaybe<Array<SubscriptionFrequence>>;
  not?: InputMaybe<NestedEnumSubscriptionFrequenceFilter>;
  notIn?: InputMaybe<Array<SubscriptionFrequence>>;
};

export type EnumTeethShadeSideFieldUpdateOperationsInput = {
  set?: InputMaybe<TeethShadeSide>;
};

export type EnumTeethShadeSideFilter = {
  equals?: InputMaybe<TeethShadeSide>;
  in?: InputMaybe<Array<TeethShadeSide>>;
  not?: InputMaybe<NestedEnumTeethShadeSideFilter>;
  notIn?: InputMaybe<Array<TeethShadeSide>>;
};

export type EnumTeethShadeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TeethShadeType>;
};

export type EnumTeethShadeTypeFilter = {
  equals?: InputMaybe<TeethShadeType>;
  in?: InputMaybe<Array<TeethShadeType>>;
  not?: InputMaybe<NestedEnumTeethShadeTypeFilter>;
  notIn?: InputMaybe<Array<TeethShadeType>>;
};

export type EnumThreeDModelPricingTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ThreeDModelPricingType>;
};

export type EnumThreeDModelPricingTypeFilter = {
  equals?: InputMaybe<ThreeDModelPricingType>;
  in?: InputMaybe<Array<ThreeDModelPricingType>>;
  not?: InputMaybe<NestedEnumThreeDModelPricingTypeFilter>;
  notIn?: InputMaybe<Array<ThreeDModelPricingType>>;
};

export type EnumUserGroupStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<UserGroupStatus>;
};

export type EnumUserGroupStatusFilter = {
  equals?: InputMaybe<UserGroupStatus>;
  in?: InputMaybe<Array<UserGroupStatus>>;
  not?: InputMaybe<NestedEnumUserGroupStatusFilter>;
  notIn?: InputMaybe<Array<UserGroupStatus>>;
};

export type EnumUserGroupTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserGroupType>;
};

export type EnumUserGroupTypeFilter = {
  equals?: InputMaybe<UserGroupType>;
  in?: InputMaybe<Array<UserGroupType>>;
  not?: InputMaybe<NestedEnumUserGroupTypeFilter>;
  notIn?: InputMaybe<Array<UserGroupType>>;
};

export type EnumUserRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<UserRole>;
};

export type EnumUserRoleFilter = {
  equals?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  not?: InputMaybe<NestedEnumUserRoleFilter>;
  notIn?: InputMaybe<Array<UserRole>>;
};

export type EnumUserStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<UserStatus>;
};

export type EnumUserStatusFilter = {
  equals?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  not?: InputMaybe<NestedEnumUserStatusFilter>;
  notIn?: InputMaybe<Array<UserStatus>>;
};

export type EnumUserTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserType>;
};

export type EnumUserTypeFilter = {
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  not?: InputMaybe<NestedEnumUserTypeFilter>;
  notIn?: InputMaybe<Array<UserType>>;
};

export type EnumWorkflowTypeNullableFilter = {
  equals?: InputMaybe<WorkflowType>;
  in?: InputMaybe<Array<WorkflowType>>;
  not?: InputMaybe<NestedEnumWorkflowTypeNullableFilter>;
  notIn?: InputMaybe<Array<WorkflowType>>;
};

export type EnumwaxUpTypeNullableFilter = {
  equals?: InputMaybe<WaxUpType>;
  in?: InputMaybe<Array<WaxUpType>>;
  not?: InputMaybe<NestedEnumwaxUpTypeNullableFilter>;
  notIn?: InputMaybe<Array<WaxUpType>>;
};

export type EstimatedDeliveryDate = {
  __typename?: 'EstimatedDeliveryDate';
  estimatedOptimalDeliveryDate: Scalars['Timestamp']['output'];
  estimatedRushDeliveryDate: Scalars['Timestamp']['output'];
};

export type ExternalCase = {
  __typename?: 'ExternalCase';
  createdAt: Scalars['Timestamp']['output'];
  directId: Scalars['String']['output'];
  externalEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
  patientFirstName?: Maybe<Scalars['String']['output']>;
  patientLastName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ExternalCaseCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  directId: Scalars['String']['input'];
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType: IntegrationType;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalCaseCreateManyUserInputEnvelope = {
  data: Array<ExternalCaseCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalCaseCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ExternalCaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCaseCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ExternalCaseCreateWithoutUserInput>>;
  createMany?: InputMaybe<ExternalCaseCreateManyUserInputEnvelope>;
};

export type ExternalCaseCreateOrConnectWithoutUserInput = {
  create: ExternalCaseCreateWithoutUserInput;
  where: ExternalCaseWhereUniqueInput;
};

export type ExternalCaseCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  directId: Scalars['String']['input'];
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType: IntegrationType;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientLastName?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalCaseListRelationFilter = {
  every?: InputMaybe<ExternalCaseWhereInput>;
  none?: InputMaybe<ExternalCaseWhereInput>;
  some?: InputMaybe<ExternalCaseWhereInput>;
};

export type ExternalCaseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ExternalCaseScalarWhereInput = {
  AND?: InputMaybe<Array<ExternalCaseScalarWhereInput>>;
  NOT?: InputMaybe<Array<ExternalCaseScalarWhereInput>>;
  OR?: InputMaybe<Array<ExternalCaseScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  directId?: InputMaybe<StringFilter>;
  externalEmail?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  integrationType?: InputMaybe<EnumIntegrationTypeFilter>;
  patientFirstName?: InputMaybe<StringNullableFilter>;
  patientLastName?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ExternalCaseUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<EnumIntegrationTypeFieldUpdateOperationsInput>;
  patientFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  patientLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ExternalCaseUpdateManyWithWhereWithoutUserInput = {
  data: ExternalCaseUpdateManyMutationInput;
  where: ExternalCaseScalarWhereInput;
};

export type ExternalCaseUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ExternalCaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCaseCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ExternalCaseCreateWithoutUserInput>>;
  createMany?: InputMaybe<ExternalCaseCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ExternalCaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExternalCaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExternalCaseWhereUniqueInput>>;
  set?: InputMaybe<Array<ExternalCaseWhereUniqueInput>>;
  update?: InputMaybe<Array<ExternalCaseUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ExternalCaseUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ExternalCaseUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ExternalCaseUpdateWithWhereUniqueWithoutUserInput = {
  data: ExternalCaseUpdateWithoutUserInput;
  where: ExternalCaseWhereUniqueInput;
};

export type ExternalCaseUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<EnumIntegrationTypeFieldUpdateOperationsInput>;
  patientFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  patientLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ExternalCaseUpsertWithWhereUniqueWithoutUserInput = {
  create: ExternalCaseCreateWithoutUserInput;
  update: ExternalCaseUpdateWithoutUserInput;
  where: ExternalCaseWhereUniqueInput;
};

export type ExternalCaseWhereInput = {
  AND?: InputMaybe<Array<ExternalCaseWhereInput>>;
  NOT?: InputMaybe<Array<ExternalCaseWhereInput>>;
  OR?: InputMaybe<Array<ExternalCaseWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  directId?: InputMaybe<StringFilter>;
  externalEmail?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  integrationType?: InputMaybe<EnumIntegrationTypeFilter>;
  patientFirstName?: InputMaybe<StringNullableFilter>;
  patientLastName?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type ExternalCaseWhereUniqueInput = {
  AND?: InputMaybe<Array<ExternalCaseWhereInput>>;
  NOT?: InputMaybe<Array<ExternalCaseWhereInput>>;
  OR?: InputMaybe<Array<ExternalCaseWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  directId?: InputMaybe<Scalars['String']['input']>;
  externalEmail?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<EnumIntegrationTypeFilter>;
  patientFirstName?: InputMaybe<StringNullableFilter>;
  patientLastName?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type FedexDeliveryEvent = {
  __typename?: 'FedexDeliveryEvent';
  date: Scalars['String']['output'];
  eventDescription: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
};

export type File = {
  __typename?: 'File';
  _count: FileCount;
  chat?: Maybe<Chat>;
  chatId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  fileType: FileType;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  keyCompressed?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderBilling?: Maybe<Array<OrderBilling>>;
  orderComment?: Maybe<OrderComment>;
  orderCommentid?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  pickup?: Maybe<Pickup>;
  read: Scalars['Boolean']['output'];
  shipping?: Maybe<Array<Shipping>>;
  status: FileStatus;
  updatedAt: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type FileCount = {
  __typename?: 'FileCount';
  orderBilling: Scalars['Int']['output'];
  shipping: Scalars['Int']['output'];
};

export type FileCreateInput = {
  chat?: InputMaybe<ChatCreateNestedOneWithoutFilesInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutFilesInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedOneWithoutFilesInput>;
  pickup?: InputMaybe<PickupCreateNestedOneWithoutFileInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutFileInput>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateManyChatInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  orderCommentid?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyChatInputEnvelope = {
  data: Array<FileCreateManyChatInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyOrderCommentInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyOrderCommentInputEnvelope = {
  data: Array<FileCreateManyOrderCommentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyOrderInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  orderCommentid?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type FileCreateManyOrderInputEnvelope = {
  data: Array<FileCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateManyUserInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  orderCommentid?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type FileCreateManyUserInputEnvelope = {
  data: Array<FileCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCreateNestedManyWithoutChatInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutChatInput>>;
  create?: InputMaybe<Array<FileCreateWithoutChatInput>>;
  createMany?: InputMaybe<FileCreateManyChatInputEnvelope>;
};

export type FileCreateNestedManyWithoutOrderBillingInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderBillingInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderBillingInput>>;
};

export type FileCreateNestedManyWithoutOrderCommentInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderCommentInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderCommentInput>>;
  createMany?: InputMaybe<FileCreateManyOrderCommentInputEnvelope>;
};

export type FileCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderInput>>;
  createMany?: InputMaybe<FileCreateManyOrderInputEnvelope>;
};

export type FileCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserInput>>;
  createMany?: InputMaybe<FileCreateManyUserInputEnvelope>;
};

export type FileCreateNestedOneWithoutPickupInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPickupInput>;
  create?: InputMaybe<FileCreateWithoutPickupInput>;
};

export type FileCreateNestedOneWithoutShippingInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutShippingInput>;
  create?: InputMaybe<FileCreateWithoutShippingInput>;
};

export type FileCreateOrConnectWithoutChatInput = {
  create: FileCreateWithoutChatInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutOrderBillingInput = {
  create: FileCreateWithoutOrderBillingInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutOrderCommentInput = {
  create: FileCreateWithoutOrderCommentInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutOrderInput = {
  create: FileCreateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutPickupInput = {
  create: FileCreateWithoutPickupInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutShippingInput = {
  create: FileCreateWithoutShippingInput;
  where: FileWhereUniqueInput;
};

export type FileCreateOrConnectWithoutUserInput = {
  create: FileCreateWithoutUserInput;
  where: FileWhereUniqueInput;
};

export type FileCreateWithoutChatInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutFilesInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedOneWithoutFilesInput>;
  pickup?: InputMaybe<PickupCreateNestedOneWithoutFileInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutFileInput>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutOrderBillingInput = {
  chat?: InputMaybe<ChatCreateNestedOneWithoutFilesInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedOneWithoutFilesInput>;
  pickup?: InputMaybe<PickupCreateNestedOneWithoutFileInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutFileInput>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutOrderCommentInput = {
  chat?: InputMaybe<ChatCreateNestedOneWithoutFilesInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutFilesInput>;
  pickup?: InputMaybe<PickupCreateNestedOneWithoutFileInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutFileInput>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutOrderInput = {
  chat?: InputMaybe<ChatCreateNestedOneWithoutFilesInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutFilesInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedOneWithoutFilesInput>;
  pickup?: InputMaybe<PickupCreateNestedOneWithoutFileInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutFileInput>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutPickupInput = {
  chat?: InputMaybe<ChatCreateNestedOneWithoutFilesInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutFilesInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedOneWithoutFilesInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutFileInput>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutShippingInput = {
  chat?: InputMaybe<ChatCreateNestedOneWithoutFilesInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutFilesInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedOneWithoutFilesInput>;
  pickup?: InputMaybe<PickupCreateNestedOneWithoutFileInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user?: InputMaybe<UserCreateNestedOneWithoutFilesInput>;
};

export type FileCreateWithoutUserInput = {
  chat?: InputMaybe<ChatCreateNestedOneWithoutFilesInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileType?: InputMaybe<FileType>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderCreateNestedOneWithoutFilesInput>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutFilesInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedOneWithoutFilesInput>;
  pickup?: InputMaybe<PickupCreateNestedOneWithoutFileInput>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutFileInput>;
  status?: InputMaybe<FileStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type FileDetailsInput = {
  createdAt: Scalars['Float']['input'];
  fileType: FileTypeEnum;
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  keyCompressed?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileDetailsResponse = {
  __typename?: 'FileDetailsResponse';
  createdAt: Scalars['Float']['output'];
  fileType: FileTypeEnum;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  keyCompressed?: Maybe<Scalars['String']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
};

export type FileListRelationFilter = {
  every?: InputMaybe<FileWhereInput>;
  none?: InputMaybe<FileWhereInput>;
  some?: InputMaybe<FileWhereInput>;
};

export type FileNullableScalarRelationFilter = {
  is?: InputMaybe<FileWhereInput>;
  isNot?: InputMaybe<FileWhereInput>;
};

export type FileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FileOrderByWithRelationInput = {
  chat?: InputMaybe<ChatOrderByWithRelationInput>;
  chatId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  keyCompressed?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderBilling?: InputMaybe<OrderBillingOrderByRelationAggregateInput>;
  orderComment?: InputMaybe<OrderCommentOrderByWithRelationInput>;
  orderCommentid?: InputMaybe<SortOrderInput>;
  orderId?: InputMaybe<SortOrderInput>;
  pickup?: InputMaybe<PickupOrderByWithRelationInput>;
  read?: InputMaybe<SortOrder>;
  shipping?: InputMaybe<ShippingOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum FileScalarFieldEnum {
  ChatId = 'chatId',
  CreatedAt = 'createdAt',
  FileType = 'fileType',
  Id = 'id',
  Key = 'key',
  KeyCompressed = 'keyCompressed',
  OrderCommentid = 'orderCommentid',
  OrderId = 'orderId',
  Read = 'read',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type FileScalarWhereInput = {
  AND?: InputMaybe<Array<FileScalarWhereInput>>;
  NOT?: InputMaybe<Array<FileScalarWhereInput>>;
  OR?: InputMaybe<Array<FileScalarWhereInput>>;
  chatId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileType?: InputMaybe<EnumFileTypeFilter>;
  id?: InputMaybe<UuidFilter>;
  key?: InputMaybe<StringFilter>;
  keyCompressed?: InputMaybe<StringNullableFilter>;
  orderCommentid?: InputMaybe<UuidNullableFilter>;
  orderId?: InputMaybe<UuidNullableFilter>;
  read?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumFileStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export enum FileStatus {
  Draft = 'DRAFT',
  Uploaded = 'UPLOADED'
}

export enum FileType {
  BillingDentistTraceability = 'Billing_Dentist_Traceability',
  BillingPatientTraceability = 'Billing_Patient_Traceability',
  ChatFile = 'Chat_File',
  ClientFile = 'ClientFile',
  HelpFile = 'Help_File',
  LabsFile = 'LabsFile',
  OrderFile = 'OrderFile',
  OrderAddonFile = 'Order_Addon_File',
  Pickup = 'Pickup'
}

/** File type enum */
export enum FileTypeEnum {
  BillingDentistTraceability = 'Billing_Dentist_Traceability',
  BillingPatientTraceability = 'Billing_Patient_Traceability',
  ChatFile = 'Chat_File',
  ClientFile = 'ClientFile',
  HelpFile = 'Help_File',
  LabsFile = 'LabsFile',
  OrderFile = 'OrderFile',
  OrderAddonFile = 'Order_Addon_File',
  Pickup = 'Pickup'
}

export type FileUpdateInput = {
  chat?: InputMaybe<ChatUpdateOneWithoutFilesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutFilesNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateOneWithoutFilesNestedInput>;
  pickup?: InputMaybe<PickupUpdateOneWithoutFileNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutFileNestedInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FileUpdateManyWithWhereWithoutChatInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutOrderBillingInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutOrderCommentInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutOrderInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithWhereWithoutUserInput = {
  data: FileUpdateManyMutationInput;
  where: FileScalarWhereInput;
};

export type FileUpdateManyWithoutChatNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutChatInput>>;
  create?: InputMaybe<Array<FileCreateWithoutChatInput>>;
  createMany?: InputMaybe<FileCreateManyChatInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutChatInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutChatInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutChatInput>>;
};

export type FileUpdateManyWithoutOrderBillingNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderBillingInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderBillingInput>>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutOrderBillingInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutOrderBillingInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutOrderBillingInput>>;
};

export type FileUpdateManyWithoutOrderCommentNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderCommentInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderCommentInput>>;
  createMany?: InputMaybe<FileCreateManyOrderCommentInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutOrderCommentInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutOrderCommentInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutOrderCommentInput>>;
};

export type FileUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<FileCreateWithoutOrderInput>>;
  createMany?: InputMaybe<FileCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type FileUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<FileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<FileCreateWithoutUserInput>>;
  createMany?: InputMaybe<FileCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<FileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileWhereUniqueInput>>;
  set?: InputMaybe<Array<FileWhereUniqueInput>>;
  update?: InputMaybe<Array<FileUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<FileUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<FileUpsertWithWhereUniqueWithoutUserInput>>;
};

export type FileUpdateOneWithoutPickupNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutPickupInput>;
  create?: InputMaybe<FileCreateWithoutPickupInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutPickupInput>;
  upsert?: InputMaybe<FileUpsertWithoutPickupInput>;
};

export type FileUpdateOneWithoutShippingNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutShippingInput>;
  create?: InputMaybe<FileCreateWithoutShippingInput>;
  delete?: InputMaybe<FileWhereInput>;
  disconnect?: InputMaybe<FileWhereInput>;
  update?: InputMaybe<FileUpdateToOneWithWhereWithoutShippingInput>;
  upsert?: InputMaybe<FileUpsertWithoutShippingInput>;
};

export type FileUpdateToOneWithWhereWithoutPickupInput = {
  data: FileUpdateWithoutPickupInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateToOneWithWhereWithoutShippingInput = {
  data: FileUpdateWithoutShippingInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpdateWithWhereUniqueWithoutChatInput = {
  data: FileUpdateWithoutChatInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutOrderBillingInput = {
  data: FileUpdateWithoutOrderBillingInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutOrderCommentInput = {
  data: FileUpdateWithoutOrderCommentInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutOrderInput = {
  data: FileUpdateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithWhereUniqueWithoutUserInput = {
  data: FileUpdateWithoutUserInput;
  where: FileWhereUniqueInput;
};

export type FileUpdateWithoutChatInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutFilesNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateOneWithoutFilesNestedInput>;
  pickup?: InputMaybe<PickupUpdateOneWithoutFileNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutFileNestedInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutOrderBillingInput = {
  chat?: InputMaybe<ChatUpdateOneWithoutFilesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateOneWithoutFilesNestedInput>;
  pickup?: InputMaybe<PickupUpdateOneWithoutFileNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutFileNestedInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutOrderCommentInput = {
  chat?: InputMaybe<ChatUpdateOneWithoutFilesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutFilesNestedInput>;
  pickup?: InputMaybe<PickupUpdateOneWithoutFileNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutFileNestedInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutOrderInput = {
  chat?: InputMaybe<ChatUpdateOneWithoutFilesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutFilesNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateOneWithoutFilesNestedInput>;
  pickup?: InputMaybe<PickupUpdateOneWithoutFileNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutFileNestedInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutPickupInput = {
  chat?: InputMaybe<ChatUpdateOneWithoutFilesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutFilesNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateOneWithoutFilesNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutFileNestedInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutShippingInput = {
  chat?: InputMaybe<ChatUpdateOneWithoutFilesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutFilesNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateOneWithoutFilesNestedInput>;
  pickup?: InputMaybe<PickupUpdateOneWithoutFileNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutFilesNestedInput>;
};

export type FileUpdateWithoutUserInput = {
  chat?: InputMaybe<ChatUpdateOneWithoutFilesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyCompressed?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutFilesNestedInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutFilesNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateOneWithoutFilesNestedInput>;
  pickup?: InputMaybe<PickupUpdateOneWithoutFileNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutFileNestedInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FileUpsertWithWhereUniqueWithoutChatInput = {
  create: FileCreateWithoutChatInput;
  update: FileUpdateWithoutChatInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutOrderBillingInput = {
  create: FileCreateWithoutOrderBillingInput;
  update: FileUpdateWithoutOrderBillingInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutOrderCommentInput = {
  create: FileCreateWithoutOrderCommentInput;
  update: FileUpdateWithoutOrderCommentInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutOrderInput = {
  create: FileCreateWithoutOrderInput;
  update: FileUpdateWithoutOrderInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithWhereUniqueWithoutUserInput = {
  create: FileCreateWithoutUserInput;
  update: FileUpdateWithoutUserInput;
  where: FileWhereUniqueInput;
};

export type FileUpsertWithoutPickupInput = {
  create: FileCreateWithoutPickupInput;
  update: FileUpdateWithoutPickupInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileUpsertWithoutShippingInput = {
  create: FileCreateWithoutShippingInput;
  update: FileUpdateWithoutShippingInput;
  where?: InputMaybe<FileWhereInput>;
};

export type FileV2 = {
  __typename?: 'FileV2';
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  owner?: Maybe<UserV2>;
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FileWhereInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  chat?: InputMaybe<ChatNullableScalarRelationFilter>;
  chatId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileType?: InputMaybe<EnumFileTypeFilter>;
  id?: InputMaybe<UuidFilter>;
  key?: InputMaybe<StringFilter>;
  keyCompressed?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderBilling?: InputMaybe<OrderBillingListRelationFilter>;
  orderComment?: InputMaybe<OrderCommentNullableScalarRelationFilter>;
  orderCommentid?: InputMaybe<UuidNullableFilter>;
  orderId?: InputMaybe<UuidNullableFilter>;
  pickup?: InputMaybe<PickupNullableScalarRelationFilter>;
  read?: InputMaybe<BoolFilter>;
  shipping?: InputMaybe<ShippingListRelationFilter>;
  status?: InputMaybe<EnumFileStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type FileWhereUniqueInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  chat?: InputMaybe<ChatNullableScalarRelationFilter>;
  chatId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileType?: InputMaybe<EnumFileTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<StringFilter>;
  keyCompressed?: InputMaybe<StringNullableFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderBilling?: InputMaybe<OrderBillingListRelationFilter>;
  orderComment?: InputMaybe<OrderCommentNullableScalarRelationFilter>;
  orderCommentid?: InputMaybe<UuidNullableFilter>;
  orderId?: InputMaybe<UuidNullableFilter>;
  pickup?: InputMaybe<PickupNullableScalarRelationFilter>;
  read?: InputMaybe<BoolFilter>;
  shipping?: InputMaybe<ShippingListRelationFilter>;
  status?: InputMaybe<EnumFileStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type FilesInput = {
  files: Array<FileDetailsInput>;
};

export type FilesResponse = {
  __typename?: 'FilesResponse';
  files: Array<FileDetailsResponse>;
};

export type FixedProsthesisPreferences = {
  __typename?: 'FixedProsthesisPreferences';
  anteriorPosteriorPonticDesign: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  interproximalContactDesign: Scalars['String']['output'];
  itemType: ItemType;
  noOcclusalClearance: Scalars['String']['output'];
  occlusalContactTightness: Scalars['String']['output'];
  occlusalStaining: Scalars['String']['output'];
  productPreferences: ProductPreferences;
  productPreferencesId: Scalars['String']['output'];
  proximalContactTightness: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type FixedProsthesisPreferencesCreateInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  interproximalContactDesign?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  noOcclusalClearance?: InputMaybe<Scalars['String']['input']>;
  occlusalContactTightness?: InputMaybe<Scalars['String']['input']>;
  occlusalStaining?: InputMaybe<Scalars['String']['input']>;
  productPreferences: ProductPreferencesCreateNestedOneWithoutFixedProsthesisPreferencesInput;
  proximalContactTightness?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type FixedProsthesisPreferencesCreateManyProductPreferencesInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  interproximalContactDesign?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  noOcclusalClearance?: InputMaybe<Scalars['String']['input']>;
  occlusalContactTightness?: InputMaybe<Scalars['String']['input']>;
  occlusalStaining?: InputMaybe<Scalars['String']['input']>;
  proximalContactTightness?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type FixedProsthesisPreferencesCreateManyProductPreferencesInputEnvelope = {
  data: Array<FixedProsthesisPreferencesCreateManyProductPreferencesInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FixedProsthesisPreferencesCreateNestedManyWithoutProductPreferencesInput = {
  connect?: InputMaybe<Array<FixedProsthesisPreferencesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FixedProsthesisPreferencesCreateOrConnectWithoutProductPreferencesInput>>;
  create?: InputMaybe<Array<FixedProsthesisPreferencesCreateWithoutProductPreferencesInput>>;
  createMany?: InputMaybe<FixedProsthesisPreferencesCreateManyProductPreferencesInputEnvelope>;
};

export type FixedProsthesisPreferencesCreateOrConnectWithoutProductPreferencesInput = {
  create: FixedProsthesisPreferencesCreateWithoutProductPreferencesInput;
  where: FixedProsthesisPreferencesWhereUniqueInput;
};

export type FixedProsthesisPreferencesCreateWithoutProductPreferencesInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  interproximalContactDesign?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  noOcclusalClearance?: InputMaybe<Scalars['String']['input']>;
  occlusalContactTightness?: InputMaybe<Scalars['String']['input']>;
  occlusalStaining?: InputMaybe<Scalars['String']['input']>;
  proximalContactTightness?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type FixedProsthesisPreferencesListRelationFilter = {
  every?: InputMaybe<FixedProsthesisPreferencesWhereInput>;
  none?: InputMaybe<FixedProsthesisPreferencesWhereInput>;
  some?: InputMaybe<FixedProsthesisPreferencesWhereInput>;
};

export type FixedProsthesisPreferencesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FixedProsthesisPreferencesOrderByWithRelationInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  interproximalContactDesign?: InputMaybe<SortOrder>;
  itemType?: InputMaybe<SortOrder>;
  noOcclusalClearance?: InputMaybe<SortOrder>;
  occlusalContactTightness?: InputMaybe<SortOrder>;
  occlusalStaining?: InputMaybe<SortOrder>;
  productPreferences?: InputMaybe<ProductPreferencesOrderByWithRelationInput>;
  productPreferencesId?: InputMaybe<SortOrder>;
  proximalContactTightness?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FixedProsthesisPreferencesScalarFieldEnum {
  AnteriorPosteriorPonticDesign = 'anteriorPosteriorPonticDesign',
  CreatedAt = 'createdAt',
  Id = 'id',
  InterproximalContactDesign = 'interproximalContactDesign',
  ItemType = 'itemType',
  NoOcclusalClearance = 'noOcclusalClearance',
  OcclusalContactTightness = 'occlusalContactTightness',
  OcclusalStaining = 'occlusalStaining',
  ProductPreferencesId = 'productPreferencesId',
  ProximalContactTightness = 'proximalContactTightness',
  UpdatedAt = 'updatedAt'
}

export type FixedProsthesisPreferencesScalarWhereInput = {
  AND?: InputMaybe<Array<FixedProsthesisPreferencesScalarWhereInput>>;
  NOT?: InputMaybe<Array<FixedProsthesisPreferencesScalarWhereInput>>;
  OR?: InputMaybe<Array<FixedProsthesisPreferencesScalarWhereInput>>;
  anteriorPosteriorPonticDesign?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  interproximalContactDesign?: InputMaybe<StringFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  noOcclusalClearance?: InputMaybe<StringFilter>;
  occlusalContactTightness?: InputMaybe<StringFilter>;
  occlusalStaining?: InputMaybe<StringFilter>;
  productPreferencesId?: InputMaybe<UuidFilter>;
  proximalContactTightness?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FixedProsthesisPreferencesUpdateInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interproximalContactDesign?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  noOcclusalClearance?: InputMaybe<StringFieldUpdateOperationsInput>;
  occlusalContactTightness?: InputMaybe<StringFieldUpdateOperationsInput>;
  occlusalStaining?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateOneRequiredWithoutFixedProsthesisPreferencesNestedInput>;
  proximalContactTightness?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FixedProsthesisPreferencesUpdateManyMutationInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interproximalContactDesign?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  noOcclusalClearance?: InputMaybe<StringFieldUpdateOperationsInput>;
  occlusalContactTightness?: InputMaybe<StringFieldUpdateOperationsInput>;
  occlusalStaining?: InputMaybe<StringFieldUpdateOperationsInput>;
  proximalContactTightness?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FixedProsthesisPreferencesUpdateManyWithWhereWithoutProductPreferencesInput = {
  data: FixedProsthesisPreferencesUpdateManyMutationInput;
  where: FixedProsthesisPreferencesScalarWhereInput;
};

export type FixedProsthesisPreferencesUpdateManyWithoutProductPreferencesNestedInput = {
  connect?: InputMaybe<Array<FixedProsthesisPreferencesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FixedProsthesisPreferencesCreateOrConnectWithoutProductPreferencesInput>>;
  create?: InputMaybe<Array<FixedProsthesisPreferencesCreateWithoutProductPreferencesInput>>;
  createMany?: InputMaybe<FixedProsthesisPreferencesCreateManyProductPreferencesInputEnvelope>;
  delete?: InputMaybe<Array<FixedProsthesisPreferencesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FixedProsthesisPreferencesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FixedProsthesisPreferencesWhereUniqueInput>>;
  set?: InputMaybe<Array<FixedProsthesisPreferencesWhereUniqueInput>>;
  update?: InputMaybe<Array<FixedProsthesisPreferencesUpdateWithWhereUniqueWithoutProductPreferencesInput>>;
  updateMany?: InputMaybe<Array<FixedProsthesisPreferencesUpdateManyWithWhereWithoutProductPreferencesInput>>;
  upsert?: InputMaybe<Array<FixedProsthesisPreferencesUpsertWithWhereUniqueWithoutProductPreferencesInput>>;
};

export type FixedProsthesisPreferencesUpdateWithWhereUniqueWithoutProductPreferencesInput = {
  data: FixedProsthesisPreferencesUpdateWithoutProductPreferencesInput;
  where: FixedProsthesisPreferencesWhereUniqueInput;
};

export type FixedProsthesisPreferencesUpdateWithoutProductPreferencesInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interproximalContactDesign?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  noOcclusalClearance?: InputMaybe<StringFieldUpdateOperationsInput>;
  occlusalContactTightness?: InputMaybe<StringFieldUpdateOperationsInput>;
  occlusalStaining?: InputMaybe<StringFieldUpdateOperationsInput>;
  proximalContactTightness?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FixedProsthesisPreferencesUpsertWithWhereUniqueWithoutProductPreferencesInput = {
  create: FixedProsthesisPreferencesCreateWithoutProductPreferencesInput;
  update: FixedProsthesisPreferencesUpdateWithoutProductPreferencesInput;
  where: FixedProsthesisPreferencesWhereUniqueInput;
};

export type FixedProsthesisPreferencesWhereInput = {
  AND?: InputMaybe<Array<FixedProsthesisPreferencesWhereInput>>;
  NOT?: InputMaybe<Array<FixedProsthesisPreferencesWhereInput>>;
  OR?: InputMaybe<Array<FixedProsthesisPreferencesWhereInput>>;
  anteriorPosteriorPonticDesign?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  interproximalContactDesign?: InputMaybe<StringFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  noOcclusalClearance?: InputMaybe<StringFilter>;
  occlusalContactTightness?: InputMaybe<StringFilter>;
  occlusalStaining?: InputMaybe<StringFilter>;
  productPreferences?: InputMaybe<ProductPreferencesScalarRelationFilter>;
  productPreferencesId?: InputMaybe<UuidFilter>;
  proximalContactTightness?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FixedProsthesisPreferencesWhereUniqueInput = {
  AND?: InputMaybe<Array<FixedProsthesisPreferencesWhereInput>>;
  NOT?: InputMaybe<Array<FixedProsthesisPreferencesWhereInput>>;
  OR?: InputMaybe<Array<FixedProsthesisPreferencesWhereInput>>;
  anteriorPosteriorPonticDesign?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  interproximalContactDesign?: InputMaybe<StringFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  noOcclusalClearance?: InputMaybe<StringFilter>;
  occlusalContactTightness?: InputMaybe<StringFilter>;
  occlusalStaining?: InputMaybe<StringFilter>;
  productPreferences?: InputMaybe<ProductPreferencesScalarRelationFilter>;
  productPreferencesId?: InputMaybe<UuidFilter>;
  proximalContactTightness?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Get_Analytics_Dto = {
  __typename?: 'GET_ANALYTICS_DTO';
  orderByMonth: Array<OrderByMonth>;
  orderByWeek: Array<OrderByWeek>;
};

export type GetPickupsDto = {
  __typename?: 'GetPickupsDTO';
  data: Array<Pickup>;
  totalCount: Scalars['Float']['output'];
};

export type HelpMessageInput = {
  onlyUnreadMessage?: InputMaybe<Scalars['Boolean']['input']>;
  searchInput: Scalars['String']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type HelpMessageResponse = {
  __typename?: 'HelpMessageResponse';
  count: Scalars['Int']['output'];
  notification: Array<OrderComment>;
};

export type ImplantCharacteristics = ReferencedImplantCharacteristicsModel | UnreferencedImplantCharacteristicsModel;

export type ImplantItem = {
  __typename?: 'ImplantItem';
  _count: ImplantItemCount;
  abutmentMaterial?: Maybe<ItemMaterial>;
  abutmentMaterialId?: Maybe<Scalars['String']['output']>;
  abutmentType?: Maybe<AbutmentType>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  implantPlatform?: Maybe<Scalars['String']['output']>;
  implantReference?: Maybe<ImplantReference>;
  implantReferenceId?: Maybe<Scalars['String']['output']>;
  implantReferenceSuggestion?: Maybe<Scalars['String']['output']>;
  itemBilling?: Maybe<Array<ItemBilling>>;
  itemMaterial?: Maybe<ItemMaterial>;
  itemMaterialId?: Maybe<Scalars['String']['output']>;
  itemShade?: Maybe<ItemShade>;
  itemShadeId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<ItemType>;
  multiShadeInfo?: Maybe<Array<MultiShadeInfo>>;
  product: Product;
  productId: Scalars['String']['output'];
  retentionType?: Maybe<RetentionType>;
  scanBodySuggestion?: Maybe<Scalars['String']['output']>;
  standardAbutmentSuggestion?: Maybe<Scalars['String']['output']>;
  teeth?: Maybe<Scalars['JSON']['output']>;
  teethshadeType: TeethShadeType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ImplantItemCount = {
  __typename?: 'ImplantItemCount';
  itemBilling: Scalars['Int']['output'];
  multiShadeInfo: Scalars['Int']['output'];
};

export type ImplantItemCreateInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReference?: InputMaybe<ImplantReferenceCreateNestedOneWithoutImplantItemInput>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutImplantItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutImplantItemInput>;
  product: ProductCreateNestedOneWithoutImplantItemInput;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateManyAbutmentMaterialInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReferenceId?: InputMaybe<Scalars['String']['input']>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemShadeId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  productId: Scalars['String']['input'];
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateManyAbutmentMaterialInputEnvelope = {
  data: Array<ImplantItemCreateManyAbutmentMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImplantItemCreateManyImplantReferenceInput = {
  abutmentMaterialId?: InputMaybe<Scalars['String']['input']>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemShadeId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  productId: Scalars['String']['input'];
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateManyImplantReferenceInputEnvelope = {
  data: Array<ImplantItemCreateManyImplantReferenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImplantItemCreateManyItemMaterialInput = {
  abutmentMaterialId?: InputMaybe<Scalars['String']['input']>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReferenceId?: InputMaybe<Scalars['String']['input']>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemShadeId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  productId: Scalars['String']['input'];
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateManyItemMaterialInputEnvelope = {
  data: Array<ImplantItemCreateManyItemMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImplantItemCreateManyItemShadeInput = {
  abutmentMaterialId?: InputMaybe<Scalars['String']['input']>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReferenceId?: InputMaybe<Scalars['String']['input']>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  productId: Scalars['String']['input'];
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateManyItemShadeInputEnvelope = {
  data: Array<ImplantItemCreateManyItemShadeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImplantItemCreateManyProductInput = {
  abutmentMaterialId?: InputMaybe<Scalars['String']['input']>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReferenceId?: InputMaybe<Scalars['String']['input']>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemShadeId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateManyProductInputEnvelope = {
  data: Array<ImplantItemCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImplantItemCreateNestedManyWithoutAbutmentMaterialInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutAbutmentMaterialInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutAbutmentMaterialInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyAbutmentMaterialInputEnvelope>;
};

export type ImplantItemCreateNestedManyWithoutImplantReferenceInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutImplantReferenceInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutImplantReferenceInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyImplantReferenceInputEnvelope>;
};

export type ImplantItemCreateNestedManyWithoutItemMaterialInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyItemMaterialInputEnvelope>;
};

export type ImplantItemCreateNestedManyWithoutItemShadeInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutItemShadeInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutItemShadeInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyItemShadeInputEnvelope>;
};

export type ImplantItemCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyProductInputEnvelope>;
};

export type ImplantItemCreateNestedOneWithoutItemBillingInput = {
  connect?: InputMaybe<ImplantItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImplantItemCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<ImplantItemCreateWithoutItemBillingInput>;
};

export type ImplantItemCreateNestedOneWithoutMultiShadeInfoInput = {
  connect?: InputMaybe<ImplantItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImplantItemCreateOrConnectWithoutMultiShadeInfoInput>;
  create?: InputMaybe<ImplantItemCreateWithoutMultiShadeInfoInput>;
};

export type ImplantItemCreateOrConnectWithoutAbutmentMaterialInput = {
  create: ImplantItemCreateWithoutAbutmentMaterialInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemCreateOrConnectWithoutImplantReferenceInput = {
  create: ImplantItemCreateWithoutImplantReferenceInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemCreateOrConnectWithoutItemBillingInput = {
  create: ImplantItemCreateWithoutItemBillingInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemCreateOrConnectWithoutItemMaterialInput = {
  create: ImplantItemCreateWithoutItemMaterialInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemCreateOrConnectWithoutItemShadeInput = {
  create: ImplantItemCreateWithoutItemShadeInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemCreateOrConnectWithoutMultiShadeInfoInput = {
  create: ImplantItemCreateWithoutMultiShadeInfoInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemCreateOrConnectWithoutProductInput = {
  create: ImplantItemCreateWithoutProductInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemCreateWithoutAbutmentMaterialInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReference?: InputMaybe<ImplantReferenceCreateNestedOneWithoutImplantItemInput>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutImplantItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutImplantItemInput>;
  product: ProductCreateNestedOneWithoutImplantItemInput;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateWithoutImplantReferenceInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutImplantItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutImplantItemInput>;
  product: ProductCreateNestedOneWithoutImplantItemInput;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateWithoutItemBillingInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReference?: InputMaybe<ImplantReferenceCreateNestedOneWithoutImplantItemInput>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutImplantItemInput>;
  product: ProductCreateNestedOneWithoutImplantItemInput;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateWithoutItemMaterialInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReference?: InputMaybe<ImplantReferenceCreateNestedOneWithoutImplantItemInput>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutImplantItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutImplantItemInput>;
  product: ProductCreateNestedOneWithoutImplantItemInput;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateWithoutItemShadeInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReference?: InputMaybe<ImplantReferenceCreateNestedOneWithoutImplantItemInput>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutImplantItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutImplantItemInput>;
  product: ProductCreateNestedOneWithoutImplantItemInput;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateWithoutMultiShadeInfoInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReference?: InputMaybe<ImplantReferenceCreateNestedOneWithoutImplantItemInput>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutImplantItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  product: ProductCreateNestedOneWithoutImplantItemInput;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemCreateWithoutProductInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput>;
  abutmentType?: InputMaybe<AbutmentType>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<Scalars['String']['input']>;
  implantReference?: InputMaybe<ImplantReferenceCreateNestedOneWithoutImplantItemInput>;
  implantReferenceSuggestion?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutImplantItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutImplantItemInput>;
  itemShade?: InputMaybe<ItemShadeCreateNestedOneWithoutImplantItemInput>;
  itemType?: InputMaybe<ItemType>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutImplantItemInput>;
  retentionType?: InputMaybe<RetentionType>;
  scanBodySuggestion?: InputMaybe<Scalars['String']['input']>;
  standardAbutmentSuggestion?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<TeethShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantItemListRelationFilter = {
  every?: InputMaybe<ImplantItemWhereInput>;
  none?: InputMaybe<ImplantItemWhereInput>;
  some?: InputMaybe<ImplantItemWhereInput>;
};

export type ImplantItemNullableScalarRelationFilter = {
  is?: InputMaybe<ImplantItemWhereInput>;
  isNot?: InputMaybe<ImplantItemWhereInput>;
};

export type ImplantItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ImplantItemOrderByWithRelationInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialOrderByWithRelationInput>;
  abutmentMaterialId?: InputMaybe<SortOrderInput>;
  abutmentType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  implantPlatform?: InputMaybe<SortOrderInput>;
  implantReference?: InputMaybe<ImplantReferenceOrderByWithRelationInput>;
  implantReferenceId?: InputMaybe<SortOrderInput>;
  implantReferenceSuggestion?: InputMaybe<SortOrderInput>;
  itemBilling?: InputMaybe<ItemBillingOrderByRelationAggregateInput>;
  itemMaterial?: InputMaybe<ItemMaterialOrderByWithRelationInput>;
  itemMaterialId?: InputMaybe<SortOrderInput>;
  itemShade?: InputMaybe<ItemShadeOrderByWithRelationInput>;
  itemShadeId?: InputMaybe<SortOrderInput>;
  itemType?: InputMaybe<SortOrderInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoOrderByRelationAggregateInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  retentionType?: InputMaybe<SortOrderInput>;
  scanBodySuggestion?: InputMaybe<SortOrderInput>;
  standardAbutmentSuggestion?: InputMaybe<SortOrderInput>;
  teeth?: InputMaybe<SortOrderInput>;
  teethshadeType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ImplantItemScalarFieldEnum {
  AbutmentMaterialId = 'abutmentMaterialId',
  AbutmentType = 'abutmentType',
  CreatedAt = 'createdAt',
  Id = 'id',
  ImplantPlatform = 'implantPlatform',
  ImplantReferenceId = 'implantReferenceId',
  ImplantReferenceSuggestion = 'implantReferenceSuggestion',
  ItemMaterialId = 'itemMaterialId',
  ItemShadeId = 'itemShadeId',
  ItemType = 'itemType',
  ProductId = 'productId',
  RetentionType = 'retentionType',
  ScanBodySuggestion = 'scanBodySuggestion',
  StandardAbutmentSuggestion = 'standardAbutmentSuggestion',
  Teeth = 'teeth',
  TeethshadeType = 'teethshadeType',
  UpdatedAt = 'updatedAt'
}

export type ImplantItemScalarWhereInput = {
  AND?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  OR?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  abutmentMaterialId?: InputMaybe<StringNullableFilter>;
  abutmentType?: InputMaybe<EnumAbutmentTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  implantPlatform?: InputMaybe<StringNullableFilter>;
  implantReferenceId?: InputMaybe<StringNullableFilter>;
  implantReferenceSuggestion?: InputMaybe<StringNullableFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemShadeId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  productId?: InputMaybe<UuidFilter>;
  retentionType?: InputMaybe<EnumRetentionTypeNullableFilter>;
  scanBodySuggestion?: InputMaybe<StringNullableFilter>;
  standardAbutmentSuggestion?: InputMaybe<StringNullableFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ImplantItemUpdateInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput>;
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReference?: InputMaybe<ImplantReferenceUpdateOneWithoutImplantItemNestedInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutImplantItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutImplantItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateManyMutationInput = {
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateManyWithWhereWithoutAbutmentMaterialInput = {
  data: ImplantItemUpdateManyMutationInput;
  where: ImplantItemScalarWhereInput;
};

export type ImplantItemUpdateManyWithWhereWithoutImplantReferenceInput = {
  data: ImplantItemUpdateManyMutationInput;
  where: ImplantItemScalarWhereInput;
};

export type ImplantItemUpdateManyWithWhereWithoutItemMaterialInput = {
  data: ImplantItemUpdateManyMutationInput;
  where: ImplantItemScalarWhereInput;
};

export type ImplantItemUpdateManyWithWhereWithoutItemShadeInput = {
  data: ImplantItemUpdateManyMutationInput;
  where: ImplantItemScalarWhereInput;
};

export type ImplantItemUpdateManyWithWhereWithoutProductInput = {
  data: ImplantItemUpdateManyMutationInput;
  where: ImplantItemScalarWhereInput;
};

export type ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutAbutmentMaterialInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutAbutmentMaterialInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyAbutmentMaterialInputEnvelope>;
  delete?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ImplantItemUpdateWithWhereUniqueWithoutAbutmentMaterialInput>>;
  updateMany?: InputMaybe<Array<ImplantItemUpdateManyWithWhereWithoutAbutmentMaterialInput>>;
  upsert?: InputMaybe<Array<ImplantItemUpsertWithWhereUniqueWithoutAbutmentMaterialInput>>;
};

export type ImplantItemUpdateManyWithoutImplantReferenceNestedInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutImplantReferenceInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutImplantReferenceInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyImplantReferenceInputEnvelope>;
  delete?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ImplantItemUpdateWithWhereUniqueWithoutImplantReferenceInput>>;
  updateMany?: InputMaybe<Array<ImplantItemUpdateManyWithWhereWithoutImplantReferenceInput>>;
  upsert?: InputMaybe<Array<ImplantItemUpsertWithWhereUniqueWithoutImplantReferenceInput>>;
};

export type ImplantItemUpdateManyWithoutItemMaterialNestedInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyItemMaterialInputEnvelope>;
  delete?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ImplantItemUpdateWithWhereUniqueWithoutItemMaterialInput>>;
  updateMany?: InputMaybe<Array<ImplantItemUpdateManyWithWhereWithoutItemMaterialInput>>;
  upsert?: InputMaybe<Array<ImplantItemUpsertWithWhereUniqueWithoutItemMaterialInput>>;
};

export type ImplantItemUpdateManyWithoutItemShadeNestedInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutItemShadeInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutItemShadeInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyItemShadeInputEnvelope>;
  delete?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ImplantItemUpdateWithWhereUniqueWithoutItemShadeInput>>;
  updateMany?: InputMaybe<Array<ImplantItemUpdateManyWithWhereWithoutItemShadeInput>>;
  upsert?: InputMaybe<Array<ImplantItemUpsertWithWhereUniqueWithoutItemShadeInput>>;
};

export type ImplantItemUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImplantItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ImplantItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<ImplantItemCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ImplantItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ImplantItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ImplantItemUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ImplantItemUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ImplantItemUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ImplantItemUpdateOneWithoutItemBillingNestedInput = {
  connect?: InputMaybe<ImplantItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImplantItemCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<ImplantItemCreateWithoutItemBillingInput>;
  delete?: InputMaybe<ImplantItemWhereInput>;
  disconnect?: InputMaybe<ImplantItemWhereInput>;
  update?: InputMaybe<ImplantItemUpdateToOneWithWhereWithoutItemBillingInput>;
  upsert?: InputMaybe<ImplantItemUpsertWithoutItemBillingInput>;
};

export type ImplantItemUpdateOneWithoutMultiShadeInfoNestedInput = {
  connect?: InputMaybe<ImplantItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImplantItemCreateOrConnectWithoutMultiShadeInfoInput>;
  create?: InputMaybe<ImplantItemCreateWithoutMultiShadeInfoInput>;
  delete?: InputMaybe<ImplantItemWhereInput>;
  disconnect?: InputMaybe<ImplantItemWhereInput>;
  update?: InputMaybe<ImplantItemUpdateToOneWithWhereWithoutMultiShadeInfoInput>;
  upsert?: InputMaybe<ImplantItemUpsertWithoutMultiShadeInfoInput>;
};

export type ImplantItemUpdateToOneWithWhereWithoutItemBillingInput = {
  data: ImplantItemUpdateWithoutItemBillingInput;
  where?: InputMaybe<ImplantItemWhereInput>;
};

export type ImplantItemUpdateToOneWithWhereWithoutMultiShadeInfoInput = {
  data: ImplantItemUpdateWithoutMultiShadeInfoInput;
  where?: InputMaybe<ImplantItemWhereInput>;
};

export type ImplantItemUpdateWithWhereUniqueWithoutAbutmentMaterialInput = {
  data: ImplantItemUpdateWithoutAbutmentMaterialInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpdateWithWhereUniqueWithoutImplantReferenceInput = {
  data: ImplantItemUpdateWithoutImplantReferenceInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpdateWithWhereUniqueWithoutItemMaterialInput = {
  data: ImplantItemUpdateWithoutItemMaterialInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpdateWithWhereUniqueWithoutItemShadeInput = {
  data: ImplantItemUpdateWithoutItemShadeInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpdateWithWhereUniqueWithoutProductInput = {
  data: ImplantItemUpdateWithoutProductInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpdateWithoutAbutmentMaterialInput = {
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReference?: InputMaybe<ImplantReferenceUpdateOneWithoutImplantItemNestedInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutImplantItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutImplantItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateWithoutImplantReferenceInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput>;
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutImplantItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutImplantItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateWithoutItemBillingInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput>;
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReference?: InputMaybe<ImplantReferenceUpdateOneWithoutImplantItemNestedInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutImplantItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateWithoutItemMaterialInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput>;
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReference?: InputMaybe<ImplantReferenceUpdateOneWithoutImplantItemNestedInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutImplantItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutImplantItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateWithoutItemShadeInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput>;
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReference?: InputMaybe<ImplantReferenceUpdateOneWithoutImplantItemNestedInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutImplantItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutImplantItemNestedInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateWithoutMultiShadeInfoInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput>;
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReference?: InputMaybe<ImplantReferenceUpdateOneWithoutImplantItemNestedInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutImplantItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpdateWithoutProductInput = {
  abutmentMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput>;
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantPlatform?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  implantReference?: InputMaybe<ImplantReferenceUpdateOneWithoutImplantItemNestedInput>;
  implantReferenceSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutImplantItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutImplantItemNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneWithoutImplantItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutImplantItemNestedInput>;
  retentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  scanBodySuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  standardAbutmentSuggestion?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantItemUpsertWithWhereUniqueWithoutAbutmentMaterialInput = {
  create: ImplantItemCreateWithoutAbutmentMaterialInput;
  update: ImplantItemUpdateWithoutAbutmentMaterialInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpsertWithWhereUniqueWithoutImplantReferenceInput = {
  create: ImplantItemCreateWithoutImplantReferenceInput;
  update: ImplantItemUpdateWithoutImplantReferenceInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpsertWithWhereUniqueWithoutItemMaterialInput = {
  create: ImplantItemCreateWithoutItemMaterialInput;
  update: ImplantItemUpdateWithoutItemMaterialInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpsertWithWhereUniqueWithoutItemShadeInput = {
  create: ImplantItemCreateWithoutItemShadeInput;
  update: ImplantItemUpdateWithoutItemShadeInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpsertWithWhereUniqueWithoutProductInput = {
  create: ImplantItemCreateWithoutProductInput;
  update: ImplantItemUpdateWithoutProductInput;
  where: ImplantItemWhereUniqueInput;
};

export type ImplantItemUpsertWithoutItemBillingInput = {
  create: ImplantItemCreateWithoutItemBillingInput;
  update: ImplantItemUpdateWithoutItemBillingInput;
  where?: InputMaybe<ImplantItemWhereInput>;
};

export type ImplantItemUpsertWithoutMultiShadeInfoInput = {
  create: ImplantItemCreateWithoutMultiShadeInfoInput;
  update: ImplantItemUpdateWithoutMultiShadeInfoInput;
  where?: InputMaybe<ImplantItemWhereInput>;
};

export type ImplantItemWhereInput = {
  AND?: InputMaybe<Array<ImplantItemWhereInput>>;
  NOT?: InputMaybe<Array<ImplantItemWhereInput>>;
  OR?: InputMaybe<Array<ImplantItemWhereInput>>;
  abutmentMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  abutmentMaterialId?: InputMaybe<StringNullableFilter>;
  abutmentType?: InputMaybe<EnumAbutmentTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  implantPlatform?: InputMaybe<StringNullableFilter>;
  implantReference?: InputMaybe<ImplantReferenceNullableScalarRelationFilter>;
  implantReferenceId?: InputMaybe<StringNullableFilter>;
  implantReferenceSuggestion?: InputMaybe<StringNullableFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  itemShadeId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoListRelationFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<UuidFilter>;
  retentionType?: InputMaybe<EnumRetentionTypeNullableFilter>;
  scanBodySuggestion?: InputMaybe<StringNullableFilter>;
  standardAbutmentSuggestion?: InputMaybe<StringNullableFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ImplantItemWhereUniqueInput = {
  AND?: InputMaybe<Array<ImplantItemWhereInput>>;
  NOT?: InputMaybe<Array<ImplantItemWhereInput>>;
  OR?: InputMaybe<Array<ImplantItemWhereInput>>;
  abutmentMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  abutmentMaterialId?: InputMaybe<StringNullableFilter>;
  abutmentType?: InputMaybe<EnumAbutmentTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantPlatform?: InputMaybe<StringNullableFilter>;
  implantReference?: InputMaybe<ImplantReferenceNullableScalarRelationFilter>;
  implantReferenceId?: InputMaybe<StringNullableFilter>;
  implantReferenceSuggestion?: InputMaybe<StringNullableFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  itemShadeId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoListRelationFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<UuidFilter>;
  retentionType?: InputMaybe<EnumRetentionTypeNullableFilter>;
  scanBodySuggestion?: InputMaybe<StringNullableFilter>;
  standardAbutmentSuggestion?: InputMaybe<StringNullableFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethshadeType?: InputMaybe<EnumTeethShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ImplantReference = {
  __typename?: 'ImplantReference';
  _count: ImplantReferenceCount;
  brand: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  implantItem?: Maybe<Array<ImplantItem>>;
  label: Scalars['String']['output'];
  platforms?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ImplantReferenceCount = {
  __typename?: 'ImplantReferenceCount';
  implantItem: Scalars['Int']['output'];
};

export type ImplantReferenceCreateInput = {
  brand: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id: Scalars['String']['input'];
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutImplantReferenceInput>;
  label: Scalars['String']['input'];
  platforms?: InputMaybe<ImplantReferenceCreateplatformsInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantReferenceCreateNestedOneWithoutImplantItemInput = {
  connect?: InputMaybe<ImplantReferenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImplantReferenceCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ImplantReferenceCreateWithoutImplantItemInput>;
};

export type ImplantReferenceCreateOrConnectWithoutImplantItemInput = {
  create: ImplantReferenceCreateWithoutImplantItemInput;
  where: ImplantReferenceWhereUniqueInput;
};

export type ImplantReferenceCreateWithoutImplantItemInput = {
  brand: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  platforms?: InputMaybe<ImplantReferenceCreateplatformsInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ImplantReferenceCreateplatformsInput = {
  set: Array<Scalars['String']['input']>;
};

export type ImplantReferenceNullableScalarRelationFilter = {
  is?: InputMaybe<ImplantReferenceWhereInput>;
  isNot?: InputMaybe<ImplantReferenceWhereInput>;
};

export type ImplantReferenceOrderByWithRelationInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  implantItem?: InputMaybe<ImplantItemOrderByRelationAggregateInput>;
  label?: InputMaybe<SortOrder>;
  platforms?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ImplantReferenceUpdateInput = {
  brand?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutImplantReferenceNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  platforms?: InputMaybe<ImplantReferenceUpdateplatformsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantReferenceUpdateOneWithoutImplantItemNestedInput = {
  connect?: InputMaybe<ImplantReferenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImplantReferenceCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ImplantReferenceCreateWithoutImplantItemInput>;
  delete?: InputMaybe<ImplantReferenceWhereInput>;
  disconnect?: InputMaybe<ImplantReferenceWhereInput>;
  update?: InputMaybe<ImplantReferenceUpdateToOneWithWhereWithoutImplantItemInput>;
  upsert?: InputMaybe<ImplantReferenceUpsertWithoutImplantItemInput>;
};

export type ImplantReferenceUpdateToOneWithWhereWithoutImplantItemInput = {
  data: ImplantReferenceUpdateWithoutImplantItemInput;
  where?: InputMaybe<ImplantReferenceWhereInput>;
};

export type ImplantReferenceUpdateWithoutImplantItemInput = {
  brand?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  platforms?: InputMaybe<ImplantReferenceUpdateplatformsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ImplantReferenceUpdateplatformsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImplantReferenceUpsertWithoutImplantItemInput = {
  create: ImplantReferenceCreateWithoutImplantItemInput;
  update: ImplantReferenceUpdateWithoutImplantItemInput;
  where?: InputMaybe<ImplantReferenceWhereInput>;
};

export type ImplantReferenceV2 = {
  __typename?: 'ImplantReferenceV2';
  brand: Scalars['String']['output'];
  id: Scalars['String']['output'];
  platforms: Array<Scalars['String']['output']>;
  referenceName: Scalars['String']['output'];
};

export type ImplantReferenceWhereInput = {
  AND?: InputMaybe<Array<ImplantReferenceWhereInput>>;
  NOT?: InputMaybe<Array<ImplantReferenceWhereInput>>;
  OR?: InputMaybe<Array<ImplantReferenceWhereInput>>;
  brand?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  label?: InputMaybe<StringFilter>;
  platforms?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ImplantReferenceWhereUniqueInput = {
  AND?: InputMaybe<Array<ImplantReferenceWhereInput>>;
  NOT?: InputMaybe<Array<ImplantReferenceWhereInput>>;
  OR?: InputMaybe<Array<ImplantReferenceWhereInput>>;
  brand?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  label?: InputMaybe<StringFilter>;
  platforms?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ImplantedItemCharacteristicsModel = {
  __typename?: 'ImplantedItemCharacteristicsModel';
  retentionType: RetentionTypeV2;
};

export enum ImprintType {
  EdentulousArchRdv1 = 'EDENTULOUS_ARCH_RDV1',
  PreExistingDentureRdv1 = 'PRE_EXISTING_DENTURE_RDV1',
  TryInRdv2 = 'TRY_IN_RDV2',
  WaxBiteRdv2 = 'WAX_BITE_RDV2'
}

export type InlayCoreCharacteristicsModel = {
  __typename?: 'InlayCoreCharacteristicsModel';
  hasClavette: Scalars['Boolean']['output'];
  scanPost: Scalars['String']['output'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Int']['input']>>;
  has?: InputMaybe<Scalars['Int']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['Int']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IntegrationType {
  Dscore = 'DSCORE',
  Meditlink = 'MEDITLINK',
  Shining3D = 'SHINING3D',
  Threeshape = 'THREESHAPE'
}

export enum InterproximalContactDesignV2 {
  NormalContactPoint = 'NORMAL_CONTACT_POINT',
  WideContactSurface = 'WIDE_CONTACT_SURFACE'
}

export type ItemBilling = {
  __typename?: 'ItemBilling';
  anatomyItem?: Maybe<AnatomyItem>;
  anatomyItemId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  discount: Scalars['Decimal']['output'];
  firstMaterialApprovalReference?: Maybe<Scalars['String']['output']>;
  firstMaterialBrand?: Maybe<Scalars['String']['output']>;
  firstMaterialCountry?: Maybe<Scalars['String']['output']>;
  firstMaterialLotNumber?: Maybe<Scalars['String']['output']>;
  firstMaterialReference?: Maybe<Scalars['String']['output']>;
  firstMaterialTraceability?: Maybe<MaterialTraceability>;
  firstMaterialTraceabilityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  implantItem?: Maybe<ImplantItem>;
  implantItemId?: Maybe<Scalars['String']['output']>;
  itemPriceReference?: Maybe<ItemPrice>;
  itemPriceReferenceId?: Maybe<Scalars['String']['output']>;
  matchingKey?: Maybe<Scalars['String']['output']>;
  orderBilling: OrderBilling;
  orderBillingId: Scalars['String']['output'];
  priceExcludingTaxes: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  removableItem?: Maybe<RemovableItem>;
  removableItemAdditionalArchInfo?: Maybe<Arch>;
  removableItemId?: Maybe<Scalars['String']['output']>;
  secondMaterialApprovalReference?: Maybe<Scalars['String']['output']>;
  secondMaterialBrand?: Maybe<Scalars['String']['output']>;
  secondMaterialCountry?: Maybe<Scalars['String']['output']>;
  secondMaterialLotNumber?: Maybe<Scalars['String']['output']>;
  secondMaterialReference?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Decimal']['output'];
  totalVat: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
  unitVat: Scalars['Decimal']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ItemBillingCreateInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutItemBillingInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedOneWithoutItemBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutItemBillingInput>;
  itemPriceReference?: InputMaybe<ItemPriceCreateNestedOneWithoutItemBillingInput>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBilling: OrderBillingCreateNestedOneWithoutItemBillingInput;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItem?: InputMaybe<RemovableItemCreateNestedOneWithoutItemBillingInput>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateManyAnatomyItemInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceabilityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItemId?: InputMaybe<Scalars['String']['input']>;
  itemPriceReferenceId?: InputMaybe<Scalars['String']['input']>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBillingId: Scalars['String']['input'];
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  removableItemId?: InputMaybe<Scalars['String']['input']>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateManyAnatomyItemInputEnvelope = {
  data: Array<ItemBillingCreateManyAnatomyItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemBillingCreateManyFirstMaterialTraceabilityInput = {
  anatomyItemId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItemId?: InputMaybe<Scalars['String']['input']>;
  itemPriceReferenceId?: InputMaybe<Scalars['String']['input']>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBillingId: Scalars['String']['input'];
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  removableItemId?: InputMaybe<Scalars['String']['input']>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateManyFirstMaterialTraceabilityInputEnvelope = {
  data: Array<ItemBillingCreateManyFirstMaterialTraceabilityInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemBillingCreateManyImplantItemInput = {
  anatomyItemId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceabilityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemPriceReferenceId?: InputMaybe<Scalars['String']['input']>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBillingId: Scalars['String']['input'];
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  removableItemId?: InputMaybe<Scalars['String']['input']>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateManyImplantItemInputEnvelope = {
  data: Array<ItemBillingCreateManyImplantItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemBillingCreateManyItemPriceReferenceInput = {
  anatomyItemId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceabilityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItemId?: InputMaybe<Scalars['String']['input']>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBillingId: Scalars['String']['input'];
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  removableItemId?: InputMaybe<Scalars['String']['input']>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateManyItemPriceReferenceInputEnvelope = {
  data: Array<ItemBillingCreateManyItemPriceReferenceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemBillingCreateManyOrderBillingInput = {
  anatomyItemId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceabilityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItemId?: InputMaybe<Scalars['String']['input']>;
  itemPriceReferenceId?: InputMaybe<Scalars['String']['input']>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  removableItemId?: InputMaybe<Scalars['String']['input']>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateManyOrderBillingInputEnvelope = {
  data: Array<ItemBillingCreateManyOrderBillingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemBillingCreateManyRemovableItemInput = {
  anatomyItemId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceabilityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItemId?: InputMaybe<Scalars['String']['input']>;
  itemPriceReferenceId?: InputMaybe<Scalars['String']['input']>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBillingId: Scalars['String']['input'];
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateManyRemovableItemInputEnvelope = {
  data: Array<ItemBillingCreateManyRemovableItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemBillingCreateNestedManyWithoutAnatomyItemInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutAnatomyItemInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutAnatomyItemInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyAnatomyItemInputEnvelope>;
};

export type ItemBillingCreateNestedManyWithoutFirstMaterialTraceabilityInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutFirstMaterialTraceabilityInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutFirstMaterialTraceabilityInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyFirstMaterialTraceabilityInputEnvelope>;
};

export type ItemBillingCreateNestedManyWithoutImplantItemInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutImplantItemInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutImplantItemInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyImplantItemInputEnvelope>;
};

export type ItemBillingCreateNestedManyWithoutItemPriceReferenceInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutItemPriceReferenceInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutItemPriceReferenceInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyItemPriceReferenceInputEnvelope>;
};

export type ItemBillingCreateNestedManyWithoutOrderBillingInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutOrderBillingInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutOrderBillingInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyOrderBillingInputEnvelope>;
};

export type ItemBillingCreateNestedManyWithoutRemovableItemInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutRemovableItemInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutRemovableItemInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyRemovableItemInputEnvelope>;
};

export type ItemBillingCreateOrConnectWithoutAnatomyItemInput = {
  create: ItemBillingCreateWithoutAnatomyItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingCreateOrConnectWithoutFirstMaterialTraceabilityInput = {
  create: ItemBillingCreateWithoutFirstMaterialTraceabilityInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingCreateOrConnectWithoutImplantItemInput = {
  create: ItemBillingCreateWithoutImplantItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingCreateOrConnectWithoutItemPriceReferenceInput = {
  create: ItemBillingCreateWithoutItemPriceReferenceInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingCreateOrConnectWithoutOrderBillingInput = {
  create: ItemBillingCreateWithoutOrderBillingInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingCreateOrConnectWithoutRemovableItemInput = {
  create: ItemBillingCreateWithoutRemovableItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingCreateWithoutAnatomyItemInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedOneWithoutItemBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutItemBillingInput>;
  itemPriceReference?: InputMaybe<ItemPriceCreateNestedOneWithoutItemBillingInput>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBilling: OrderBillingCreateNestedOneWithoutItemBillingInput;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItem?: InputMaybe<RemovableItemCreateNestedOneWithoutItemBillingInput>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateWithoutFirstMaterialTraceabilityInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutItemBillingInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutItemBillingInput>;
  itemPriceReference?: InputMaybe<ItemPriceCreateNestedOneWithoutItemBillingInput>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBilling: OrderBillingCreateNestedOneWithoutItemBillingInput;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItem?: InputMaybe<RemovableItemCreateNestedOneWithoutItemBillingInput>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutItemBillingInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedOneWithoutItemBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemPriceReference?: InputMaybe<ItemPriceCreateNestedOneWithoutItemBillingInput>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBilling: OrderBillingCreateNestedOneWithoutItemBillingInput;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItem?: InputMaybe<RemovableItemCreateNestedOneWithoutItemBillingInput>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateWithoutItemPriceReferenceInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutItemBillingInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedOneWithoutItemBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutItemBillingInput>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBilling: OrderBillingCreateNestedOneWithoutItemBillingInput;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItem?: InputMaybe<RemovableItemCreateNestedOneWithoutItemBillingInput>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateWithoutOrderBillingInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutItemBillingInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedOneWithoutItemBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutItemBillingInput>;
  itemPriceReference?: InputMaybe<ItemPriceCreateNestedOneWithoutItemBillingInput>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItem?: InputMaybe<RemovableItemCreateNestedOneWithoutItemBillingInput>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingCreateWithoutRemovableItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutItemBillingInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedOneWithoutItemBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutItemBillingInput>;
  itemPriceReference?: InputMaybe<ItemPriceCreateNestedOneWithoutItemBillingInput>;
  matchingKey?: InputMaybe<Scalars['String']['input']>;
  orderBilling: OrderBillingCreateNestedOneWithoutItemBillingInput;
  priceExcludingTaxes?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Decimal']['input']>;
  removableItemAdditionalArchInfo?: InputMaybe<Arch>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialLotNumber?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitVat?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemBillingListRelationFilter = {
  every?: InputMaybe<ItemBillingWhereInput>;
  none?: InputMaybe<ItemBillingWhereInput>;
  some?: InputMaybe<ItemBillingWhereInput>;
};

export type ItemBillingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ItemBillingScalarWhereInput = {
  AND?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  NOT?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  OR?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  anatomyItemId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discount?: InputMaybe<DecimalFilter>;
  firstMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  firstMaterialBrand?: InputMaybe<StringNullableFilter>;
  firstMaterialCountry?: InputMaybe<StringNullableFilter>;
  firstMaterialLotNumber?: InputMaybe<StringNullableFilter>;
  firstMaterialReference?: InputMaybe<StringNullableFilter>;
  firstMaterialTraceabilityId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  implantItemId?: InputMaybe<UuidNullableFilter>;
  itemPriceReferenceId?: InputMaybe<UuidNullableFilter>;
  matchingKey?: InputMaybe<StringNullableFilter>;
  orderBillingId?: InputMaybe<UuidFilter>;
  priceExcludingTaxes?: InputMaybe<DecimalFilter>;
  quantity?: InputMaybe<DecimalFilter>;
  removableItemAdditionalArchInfo?: InputMaybe<EnumArchNullableFilter>;
  removableItemId?: InputMaybe<UuidNullableFilter>;
  secondMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  secondMaterialBrand?: InputMaybe<StringNullableFilter>;
  secondMaterialCountry?: InputMaybe<StringNullableFilter>;
  secondMaterialLotNumber?: InputMaybe<StringNullableFilter>;
  secondMaterialReference?: InputMaybe<StringNullableFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitVat?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItemBillingUpdateInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutItemBillingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateOneWithoutItemBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutItemBillingNestedInput>;
  itemPriceReference?: InputMaybe<ItemPriceUpdateOneWithoutItemBillingNestedInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateOneRequiredWithoutItemBillingNestedInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateOneWithoutItemBillingNestedInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpdateManyWithWhereWithoutAnatomyItemInput = {
  data: ItemBillingUpdateManyMutationInput;
  where: ItemBillingScalarWhereInput;
};

export type ItemBillingUpdateManyWithWhereWithoutFirstMaterialTraceabilityInput = {
  data: ItemBillingUpdateManyMutationInput;
  where: ItemBillingScalarWhereInput;
};

export type ItemBillingUpdateManyWithWhereWithoutImplantItemInput = {
  data: ItemBillingUpdateManyMutationInput;
  where: ItemBillingScalarWhereInput;
};

export type ItemBillingUpdateManyWithWhereWithoutItemPriceReferenceInput = {
  data: ItemBillingUpdateManyMutationInput;
  where: ItemBillingScalarWhereInput;
};

export type ItemBillingUpdateManyWithWhereWithoutOrderBillingInput = {
  data: ItemBillingUpdateManyMutationInput;
  where: ItemBillingScalarWhereInput;
};

export type ItemBillingUpdateManyWithWhereWithoutRemovableItemInput = {
  data: ItemBillingUpdateManyMutationInput;
  where: ItemBillingScalarWhereInput;
};

export type ItemBillingUpdateManyWithoutAnatomyItemNestedInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutAnatomyItemInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutAnatomyItemInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyAnatomyItemInputEnvelope>;
  delete?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemBillingUpdateWithWhereUniqueWithoutAnatomyItemInput>>;
  updateMany?: InputMaybe<Array<ItemBillingUpdateManyWithWhereWithoutAnatomyItemInput>>;
  upsert?: InputMaybe<Array<ItemBillingUpsertWithWhereUniqueWithoutAnatomyItemInput>>;
};

export type ItemBillingUpdateManyWithoutFirstMaterialTraceabilityNestedInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutFirstMaterialTraceabilityInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutFirstMaterialTraceabilityInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyFirstMaterialTraceabilityInputEnvelope>;
  delete?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemBillingUpdateWithWhereUniqueWithoutFirstMaterialTraceabilityInput>>;
  updateMany?: InputMaybe<Array<ItemBillingUpdateManyWithWhereWithoutFirstMaterialTraceabilityInput>>;
  upsert?: InputMaybe<Array<ItemBillingUpsertWithWhereUniqueWithoutFirstMaterialTraceabilityInput>>;
};

export type ItemBillingUpdateManyWithoutImplantItemNestedInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutImplantItemInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutImplantItemInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyImplantItemInputEnvelope>;
  delete?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemBillingUpdateWithWhereUniqueWithoutImplantItemInput>>;
  updateMany?: InputMaybe<Array<ItemBillingUpdateManyWithWhereWithoutImplantItemInput>>;
  upsert?: InputMaybe<Array<ItemBillingUpsertWithWhereUniqueWithoutImplantItemInput>>;
};

export type ItemBillingUpdateManyWithoutItemPriceReferenceNestedInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutItemPriceReferenceInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutItemPriceReferenceInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyItemPriceReferenceInputEnvelope>;
  delete?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemBillingUpdateWithWhereUniqueWithoutItemPriceReferenceInput>>;
  updateMany?: InputMaybe<Array<ItemBillingUpdateManyWithWhereWithoutItemPriceReferenceInput>>;
  upsert?: InputMaybe<Array<ItemBillingUpsertWithWhereUniqueWithoutItemPriceReferenceInput>>;
};

export type ItemBillingUpdateManyWithoutOrderBillingNestedInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutOrderBillingInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutOrderBillingInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyOrderBillingInputEnvelope>;
  delete?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemBillingUpdateWithWhereUniqueWithoutOrderBillingInput>>;
  updateMany?: InputMaybe<Array<ItemBillingUpdateManyWithWhereWithoutOrderBillingInput>>;
  upsert?: InputMaybe<Array<ItemBillingUpsertWithWhereUniqueWithoutOrderBillingInput>>;
};

export type ItemBillingUpdateManyWithoutRemovableItemNestedInput = {
  connect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemBillingCreateOrConnectWithoutRemovableItemInput>>;
  create?: InputMaybe<Array<ItemBillingCreateWithoutRemovableItemInput>>;
  createMany?: InputMaybe<ItemBillingCreateManyRemovableItemInputEnvelope>;
  delete?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemBillingUpdateWithWhereUniqueWithoutRemovableItemInput>>;
  updateMany?: InputMaybe<Array<ItemBillingUpdateManyWithWhereWithoutRemovableItemInput>>;
  upsert?: InputMaybe<Array<ItemBillingUpsertWithWhereUniqueWithoutRemovableItemInput>>;
};

export type ItemBillingUpdateWithWhereUniqueWithoutAnatomyItemInput = {
  data: ItemBillingUpdateWithoutAnatomyItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpdateWithWhereUniqueWithoutFirstMaterialTraceabilityInput = {
  data: ItemBillingUpdateWithoutFirstMaterialTraceabilityInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpdateWithWhereUniqueWithoutImplantItemInput = {
  data: ItemBillingUpdateWithoutImplantItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpdateWithWhereUniqueWithoutItemPriceReferenceInput = {
  data: ItemBillingUpdateWithoutItemPriceReferenceInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpdateWithWhereUniqueWithoutOrderBillingInput = {
  data: ItemBillingUpdateWithoutOrderBillingInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpdateWithWhereUniqueWithoutRemovableItemInput = {
  data: ItemBillingUpdateWithoutRemovableItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpdateWithoutAnatomyItemInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateOneWithoutItemBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutItemBillingNestedInput>;
  itemPriceReference?: InputMaybe<ItemPriceUpdateOneWithoutItemBillingNestedInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateOneRequiredWithoutItemBillingNestedInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateOneWithoutItemBillingNestedInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpdateWithoutFirstMaterialTraceabilityInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutItemBillingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutItemBillingNestedInput>;
  itemPriceReference?: InputMaybe<ItemPriceUpdateOneWithoutItemBillingNestedInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateOneRequiredWithoutItemBillingNestedInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateOneWithoutItemBillingNestedInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpdateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutItemBillingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateOneWithoutItemBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemPriceReference?: InputMaybe<ItemPriceUpdateOneWithoutItemBillingNestedInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateOneRequiredWithoutItemBillingNestedInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateOneWithoutItemBillingNestedInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpdateWithoutItemPriceReferenceInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutItemBillingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateOneWithoutItemBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutItemBillingNestedInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateOneRequiredWithoutItemBillingNestedInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateOneWithoutItemBillingNestedInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpdateWithoutOrderBillingInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutItemBillingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateOneWithoutItemBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutItemBillingNestedInput>;
  itemPriceReference?: InputMaybe<ItemPriceUpdateOneWithoutItemBillingNestedInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateOneWithoutItemBillingNestedInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpdateWithoutRemovableItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutItemBillingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateOneWithoutItemBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutItemBillingNestedInput>;
  itemPriceReference?: InputMaybe<ItemPriceUpdateOneWithoutItemBillingNestedInput>;
  matchingKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateOneRequiredWithoutItemBillingNestedInput>;
  priceExcludingTaxes?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  quantity?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  removableItemAdditionalArchInfo?: InputMaybe<NullableEnumArchFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialLotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemBillingUpsertWithWhereUniqueWithoutAnatomyItemInput = {
  create: ItemBillingCreateWithoutAnatomyItemInput;
  update: ItemBillingUpdateWithoutAnatomyItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpsertWithWhereUniqueWithoutFirstMaterialTraceabilityInput = {
  create: ItemBillingCreateWithoutFirstMaterialTraceabilityInput;
  update: ItemBillingUpdateWithoutFirstMaterialTraceabilityInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpsertWithWhereUniqueWithoutImplantItemInput = {
  create: ItemBillingCreateWithoutImplantItemInput;
  update: ItemBillingUpdateWithoutImplantItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpsertWithWhereUniqueWithoutItemPriceReferenceInput = {
  create: ItemBillingCreateWithoutItemPriceReferenceInput;
  update: ItemBillingUpdateWithoutItemPriceReferenceInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpsertWithWhereUniqueWithoutOrderBillingInput = {
  create: ItemBillingCreateWithoutOrderBillingInput;
  update: ItemBillingUpdateWithoutOrderBillingInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingUpsertWithWhereUniqueWithoutRemovableItemInput = {
  create: ItemBillingCreateWithoutRemovableItemInput;
  update: ItemBillingUpdateWithoutRemovableItemInput;
  where: ItemBillingWhereUniqueInput;
};

export type ItemBillingWhereInput = {
  AND?: InputMaybe<Array<ItemBillingWhereInput>>;
  NOT?: InputMaybe<Array<ItemBillingWhereInput>>;
  OR?: InputMaybe<Array<ItemBillingWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemNullableScalarRelationFilter>;
  anatomyItemId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discount?: InputMaybe<DecimalFilter>;
  firstMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  firstMaterialBrand?: InputMaybe<StringNullableFilter>;
  firstMaterialCountry?: InputMaybe<StringNullableFilter>;
  firstMaterialLotNumber?: InputMaybe<StringNullableFilter>;
  firstMaterialReference?: InputMaybe<StringNullableFilter>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityNullableScalarRelationFilter>;
  firstMaterialTraceabilityId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  implantItem?: InputMaybe<ImplantItemNullableScalarRelationFilter>;
  implantItemId?: InputMaybe<UuidNullableFilter>;
  itemPriceReference?: InputMaybe<ItemPriceNullableScalarRelationFilter>;
  itemPriceReferenceId?: InputMaybe<UuidNullableFilter>;
  matchingKey?: InputMaybe<StringNullableFilter>;
  orderBilling?: InputMaybe<OrderBillingScalarRelationFilter>;
  orderBillingId?: InputMaybe<UuidFilter>;
  priceExcludingTaxes?: InputMaybe<DecimalFilter>;
  quantity?: InputMaybe<DecimalFilter>;
  removableItem?: InputMaybe<RemovableItemNullableScalarRelationFilter>;
  removableItemAdditionalArchInfo?: InputMaybe<EnumArchNullableFilter>;
  removableItemId?: InputMaybe<UuidNullableFilter>;
  secondMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  secondMaterialBrand?: InputMaybe<StringNullableFilter>;
  secondMaterialCountry?: InputMaybe<StringNullableFilter>;
  secondMaterialLotNumber?: InputMaybe<StringNullableFilter>;
  secondMaterialReference?: InputMaybe<StringNullableFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitVat?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItemBillingWhereUniqueInput = {
  AND?: InputMaybe<Array<ItemBillingWhereInput>>;
  NOT?: InputMaybe<Array<ItemBillingWhereInput>>;
  OR?: InputMaybe<Array<ItemBillingWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemNullableScalarRelationFilter>;
  anatomyItemId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discount?: InputMaybe<DecimalFilter>;
  firstMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  firstMaterialBrand?: InputMaybe<StringNullableFilter>;
  firstMaterialCountry?: InputMaybe<StringNullableFilter>;
  firstMaterialLotNumber?: InputMaybe<StringNullableFilter>;
  firstMaterialReference?: InputMaybe<StringNullableFilter>;
  firstMaterialTraceability?: InputMaybe<MaterialTraceabilityNullableScalarRelationFilter>;
  firstMaterialTraceabilityId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemNullableScalarRelationFilter>;
  implantItemId?: InputMaybe<UuidNullableFilter>;
  itemPriceReference?: InputMaybe<ItemPriceNullableScalarRelationFilter>;
  itemPriceReferenceId?: InputMaybe<UuidNullableFilter>;
  matchingKey?: InputMaybe<StringNullableFilter>;
  orderBilling?: InputMaybe<OrderBillingScalarRelationFilter>;
  orderBillingId?: InputMaybe<UuidFilter>;
  priceExcludingTaxes?: InputMaybe<DecimalFilter>;
  quantity?: InputMaybe<DecimalFilter>;
  removableItem?: InputMaybe<RemovableItemNullableScalarRelationFilter>;
  removableItemAdditionalArchInfo?: InputMaybe<EnumArchNullableFilter>;
  removableItemId?: InputMaybe<UuidNullableFilter>;
  secondMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  secondMaterialBrand?: InputMaybe<StringNullableFilter>;
  secondMaterialCountry?: InputMaybe<StringNullableFilter>;
  secondMaterialLotNumber?: InputMaybe<StringNullableFilter>;
  secondMaterialReference?: InputMaybe<StringNullableFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitVat?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItemMaterial = {
  __typename?: 'ItemMaterial';
  _count: ItemMaterialCount;
  abutment: Scalars['Boolean']['output'];
  anatomyItem?: Maybe<Array<AnatomyItem>>;
  anatomyItemInlayCore?: Maybe<Array<AnatomyItem>>;
  bridge: Scalars['Boolean']['output'];
  compatibleAsA?: Maybe<Array<ItemMaterialCompatibility>>;
  compatibleAsB?: Maybe<Array<ItemMaterialCompatibility>>;
  createdAt: Scalars['Timestamp']['output'];
  crown: Scalars['Boolean']['output'];
  fullDenture: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  implantCrown: Scalars['Boolean']['output'];
  implantItem?: Maybe<Array<ImplantItem>>;
  implantItemAbutment?: Maybe<Array<ImplantItem>>;
  inlayCore: Scalars['Boolean']['output'];
  isShadeRequired: Scalars['Boolean']['output'];
  itemPrice?: Maybe<Array<ItemPrice>>;
  label: Scalars['String']['output'];
  lay: Scalars['Boolean']['output'];
  nightGuard: Scalars['Boolean']['output'];
  partialDenture: Scalars['Boolean']['output'];
  partialDentureHook: Scalars['Boolean']['output'];
  partialDentureHookModel?: Maybe<Array<PartialDentureHook>>;
  removableItem?: Maybe<Array<RemovableItem>>;
  supplierMaterialTraceability?: Maybe<Array<MaterialTraceability>>;
  updatedAt: Scalars['Timestamp']['output'];
  veneer: Scalars['Boolean']['output'];
};

export type ItemMaterialCompatibility = {
  __typename?: 'ItemMaterialCompatibility';
  id: Scalars['ID']['output'];
  materialA: ItemMaterial;
  materialAId: Scalars['String']['output'];
  materialB: ItemMaterial;
  materialBId: Scalars['String']['output'];
};

export type ItemMaterialCompatibilityCreateManyMaterialAInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  materialBId: Scalars['String']['input'];
};

export type ItemMaterialCompatibilityCreateManyMaterialAInputEnvelope = {
  data: Array<ItemMaterialCompatibilityCreateManyMaterialAInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCompatibilityCreateManyMaterialBInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  materialAId: Scalars['String']['input'];
};

export type ItemMaterialCompatibilityCreateManyMaterialBInputEnvelope = {
  data: Array<ItemMaterialCompatibilityCreateManyMaterialBInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput = {
  connect?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemMaterialCompatibilityCreateOrConnectWithoutMaterialAInput>>;
  create?: InputMaybe<Array<ItemMaterialCompatibilityCreateWithoutMaterialAInput>>;
  createMany?: InputMaybe<ItemMaterialCompatibilityCreateManyMaterialAInputEnvelope>;
};

export type ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput = {
  connect?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemMaterialCompatibilityCreateOrConnectWithoutMaterialBInput>>;
  create?: InputMaybe<Array<ItemMaterialCompatibilityCreateWithoutMaterialBInput>>;
  createMany?: InputMaybe<ItemMaterialCompatibilityCreateManyMaterialBInputEnvelope>;
};

export type ItemMaterialCompatibilityCreateOrConnectWithoutMaterialAInput = {
  create: ItemMaterialCompatibilityCreateWithoutMaterialAInput;
  where: ItemMaterialCompatibilityWhereUniqueInput;
};

export type ItemMaterialCompatibilityCreateOrConnectWithoutMaterialBInput = {
  create: ItemMaterialCompatibilityCreateWithoutMaterialBInput;
  where: ItemMaterialCompatibilityWhereUniqueInput;
};

export type ItemMaterialCompatibilityCreateWithoutMaterialAInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  materialB: ItemMaterialCreateNestedOneWithoutCompatibleAsBInput;
};

export type ItemMaterialCompatibilityCreateWithoutMaterialBInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  materialA: ItemMaterialCreateNestedOneWithoutCompatibleAsAInput;
};

export type ItemMaterialCompatibilityListRelationFilter = {
  every?: InputMaybe<ItemMaterialCompatibilityWhereInput>;
  none?: InputMaybe<ItemMaterialCompatibilityWhereInput>;
  some?: InputMaybe<ItemMaterialCompatibilityWhereInput>;
};

export type ItemMaterialCompatibilityMaterialAIdMaterialBIdCompoundUniqueInput = {
  materialAId: Scalars['String']['input'];
  materialBId: Scalars['String']['input'];
};

export type ItemMaterialCompatibilityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ItemMaterialCompatibilityScalarWhereInput = {
  AND?: InputMaybe<Array<ItemMaterialCompatibilityScalarWhereInput>>;
  NOT?: InputMaybe<Array<ItemMaterialCompatibilityScalarWhereInput>>;
  OR?: InputMaybe<Array<ItemMaterialCompatibilityScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  materialAId?: InputMaybe<StringFilter>;
  materialBId?: InputMaybe<StringFilter>;
};

export type ItemMaterialCompatibilityUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ItemMaterialCompatibilityUpdateManyWithWhereWithoutMaterialAInput = {
  data: ItemMaterialCompatibilityUpdateManyMutationInput;
  where: ItemMaterialCompatibilityScalarWhereInput;
};

export type ItemMaterialCompatibilityUpdateManyWithWhereWithoutMaterialBInput = {
  data: ItemMaterialCompatibilityUpdateManyMutationInput;
  where: ItemMaterialCompatibilityScalarWhereInput;
};

export type ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput = {
  connect?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemMaterialCompatibilityCreateOrConnectWithoutMaterialAInput>>;
  create?: InputMaybe<Array<ItemMaterialCompatibilityCreateWithoutMaterialAInput>>;
  createMany?: InputMaybe<ItemMaterialCompatibilityCreateManyMaterialAInputEnvelope>;
  delete?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemMaterialCompatibilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemMaterialCompatibilityUpdateWithWhereUniqueWithoutMaterialAInput>>;
  updateMany?: InputMaybe<Array<ItemMaterialCompatibilityUpdateManyWithWhereWithoutMaterialAInput>>;
  upsert?: InputMaybe<Array<ItemMaterialCompatibilityUpsertWithWhereUniqueWithoutMaterialAInput>>;
};

export type ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput = {
  connect?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemMaterialCompatibilityCreateOrConnectWithoutMaterialBInput>>;
  create?: InputMaybe<Array<ItemMaterialCompatibilityCreateWithoutMaterialBInput>>;
  createMany?: InputMaybe<ItemMaterialCompatibilityCreateManyMaterialBInputEnvelope>;
  delete?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemMaterialCompatibilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemMaterialCompatibilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemMaterialCompatibilityUpdateWithWhereUniqueWithoutMaterialBInput>>;
  updateMany?: InputMaybe<Array<ItemMaterialCompatibilityUpdateManyWithWhereWithoutMaterialBInput>>;
  upsert?: InputMaybe<Array<ItemMaterialCompatibilityUpsertWithWhereUniqueWithoutMaterialBInput>>;
};

export type ItemMaterialCompatibilityUpdateWithWhereUniqueWithoutMaterialAInput = {
  data: ItemMaterialCompatibilityUpdateWithoutMaterialAInput;
  where: ItemMaterialCompatibilityWhereUniqueInput;
};

export type ItemMaterialCompatibilityUpdateWithWhereUniqueWithoutMaterialBInput = {
  data: ItemMaterialCompatibilityUpdateWithoutMaterialBInput;
  where: ItemMaterialCompatibilityWhereUniqueInput;
};

export type ItemMaterialCompatibilityUpdateWithoutMaterialAInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  materialB?: InputMaybe<ItemMaterialUpdateOneRequiredWithoutCompatibleAsBNestedInput>;
};

export type ItemMaterialCompatibilityUpdateWithoutMaterialBInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  materialA?: InputMaybe<ItemMaterialUpdateOneRequiredWithoutCompatibleAsANestedInput>;
};

export type ItemMaterialCompatibilityUpsertWithWhereUniqueWithoutMaterialAInput = {
  create: ItemMaterialCompatibilityCreateWithoutMaterialAInput;
  update: ItemMaterialCompatibilityUpdateWithoutMaterialAInput;
  where: ItemMaterialCompatibilityWhereUniqueInput;
};

export type ItemMaterialCompatibilityUpsertWithWhereUniqueWithoutMaterialBInput = {
  create: ItemMaterialCompatibilityCreateWithoutMaterialBInput;
  update: ItemMaterialCompatibilityUpdateWithoutMaterialBInput;
  where: ItemMaterialCompatibilityWhereUniqueInput;
};

export type ItemMaterialCompatibilityWhereInput = {
  AND?: InputMaybe<Array<ItemMaterialCompatibilityWhereInput>>;
  NOT?: InputMaybe<Array<ItemMaterialCompatibilityWhereInput>>;
  OR?: InputMaybe<Array<ItemMaterialCompatibilityWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  materialA?: InputMaybe<ItemMaterialScalarRelationFilter>;
  materialAId?: InputMaybe<StringFilter>;
  materialB?: InputMaybe<ItemMaterialScalarRelationFilter>;
  materialBId?: InputMaybe<StringFilter>;
};

export type ItemMaterialCompatibilityWhereUniqueInput = {
  AND?: InputMaybe<Array<ItemMaterialCompatibilityWhereInput>>;
  NOT?: InputMaybe<Array<ItemMaterialCompatibilityWhereInput>>;
  OR?: InputMaybe<Array<ItemMaterialCompatibilityWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  materialA?: InputMaybe<ItemMaterialScalarRelationFilter>;
  materialAId?: InputMaybe<StringFilter>;
  materialAId_materialBId?: InputMaybe<ItemMaterialCompatibilityMaterialAIdMaterialBIdCompoundUniqueInput>;
  materialB?: InputMaybe<ItemMaterialScalarRelationFilter>;
  materialBId?: InputMaybe<StringFilter>;
};

export type ItemMaterialCount = {
  __typename?: 'ItemMaterialCount';
  anatomyItem: Scalars['Int']['output'];
  anatomyItemInlayCore: Scalars['Int']['output'];
  compatibleAsA: Scalars['Int']['output'];
  compatibleAsB: Scalars['Int']['output'];
  implantItem: Scalars['Int']['output'];
  implantItemAbutment: Scalars['Int']['output'];
  itemPrice: Scalars['Int']['output'];
  partialDentureHookModel: Scalars['Int']['output'];
  removableItem: Scalars['Int']['output'];
  supplierMaterialTraceability: Scalars['Int']['output'];
};

export type ItemMaterialCreateInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateNestedOneWithoutAnatomyItemInlayCoreInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutAnatomyItemInlayCoreInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutAnatomyItemInlayCoreInput>;
};

export type ItemMaterialCreateNestedOneWithoutAnatomyItemInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutAnatomyItemInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutAnatomyItemInput>;
};

export type ItemMaterialCreateNestedOneWithoutCompatibleAsAInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutCompatibleAsAInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutCompatibleAsAInput>;
};

export type ItemMaterialCreateNestedOneWithoutCompatibleAsBInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutCompatibleAsBInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutCompatibleAsBInput>;
};

export type ItemMaterialCreateNestedOneWithoutImplantItemAbutmentInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutImplantItemAbutmentInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutImplantItemAbutmentInput>;
};

export type ItemMaterialCreateNestedOneWithoutImplantItemInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutImplantItemInput>;
};

export type ItemMaterialCreateNestedOneWithoutItemPriceInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutItemPriceInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutItemPriceInput>;
};

export type ItemMaterialCreateNestedOneWithoutPartialDentureHookModelInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutPartialDentureHookModelInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutPartialDentureHookModelInput>;
};

export type ItemMaterialCreateNestedOneWithoutRemovableItemInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutRemovableItemInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutRemovableItemInput>;
};

export type ItemMaterialCreateNestedOneWithoutSupplierMaterialTraceabilityInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutSupplierMaterialTraceabilityInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutSupplierMaterialTraceabilityInput>;
};

export type ItemMaterialCreateOrConnectWithoutAnatomyItemInlayCoreInput = {
  create: ItemMaterialCreateWithoutAnatomyItemInlayCoreInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutAnatomyItemInput = {
  create: ItemMaterialCreateWithoutAnatomyItemInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutCompatibleAsAInput = {
  create: ItemMaterialCreateWithoutCompatibleAsAInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutCompatibleAsBInput = {
  create: ItemMaterialCreateWithoutCompatibleAsBInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutImplantItemAbutmentInput = {
  create: ItemMaterialCreateWithoutImplantItemAbutmentInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutImplantItemInput = {
  create: ItemMaterialCreateWithoutImplantItemInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutItemPriceInput = {
  create: ItemMaterialCreateWithoutItemPriceInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutPartialDentureHookModelInput = {
  create: ItemMaterialCreateWithoutPartialDentureHookModelInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutRemovableItemInput = {
  create: ItemMaterialCreateWithoutRemovableItemInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateOrConnectWithoutSupplierMaterialTraceabilityInput = {
  create: ItemMaterialCreateWithoutSupplierMaterialTraceabilityInput;
  where: ItemMaterialWhereUniqueInput;
};

export type ItemMaterialCreateWithoutAnatomyItemInlayCoreInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutAnatomyItemInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutCompatibleAsAInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutCompatibleAsBInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutImplantItemAbutmentInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutImplantItemInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutItemPriceInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutPartialDentureHookModelInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutRemovableItemInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialCreateWithoutSupplierMaterialTraceabilityInput = {
  abutment?: InputMaybe<Scalars['Boolean']['input']>;
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemMaterialInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemCreateNestedManyWithoutInlayCoreMaterialInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialAInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityCreateNestedManyWithoutMaterialBInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDenture?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantCrown?: InputMaybe<Scalars['Boolean']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemMaterialInput>;
  implantItemAbutment?: InputMaybe<ImplantItemCreateNestedManyWithoutAbutmentMaterialInput>;
  inlayCore?: InputMaybe<Scalars['Boolean']['input']>;
  isShadeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutItemMaterialInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  nightGuard?: InputMaybe<Scalars['Boolean']['input']>;
  partialDenture?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHook?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookCreateNestedManyWithoutHooksMaterialInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutItemMaterialInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemMaterialModel = {
  __typename?: 'ItemMaterialModel';
  allowedItemTypes: Array<ItemTypeV2>;
  compatibleMaterials: Array<ItemMaterialModel>;
  id: Scalars['String']['output'];
  isShadeRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ItemMaterialNullableScalarRelationFilter = {
  is?: InputMaybe<ItemMaterialWhereInput>;
  isNot?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialOrderByWithRelationInput = {
  abutment?: InputMaybe<SortOrder>;
  anatomyItem?: InputMaybe<AnatomyItemOrderByRelationAggregateInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemOrderByRelationAggregateInput>;
  bridge?: InputMaybe<SortOrder>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityOrderByRelationAggregateInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  crown?: InputMaybe<SortOrder>;
  fullDenture?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  implantCrown?: InputMaybe<SortOrder>;
  implantItem?: InputMaybe<ImplantItemOrderByRelationAggregateInput>;
  implantItemAbutment?: InputMaybe<ImplantItemOrderByRelationAggregateInput>;
  inlayCore?: InputMaybe<SortOrder>;
  isShadeRequired?: InputMaybe<SortOrder>;
  itemPrice?: InputMaybe<ItemPriceOrderByRelationAggregateInput>;
  label?: InputMaybe<SortOrder>;
  lay?: InputMaybe<SortOrder>;
  nightGuard?: InputMaybe<SortOrder>;
  partialDenture?: InputMaybe<SortOrder>;
  partialDentureHook?: InputMaybe<SortOrder>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookOrderByRelationAggregateInput>;
  removableItem?: InputMaybe<RemovableItemOrderByRelationAggregateInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  veneer?: InputMaybe<SortOrder>;
};

export enum ItemMaterialScalarFieldEnum {
  Abutment = 'abutment',
  Bridge = 'bridge',
  CreatedAt = 'createdAt',
  Crown = 'crown',
  FullDenture = 'fullDenture',
  Id = 'id',
  ImplantCrown = 'implantCrown',
  InlayCore = 'inlayCore',
  IsShadeRequired = 'isShadeRequired',
  Label = 'label',
  Lay = 'lay',
  NightGuard = 'nightGuard',
  PartialDenture = 'partialDenture',
  PartialDentureHook = 'partialDentureHook',
  UpdatedAt = 'updatedAt',
  Veneer = 'veneer'
}

export type ItemMaterialScalarRelationFilter = {
  is?: InputMaybe<ItemMaterialWhereInput>;
  isNot?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateOneRequiredWithoutCompatibleAsANestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutCompatibleAsAInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutCompatibleAsAInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutCompatibleAsAInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutCompatibleAsAInput>;
};

export type ItemMaterialUpdateOneRequiredWithoutCompatibleAsBNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutCompatibleAsBInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutCompatibleAsBInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutCompatibleAsBInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutCompatibleAsBInput>;
};

export type ItemMaterialUpdateOneRequiredWithoutSupplierMaterialTraceabilityNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutSupplierMaterialTraceabilityInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutSupplierMaterialTraceabilityInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutSupplierMaterialTraceabilityInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutSupplierMaterialTraceabilityInput>;
};

export type ItemMaterialUpdateOneWithoutAnatomyItemInlayCoreNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutAnatomyItemInlayCoreInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutAnatomyItemInlayCoreInput>;
  delete?: InputMaybe<ItemMaterialWhereInput>;
  disconnect?: InputMaybe<ItemMaterialWhereInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutAnatomyItemInlayCoreInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutAnatomyItemInlayCoreInput>;
};

export type ItemMaterialUpdateOneWithoutAnatomyItemNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutAnatomyItemInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutAnatomyItemInput>;
  delete?: InputMaybe<ItemMaterialWhereInput>;
  disconnect?: InputMaybe<ItemMaterialWhereInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutAnatomyItemInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutAnatomyItemInput>;
};

export type ItemMaterialUpdateOneWithoutImplantItemAbutmentNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutImplantItemAbutmentInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutImplantItemAbutmentInput>;
  delete?: InputMaybe<ItemMaterialWhereInput>;
  disconnect?: InputMaybe<ItemMaterialWhereInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutImplantItemAbutmentInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutImplantItemAbutmentInput>;
};

export type ItemMaterialUpdateOneWithoutImplantItemNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutImplantItemInput>;
  delete?: InputMaybe<ItemMaterialWhereInput>;
  disconnect?: InputMaybe<ItemMaterialWhereInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutImplantItemInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutImplantItemInput>;
};

export type ItemMaterialUpdateOneWithoutItemPriceNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutItemPriceInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutItemPriceInput>;
  delete?: InputMaybe<ItemMaterialWhereInput>;
  disconnect?: InputMaybe<ItemMaterialWhereInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutItemPriceInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutItemPriceInput>;
};

export type ItemMaterialUpdateOneWithoutPartialDentureHookModelNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutPartialDentureHookModelInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutPartialDentureHookModelInput>;
  delete?: InputMaybe<ItemMaterialWhereInput>;
  disconnect?: InputMaybe<ItemMaterialWhereInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutPartialDentureHookModelInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutPartialDentureHookModelInput>;
};

export type ItemMaterialUpdateOneWithoutRemovableItemNestedInput = {
  connect?: InputMaybe<ItemMaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemMaterialCreateOrConnectWithoutRemovableItemInput>;
  create?: InputMaybe<ItemMaterialCreateWithoutRemovableItemInput>;
  delete?: InputMaybe<ItemMaterialWhereInput>;
  disconnect?: InputMaybe<ItemMaterialWhereInput>;
  update?: InputMaybe<ItemMaterialUpdateToOneWithWhereWithoutRemovableItemInput>;
  upsert?: InputMaybe<ItemMaterialUpsertWithoutRemovableItemInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutAnatomyItemInlayCoreInput = {
  data: ItemMaterialUpdateWithoutAnatomyItemInlayCoreInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutAnatomyItemInput = {
  data: ItemMaterialUpdateWithoutAnatomyItemInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutCompatibleAsAInput = {
  data: ItemMaterialUpdateWithoutCompatibleAsAInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutCompatibleAsBInput = {
  data: ItemMaterialUpdateWithoutCompatibleAsBInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutImplantItemAbutmentInput = {
  data: ItemMaterialUpdateWithoutImplantItemAbutmentInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutImplantItemInput = {
  data: ItemMaterialUpdateWithoutImplantItemInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutItemPriceInput = {
  data: ItemMaterialUpdateWithoutItemPriceInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutPartialDentureHookModelInput = {
  data: ItemMaterialUpdateWithoutPartialDentureHookModelInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutRemovableItemInput = {
  data: ItemMaterialUpdateWithoutRemovableItemInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateToOneWithWhereWithoutSupplierMaterialTraceabilityInput = {
  data: ItemMaterialUpdateWithoutSupplierMaterialTraceabilityInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpdateWithoutAnatomyItemInlayCoreInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutAnatomyItemInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutCompatibleAsAInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutCompatibleAsBInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutImplantItemAbutmentInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutImplantItemInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutItemPriceInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutPartialDentureHookModelInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutRemovableItemInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpdateWithoutSupplierMaterialTraceabilityInput = {
  abutment?: InputMaybe<BoolFieldUpdateOperationsInput>;
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemMaterialNestedInput>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemUpdateManyWithoutInlayCoreMaterialNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialANestedInput>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityUpdateManyWithoutMaterialBNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantCrown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemMaterialNestedInput>;
  implantItemAbutment?: InputMaybe<ImplantItemUpdateManyWithoutAbutmentMaterialNestedInput>;
  inlayCore?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShadeRequired?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutItemMaterialNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nightGuard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHook?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutItemMaterialNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemMaterialUpsertWithoutAnatomyItemInlayCoreInput = {
  create: ItemMaterialCreateWithoutAnatomyItemInlayCoreInput;
  update: ItemMaterialUpdateWithoutAnatomyItemInlayCoreInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutAnatomyItemInput = {
  create: ItemMaterialCreateWithoutAnatomyItemInput;
  update: ItemMaterialUpdateWithoutAnatomyItemInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutCompatibleAsAInput = {
  create: ItemMaterialCreateWithoutCompatibleAsAInput;
  update: ItemMaterialUpdateWithoutCompatibleAsAInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutCompatibleAsBInput = {
  create: ItemMaterialCreateWithoutCompatibleAsBInput;
  update: ItemMaterialUpdateWithoutCompatibleAsBInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutImplantItemAbutmentInput = {
  create: ItemMaterialCreateWithoutImplantItemAbutmentInput;
  update: ItemMaterialUpdateWithoutImplantItemAbutmentInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutImplantItemInput = {
  create: ItemMaterialCreateWithoutImplantItemInput;
  update: ItemMaterialUpdateWithoutImplantItemInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutItemPriceInput = {
  create: ItemMaterialCreateWithoutItemPriceInput;
  update: ItemMaterialUpdateWithoutItemPriceInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutPartialDentureHookModelInput = {
  create: ItemMaterialCreateWithoutPartialDentureHookModelInput;
  update: ItemMaterialUpdateWithoutPartialDentureHookModelInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutRemovableItemInput = {
  create: ItemMaterialCreateWithoutRemovableItemInput;
  update: ItemMaterialUpdateWithoutRemovableItemInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialUpsertWithoutSupplierMaterialTraceabilityInput = {
  create: ItemMaterialCreateWithoutSupplierMaterialTraceabilityInput;
  update: ItemMaterialUpdateWithoutSupplierMaterialTraceabilityInput;
  where?: InputMaybe<ItemMaterialWhereInput>;
};

export type ItemMaterialWhereInput = {
  AND?: InputMaybe<Array<ItemMaterialWhereInput>>;
  NOT?: InputMaybe<Array<ItemMaterialWhereInput>>;
  OR?: InputMaybe<Array<ItemMaterialWhereInput>>;
  abutment?: InputMaybe<BoolFilter>;
  anatomyItem?: InputMaybe<AnatomyItemListRelationFilter>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemListRelationFilter>;
  bridge?: InputMaybe<BoolFilter>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityListRelationFilter>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crown?: InputMaybe<BoolFilter>;
  fullDenture?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  implantCrown?: InputMaybe<BoolFilter>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  implantItemAbutment?: InputMaybe<ImplantItemListRelationFilter>;
  inlayCore?: InputMaybe<BoolFilter>;
  isShadeRequired?: InputMaybe<BoolFilter>;
  itemPrice?: InputMaybe<ItemPriceListRelationFilter>;
  label?: InputMaybe<StringFilter>;
  lay?: InputMaybe<BoolFilter>;
  nightGuard?: InputMaybe<BoolFilter>;
  partialDenture?: InputMaybe<BoolFilter>;
  partialDentureHook?: InputMaybe<BoolFilter>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookListRelationFilter>;
  removableItem?: InputMaybe<RemovableItemListRelationFilter>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  veneer?: InputMaybe<BoolFilter>;
};

export type ItemMaterialWhereUniqueInput = {
  AND?: InputMaybe<Array<ItemMaterialWhereInput>>;
  NOT?: InputMaybe<Array<ItemMaterialWhereInput>>;
  OR?: InputMaybe<Array<ItemMaterialWhereInput>>;
  abutment?: InputMaybe<BoolFilter>;
  anatomyItem?: InputMaybe<AnatomyItemListRelationFilter>;
  anatomyItemInlayCore?: InputMaybe<AnatomyItemListRelationFilter>;
  bridge?: InputMaybe<BoolFilter>;
  compatibleAsA?: InputMaybe<ItemMaterialCompatibilityListRelationFilter>;
  compatibleAsB?: InputMaybe<ItemMaterialCompatibilityListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crown?: InputMaybe<BoolFilter>;
  fullDenture?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantCrown?: InputMaybe<BoolFilter>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  implantItemAbutment?: InputMaybe<ImplantItemListRelationFilter>;
  inlayCore?: InputMaybe<BoolFilter>;
  isShadeRequired?: InputMaybe<BoolFilter>;
  itemPrice?: InputMaybe<ItemPriceListRelationFilter>;
  label?: InputMaybe<StringFilter>;
  lay?: InputMaybe<BoolFilter>;
  nightGuard?: InputMaybe<BoolFilter>;
  partialDenture?: InputMaybe<BoolFilter>;
  partialDentureHook?: InputMaybe<BoolFilter>;
  partialDentureHookModel?: InputMaybe<PartialDentureHookListRelationFilter>;
  removableItem?: InputMaybe<RemovableItemListRelationFilter>;
  supplierMaterialTraceability?: InputMaybe<MaterialTraceabilityListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  veneer?: InputMaybe<BoolFilter>;
};

export type ItemPreferencesInput = {
  anteriorPosteriorPonticDesign?: InputMaybe<AnteriorPosteriorPonticDesignV2>;
  interproximalContactDesign: InterproximalContactDesignV2;
  noOcclusalClearance: NoOcclusalClearanceV2;
  occlusalContactTightness: OcclusalContactTightnessV2;
  occlusalStaining: OcclusalStainingV2;
  proximalContactTightness: ProximalContactTightnessV2;
};

export type ItemPreferencesModel = {
  __typename?: 'ItemPreferencesModel';
  anteriorPosteriorPonticDesign?: Maybe<AnteriorPosteriorPonticDesignV2>;
  interproximalContactDesign: InterproximalContactDesignV2;
  noOcclusalClearance: NoOcclusalClearanceV2;
  occlusalContactTightness: OcclusalContactTightnessV2;
  occlusalStaining: OcclusalStainingV2;
  proximalContactTightness: ProximalContactTightnessV2;
};

export type ItemPrice = {
  __typename?: 'ItemPrice';
  _count: ItemPriceCount;
  abutmentType?: Maybe<AbutmentType>;
  aggressivePrice?: Maybe<Scalars['Decimal']['output']>;
  basePrice?: Maybe<Scalars['Decimal']['output']>;
  bronzePrice?: Maybe<Scalars['Decimal']['output']>;
  centerPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  goldPrice?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  implantRetentionType?: Maybe<RetentionType>;
  isJasperPrice: Scalars['Boolean']['output'];
  itemBilling?: Maybe<Array<ItemBilling>>;
  itemLabel: Scalars['String']['output'];
  itemMaterial?: Maybe<ItemMaterial>;
  itemMaterialId?: Maybe<Scalars['String']['output']>;
  itemReferenceCode: Scalars['String']['output'];
  itemType: ItemType;
  removableItemWorkflowType?: Maybe<ItemPriceType>;
  removableTeethToManufactureMax: Scalars['Int']['output'];
  removableTeethToManufactureMin: Scalars['Int']['output'];
  silverPrice?: Maybe<Scalars['Decimal']['output']>;
  supplier?: Maybe<User>;
  supplierId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ItemPriceCount = {
  __typename?: 'ItemPriceCount';
  itemBilling: Scalars['Int']['output'];
};

export type ItemPriceCreateInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  aggressivePrice?: InputMaybe<Scalars['Decimal']['input']>;
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  bronzePrice?: InputMaybe<Scalars['Decimal']['input']>;
  centerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  goldPrice?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantRetentionType?: InputMaybe<RetentionType>;
  isJasperPrice?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutItemPriceReferenceInput>;
  itemLabel: Scalars['String']['input'];
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutItemPriceInput>;
  itemReferenceCode: Scalars['String']['input'];
  itemType: ItemType;
  removableItemWorkflowType?: InputMaybe<ItemPriceType>;
  removableTeethToManufactureMax?: InputMaybe<Scalars['Int']['input']>;
  removableTeethToManufactureMin?: InputMaybe<Scalars['Int']['input']>;
  silverPrice?: InputMaybe<Scalars['Decimal']['input']>;
  supplier?: InputMaybe<UserCreateNestedOneWithoutItemPriceInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemPriceCreateManyItemMaterialInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  aggressivePrice?: InputMaybe<Scalars['Decimal']['input']>;
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  bronzePrice?: InputMaybe<Scalars['Decimal']['input']>;
  centerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  goldPrice?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantRetentionType?: InputMaybe<RetentionType>;
  isJasperPrice?: InputMaybe<Scalars['Boolean']['input']>;
  itemLabel: Scalars['String']['input'];
  itemReferenceCode: Scalars['String']['input'];
  itemType: ItemType;
  removableItemWorkflowType?: InputMaybe<ItemPriceType>;
  removableTeethToManufactureMax?: InputMaybe<Scalars['Int']['input']>;
  removableTeethToManufactureMin?: InputMaybe<Scalars['Int']['input']>;
  silverPrice?: InputMaybe<Scalars['Decimal']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemPriceCreateManyItemMaterialInputEnvelope = {
  data: Array<ItemPriceCreateManyItemMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemPriceCreateManySupplierInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  aggressivePrice?: InputMaybe<Scalars['Decimal']['input']>;
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  bronzePrice?: InputMaybe<Scalars['Decimal']['input']>;
  centerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  goldPrice?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantRetentionType?: InputMaybe<RetentionType>;
  isJasperPrice?: InputMaybe<Scalars['Boolean']['input']>;
  itemLabel: Scalars['String']['input'];
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemReferenceCode: Scalars['String']['input'];
  itemType: ItemType;
  removableItemWorkflowType?: InputMaybe<ItemPriceType>;
  removableTeethToManufactureMax?: InputMaybe<Scalars['Int']['input']>;
  removableTeethToManufactureMin?: InputMaybe<Scalars['Int']['input']>;
  silverPrice?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemPriceCreateManySupplierInputEnvelope = {
  data: Array<ItemPriceCreateManySupplierInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemPriceCreateNestedManyWithoutItemMaterialInput = {
  connect?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemPriceCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<ItemPriceCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<ItemPriceCreateManyItemMaterialInputEnvelope>;
};

export type ItemPriceCreateNestedManyWithoutSupplierInput = {
  connect?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemPriceCreateOrConnectWithoutSupplierInput>>;
  create?: InputMaybe<Array<ItemPriceCreateWithoutSupplierInput>>;
  createMany?: InputMaybe<ItemPriceCreateManySupplierInputEnvelope>;
};

export type ItemPriceCreateNestedOneWithoutItemBillingInput = {
  connect?: InputMaybe<ItemPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemPriceCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<ItemPriceCreateWithoutItemBillingInput>;
};

export type ItemPriceCreateOrConnectWithoutItemBillingInput = {
  create: ItemPriceCreateWithoutItemBillingInput;
  where: ItemPriceWhereUniqueInput;
};

export type ItemPriceCreateOrConnectWithoutItemMaterialInput = {
  create: ItemPriceCreateWithoutItemMaterialInput;
  where: ItemPriceWhereUniqueInput;
};

export type ItemPriceCreateOrConnectWithoutSupplierInput = {
  create: ItemPriceCreateWithoutSupplierInput;
  where: ItemPriceWhereUniqueInput;
};

export type ItemPriceCreateWithoutItemBillingInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  aggressivePrice?: InputMaybe<Scalars['Decimal']['input']>;
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  bronzePrice?: InputMaybe<Scalars['Decimal']['input']>;
  centerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  goldPrice?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantRetentionType?: InputMaybe<RetentionType>;
  isJasperPrice?: InputMaybe<Scalars['Boolean']['input']>;
  itemLabel: Scalars['String']['input'];
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutItemPriceInput>;
  itemReferenceCode: Scalars['String']['input'];
  itemType: ItemType;
  removableItemWorkflowType?: InputMaybe<ItemPriceType>;
  removableTeethToManufactureMax?: InputMaybe<Scalars['Int']['input']>;
  removableTeethToManufactureMin?: InputMaybe<Scalars['Int']['input']>;
  silverPrice?: InputMaybe<Scalars['Decimal']['input']>;
  supplier?: InputMaybe<UserCreateNestedOneWithoutItemPriceInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemPriceCreateWithoutItemMaterialInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  aggressivePrice?: InputMaybe<Scalars['Decimal']['input']>;
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  bronzePrice?: InputMaybe<Scalars['Decimal']['input']>;
  centerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  goldPrice?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantRetentionType?: InputMaybe<RetentionType>;
  isJasperPrice?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutItemPriceReferenceInput>;
  itemLabel: Scalars['String']['input'];
  itemReferenceCode: Scalars['String']['input'];
  itemType: ItemType;
  removableItemWorkflowType?: InputMaybe<ItemPriceType>;
  removableTeethToManufactureMax?: InputMaybe<Scalars['Int']['input']>;
  removableTeethToManufactureMin?: InputMaybe<Scalars['Int']['input']>;
  silverPrice?: InputMaybe<Scalars['Decimal']['input']>;
  supplier?: InputMaybe<UserCreateNestedOneWithoutItemPriceInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemPriceCreateWithoutSupplierInput = {
  abutmentType?: InputMaybe<AbutmentType>;
  aggressivePrice?: InputMaybe<Scalars['Decimal']['input']>;
  basePrice?: InputMaybe<Scalars['Decimal']['input']>;
  bronzePrice?: InputMaybe<Scalars['Decimal']['input']>;
  centerPrice?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  goldPrice?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantRetentionType?: InputMaybe<RetentionType>;
  isJasperPrice?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutItemPriceReferenceInput>;
  itemLabel: Scalars['String']['input'];
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutItemPriceInput>;
  itemReferenceCode: Scalars['String']['input'];
  itemType: ItemType;
  removableItemWorkflowType?: InputMaybe<ItemPriceType>;
  removableTeethToManufactureMax?: InputMaybe<Scalars['Int']['input']>;
  removableTeethToManufactureMin?: InputMaybe<Scalars['Int']['input']>;
  silverPrice?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ItemPriceListRelationFilter = {
  every?: InputMaybe<ItemPriceWhereInput>;
  none?: InputMaybe<ItemPriceWhereInput>;
  some?: InputMaybe<ItemPriceWhereInput>;
};

export type ItemPriceNullableScalarRelationFilter = {
  is?: InputMaybe<ItemPriceWhereInput>;
  isNot?: InputMaybe<ItemPriceWhereInput>;
};

export type ItemPriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ItemPriceOrderByWithRelationInput = {
  abutmentType?: InputMaybe<SortOrderInput>;
  aggressivePrice?: InputMaybe<SortOrderInput>;
  basePrice?: InputMaybe<SortOrderInput>;
  bronzePrice?: InputMaybe<SortOrderInput>;
  centerPrice?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  goldPrice?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  implantRetentionType?: InputMaybe<SortOrderInput>;
  isJasperPrice?: InputMaybe<SortOrder>;
  itemBilling?: InputMaybe<ItemBillingOrderByRelationAggregateInput>;
  itemLabel?: InputMaybe<SortOrder>;
  itemMaterial?: InputMaybe<ItemMaterialOrderByWithRelationInput>;
  itemMaterialId?: InputMaybe<SortOrderInput>;
  itemReferenceCode?: InputMaybe<SortOrder>;
  itemType?: InputMaybe<SortOrder>;
  removableItemWorkflowType?: InputMaybe<SortOrderInput>;
  removableTeethToManufactureMax?: InputMaybe<SortOrder>;
  removableTeethToManufactureMin?: InputMaybe<SortOrder>;
  silverPrice?: InputMaybe<SortOrderInput>;
  supplier?: InputMaybe<UserOrderByWithRelationInput>;
  supplierId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ItemPriceScalarFieldEnum {
  AbutmentType = 'abutmentType',
  AggressivePrice = 'aggressivePrice',
  BasePrice = 'basePrice',
  BronzePrice = 'bronzePrice',
  CenterPrice = 'centerPrice',
  CreatedAt = 'createdAt',
  GoldPrice = 'goldPrice',
  Id = 'id',
  ImplantRetentionType = 'implantRetentionType',
  IsJasperPrice = 'isJasperPrice',
  ItemLabel = 'itemLabel',
  ItemMaterialId = 'itemMaterialId',
  ItemReferenceCode = 'itemReferenceCode',
  ItemType = 'itemType',
  RemovableItemWorkflowType = 'removableItemWorkflowType',
  RemovableTeethToManufactureMax = 'removableTeethToManufactureMax',
  RemovableTeethToManufactureMin = 'removableTeethToManufactureMin',
  SilverPrice = 'silverPrice',
  SupplierId = 'supplierId',
  UpdatedAt = 'updatedAt'
}

export type ItemPriceScalarWhereInput = {
  AND?: InputMaybe<Array<ItemPriceScalarWhereInput>>;
  NOT?: InputMaybe<Array<ItemPriceScalarWhereInput>>;
  OR?: InputMaybe<Array<ItemPriceScalarWhereInput>>;
  abutmentType?: InputMaybe<EnumAbutmentTypeNullableFilter>;
  aggressivePrice?: InputMaybe<DecimalNullableFilter>;
  basePrice?: InputMaybe<DecimalNullableFilter>;
  bronzePrice?: InputMaybe<DecimalNullableFilter>;
  centerPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  goldPrice?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  implantRetentionType?: InputMaybe<EnumRetentionTypeNullableFilter>;
  isJasperPrice?: InputMaybe<BoolFilter>;
  itemLabel?: InputMaybe<StringFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemReferenceCode?: InputMaybe<StringFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  removableItemWorkflowType?: InputMaybe<EnumItemPriceTypeNullableFilter>;
  removableTeethToManufactureMax?: InputMaybe<IntFilter>;
  removableTeethToManufactureMin?: InputMaybe<IntFilter>;
  silverPrice?: InputMaybe<DecimalNullableFilter>;
  supplierId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ItemPriceType {
  DirectFinish = 'DIRECT_FINISH',
  Fitting = 'FITTING',
  FittingAfterWaxRim = 'FITTING_AFTER_WAX_RIM',
  OneAppointmentDirectAfterFitting = 'ONE_APPOINTMENT_DIRECT_AFTER_FITTING',
  OneAppointmentDirectAfterWaxRim = 'ONE_APPOINTMENT_DIRECT_AFTER_WAX_RIM',
  WaxRim = 'WAX_RIM'
}

export type ItemPriceUpdateInput = {
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  aggressivePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  bronzePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  centerPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  goldPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantRetentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  isJasperPrice?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutItemPriceReferenceNestedInput>;
  itemLabel?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutItemPriceNestedInput>;
  itemReferenceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItemWorkflowType?: InputMaybe<NullableEnumItemPriceTypeFieldUpdateOperationsInput>;
  removableTeethToManufactureMax?: InputMaybe<IntFieldUpdateOperationsInput>;
  removableTeethToManufactureMin?: InputMaybe<IntFieldUpdateOperationsInput>;
  silverPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  supplier?: InputMaybe<UserUpdateOneWithoutItemPriceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemPriceUpdateManyMutationInput = {
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  aggressivePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  bronzePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  centerPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  goldPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantRetentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  isJasperPrice?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemLabel?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemReferenceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItemWorkflowType?: InputMaybe<NullableEnumItemPriceTypeFieldUpdateOperationsInput>;
  removableTeethToManufactureMax?: InputMaybe<IntFieldUpdateOperationsInput>;
  removableTeethToManufactureMin?: InputMaybe<IntFieldUpdateOperationsInput>;
  silverPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemPriceUpdateManyWithWhereWithoutItemMaterialInput = {
  data: ItemPriceUpdateManyMutationInput;
  where: ItemPriceScalarWhereInput;
};

export type ItemPriceUpdateManyWithWhereWithoutSupplierInput = {
  data: ItemPriceUpdateManyMutationInput;
  where: ItemPriceScalarWhereInput;
};

export type ItemPriceUpdateManyWithoutItemMaterialNestedInput = {
  connect?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemPriceCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<ItemPriceCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<ItemPriceCreateManyItemMaterialInputEnvelope>;
  delete?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemPriceUpdateWithWhereUniqueWithoutItemMaterialInput>>;
  updateMany?: InputMaybe<Array<ItemPriceUpdateManyWithWhereWithoutItemMaterialInput>>;
  upsert?: InputMaybe<Array<ItemPriceUpsertWithWhereUniqueWithoutItemMaterialInput>>;
};

export type ItemPriceUpdateManyWithoutSupplierNestedInput = {
  connect?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemPriceCreateOrConnectWithoutSupplierInput>>;
  create?: InputMaybe<Array<ItemPriceCreateWithoutSupplierInput>>;
  createMany?: InputMaybe<ItemPriceCreateManySupplierInputEnvelope>;
  delete?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemPriceUpdateWithWhereUniqueWithoutSupplierInput>>;
  updateMany?: InputMaybe<Array<ItemPriceUpdateManyWithWhereWithoutSupplierInput>>;
  upsert?: InputMaybe<Array<ItemPriceUpsertWithWhereUniqueWithoutSupplierInput>>;
};

export type ItemPriceUpdateOneWithoutItemBillingNestedInput = {
  connect?: InputMaybe<ItemPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemPriceCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<ItemPriceCreateWithoutItemBillingInput>;
  delete?: InputMaybe<ItemPriceWhereInput>;
  disconnect?: InputMaybe<ItemPriceWhereInput>;
  update?: InputMaybe<ItemPriceUpdateToOneWithWhereWithoutItemBillingInput>;
  upsert?: InputMaybe<ItemPriceUpsertWithoutItemBillingInput>;
};

export type ItemPriceUpdateToOneWithWhereWithoutItemBillingInput = {
  data: ItemPriceUpdateWithoutItemBillingInput;
  where?: InputMaybe<ItemPriceWhereInput>;
};

export type ItemPriceUpdateWithWhereUniqueWithoutItemMaterialInput = {
  data: ItemPriceUpdateWithoutItemMaterialInput;
  where: ItemPriceWhereUniqueInput;
};

export type ItemPriceUpdateWithWhereUniqueWithoutSupplierInput = {
  data: ItemPriceUpdateWithoutSupplierInput;
  where: ItemPriceWhereUniqueInput;
};

export type ItemPriceUpdateWithoutItemBillingInput = {
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  aggressivePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  bronzePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  centerPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  goldPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantRetentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  isJasperPrice?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemLabel?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutItemPriceNestedInput>;
  itemReferenceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItemWorkflowType?: InputMaybe<NullableEnumItemPriceTypeFieldUpdateOperationsInput>;
  removableTeethToManufactureMax?: InputMaybe<IntFieldUpdateOperationsInput>;
  removableTeethToManufactureMin?: InputMaybe<IntFieldUpdateOperationsInput>;
  silverPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  supplier?: InputMaybe<UserUpdateOneWithoutItemPriceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemPriceUpdateWithoutItemMaterialInput = {
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  aggressivePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  bronzePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  centerPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  goldPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantRetentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  isJasperPrice?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutItemPriceReferenceNestedInput>;
  itemLabel?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemReferenceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItemWorkflowType?: InputMaybe<NullableEnumItemPriceTypeFieldUpdateOperationsInput>;
  removableTeethToManufactureMax?: InputMaybe<IntFieldUpdateOperationsInput>;
  removableTeethToManufactureMin?: InputMaybe<IntFieldUpdateOperationsInput>;
  silverPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  supplier?: InputMaybe<UserUpdateOneWithoutItemPriceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemPriceUpdateWithoutSupplierInput = {
  abutmentType?: InputMaybe<NullableEnumAbutmentTypeFieldUpdateOperationsInput>;
  aggressivePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  basePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  bronzePrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  centerPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  goldPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantRetentionType?: InputMaybe<NullableEnumRetentionTypeFieldUpdateOperationsInput>;
  isJasperPrice?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutItemPriceReferenceNestedInput>;
  itemLabel?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutItemPriceNestedInput>;
  itemReferenceCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItemWorkflowType?: InputMaybe<NullableEnumItemPriceTypeFieldUpdateOperationsInput>;
  removableTeethToManufactureMax?: InputMaybe<IntFieldUpdateOperationsInput>;
  removableTeethToManufactureMin?: InputMaybe<IntFieldUpdateOperationsInput>;
  silverPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ItemPriceUpsertWithWhereUniqueWithoutItemMaterialInput = {
  create: ItemPriceCreateWithoutItemMaterialInput;
  update: ItemPriceUpdateWithoutItemMaterialInput;
  where: ItemPriceWhereUniqueInput;
};

export type ItemPriceUpsertWithWhereUniqueWithoutSupplierInput = {
  create: ItemPriceCreateWithoutSupplierInput;
  update: ItemPriceUpdateWithoutSupplierInput;
  where: ItemPriceWhereUniqueInput;
};

export type ItemPriceUpsertWithoutItemBillingInput = {
  create: ItemPriceCreateWithoutItemBillingInput;
  update: ItemPriceUpdateWithoutItemBillingInput;
  where?: InputMaybe<ItemPriceWhereInput>;
};

export type ItemPriceWhereInput = {
  AND?: InputMaybe<Array<ItemPriceWhereInput>>;
  NOT?: InputMaybe<Array<ItemPriceWhereInput>>;
  OR?: InputMaybe<Array<ItemPriceWhereInput>>;
  abutmentType?: InputMaybe<EnumAbutmentTypeNullableFilter>;
  aggressivePrice?: InputMaybe<DecimalNullableFilter>;
  basePrice?: InputMaybe<DecimalNullableFilter>;
  bronzePrice?: InputMaybe<DecimalNullableFilter>;
  centerPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  goldPrice?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  implantRetentionType?: InputMaybe<EnumRetentionTypeNullableFilter>;
  isJasperPrice?: InputMaybe<BoolFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemLabel?: InputMaybe<StringFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemReferenceCode?: InputMaybe<StringFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  removableItemWorkflowType?: InputMaybe<EnumItemPriceTypeNullableFilter>;
  removableTeethToManufactureMax?: InputMaybe<IntFilter>;
  removableTeethToManufactureMin?: InputMaybe<IntFilter>;
  silverPrice?: InputMaybe<DecimalNullableFilter>;
  supplier?: InputMaybe<UserNullableScalarRelationFilter>;
  supplierId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ItemPriceWhereUniqueInput = {
  AND?: InputMaybe<Array<ItemPriceWhereInput>>;
  NOT?: InputMaybe<Array<ItemPriceWhereInput>>;
  OR?: InputMaybe<Array<ItemPriceWhereInput>>;
  abutmentType?: InputMaybe<EnumAbutmentTypeNullableFilter>;
  aggressivePrice?: InputMaybe<DecimalNullableFilter>;
  basePrice?: InputMaybe<DecimalNullableFilter>;
  bronzePrice?: InputMaybe<DecimalNullableFilter>;
  centerPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  goldPrice?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantRetentionType?: InputMaybe<EnumRetentionTypeNullableFilter>;
  isJasperPrice?: InputMaybe<BoolFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemLabel?: InputMaybe<StringFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemReferenceCode?: InputMaybe<StringFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  removableItemWorkflowType?: InputMaybe<EnumItemPriceTypeNullableFilter>;
  removableTeethToManufactureMax?: InputMaybe<IntFilter>;
  removableTeethToManufactureMin?: InputMaybe<IntFilter>;
  silverPrice?: InputMaybe<DecimalNullableFilter>;
  supplier?: InputMaybe<UserNullableScalarRelationFilter>;
  supplierId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ItemScopeV2 {
  Arch = 'ARCH',
  Tooth = 'TOOTH'
}

export type ItemShade = {
  __typename?: 'ItemShade';
  _count: ItemShadeCount;
  anatomyItem?: Maybe<Array<AnatomyItem>>;
  bridge: Scalars['Boolean']['output'];
  colorCode: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  crown: Scalars['Boolean']['output'];
  fullDentureTeeth: Scalars['Boolean']['output'];
  gingiva: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  implantItem?: Maybe<Array<ImplantItem>>;
  label: Scalars['String']['output'];
  lay: Scalars['Boolean']['output'];
  multiShadeInfo?: Maybe<Array<MultiShadeInfo>>;
  partialDentureTeeth: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  removableItemGingiva?: Maybe<Array<RemovableItem>>;
  removableItemTeeth?: Maybe<Array<RemovableItem>>;
  shadeType?: Maybe<ItemShadeType>;
  updatedAt: Scalars['Timestamp']['output'];
  veneer: Scalars['Boolean']['output'];
};

export type ItemShadeCount = {
  __typename?: 'ItemShadeCount';
  anatomyItem: Scalars['Int']['output'];
  implantItem: Scalars['Int']['output'];
  multiShadeInfo: Scalars['Int']['output'];
  removableItemGingiva: Scalars['Int']['output'];
  removableItemTeeth: Scalars['Int']['output'];
};

export type ItemShadeCreateInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemShadeInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  colorCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  gingiva?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemShadeInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutItemShadeInput>;
  partialDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  removableItemGingiva?: InputMaybe<RemovableItemCreateNestedManyWithoutGingivaShadeInput>;
  removableItemTeeth?: InputMaybe<RemovableItemCreateNestedManyWithoutTeethShadeInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemShadeCreateNestedOneWithoutAnatomyItemInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutAnatomyItemInput>;
  create?: InputMaybe<ItemShadeCreateWithoutAnatomyItemInput>;
};

export type ItemShadeCreateNestedOneWithoutImplantItemInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ItemShadeCreateWithoutImplantItemInput>;
};

export type ItemShadeCreateNestedOneWithoutMultiShadeInfoInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutMultiShadeInfoInput>;
  create?: InputMaybe<ItemShadeCreateWithoutMultiShadeInfoInput>;
};

export type ItemShadeCreateNestedOneWithoutRemovableItemGingivaInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutRemovableItemGingivaInput>;
  create?: InputMaybe<ItemShadeCreateWithoutRemovableItemGingivaInput>;
};

export type ItemShadeCreateNestedOneWithoutRemovableItemTeethInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutRemovableItemTeethInput>;
  create?: InputMaybe<ItemShadeCreateWithoutRemovableItemTeethInput>;
};

export type ItemShadeCreateOrConnectWithoutAnatomyItemInput = {
  create: ItemShadeCreateWithoutAnatomyItemInput;
  where: ItemShadeWhereUniqueInput;
};

export type ItemShadeCreateOrConnectWithoutImplantItemInput = {
  create: ItemShadeCreateWithoutImplantItemInput;
  where: ItemShadeWhereUniqueInput;
};

export type ItemShadeCreateOrConnectWithoutMultiShadeInfoInput = {
  create: ItemShadeCreateWithoutMultiShadeInfoInput;
  where: ItemShadeWhereUniqueInput;
};

export type ItemShadeCreateOrConnectWithoutRemovableItemGingivaInput = {
  create: ItemShadeCreateWithoutRemovableItemGingivaInput;
  where: ItemShadeWhereUniqueInput;
};

export type ItemShadeCreateOrConnectWithoutRemovableItemTeethInput = {
  create: ItemShadeCreateWithoutRemovableItemTeethInput;
  where: ItemShadeWhereUniqueInput;
};

export type ItemShadeCreateWithoutAnatomyItemInput = {
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  colorCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  gingiva?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemShadeInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutItemShadeInput>;
  partialDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  removableItemGingiva?: InputMaybe<RemovableItemCreateNestedManyWithoutGingivaShadeInput>;
  removableItemTeeth?: InputMaybe<RemovableItemCreateNestedManyWithoutTeethShadeInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemShadeCreateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemShadeInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  colorCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  gingiva?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutItemShadeInput>;
  partialDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  removableItemGingiva?: InputMaybe<RemovableItemCreateNestedManyWithoutGingivaShadeInput>;
  removableItemTeeth?: InputMaybe<RemovableItemCreateNestedManyWithoutTeethShadeInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemShadeCreateWithoutMultiShadeInfoInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemShadeInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  colorCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  gingiva?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemShadeInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  removableItemGingiva?: InputMaybe<RemovableItemCreateNestedManyWithoutGingivaShadeInput>;
  removableItemTeeth?: InputMaybe<RemovableItemCreateNestedManyWithoutTeethShadeInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemShadeCreateWithoutRemovableItemGingivaInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemShadeInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  colorCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  gingiva?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemShadeInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutItemShadeInput>;
  partialDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  removableItemTeeth?: InputMaybe<RemovableItemCreateNestedManyWithoutTeethShadeInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemShadeCreateWithoutRemovableItemTeethInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutItemShadeInput>;
  bridge?: InputMaybe<Scalars['Boolean']['input']>;
  colorCode: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  crown?: InputMaybe<Scalars['Boolean']['input']>;
  fullDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  gingiva?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutItemShadeInput>;
  label: Scalars['String']['input'];
  lay?: InputMaybe<Scalars['Boolean']['input']>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoCreateNestedManyWithoutItemShadeInput>;
  partialDentureTeeth?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  removableItemGingiva?: InputMaybe<RemovableItemCreateNestedManyWithoutGingivaShadeInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  veneer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemShadeModel = {
  __typename?: 'ItemShadeModel';
  colorCode?: Maybe<Scalars['String']['output']>;
  compatibleItemTypes: Array<ItemTypeV2>;
  id: Scalars['String']['output'];
  isGingivaShade: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Float']['output']>;
  shadeType: Scalars['String']['output'];
};

export type ItemShadeNullableScalarRelationFilter = {
  is?: InputMaybe<ItemShadeWhereInput>;
  isNot?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeOrderByWithRelationInput = {
  anatomyItem?: InputMaybe<AnatomyItemOrderByRelationAggregateInput>;
  bridge?: InputMaybe<SortOrder>;
  colorCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  crown?: InputMaybe<SortOrder>;
  fullDentureTeeth?: InputMaybe<SortOrder>;
  gingiva?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  implantItem?: InputMaybe<ImplantItemOrderByRelationAggregateInput>;
  label?: InputMaybe<SortOrder>;
  lay?: InputMaybe<SortOrder>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoOrderByRelationAggregateInput>;
  partialDentureTeeth?: InputMaybe<SortOrder>;
  priority?: InputMaybe<SortOrderInput>;
  removableItemGingiva?: InputMaybe<RemovableItemOrderByRelationAggregateInput>;
  removableItemTeeth?: InputMaybe<RemovableItemOrderByRelationAggregateInput>;
  shadeType?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  veneer?: InputMaybe<SortOrder>;
};

export enum ItemShadeScalarFieldEnum {
  Bridge = 'bridge',
  ColorCode = 'colorCode',
  CreatedAt = 'createdAt',
  Crown = 'crown',
  FullDentureTeeth = 'fullDentureTeeth',
  Gingiva = 'gingiva',
  Id = 'id',
  Label = 'label',
  Lay = 'lay',
  PartialDentureTeeth = 'partialDentureTeeth',
  Priority = 'priority',
  ShadeType = 'shadeType',
  UpdatedAt = 'updatedAt',
  Veneer = 'veneer'
}

export type ItemShadeScalarRelationFilter = {
  is?: InputMaybe<ItemShadeWhereInput>;
  isNot?: InputMaybe<ItemShadeWhereInput>;
};

export enum ItemShadeType {
  Chromascop = 'CHROMASCOP',
  Gingiva = 'GINGIVA',
  SrVivodentSpe = 'SR_VIVODENT_SPE',
  Vita_3DClassic = 'VITA_3D_CLASSIC',
  Vita_3DMaster = 'VITA_3D_MASTER',
  VitaClassic = 'VITA_CLASSIC'
}

export type ItemShadeUpdateInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemShadeNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  colorCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gingiva?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemShadeNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutItemShadeNestedInput>;
  partialDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  removableItemGingiva?: InputMaybe<RemovableItemUpdateManyWithoutGingivaShadeNestedInput>;
  removableItemTeeth?: InputMaybe<RemovableItemUpdateManyWithoutTeethShadeNestedInput>;
  shadeType?: InputMaybe<NullableEnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemShadeUpdateOneRequiredWithoutMultiShadeInfoNestedInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutMultiShadeInfoInput>;
  create?: InputMaybe<ItemShadeCreateWithoutMultiShadeInfoInput>;
  update?: InputMaybe<ItemShadeUpdateToOneWithWhereWithoutMultiShadeInfoInput>;
  upsert?: InputMaybe<ItemShadeUpsertWithoutMultiShadeInfoInput>;
};

export type ItemShadeUpdateOneWithoutAnatomyItemNestedInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutAnatomyItemInput>;
  create?: InputMaybe<ItemShadeCreateWithoutAnatomyItemInput>;
  delete?: InputMaybe<ItemShadeWhereInput>;
  disconnect?: InputMaybe<ItemShadeWhereInput>;
  update?: InputMaybe<ItemShadeUpdateToOneWithWhereWithoutAnatomyItemInput>;
  upsert?: InputMaybe<ItemShadeUpsertWithoutAnatomyItemInput>;
};

export type ItemShadeUpdateOneWithoutImplantItemNestedInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ItemShadeCreateWithoutImplantItemInput>;
  delete?: InputMaybe<ItemShadeWhereInput>;
  disconnect?: InputMaybe<ItemShadeWhereInput>;
  update?: InputMaybe<ItemShadeUpdateToOneWithWhereWithoutImplantItemInput>;
  upsert?: InputMaybe<ItemShadeUpsertWithoutImplantItemInput>;
};

export type ItemShadeUpdateOneWithoutRemovableItemGingivaNestedInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutRemovableItemGingivaInput>;
  create?: InputMaybe<ItemShadeCreateWithoutRemovableItemGingivaInput>;
  delete?: InputMaybe<ItemShadeWhereInput>;
  disconnect?: InputMaybe<ItemShadeWhereInput>;
  update?: InputMaybe<ItemShadeUpdateToOneWithWhereWithoutRemovableItemGingivaInput>;
  upsert?: InputMaybe<ItemShadeUpsertWithoutRemovableItemGingivaInput>;
};

export type ItemShadeUpdateOneWithoutRemovableItemTeethNestedInput = {
  connect?: InputMaybe<ItemShadeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemShadeCreateOrConnectWithoutRemovableItemTeethInput>;
  create?: InputMaybe<ItemShadeCreateWithoutRemovableItemTeethInput>;
  delete?: InputMaybe<ItemShadeWhereInput>;
  disconnect?: InputMaybe<ItemShadeWhereInput>;
  update?: InputMaybe<ItemShadeUpdateToOneWithWhereWithoutRemovableItemTeethInput>;
  upsert?: InputMaybe<ItemShadeUpsertWithoutRemovableItemTeethInput>;
};

export type ItemShadeUpdateToOneWithWhereWithoutAnatomyItemInput = {
  data: ItemShadeUpdateWithoutAnatomyItemInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpdateToOneWithWhereWithoutImplantItemInput = {
  data: ItemShadeUpdateWithoutImplantItemInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpdateToOneWithWhereWithoutMultiShadeInfoInput = {
  data: ItemShadeUpdateWithoutMultiShadeInfoInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpdateToOneWithWhereWithoutRemovableItemGingivaInput = {
  data: ItemShadeUpdateWithoutRemovableItemGingivaInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpdateToOneWithWhereWithoutRemovableItemTeethInput = {
  data: ItemShadeUpdateWithoutRemovableItemTeethInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpdateWithoutAnatomyItemInput = {
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  colorCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gingiva?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemShadeNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutItemShadeNestedInput>;
  partialDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  removableItemGingiva?: InputMaybe<RemovableItemUpdateManyWithoutGingivaShadeNestedInput>;
  removableItemTeeth?: InputMaybe<RemovableItemUpdateManyWithoutTeethShadeNestedInput>;
  shadeType?: InputMaybe<NullableEnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemShadeUpdateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemShadeNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  colorCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gingiva?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutItemShadeNestedInput>;
  partialDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  removableItemGingiva?: InputMaybe<RemovableItemUpdateManyWithoutGingivaShadeNestedInput>;
  removableItemTeeth?: InputMaybe<RemovableItemUpdateManyWithoutTeethShadeNestedInput>;
  shadeType?: InputMaybe<NullableEnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemShadeUpdateWithoutMultiShadeInfoInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemShadeNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  colorCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gingiva?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemShadeNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  removableItemGingiva?: InputMaybe<RemovableItemUpdateManyWithoutGingivaShadeNestedInput>;
  removableItemTeeth?: InputMaybe<RemovableItemUpdateManyWithoutTeethShadeNestedInput>;
  shadeType?: InputMaybe<NullableEnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemShadeUpdateWithoutRemovableItemGingivaInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemShadeNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  colorCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gingiva?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemShadeNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutItemShadeNestedInput>;
  partialDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  removableItemTeeth?: InputMaybe<RemovableItemUpdateManyWithoutTeethShadeNestedInput>;
  shadeType?: InputMaybe<NullableEnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemShadeUpdateWithoutRemovableItemTeethInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutItemShadeNestedInput>;
  bridge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  colorCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  crown?: InputMaybe<BoolFieldUpdateOperationsInput>;
  fullDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  gingiva?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutItemShadeNestedInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  lay?: InputMaybe<BoolFieldUpdateOperationsInput>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoUpdateManyWithoutItemShadeNestedInput>;
  partialDentureTeeth?: InputMaybe<BoolFieldUpdateOperationsInput>;
  priority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  removableItemGingiva?: InputMaybe<RemovableItemUpdateManyWithoutGingivaShadeNestedInput>;
  shadeType?: InputMaybe<NullableEnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  veneer?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ItemShadeUpsertWithoutAnatomyItemInput = {
  create: ItemShadeCreateWithoutAnatomyItemInput;
  update: ItemShadeUpdateWithoutAnatomyItemInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpsertWithoutImplantItemInput = {
  create: ItemShadeCreateWithoutImplantItemInput;
  update: ItemShadeUpdateWithoutImplantItemInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpsertWithoutMultiShadeInfoInput = {
  create: ItemShadeCreateWithoutMultiShadeInfoInput;
  update: ItemShadeUpdateWithoutMultiShadeInfoInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpsertWithoutRemovableItemGingivaInput = {
  create: ItemShadeCreateWithoutRemovableItemGingivaInput;
  update: ItemShadeUpdateWithoutRemovableItemGingivaInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeUpsertWithoutRemovableItemTeethInput = {
  create: ItemShadeCreateWithoutRemovableItemTeethInput;
  update: ItemShadeUpdateWithoutRemovableItemTeethInput;
  where?: InputMaybe<ItemShadeWhereInput>;
};

export type ItemShadeWhereInput = {
  AND?: InputMaybe<Array<ItemShadeWhereInput>>;
  NOT?: InputMaybe<Array<ItemShadeWhereInput>>;
  OR?: InputMaybe<Array<ItemShadeWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemListRelationFilter>;
  bridge?: InputMaybe<BoolFilter>;
  colorCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crown?: InputMaybe<BoolFilter>;
  fullDentureTeeth?: InputMaybe<BoolFilter>;
  gingiva?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  label?: InputMaybe<StringFilter>;
  lay?: InputMaybe<BoolFilter>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoListRelationFilter>;
  partialDentureTeeth?: InputMaybe<BoolFilter>;
  priority?: InputMaybe<IntNullableFilter>;
  removableItemGingiva?: InputMaybe<RemovableItemListRelationFilter>;
  removableItemTeeth?: InputMaybe<RemovableItemListRelationFilter>;
  shadeType?: InputMaybe<EnumItemShadeTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  veneer?: InputMaybe<BoolFilter>;
};

export type ItemShadeWhereUniqueInput = {
  AND?: InputMaybe<Array<ItemShadeWhereInput>>;
  NOT?: InputMaybe<Array<ItemShadeWhereInput>>;
  OR?: InputMaybe<Array<ItemShadeWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemListRelationFilter>;
  bridge?: InputMaybe<BoolFilter>;
  colorCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  crown?: InputMaybe<BoolFilter>;
  fullDentureTeeth?: InputMaybe<BoolFilter>;
  gingiva?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  label?: InputMaybe<StringFilter>;
  lay?: InputMaybe<BoolFilter>;
  multiShadeInfo?: InputMaybe<MultiShadeInfoListRelationFilter>;
  partialDentureTeeth?: InputMaybe<BoolFilter>;
  priority?: InputMaybe<IntNullableFilter>;
  removableItemGingiva?: InputMaybe<RemovableItemListRelationFilter>;
  removableItemTeeth?: InputMaybe<RemovableItemListRelationFilter>;
  shadeType?: InputMaybe<EnumItemShadeTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  veneer?: InputMaybe<BoolFilter>;
};

export enum ItemType {
  Abutment = 'ABUTMENT',
  AddingTeethOnExistingDenture = 'ADDING_TEETH_ON_EXISTING_DENTURE',
  AdditionalImpressionForRemovableProsthesis = 'ADDITIONAL_IMPRESSION_FOR_REMOVABLE_PROSTHESIS',
  BleachingTray = 'BLEACHING_TRAY',
  Bridge = 'BRIDGE',
  BridgeImplant = 'BRIDGE_IMPLANT',
  BridgePontic = 'BRIDGE_PONTIC',
  Crown = 'CROWN',
  CustomAbutment = 'CUSTOM_ABUTMENT',
  CustomTray = 'CUSTOM_TRAY',
  DentureRepair = 'DENTURE_REPAIR',
  FullDenture = 'FULL_DENTURE',
  FullDentureWaxBite = 'FULL_DENTURE_WAX_BITE',
  ImmediateDenture = 'IMMEDIATE_DENTURE',
  Implant = 'IMPLANT',
  ImplantCrown = 'IMPLANT_CROWN',
  Inlay = 'INLAY',
  InlayCore = 'INLAY_CORE',
  Lay = 'LAY',
  MetalMesh = 'METAL_MESH',
  Model = 'MODEL',
  NightGuard = 'NIGHT_GUARD',
  Onlay = 'ONLAY',
  OrthoModel = 'ORTHO_MODEL',
  Overlay = 'OVERLAY',
  PartialDenture = 'PARTIAL_DENTURE',
  PostAndCoreRetainedCrown = 'POST_AND_CORE_RETAINED_CROWN',
  RemovableDenture = 'REMOVABLE_DENTURE',
  Retainer = 'RETAINER',
  RetentionWire = 'RETENTION_WIRE',
  RichmondCrown = 'RICHMOND_CROWN',
  ScanOnly = 'SCAN_ONLY',
  SpaceMaintainer = 'SPACE_MAINTAINER',
  Splint = 'SPLINT',
  SplintedCrown = 'SPLINTED_CROWN',
  SplintedCrownImplant = 'SPLINTED_CROWN_IMPLANT',
  Veneer = 'VENEER',
  WaxBite = 'WAX_BITE',
  WaxUp = 'WAX_UP'
}

export enum ItemTypeV2 {
  Abutment = 'ABUTMENT',
  AddingTeethOnExistingDenture = 'ADDING_TEETH_ON_EXISTING_DENTURE',
  AdditionalImpressionForRemovableProsthesis = 'ADDITIONAL_IMPRESSION_FOR_REMOVABLE_PROSTHESIS',
  BleachingTray = 'BLEACHING_TRAY',
  Bridge = 'BRIDGE',
  BridgeImplant = 'BRIDGE_IMPLANT',
  BridgePontic = 'BRIDGE_PONTIC',
  Crown = 'CROWN',
  CustomAbutment = 'CUSTOM_ABUTMENT',
  CustomTray = 'CUSTOM_TRAY',
  DentureRepair = 'DENTURE_REPAIR',
  FullDenture = 'FULL_DENTURE',
  FullDentureWaxBite = 'FULL_DENTURE_WAX_BITE',
  ImmediateDenture = 'IMMEDIATE_DENTURE',
  Implant = 'IMPLANT',
  ImplantCrown = 'IMPLANT_CROWN',
  Inlay = 'INLAY',
  InlayCore = 'INLAY_CORE',
  Lay = 'LAY',
  MetalMesh = 'METAL_MESH',
  Model = 'MODEL',
  NightGuard = 'NIGHT_GUARD',
  Onlay = 'ONLAY',
  OrthoModel = 'ORTHO_MODEL',
  Overlay = 'OVERLAY',
  PartialDenture = 'PARTIAL_DENTURE',
  PostAndCoreRetainedCrown = 'POST_AND_CORE_RETAINED_CROWN',
  RemovableDenture = 'REMOVABLE_DENTURE',
  Retainer = 'RETAINER',
  RetentionWire = 'RETENTION_WIRE',
  RichmondCrown = 'RICHMOND_CROWN',
  ScanOnly = 'SCAN_ONLY',
  SpaceMaintainer = 'SPACE_MAINTAINER',
  Splint = 'SPLINT',
  SplintedCrown = 'SPLINTED_CROWN',
  SplintedCrownImplant = 'SPLINTED_CROWN_IMPLANT',
  Veneer = 'VENEER',
  WaxBite = 'WAX_BITE',
  WaxUp = 'WAX_UP'
}

export type ItemV2 = {
  abutmentCharacteristics?: Maybe<AbutmentCharacteristics>;
  id: Scalars['String']['output'];
  implantCharacteristics?: Maybe<ImplantCharacteristics>;
  implantedItemCharacteristics?: Maybe<ImplantedItemCharacteristicsModel>;
  inlayCoreCharacteristics?: Maybe<InlayCoreCharacteristicsModel>;
  materialCharacteristics?: Maybe<MaterialCharacteristicsModel>;
  product: ProductModel;
  scope: ItemScopeV2;
  type: ItemTypeV2;
  waxUpType?: Maybe<WaxUpTypeV2>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type Login = {
  __typename?: 'Login';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  user: User;
  userId: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type LoginCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};

export type LoginCreateManyUserInputEnvelope = {
  data: Array<LoginCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<LoginWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LoginCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LoginCreateWithoutUserInput>>;
  createMany?: InputMaybe<LoginCreateManyUserInputEnvelope>;
};

export type LoginCreateOrConnectWithoutUserInput = {
  create: LoginCreateWithoutUserInput;
  where: LoginWhereUniqueInput;
};

export type LoginCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};

export type LoginListRelationFilter = {
  every?: InputMaybe<LoginWhereInput>;
  none?: InputMaybe<LoginWhereInput>;
  some?: InputMaybe<LoginWhereInput>;
};

export type LoginOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LoginScalarWhereInput = {
  AND?: InputMaybe<Array<LoginScalarWhereInput>>;
  NOT?: InputMaybe<Array<LoginScalarWhereInput>>;
  OR?: InputMaybe<Array<LoginScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
  version?: InputMaybe<StringFilter>;
};

export type LoginUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LoginUpdateManyWithWhereWithoutUserInput = {
  data: LoginUpdateManyMutationInput;
  where: LoginScalarWhereInput;
};

export type LoginUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<LoginWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LoginCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LoginCreateWithoutUserInput>>;
  createMany?: InputMaybe<LoginCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<LoginWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LoginScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LoginWhereUniqueInput>>;
  set?: InputMaybe<Array<LoginWhereUniqueInput>>;
  update?: InputMaybe<Array<LoginUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<LoginUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<LoginUpsertWithWhereUniqueWithoutUserInput>>;
};

export type LoginUpdateWithWhereUniqueWithoutUserInput = {
  data: LoginUpdateWithoutUserInput;
  where: LoginWhereUniqueInput;
};

export type LoginUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LoginUpsertWithWhereUniqueWithoutUserInput = {
  create: LoginCreateWithoutUserInput;
  update: LoginUpdateWithoutUserInput;
  where: LoginWhereUniqueInput;
};

export type LoginWhereInput = {
  AND?: InputMaybe<Array<LoginWhereInput>>;
  NOT?: InputMaybe<Array<LoginWhereInput>>;
  OR?: InputMaybe<Array<LoginWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  version?: InputMaybe<StringFilter>;
};

export type LoginWhereUniqueInput = {
  AND?: InputMaybe<Array<LoginWhereInput>>;
  NOT?: InputMaybe<Array<LoginWhereInput>>;
  OR?: InputMaybe<Array<LoginWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
  version?: InputMaybe<StringFilter>;
};

export type MaterialCharacteristicsModel = {
  __typename?: 'MaterialCharacteristicsModel';
  material: ItemMaterialModel;
  shadeCharacteristics?: Maybe<ShadeCharacteristics>;
};

export type MaterialTraceability = {
  __typename?: 'MaterialTraceability';
  _count: MaterialTraceabilityCount;
  createdAt: Scalars['Timestamp']['output'];
  firstMaterialApprovalReference?: Maybe<Scalars['String']['output']>;
  firstMaterialBrand?: Maybe<Scalars['String']['output']>;
  firstMaterialCountry?: Maybe<Scalars['String']['output']>;
  firstMaterialReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemBilling?: Maybe<Array<ItemBilling>>;
  itemMaterial: ItemMaterial;
  itemMaterialId: Scalars['String']['output'];
  providerMaterialTraceability?: Maybe<Array<ProviderMaterialTraceability>>;
  secondMaterialApprovalReference?: Maybe<Scalars['String']['output']>;
  secondMaterialBrand?: Maybe<Scalars['String']['output']>;
  secondMaterialCountry?: Maybe<Scalars['String']['output']>;
  secondMaterialReference?: Maybe<Scalars['String']['output']>;
  translatedName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type MaterialTraceabilityCount = {
  __typename?: 'MaterialTraceabilityCount';
  itemBilling: Scalars['Int']['output'];
  providerMaterialTraceability: Scalars['Int']['output'];
};

export type MaterialTraceabilityCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutFirstMaterialTraceabilityInput>;
  itemMaterial: ItemMaterialCreateNestedOneWithoutSupplierMaterialTraceabilityInput;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutMaterialTraceabilityInput>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MaterialTraceabilityCreateManyItemMaterialInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MaterialTraceabilityCreateManyItemMaterialInputEnvelope = {
  data: Array<MaterialTraceabilityCreateManyItemMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterialTraceabilityCreateNestedManyWithoutItemMaterialInput = {
  connect?: InputMaybe<Array<MaterialTraceabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTraceabilityCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<MaterialTraceabilityCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<MaterialTraceabilityCreateManyItemMaterialInputEnvelope>;
};

export type MaterialTraceabilityCreateNestedOneWithoutItemBillingInput = {
  connect?: InputMaybe<MaterialTraceabilityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaterialTraceabilityCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<MaterialTraceabilityCreateWithoutItemBillingInput>;
};

export type MaterialTraceabilityCreateNestedOneWithoutProviderMaterialTraceabilityInput = {
  connect?: InputMaybe<MaterialTraceabilityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaterialTraceabilityCreateOrConnectWithoutProviderMaterialTraceabilityInput>;
  create?: InputMaybe<MaterialTraceabilityCreateWithoutProviderMaterialTraceabilityInput>;
};

export type MaterialTraceabilityCreateOrConnectWithoutItemBillingInput = {
  create: MaterialTraceabilityCreateWithoutItemBillingInput;
  where: MaterialTraceabilityWhereUniqueInput;
};

export type MaterialTraceabilityCreateOrConnectWithoutItemMaterialInput = {
  create: MaterialTraceabilityCreateWithoutItemMaterialInput;
  where: MaterialTraceabilityWhereUniqueInput;
};

export type MaterialTraceabilityCreateOrConnectWithoutProviderMaterialTraceabilityInput = {
  create: MaterialTraceabilityCreateWithoutProviderMaterialTraceabilityInput;
  where: MaterialTraceabilityWhereUniqueInput;
};

export type MaterialTraceabilityCreateWithoutItemBillingInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemMaterial: ItemMaterialCreateNestedOneWithoutSupplierMaterialTraceabilityInput;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutMaterialTraceabilityInput>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MaterialTraceabilityCreateWithoutItemMaterialInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutFirstMaterialTraceabilityInput>;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutMaterialTraceabilityInput>;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MaterialTraceabilityCreateWithoutProviderMaterialTraceabilityInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  firstMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  firstMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  firstMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  firstMaterialReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutFirstMaterialTraceabilityInput>;
  itemMaterial: ItemMaterialCreateNestedOneWithoutSupplierMaterialTraceabilityInput;
  secondMaterialApprovalReference?: InputMaybe<Scalars['String']['input']>;
  secondMaterialBrand?: InputMaybe<Scalars['String']['input']>;
  secondMaterialCountry?: InputMaybe<Scalars['String']['input']>;
  secondMaterialReference?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MaterialTraceabilityListRelationFilter = {
  every?: InputMaybe<MaterialTraceabilityWhereInput>;
  none?: InputMaybe<MaterialTraceabilityWhereInput>;
  some?: InputMaybe<MaterialTraceabilityWhereInput>;
};

export type MaterialTraceabilityNullableScalarRelationFilter = {
  is?: InputMaybe<MaterialTraceabilityWhereInput>;
  isNot?: InputMaybe<MaterialTraceabilityWhereInput>;
};

export type MaterialTraceabilityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MaterialTraceabilityOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  firstMaterialApprovalReference?: InputMaybe<SortOrderInput>;
  firstMaterialBrand?: InputMaybe<SortOrderInput>;
  firstMaterialCountry?: InputMaybe<SortOrderInput>;
  firstMaterialReference?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  itemBilling?: InputMaybe<ItemBillingOrderByRelationAggregateInput>;
  itemMaterial?: InputMaybe<ItemMaterialOrderByWithRelationInput>;
  itemMaterialId?: InputMaybe<SortOrder>;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityOrderByRelationAggregateInput>;
  secondMaterialApprovalReference?: InputMaybe<SortOrderInput>;
  secondMaterialBrand?: InputMaybe<SortOrderInput>;
  secondMaterialCountry?: InputMaybe<SortOrderInput>;
  secondMaterialReference?: InputMaybe<SortOrderInput>;
  translatedName?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MaterialTraceabilityScalarFieldEnum {
  CreatedAt = 'createdAt',
  FirstMaterialApprovalReference = 'firstMaterialApprovalReference',
  FirstMaterialBrand = 'firstMaterialBrand',
  FirstMaterialCountry = 'firstMaterialCountry',
  FirstMaterialReference = 'firstMaterialReference',
  Id = 'id',
  ItemMaterialId = 'itemMaterialId',
  SecondMaterialApprovalReference = 'secondMaterialApprovalReference',
  SecondMaterialBrand = 'secondMaterialBrand',
  SecondMaterialCountry = 'secondMaterialCountry',
  SecondMaterialReference = 'secondMaterialReference',
  TranslatedName = 'translatedName',
  UpdatedAt = 'updatedAt'
}

export type MaterialTraceabilityScalarRelationFilter = {
  is?: InputMaybe<MaterialTraceabilityWhereInput>;
  isNot?: InputMaybe<MaterialTraceabilityWhereInput>;
};

export type MaterialTraceabilityScalarWhereInput = {
  AND?: InputMaybe<Array<MaterialTraceabilityScalarWhereInput>>;
  NOT?: InputMaybe<Array<MaterialTraceabilityScalarWhereInput>>;
  OR?: InputMaybe<Array<MaterialTraceabilityScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  firstMaterialBrand?: InputMaybe<StringNullableFilter>;
  firstMaterialCountry?: InputMaybe<StringNullableFilter>;
  firstMaterialReference?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  itemMaterialId?: InputMaybe<StringFilter>;
  secondMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  secondMaterialBrand?: InputMaybe<StringNullableFilter>;
  secondMaterialCountry?: InputMaybe<StringNullableFilter>;
  secondMaterialReference?: InputMaybe<StringNullableFilter>;
  translatedName?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MaterialTraceabilityUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutFirstMaterialTraceabilityNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneRequiredWithoutSupplierMaterialTraceabilityNestedInput>;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutMaterialTraceabilityNestedInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialTraceabilityUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialTraceabilityUpdateManyWithWhereWithoutItemMaterialInput = {
  data: MaterialTraceabilityUpdateManyMutationInput;
  where: MaterialTraceabilityScalarWhereInput;
};

export type MaterialTraceabilityUpdateManyWithoutItemMaterialNestedInput = {
  connect?: InputMaybe<Array<MaterialTraceabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialTraceabilityCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<MaterialTraceabilityCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<MaterialTraceabilityCreateManyItemMaterialInputEnvelope>;
  delete?: InputMaybe<Array<MaterialTraceabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialTraceabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialTraceabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialTraceabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialTraceabilityUpdateWithWhereUniqueWithoutItemMaterialInput>>;
  updateMany?: InputMaybe<Array<MaterialTraceabilityUpdateManyWithWhereWithoutItemMaterialInput>>;
  upsert?: InputMaybe<Array<MaterialTraceabilityUpsertWithWhereUniqueWithoutItemMaterialInput>>;
};

export type MaterialTraceabilityUpdateOneRequiredWithoutProviderMaterialTraceabilityNestedInput = {
  connect?: InputMaybe<MaterialTraceabilityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaterialTraceabilityCreateOrConnectWithoutProviderMaterialTraceabilityInput>;
  create?: InputMaybe<MaterialTraceabilityCreateWithoutProviderMaterialTraceabilityInput>;
  update?: InputMaybe<MaterialTraceabilityUpdateToOneWithWhereWithoutProviderMaterialTraceabilityInput>;
  upsert?: InputMaybe<MaterialTraceabilityUpsertWithoutProviderMaterialTraceabilityInput>;
};

export type MaterialTraceabilityUpdateOneWithoutItemBillingNestedInput = {
  connect?: InputMaybe<MaterialTraceabilityWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaterialTraceabilityCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<MaterialTraceabilityCreateWithoutItemBillingInput>;
  delete?: InputMaybe<MaterialTraceabilityWhereInput>;
  disconnect?: InputMaybe<MaterialTraceabilityWhereInput>;
  update?: InputMaybe<MaterialTraceabilityUpdateToOneWithWhereWithoutItemBillingInput>;
  upsert?: InputMaybe<MaterialTraceabilityUpsertWithoutItemBillingInput>;
};

export type MaterialTraceabilityUpdateToOneWithWhereWithoutItemBillingInput = {
  data: MaterialTraceabilityUpdateWithoutItemBillingInput;
  where?: InputMaybe<MaterialTraceabilityWhereInput>;
};

export type MaterialTraceabilityUpdateToOneWithWhereWithoutProviderMaterialTraceabilityInput = {
  data: MaterialTraceabilityUpdateWithoutProviderMaterialTraceabilityInput;
  where?: InputMaybe<MaterialTraceabilityWhereInput>;
};

export type MaterialTraceabilityUpdateWithWhereUniqueWithoutItemMaterialInput = {
  data: MaterialTraceabilityUpdateWithoutItemMaterialInput;
  where: MaterialTraceabilityWhereUniqueInput;
};

export type MaterialTraceabilityUpdateWithoutItemBillingInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneRequiredWithoutSupplierMaterialTraceabilityNestedInput>;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutMaterialTraceabilityNestedInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialTraceabilityUpdateWithoutItemMaterialInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutFirstMaterialTraceabilityNestedInput>;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutMaterialTraceabilityNestedInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialTraceabilityUpdateWithoutProviderMaterialTraceabilityInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  firstMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutFirstMaterialTraceabilityNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneRequiredWithoutSupplierMaterialTraceabilityNestedInput>;
  secondMaterialApprovalReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialBrand?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondMaterialReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialTraceabilityUpsertWithWhereUniqueWithoutItemMaterialInput = {
  create: MaterialTraceabilityCreateWithoutItemMaterialInput;
  update: MaterialTraceabilityUpdateWithoutItemMaterialInput;
  where: MaterialTraceabilityWhereUniqueInput;
};

export type MaterialTraceabilityUpsertWithoutItemBillingInput = {
  create: MaterialTraceabilityCreateWithoutItemBillingInput;
  update: MaterialTraceabilityUpdateWithoutItemBillingInput;
  where?: InputMaybe<MaterialTraceabilityWhereInput>;
};

export type MaterialTraceabilityUpsertWithoutProviderMaterialTraceabilityInput = {
  create: MaterialTraceabilityCreateWithoutProviderMaterialTraceabilityInput;
  update: MaterialTraceabilityUpdateWithoutProviderMaterialTraceabilityInput;
  where?: InputMaybe<MaterialTraceabilityWhereInput>;
};

export type MaterialTraceabilityWhereInput = {
  AND?: InputMaybe<Array<MaterialTraceabilityWhereInput>>;
  NOT?: InputMaybe<Array<MaterialTraceabilityWhereInput>>;
  OR?: InputMaybe<Array<MaterialTraceabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  firstMaterialBrand?: InputMaybe<StringNullableFilter>;
  firstMaterialCountry?: InputMaybe<StringNullableFilter>;
  firstMaterialReference?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringFilter>;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityListRelationFilter>;
  secondMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  secondMaterialBrand?: InputMaybe<StringNullableFilter>;
  secondMaterialCountry?: InputMaybe<StringNullableFilter>;
  secondMaterialReference?: InputMaybe<StringNullableFilter>;
  translatedName?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MaterialTraceabilityWhereUniqueInput = {
  AND?: InputMaybe<Array<MaterialTraceabilityWhereInput>>;
  NOT?: InputMaybe<Array<MaterialTraceabilityWhereInput>>;
  OR?: InputMaybe<Array<MaterialTraceabilityWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  firstMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  firstMaterialBrand?: InputMaybe<StringNullableFilter>;
  firstMaterialCountry?: InputMaybe<StringNullableFilter>;
  firstMaterialReference?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringFilter>;
  providerMaterialTraceability?: InputMaybe<ProviderMaterialTraceabilityListRelationFilter>;
  secondMaterialApprovalReference?: InputMaybe<StringNullableFilter>;
  secondMaterialBrand?: InputMaybe<StringNullableFilter>;
  secondMaterialCountry?: InputMaybe<StringNullableFilter>;
  secondMaterialReference?: InputMaybe<StringNullableFilter>;
  translatedName?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MultiShadeCharacteristicsModel = {
  __typename?: 'MultiShadeCharacteristicsModel';
  baseShade: ItemShadeModel;
  gingivalShade: ItemShadeModel;
  incisalShade: ItemShadeModel;
  isMultiShade: Scalars['Boolean']['output'];
};

export type MultiShadeInfo = {
  __typename?: 'MultiShadeInfo';
  anatomyItem?: Maybe<AnatomyItem>;
  anatomyItemId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  implantItem?: Maybe<ImplantItem>;
  implantItemId?: Maybe<Scalars['String']['output']>;
  itemShade: ItemShade;
  itemShadeId: Scalars['String']['output'];
  teethShadeSide: TeethShadeSide;
  updatedAt: Scalars['Timestamp']['output'];
};

export type MultiShadeInfoCreateManyAnatomyItemInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItemId?: InputMaybe<Scalars['String']['input']>;
  itemShadeId: Scalars['String']['input'];
  teethShadeSide: TeethShadeSide;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MultiShadeInfoCreateManyAnatomyItemInputEnvelope = {
  data: Array<MultiShadeInfoCreateManyAnatomyItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiShadeInfoCreateManyImplantItemInput = {
  anatomyItemId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemShadeId: Scalars['String']['input'];
  teethShadeSide: TeethShadeSide;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MultiShadeInfoCreateManyImplantItemInputEnvelope = {
  data: Array<MultiShadeInfoCreateManyImplantItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiShadeInfoCreateManyItemShadeInput = {
  anatomyItemId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItemId?: InputMaybe<Scalars['String']['input']>;
  teethShadeSide: TeethShadeSide;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MultiShadeInfoCreateManyItemShadeInputEnvelope = {
  data: Array<MultiShadeInfoCreateManyItemShadeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiShadeInfoCreateNestedManyWithoutAnatomyItemInput = {
  connect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MultiShadeInfoCreateOrConnectWithoutAnatomyItemInput>>;
  create?: InputMaybe<Array<MultiShadeInfoCreateWithoutAnatomyItemInput>>;
  createMany?: InputMaybe<MultiShadeInfoCreateManyAnatomyItemInputEnvelope>;
};

export type MultiShadeInfoCreateNestedManyWithoutImplantItemInput = {
  connect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MultiShadeInfoCreateOrConnectWithoutImplantItemInput>>;
  create?: InputMaybe<Array<MultiShadeInfoCreateWithoutImplantItemInput>>;
  createMany?: InputMaybe<MultiShadeInfoCreateManyImplantItemInputEnvelope>;
};

export type MultiShadeInfoCreateNestedManyWithoutItemShadeInput = {
  connect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MultiShadeInfoCreateOrConnectWithoutItemShadeInput>>;
  create?: InputMaybe<Array<MultiShadeInfoCreateWithoutItemShadeInput>>;
  createMany?: InputMaybe<MultiShadeInfoCreateManyItemShadeInputEnvelope>;
};

export type MultiShadeInfoCreateOrConnectWithoutAnatomyItemInput = {
  create: MultiShadeInfoCreateWithoutAnatomyItemInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoCreateOrConnectWithoutImplantItemInput = {
  create: MultiShadeInfoCreateWithoutImplantItemInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoCreateOrConnectWithoutItemShadeInput = {
  create: MultiShadeInfoCreateWithoutItemShadeInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoCreateWithoutAnatomyItemInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutMultiShadeInfoInput>;
  itemShade: ItemShadeCreateNestedOneWithoutMultiShadeInfoInput;
  teethShadeSide: TeethShadeSide;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MultiShadeInfoCreateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutMultiShadeInfoInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemShade: ItemShadeCreateNestedOneWithoutMultiShadeInfoInput;
  teethShadeSide: TeethShadeSide;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MultiShadeInfoCreateWithoutItemShadeInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedOneWithoutMultiShadeInfoInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedOneWithoutMultiShadeInfoInput>;
  teethShadeSide: TeethShadeSide;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type MultiShadeInfoListRelationFilter = {
  every?: InputMaybe<MultiShadeInfoWhereInput>;
  none?: InputMaybe<MultiShadeInfoWhereInput>;
  some?: InputMaybe<MultiShadeInfoWhereInput>;
};

export type MultiShadeInfoOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MultiShadeInfoScalarWhereInput = {
  AND?: InputMaybe<Array<MultiShadeInfoScalarWhereInput>>;
  NOT?: InputMaybe<Array<MultiShadeInfoScalarWhereInput>>;
  OR?: InputMaybe<Array<MultiShadeInfoScalarWhereInput>>;
  anatomyItemId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  implantItemId?: InputMaybe<UuidNullableFilter>;
  itemShadeId?: InputMaybe<StringFilter>;
  teethShadeSide?: InputMaybe<EnumTeethShadeSideFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MultiShadeInfoUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  teethShadeSide?: InputMaybe<EnumTeethShadeSideFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MultiShadeInfoUpdateManyWithWhereWithoutAnatomyItemInput = {
  data: MultiShadeInfoUpdateManyMutationInput;
  where: MultiShadeInfoScalarWhereInput;
};

export type MultiShadeInfoUpdateManyWithWhereWithoutImplantItemInput = {
  data: MultiShadeInfoUpdateManyMutationInput;
  where: MultiShadeInfoScalarWhereInput;
};

export type MultiShadeInfoUpdateManyWithWhereWithoutItemShadeInput = {
  data: MultiShadeInfoUpdateManyMutationInput;
  where: MultiShadeInfoScalarWhereInput;
};

export type MultiShadeInfoUpdateManyWithoutAnatomyItemNestedInput = {
  connect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MultiShadeInfoCreateOrConnectWithoutAnatomyItemInput>>;
  create?: InputMaybe<Array<MultiShadeInfoCreateWithoutAnatomyItemInput>>;
  createMany?: InputMaybe<MultiShadeInfoCreateManyAnatomyItemInputEnvelope>;
  delete?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MultiShadeInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<MultiShadeInfoUpdateWithWhereUniqueWithoutAnatomyItemInput>>;
  updateMany?: InputMaybe<Array<MultiShadeInfoUpdateManyWithWhereWithoutAnatomyItemInput>>;
  upsert?: InputMaybe<Array<MultiShadeInfoUpsertWithWhereUniqueWithoutAnatomyItemInput>>;
};

export type MultiShadeInfoUpdateManyWithoutImplantItemNestedInput = {
  connect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MultiShadeInfoCreateOrConnectWithoutImplantItemInput>>;
  create?: InputMaybe<Array<MultiShadeInfoCreateWithoutImplantItemInput>>;
  createMany?: InputMaybe<MultiShadeInfoCreateManyImplantItemInputEnvelope>;
  delete?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MultiShadeInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<MultiShadeInfoUpdateWithWhereUniqueWithoutImplantItemInput>>;
  updateMany?: InputMaybe<Array<MultiShadeInfoUpdateManyWithWhereWithoutImplantItemInput>>;
  upsert?: InputMaybe<Array<MultiShadeInfoUpsertWithWhereUniqueWithoutImplantItemInput>>;
};

export type MultiShadeInfoUpdateManyWithoutItemShadeNestedInput = {
  connect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MultiShadeInfoCreateOrConnectWithoutItemShadeInput>>;
  create?: InputMaybe<Array<MultiShadeInfoCreateWithoutItemShadeInput>>;
  createMany?: InputMaybe<MultiShadeInfoCreateManyItemShadeInputEnvelope>;
  delete?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MultiShadeInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<MultiShadeInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<MultiShadeInfoUpdateWithWhereUniqueWithoutItemShadeInput>>;
  updateMany?: InputMaybe<Array<MultiShadeInfoUpdateManyWithWhereWithoutItemShadeInput>>;
  upsert?: InputMaybe<Array<MultiShadeInfoUpsertWithWhereUniqueWithoutItemShadeInput>>;
};

export type MultiShadeInfoUpdateWithWhereUniqueWithoutAnatomyItemInput = {
  data: MultiShadeInfoUpdateWithoutAnatomyItemInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoUpdateWithWhereUniqueWithoutImplantItemInput = {
  data: MultiShadeInfoUpdateWithoutImplantItemInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoUpdateWithWhereUniqueWithoutItemShadeInput = {
  data: MultiShadeInfoUpdateWithoutItemShadeInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoUpdateWithoutAnatomyItemInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutMultiShadeInfoNestedInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneRequiredWithoutMultiShadeInfoNestedInput>;
  teethShadeSide?: InputMaybe<EnumTeethShadeSideFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MultiShadeInfoUpdateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutMultiShadeInfoNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemShade?: InputMaybe<ItemShadeUpdateOneRequiredWithoutMultiShadeInfoNestedInput>;
  teethShadeSide?: InputMaybe<EnumTeethShadeSideFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MultiShadeInfoUpdateWithoutItemShadeInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateOneWithoutMultiShadeInfoNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateOneWithoutMultiShadeInfoNestedInput>;
  teethShadeSide?: InputMaybe<EnumTeethShadeSideFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MultiShadeInfoUpsertWithWhereUniqueWithoutAnatomyItemInput = {
  create: MultiShadeInfoCreateWithoutAnatomyItemInput;
  update: MultiShadeInfoUpdateWithoutAnatomyItemInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoUpsertWithWhereUniqueWithoutImplantItemInput = {
  create: MultiShadeInfoCreateWithoutImplantItemInput;
  update: MultiShadeInfoUpdateWithoutImplantItemInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoUpsertWithWhereUniqueWithoutItemShadeInput = {
  create: MultiShadeInfoCreateWithoutItemShadeInput;
  update: MultiShadeInfoUpdateWithoutItemShadeInput;
  where: MultiShadeInfoWhereUniqueInput;
};

export type MultiShadeInfoWhereInput = {
  AND?: InputMaybe<Array<MultiShadeInfoWhereInput>>;
  NOT?: InputMaybe<Array<MultiShadeInfoWhereInput>>;
  OR?: InputMaybe<Array<MultiShadeInfoWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemNullableScalarRelationFilter>;
  anatomyItemId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  implantItem?: InputMaybe<ImplantItemNullableScalarRelationFilter>;
  implantItemId?: InputMaybe<UuidNullableFilter>;
  itemShade?: InputMaybe<ItemShadeScalarRelationFilter>;
  itemShadeId?: InputMaybe<StringFilter>;
  teethShadeSide?: InputMaybe<EnumTeethShadeSideFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MultiShadeInfoWhereUniqueInput = {
  AND?: InputMaybe<Array<MultiShadeInfoWhereInput>>;
  NOT?: InputMaybe<Array<MultiShadeInfoWhereInput>>;
  OR?: InputMaybe<Array<MultiShadeInfoWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemNullableScalarRelationFilter>;
  anatomyItemId?: InputMaybe<UuidNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemNullableScalarRelationFilter>;
  implantItemId?: InputMaybe<UuidNullableFilter>;
  itemShade?: InputMaybe<ItemShadeScalarRelationFilter>;
  itemShadeId?: InputMaybe<StringFilter>;
  teethShadeSide?: InputMaybe<EnumTeethShadeSideFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abortPickup: Scalars['Boolean']['output'];
  addOrderComment: OrderModel;
  addOrderDesignComment: OrderDesignCommentModel;
  addOrderProduct: OrderModel;
  addOrderProducts: OrderModel;
  addProductToOrderFromForm: Array<Scalars['String']['output']>;
  applyProductHasIndividualCaracteristics: Product;
  archiveDraftOrder: OrderModel;
  archiveMessagesForOrder: Scalars['Boolean']['output'];
  assignToProvider: OrderBilling;
  assignToProviderAndGenerateBilling: OrderBilling;
  calculateOrderBillingData: OrderBilling;
  confirmOrder: OrderModel;
  createAddress: Address;
  createAnatomyItem: AnatomyItem;
  createAndStoreFileByOrderId: Scalars['String']['output'];
  createClientBilling: ClientBilling;
  createDirectConnectOrder: Order;
  createDraftOrder: OrderModel;
  createFile: File;
  createFixedProsthesisPreferences: FixedProsthesisPreferences;
  createImplantItem: ImplantItem;
  createImplantReference: ImplantReference;
  createItemBilling: ItemBilling;
  createItemMaterial: ItemMaterial;
  createItemPrice: ItemPrice;
  createItemShade: ItemShade;
  createManualPickup: Pickup;
  createMaterialTraceability: MaterialTraceability;
  createOrder: Order;
  createOrderAttachment: PresignedUploadResponse;
  createOrderBilling: OrderBilling;
  createOrderCommentAttachment: PresignedUploadResponse;
  createOrderDesign: OrderDesign;
  createOrderFromExternalCase: Order;
  createOrderHelpFile: File;
  createOrderManual: Order;
  createPatient: Patient;
  createPickup: Scalars['String']['output'];
  createProductManual: Product;
  createProductPreferences: ProductPreferences;
  createRemovableItem: RemovableItem;
  createUser: User;
  createUserGroup: UserGroup;
  deleteFile: File;
  deleteItemBilling: ItemBilling;
  deleteManyAnatomyItem: Scalars['Boolean']['output'];
  deleteManyImplantItem: Scalars['Boolean']['output'];
  deleteManyProduct: Scalars['Boolean']['output'];
  deleteManyRemovableItems: Scalars['Boolean']['output'];
  deleteOrderAttachment: OrderModel;
  deleteOrderComment: OrderModel;
  deleteOrderCommentAttachment: OrderModel;
  deleteOrderHelpFile: Scalars['Boolean']['output'];
  deleteS3File: Scalars['String']['output'];
  downloadAllCarrierLabels: Array<Scalars['String']['output']>;
  editPickup: Pickup;
  generateCustomTraceabilityDocument: Scalars['Boolean']['output'];
  generateLaboratoryOrderDocument: Scalars['String']['output'];
  generateOrderBillingTraceabilityDocuments: OrderBilling;
  generateOrderDesignCommentAttachmentUploadLink: DesignUploadPresignedLink;
  generateOrderDesignUploadLink: DesignUploadPresignedLink;
  getDeliveryProof: Scalars['String']['output'];
  markCarrierShippingAsShipped: Array<Shipping>;
  markDesignReviewNotificationAsRead: Scalars['Boolean']['output'];
  markDesignReviewNotificationAsUnread: Scalars['Boolean']['output'];
  markFileAsRead: Scalars['Boolean']['output'];
  markHelpMessagesAsRead: Scalars['Boolean']['output'];
  markLastMessageAsUnread: Scalars['Boolean']['output'];
  markMessagesOfChatAsRead: Scalars['Boolean']['output'];
  markNotificationsAsRead: Scalars['Boolean']['output'];
  notifyInternalPickupRequired: Scalars['String']['output'];
  notifyPlacedOrder: Scalars['String']['output'];
  notifyPotentialOrderSupplierDelays: Scalars['Boolean']['output'];
  openOrderDesign: OrderDesign;
  populateDataFrom3shapeCommunicate: Order;
  populateDataFromMeditLink: Order;
  printClinicLabel: Array<Scalars['String']['output']>;
  redoOrder: RedoOrderDto;
  refreshPastille: Scalars['Boolean']['output'];
  regenerateDsCoreTokens: Scalars['Boolean']['output'];
  regenerateThreeshapeTokens: Scalars['Boolean']['output'];
  removeOrderProduct: OrderModel;
  removeOrderProducts: OrderModel;
  requestOrderDesign: OrderDesign;
  reviewOrderDesign: OrderDesign;
  sendMailToProvider: Scalars['String']['output'];
  sendMessage: Chat;
  sendOrderHelpRequest: Scalars['String']['output'];
  setFileAsUploaded: Scalars['Boolean']['output'];
  subscribeToNotification: NotificationSubscription;
  syncExternalCasesFrom3Shape: Array<ExternalCase>;
  syncExternalCasesFromShining3d: Array<ExternalCase>;
  translateComment: Scalars['Boolean']['output'];
  translateOrderDesignComment: OrderDesignCommentModel;
  unsubscribeFromNotification: Scalars['Boolean']['output'];
  updateAddress: Address;
  updateAllItemTeethOfProduct: Scalars['Boolean']['output'];
  updateAnatomyItem: AnatomyItem;
  updateClientBilling: ClientBilling;
  updateFile: File;
  updateFixedProsthesisPreferences: FixedProsthesisPreferences;
  updateImplantItem: ImplantItem;
  updateImplantReference: ImplantReference;
  updateItemBilling: ItemBilling;
  updateItemMaterial: ItemMaterial;
  updateItemPrice: ItemPrice;
  updateItemShade: ItemShade;
  updateManyOrder: Scalars['Boolean']['output'];
  updateManyRemovableItems: Scalars['Boolean']['output'];
  updateMaterialTraceability: MaterialTraceability;
  updateOrder: Order;
  updateOrderBilling: OrderBilling;
  updateOrderComment: OrderModel;
  updateOrderDeliveryDate?: Maybe<Order>;
  updateOrderInfo: OrderModel;
  updateOrderProduct: OrderModel;
  updateOrderProducts: OrderModel;
  updatePatient: Patient;
  updateProduct: Product;
  updateProductPreferences: ProductPreferences;
  updateProfile: User;
  updateRemovableItem: RemovableItem;
  updateUser: User;
  updateUserGroup: UserGroup;
};


export type MutationAbortPickupArgs = {
  pickupId: Scalars['String']['input'];
};


export type MutationAddOrderCommentArgs = {
  comment: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationAddOrderDesignCommentArgs = {
  comment: Scalars['String']['input'];
  orderDesignId: Scalars['String']['input'];
};


export type MutationAddOrderProductArgs = {
  orderId: Scalars['String']['input'];
  product: CreateProductInput;
};


export type MutationAddOrderProductsArgs = {
  orderId: Scalars['String']['input'];
  products: Array<CreateProductInput>;
};


export type MutationAddProductToOrderFromFormArgs = {
  orderId: Scalars['String']['input'];
  productInfo: Scalars['String']['input'];
};


export type MutationApplyProductHasIndividualCaracteristicsArgs = {
  itemsHaveIndividualCaracteristics: Scalars['Boolean']['input'];
  productId: Scalars['String']['input'];
};


export type MutationArchiveDraftOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationArchiveMessagesForOrderArgs = {
  data: ChatUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type MutationAssignToProviderArgs = {
  providerReference: Scalars['String']['input'];
  updateOrderBillingWhere: OrderBillingWhereUniqueInput;
};


export type MutationAssignToProviderAndGenerateBillingArgs = {
  providerReference: Scalars['String']['input'];
  updateOrderBillingWhere: OrderBillingWhereUniqueInput;
};


export type MutationCalculateOrderBillingDataArgs = {
  updateOrderBillingWhere: OrderBillingWhereUniqueInput;
};


export type MutationConfirmOrderArgs = {
  deliveryDate: Scalars['Timestamp']['input'];
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['String']['input'];
};


export type MutationCreateAddressArgs = {
  args: AddressCreateInput;
};


export type MutationCreateAnatomyItemArgs = {
  args: AnatomyItemCreateInput;
};


export type MutationCreateAndStoreFileByOrderIdArgs = {
  fileStream: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateClientBillingArgs = {
  args: ClientBillingCreateInput;
};


export type MutationCreateDirectConnectOrderArgs = {
  caseXml: Scalars['String']['input'];
  hasImplantScan?: Scalars['Boolean']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDraftOrderArgs = {
  order: CreateOrderInput;
  patient?: InputMaybe<CreatePatientInput>;
};


export type MutationCreateFileArgs = {
  args: FileCreateInput;
};


export type MutationCreateFixedProsthesisPreferencesArgs = {
  args: FixedProsthesisPreferencesCreateInput;
};


export type MutationCreateImplantItemArgs = {
  args: ImplantItemCreateInput;
};


export type MutationCreateImplantReferenceArgs = {
  args: ImplantReferenceCreateInput;
};


export type MutationCreateItemBillingArgs = {
  args: ItemBillingCreateInput;
};


export type MutationCreateItemMaterialArgs = {
  args: ItemMaterialCreateInput;
};


export type MutationCreateItemPriceArgs = {
  args: ItemPriceCreateInput;
};


export type MutationCreateItemShadeArgs = {
  args: ItemShadeCreateInput;
};


export type MutationCreateManualPickupArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  scheduledDate: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
};


export type MutationCreateMaterialTraceabilityArgs = {
  args: MaterialTraceabilityCreateInput;
};


export type MutationCreateOrderArgs = {
  args: CreateOrderForm;
};


export type MutationCreateOrderAttachmentArgs = {
  filename: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateOrderBillingArgs = {
  args: OrderBillingCreateInput;
};


export type MutationCreateOrderCommentAttachmentArgs = {
  filename: Scalars['String']['input'];
  orderCommentId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateOrderDesignArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationCreateOrderFromExternalCaseArgs = {
  dentistId: Scalars['String']['input'];
  externalCaseId: Scalars['String']['input'];
};


export type MutationCreateOrderHelpFileArgs = {
  key: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateOrderManualArgs = {
  args: OrderCreateInput;
};


export type MutationCreatePatientArgs = {
  args: PatientCreateInput;
};


export type MutationCreatePickupArgs = {
  clinicClosingTime?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  packageReadyTime?: InputMaybe<Scalars['String']['input']>;
  scheduledDate: Scalars['String']['input'];
};


export type MutationCreateProductManualArgs = {
  args: ProductCreateInput;
  omitItems?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateProductPreferencesArgs = {
  args: ProductPreferencesCreateInput;
};


export type MutationCreateRemovableItemArgs = {
  args: RemovableItemCreateInput;
};


export type MutationCreateUserArgs = {
  args: UserCreateInput;
};


export type MutationCreateUserGroupArgs = {
  args: UserGroupCreateInput;
  providerGroupIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteFileArgs = {
  key: Scalars['String']['input'];
  where: FileWhereUniqueInput;
};


export type MutationDeleteItemBillingArgs = {
  where: ItemBillingWhereUniqueInput;
};


export type MutationDeleteManyAnatomyItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnatomyItemWhereInput>;
};


export type MutationDeleteManyImplantItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImplantItemWhereInput>;
};


export type MutationDeleteManyProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type MutationDeleteManyRemovableItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RemovableItemWhereInput>;
};


export type MutationDeleteOrderAttachmentArgs = {
  fileId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationDeleteOrderCommentArgs = {
  orderCommentId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationDeleteOrderCommentAttachmentArgs = {
  fileId: Scalars['String']['input'];
  orderCommentId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationDeleteOrderHelpFileArgs = {
  fileId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationDeleteS3FileArgs = {
  key: Scalars['String']['input'];
};


export type MutationDownloadAllCarrierLabelsArgs = {
  carrier: Scalars['String']['input'];
};


export type MutationEditPickupArgs = {
  data: PickupUpdateInput;
  pickupId: Scalars['String']['input'];
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  where: PickupWhereUniqueInput;
};


export type MutationGenerateLaboratoryOrderDocumentArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationGenerateOrderBillingTraceabilityDocumentsArgs = {
  orderBillingWhere: OrderBillingWhereUniqueInput;
};


export type MutationGenerateOrderDesignCommentAttachmentUploadLinkArgs = {
  commentId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  orderDesignId: Scalars['String']['input'];
};


export type MutationGenerateOrderDesignUploadLinkArgs = {
  filename: Scalars['String']['input'];
  orderDesignId: Scalars['String']['input'];
};


export type MutationGetDeliveryProofArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationMarkCarrierShippingAsShippedArgs = {
  carrier: Scalars['String']['input'];
};


export type MutationMarkDesignReviewNotificationAsReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkDesignReviewNotificationAsUnreadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkFileAsReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkHelpMessagesAsReadArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationMarkLastMessageAsUnreadArgs = {
  orderId: Scalars['String']['input'];
  supplier: Scalars['String']['input'];
};


export type MutationMarkMessagesOfChatAsReadArgs = {
  data: ChatUpdateManyMutationInput;
  supplier: Scalars['String']['input'];
  where?: InputMaybe<ChatWhereInput>;
};


export type MutationMarkNotificationsAsReadArgs = {
  data: ChatUpdateManyMutationInput;
  supplier: Scalars['String']['input'];
  where?: InputMaybe<ChatWhereInput>;
};


export type MutationNotifyInternalPickupRequiredArgs = {
  createPickup?: InputMaybe<Scalars['Boolean']['input']>;
  dentistDidNotDownload?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['String']['input'];
};


export type MutationNotifyPlacedOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationOpenOrderDesignArgs = {
  orderDesignId: Scalars['String']['input'];
};


export type MutationPopulateDataFrom3shapeCommunicateArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationPopulateDataFromMeditLinkArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationPrintClinicLabelArgs = {
  userGroupId: Scalars['String']['input'];
};


export type MutationRedoOrderArgs = {
  clinicClosingTime?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  packageReadyTime?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRefreshPastilleArgs = {
  args: Array<RefreshPastilleInput>;
};


export type MutationRegenerateDsCoreTokensArgs = {
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationRegenerateThreeshapeTokensArgs = {
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationRemoveOrderProductArgs = {
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationRemoveOrderProductsArgs = {
  orderId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};


export type MutationRequestOrderDesignArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationReviewOrderDesignArgs = {
  orderDesignId: Scalars['String']['input'];
  review: OrderDesignReview;
};


export type MutationSendMailToProviderArgs = {
  args: SendMailToProvider;
};


export type MutationSendMessageArgs = {
  args: ChatCreateInput;
  olderChatRead: Scalars['Boolean']['input'];
  supplier: Scalars['String']['input'];
};


export type MutationSendOrderHelpRequestArgs = {
  args: OrderCommentCreateInput;
};


export type MutationSetFileAsUploadedArgs = {
  id: Scalars['String']['input'];
};


export type MutationSubscribeToNotificationArgs = {
  notificationChannel: NotificationChannel;
  notificationEvent: NotificationEvent;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncExternalCasesFrom3ShapeArgs = {
  fromDate: Scalars['Timestamp']['input'];
  toDate: Scalars['Timestamp']['input'];
  tryOrdersCreation: Scalars['Boolean']['input'];
};


export type MutationSyncExternalCasesFromShining3dArgs = {
  fromDate: Scalars['Timestamp']['input'];
  toDate: Scalars['Timestamp']['input'];
  tryOrdersCreation: Scalars['Boolean']['input'];
};


export type MutationTranslateCommentArgs = {
  data: OrderCommentUpdateInput;
  where: OrderCommentWhereUniqueInput;
};


export type MutationTranslateOrderDesignCommentArgs = {
  commentId: Scalars['String']['input'];
  translation: Scalars['String']['input'];
};


export type MutationUnsubscribeFromNotificationArgs = {
  notificationChannel: NotificationChannel;
  notificationEvent: NotificationEvent;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAddressArgs = {
  data: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpdateAllItemTeethOfProductArgs = {
  productId: Scalars['String']['input'];
  teeth: Scalars['String']['input'];
};


export type MutationUpdateAnatomyItemArgs = {
  data: AnatomyItemUpdateInput;
  where: AnatomyItemWhereUniqueInput;
};


export type MutationUpdateClientBillingArgs = {
  data: ClientBillingUpdateInput;
  where: ClientBillingWhereUniqueInput;
};


export type MutationUpdateFileArgs = {
  data: FileUpdateInput;
  where: FileWhereUniqueInput;
};


export type MutationUpdateFixedProsthesisPreferencesArgs = {
  data: FixedProsthesisPreferencesUpdateInput;
  where: FixedProsthesisPreferencesWhereUniqueInput;
};


export type MutationUpdateImplantItemArgs = {
  data: ImplantItemUpdateInput;
  where: ImplantItemWhereUniqueInput;
};


export type MutationUpdateImplantReferenceArgs = {
  data: ImplantReferenceUpdateInput;
  where: ImplantReferenceWhereUniqueInput;
};


export type MutationUpdateItemBillingArgs = {
  data: ItemBillingUpdateInput;
  where: ItemBillingWhereUniqueInput;
};


export type MutationUpdateItemMaterialArgs = {
  data: ItemMaterialUpdateInput;
  where: ItemMaterialWhereUniqueInput;
};


export type MutationUpdateItemPriceArgs = {
  data: ItemPriceUpdateInput;
  where: ItemPriceWhereUniqueInput;
};


export type MutationUpdateItemShadeArgs = {
  data: ItemShadeUpdateInput;
  where: ItemShadeWhereUniqueInput;
};


export type MutationUpdateManyOrderArgs = {
  data: OrderUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationUpdateManyRemovableItemsArgs = {
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  gingivaShadeId?: InputMaybe<Scalars['String']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  teethShadeId?: InputMaybe<Scalars['String']['input']>;
  workflowType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMaterialTraceabilityArgs = {
  data: MaterialTraceabilityUpdateInput;
  where: MaterialTraceabilityWhereUniqueInput;
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOrderBillingArgs = {
  data: OrderBillingUpdateInput;
  where: OrderBillingWhereUniqueInput;
};


export type MutationUpdateOrderCommentArgs = {
  comment: Scalars['String']['input'];
  orderCommentId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationUpdateOrderDeliveryDateArgs = {
  newDeliveryDate: Scalars['Timestamp']['input'];
  orderId: Scalars['String']['input'];
  shouldUpdateAbutmentType: Scalars['Boolean']['input'];
};


export type MutationUpdateOrderInfoArgs = {
  orderId: Scalars['String']['input'];
  orderInfo?: InputMaybe<CreateOrderInput>;
  patient?: InputMaybe<CreatePatientInput>;
};


export type MutationUpdateOrderProductArgs = {
  input: UpdateOrderProductInput;
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationUpdateOrderProductsArgs = {
  orderId: Scalars['String']['input'];
  products: Array<UpdateOrderProductEntryInput>;
};


export type MutationUpdatePatientArgs = {
  data: PatientUpdateInput;
  where: PatientWhereUniqueInput;
};


export type MutationUpdateProductArgs = {
  data: ProductUpdateInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpdateProductPreferencesArgs = {
  data: ProductPreferencesUpdateInput;
  where: ProductPreferencesWhereUniqueInput;
};


export type MutationUpdateProfileArgs = {
  data: UserProfileInput;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRemovableItemArgs = {
  data: RemovableItemUpdateInput;
  where: RemovableItemWhereUniqueInput;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserGroupArgs = {
  data: UserGroupUpdateInput;
  providerGroupIds: Array<Scalars['String']['input']>;
  where: UserGroupWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['Timestamp']['input']>;
  gt?: InputMaybe<Scalars['Timestamp']['input']>;
  gte?: InputMaybe<Scalars['Timestamp']['input']>;
  in?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  lt?: InputMaybe<Scalars['Timestamp']['input']>;
  lte?: InputMaybe<Scalars['Timestamp']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumAbutmentTypeNullableFilter = {
  equals?: InputMaybe<AbutmentType>;
  in?: InputMaybe<Array<AbutmentType>>;
  not?: InputMaybe<NestedEnumAbutmentTypeNullableFilter>;
  notIn?: InputMaybe<Array<AbutmentType>>;
};

export type NestedEnumArchNullableFilter = {
  equals?: InputMaybe<Arch>;
  in?: InputMaybe<Array<Arch>>;
  not?: InputMaybe<NestedEnumArchNullableFilter>;
  notIn?: InputMaybe<Array<Arch>>;
};

export type NestedEnumBillingStatusFilter = {
  equals?: InputMaybe<BillingStatus>;
  in?: InputMaybe<Array<BillingStatus>>;
  not?: InputMaybe<NestedEnumBillingStatusFilter>;
  notIn?: InputMaybe<Array<BillingStatus>>;
};

export type NestedEnumBridgeTypeNullableFilter = {
  equals?: InputMaybe<BridgeType>;
  in?: InputMaybe<Array<BridgeType>>;
  not?: InputMaybe<NestedEnumBridgeTypeNullableFilter>;
  notIn?: InputMaybe<Array<BridgeType>>;
};

export type NestedEnumCarrierTypeFilter = {
  equals?: InputMaybe<CarrierType>;
  in?: InputMaybe<Array<CarrierType>>;
  not?: InputMaybe<NestedEnumCarrierTypeFilter>;
  notIn?: InputMaybe<Array<CarrierType>>;
};

export type NestedEnumCommentTypeFilter = {
  equals?: InputMaybe<CommentType>;
  in?: InputMaybe<Array<CommentType>>;
  not?: InputMaybe<NestedEnumCommentTypeFilter>;
  notIn?: InputMaybe<Array<CommentType>>;
};

export type NestedEnumFileStatusFilter = {
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  not?: InputMaybe<NestedEnumFileStatusFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type NestedEnumFileTypeFilter = {
  equals?: InputMaybe<FileType>;
  in?: InputMaybe<Array<FileType>>;
  not?: InputMaybe<NestedEnumFileTypeFilter>;
  notIn?: InputMaybe<Array<FileType>>;
};

export type NestedEnumImprintTypeNullableFilter = {
  equals?: InputMaybe<ImprintType>;
  in?: InputMaybe<Array<ImprintType>>;
  not?: InputMaybe<NestedEnumImprintTypeNullableFilter>;
  notIn?: InputMaybe<Array<ImprintType>>;
};

export type NestedEnumIntegrationTypeFilter = {
  equals?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  not?: InputMaybe<NestedEnumIntegrationTypeFilter>;
  notIn?: InputMaybe<Array<IntegrationType>>;
};

export type NestedEnumIntegrationTypeNullableFilter = {
  equals?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  not?: InputMaybe<NestedEnumIntegrationTypeNullableFilter>;
  notIn?: InputMaybe<Array<IntegrationType>>;
};

export type NestedEnumItemPriceTypeNullableFilter = {
  equals?: InputMaybe<ItemPriceType>;
  in?: InputMaybe<Array<ItemPriceType>>;
  not?: InputMaybe<NestedEnumItemPriceTypeNullableFilter>;
  notIn?: InputMaybe<Array<ItemPriceType>>;
};

export type NestedEnumItemShadeTypeFilter = {
  equals?: InputMaybe<ItemShadeType>;
  in?: InputMaybe<Array<ItemShadeType>>;
  not?: InputMaybe<NestedEnumItemShadeTypeFilter>;
  notIn?: InputMaybe<Array<ItemShadeType>>;
};

export type NestedEnumItemShadeTypeNullableFilter = {
  equals?: InputMaybe<ItemShadeType>;
  in?: InputMaybe<Array<ItemShadeType>>;
  not?: InputMaybe<NestedEnumItemShadeTypeNullableFilter>;
  notIn?: InputMaybe<Array<ItemShadeType>>;
};

export type NestedEnumItemTypeFilter = {
  equals?: InputMaybe<ItemType>;
  in?: InputMaybe<Array<ItemType>>;
  not?: InputMaybe<NestedEnumItemTypeFilter>;
  notIn?: InputMaybe<Array<ItemType>>;
};

export type NestedEnumItemTypeNullableFilter = {
  equals?: InputMaybe<ItemType>;
  in?: InputMaybe<Array<ItemType>>;
  not?: InputMaybe<NestedEnumItemTypeNullableFilter>;
  notIn?: InputMaybe<Array<ItemType>>;
};

export type NestedEnumNotificationEntityTypeFilter = {
  equals?: InputMaybe<NotificationEntityType>;
  in?: InputMaybe<Array<NotificationEntityType>>;
  not?: InputMaybe<NestedEnumNotificationEntityTypeFilter>;
  notIn?: InputMaybe<Array<NotificationEntityType>>;
};

export type NestedEnumNotificationEventFilter = {
  equals?: InputMaybe<NotificationEvent>;
  in?: InputMaybe<Array<NotificationEvent>>;
  not?: InputMaybe<NestedEnumNotificationEventFilter>;
  notIn?: InputMaybe<Array<NotificationEvent>>;
};

export type NestedEnumOrderBillingTypeFilter = {
  equals?: InputMaybe<OrderBillingType>;
  in?: InputMaybe<Array<OrderBillingType>>;
  not?: InputMaybe<NestedEnumOrderBillingTypeFilter>;
  notIn?: InputMaybe<Array<OrderBillingType>>;
};

export type NestedEnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumOrderStatusNullableFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusNullableFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumPartialDentureRedoPartLengthNullableFilter = {
  equals?: InputMaybe<PartialDentureRedoPartLength>;
  in?: InputMaybe<Array<PartialDentureRedoPartLength>>;
  not?: InputMaybe<NestedEnumPartialDentureRedoPartLengthNullableFilter>;
  notIn?: InputMaybe<Array<PartialDentureRedoPartLength>>;
};

export type NestedEnumPartialDentureRedoPartProximalContactNullableFilter = {
  equals?: InputMaybe<PartialDentureRedoPartProximalContact>;
  in?: InputMaybe<Array<PartialDentureRedoPartProximalContact>>;
  not?: InputMaybe<NestedEnumPartialDentureRedoPartProximalContactNullableFilter>;
  notIn?: InputMaybe<Array<PartialDentureRedoPartProximalContact>>;
};

export type NestedEnumPartialDentureRedoPartShapeNullableFilter = {
  equals?: InputMaybe<PartialDentureRedoPartShape>;
  in?: InputMaybe<Array<PartialDentureRedoPartShape>>;
  not?: InputMaybe<NestedEnumPartialDentureRedoPartShapeNullableFilter>;
  notIn?: InputMaybe<Array<PartialDentureRedoPartShape>>;
};

export type NestedEnumPickupStatusFilter = {
  equals?: InputMaybe<PickupStatus>;
  in?: InputMaybe<Array<PickupStatus>>;
  not?: InputMaybe<NestedEnumPickupStatusFilter>;
  notIn?: InputMaybe<Array<PickupStatus>>;
};

export type NestedEnumPricingTypeFilter = {
  equals?: InputMaybe<PricingType>;
  in?: InputMaybe<Array<PricingType>>;
  not?: InputMaybe<NestedEnumPricingTypeFilter>;
  notIn?: InputMaybe<Array<PricingType>>;
};

export type NestedEnumProductPreferenceTypeEnumFilter = {
  equals?: InputMaybe<ProductPreferenceTypeEnum>;
  in?: InputMaybe<Array<ProductPreferenceTypeEnum>>;
  not?: InputMaybe<NestedEnumProductPreferenceTypeEnumFilter>;
  notIn?: InputMaybe<Array<ProductPreferenceTypeEnum>>;
};

export type NestedEnumRemovableItemOrderTypeNullableFilter = {
  equals?: InputMaybe<RemovableItemOrderType>;
  in?: InputMaybe<Array<RemovableItemOrderType>>;
  not?: InputMaybe<NestedEnumRemovableItemOrderTypeNullableFilter>;
  notIn?: InputMaybe<Array<RemovableItemOrderType>>;
};

export type NestedEnumRetentionTypeNullableFilter = {
  equals?: InputMaybe<RetentionType>;
  in?: InputMaybe<Array<RetentionType>>;
  not?: InputMaybe<NestedEnumRetentionTypeNullableFilter>;
  notIn?: InputMaybe<Array<RetentionType>>;
};

export type NestedEnumScannerReferenceFilter = {
  equals?: InputMaybe<ScannerReference>;
  in?: InputMaybe<Array<ScannerReference>>;
  not?: InputMaybe<NestedEnumScannerReferenceFilter>;
  notIn?: InputMaybe<Array<ScannerReference>>;
};

export type NestedEnumSexNullableFilter = {
  equals?: InputMaybe<Sex>;
  in?: InputMaybe<Array<Sex>>;
  not?: InputMaybe<NestedEnumSexNullableFilter>;
  notIn?: InputMaybe<Array<Sex>>;
};

export type NestedEnumShippingTypeFilter = {
  equals?: InputMaybe<ShippingType>;
  in?: InputMaybe<Array<ShippingType>>;
  not?: InputMaybe<NestedEnumShippingTypeFilter>;
  notIn?: InputMaybe<Array<ShippingType>>;
};

export type NestedEnumSubscriptionFrequenceFilter = {
  equals?: InputMaybe<SubscriptionFrequence>;
  in?: InputMaybe<Array<SubscriptionFrequence>>;
  not?: InputMaybe<NestedEnumSubscriptionFrequenceFilter>;
  notIn?: InputMaybe<Array<SubscriptionFrequence>>;
};

export type NestedEnumTeethShadeSideFilter = {
  equals?: InputMaybe<TeethShadeSide>;
  in?: InputMaybe<Array<TeethShadeSide>>;
  not?: InputMaybe<NestedEnumTeethShadeSideFilter>;
  notIn?: InputMaybe<Array<TeethShadeSide>>;
};

export type NestedEnumTeethShadeTypeFilter = {
  equals?: InputMaybe<TeethShadeType>;
  in?: InputMaybe<Array<TeethShadeType>>;
  not?: InputMaybe<NestedEnumTeethShadeTypeFilter>;
  notIn?: InputMaybe<Array<TeethShadeType>>;
};

export type NestedEnumThreeDModelPricingTypeFilter = {
  equals?: InputMaybe<ThreeDModelPricingType>;
  in?: InputMaybe<Array<ThreeDModelPricingType>>;
  not?: InputMaybe<NestedEnumThreeDModelPricingTypeFilter>;
  notIn?: InputMaybe<Array<ThreeDModelPricingType>>;
};

export type NestedEnumUserGroupStatusFilter = {
  equals?: InputMaybe<UserGroupStatus>;
  in?: InputMaybe<Array<UserGroupStatus>>;
  not?: InputMaybe<NestedEnumUserGroupStatusFilter>;
  notIn?: InputMaybe<Array<UserGroupStatus>>;
};

export type NestedEnumUserGroupTypeFilter = {
  equals?: InputMaybe<UserGroupType>;
  in?: InputMaybe<Array<UserGroupType>>;
  not?: InputMaybe<NestedEnumUserGroupTypeFilter>;
  notIn?: InputMaybe<Array<UserGroupType>>;
};

export type NestedEnumUserRoleFilter = {
  equals?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  not?: InputMaybe<NestedEnumUserRoleFilter>;
  notIn?: InputMaybe<Array<UserRole>>;
};

export type NestedEnumUserStatusFilter = {
  equals?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  not?: InputMaybe<NestedEnumUserStatusFilter>;
  notIn?: InputMaybe<Array<UserStatus>>;
};

export type NestedEnumUserTypeFilter = {
  equals?: InputMaybe<UserType>;
  in?: InputMaybe<Array<UserType>>;
  not?: InputMaybe<NestedEnumUserTypeFilter>;
  notIn?: InputMaybe<Array<UserType>>;
};

export type NestedEnumWorkflowTypeNullableFilter = {
  equals?: InputMaybe<WorkflowType>;
  in?: InputMaybe<Array<WorkflowType>>;
  not?: InputMaybe<NestedEnumWorkflowTypeNullableFilter>;
  notIn?: InputMaybe<Array<WorkflowType>>;
};

export type NestedEnumwaxUpTypeNullableFilter = {
  equals?: InputMaybe<WaxUpType>;
  in?: InputMaybe<Array<WaxUpType>>;
  not?: InputMaybe<NestedEnumwaxUpTypeNullableFilter>;
  notIn?: InputMaybe<Array<WaxUpType>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedUuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedUuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum NoOcclusalClearanceV2 {
  AskDentist = 'ASK_DENTIST',
  KeepManufacturing = 'KEEP_MANUFACTURING'
}

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['Timestamp']['output'];
  entityId: Scalars['String']['output'];
  entityType: NotificationEntityType;
  event: NotificationEvent;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  params?: Maybe<Scalars['JSON']['output']>;
  readAt?: Maybe<Scalars['Timestamp']['output']>;
  recipient?: Maybe<User>;
  recipientId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  userGroup?: Maybe<UserGroup>;
  userGroupId?: Maybe<Scalars['String']['output']>;
};

export enum NotificationChannel {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type NotificationCreateManyUserGroupInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  entityId: Scalars['String']['input'];
  entityType: NotificationEntityType;
  event: NotificationEvent;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  readAt?: InputMaybe<Scalars['Timestamp']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type NotificationCreateManyUserGroupInputEnvelope = {
  data: Array<NotificationCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserGroupInputEnvelope>;
};

export type NotificationCreateOrConnectWithoutUserGroupInput = {
  create: NotificationCreateWithoutUserGroupInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateWithoutUserGroupInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  entityId: Scalars['String']['input'];
  entityType: NotificationEntityType;
  event: NotificationEvent;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  readAt?: InputMaybe<Scalars['Timestamp']['input']>;
  recipient?: InputMaybe<UserCreateNestedOneWithoutNotificationsInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum NotificationEntityType {
  Order = 'ORDER',
  OrderDesign = 'ORDER_DESIGN'
}

export enum NotificationEvent {
  OrderDesignOpened = 'ORDER_DESIGN_OPENED'
}

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  chatNotification: Scalars['Int']['output'];
  designReviewNotification: Scalars['Int']['output'];
  helpNotification: Scalars['Int']['output'];
  orderDesignNotification: Scalars['Int']['output'];
};

export type NotificationScalarWhereInput = {
  AND?: InputMaybe<Array<NotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<NotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<UuidFilter>;
  entityType?: InputMaybe<EnumNotificationEntityTypeFilter>;
  event?: InputMaybe<EnumNotificationEventFilter>;
  id?: InputMaybe<UuidFilter>;
  isRead?: InputMaybe<BoolFilter>;
  params?: InputMaybe<JsonNullableFilter>;
  readAt?: InputMaybe<DateTimeNullableFilter>;
  recipientId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
};

export type NotificationSubscription = {
  __typename?: 'NotificationSubscription';
  channel: NotificationChannel;
  createdAt: Scalars['Timestamp']['output'];
  event: NotificationEvent;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  userId: Scalars['String']['output'];
};

export type NotificationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumNotificationEntityTypeFieldUpdateOperationsInput>;
  event?: InputMaybe<EnumNotificationEventFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isRead?: InputMaybe<BoolFieldUpdateOperationsInput>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  readAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyWithWhereWithoutUserGroupInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type NotificationUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: NotificationUpdateWithoutUserGroupInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithoutUserGroupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumNotificationEntityTypeFieldUpdateOperationsInput>;
  event?: InputMaybe<EnumNotificationEventFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isRead?: InputMaybe<BoolFieldUpdateOperationsInput>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  readAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  recipient?: InputMaybe<UserUpdateOneWithoutNotificationsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NotificationUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: NotificationCreateWithoutUserGroupInput;
  update: NotificationUpdateWithoutUserGroupInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<UuidFilter>;
  entityType?: InputMaybe<EnumNotificationEntityTypeFilter>;
  event?: InputMaybe<EnumNotificationEventFilter>;
  id?: InputMaybe<UuidFilter>;
  isRead?: InputMaybe<BoolFilter>;
  params?: InputMaybe<JsonNullableFilter>;
  readAt?: InputMaybe<DateTimeNullableFilter>;
  recipient?: InputMaybe<UserNullableScalarRelationFilter>;
  recipientId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
};

export type NotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  entityId?: InputMaybe<UuidFilter>;
  entityType?: InputMaybe<EnumNotificationEntityTypeFilter>;
  event?: InputMaybe<EnumNotificationEventFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<BoolFilter>;
  params?: InputMaybe<JsonNullableFilter>;
  readAt?: InputMaybe<DateTimeNullableFilter>;
  recipient?: InputMaybe<UserNullableScalarRelationFilter>;
  recipientId?: InputMaybe<UuidNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type NullableDecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type NullableEnumAbutmentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<AbutmentType>;
};

export type NullableEnumArchFieldUpdateOperationsInput = {
  set?: InputMaybe<Arch>;
};

export type NullableEnumBridgeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BridgeType>;
};

export type NullableEnumImprintTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ImprintType>;
};

export type NullableEnumIntegrationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<IntegrationType>;
};

export type NullableEnumItemPriceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ItemPriceType>;
};

export type NullableEnumItemShadeTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ItemShadeType>;
};

export type NullableEnumItemTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ItemType>;
};

export type NullableEnumOrderStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderStatus>;
};

export type NullableEnumPartialDentureRedoPartLengthFieldUpdateOperationsInput = {
  set?: InputMaybe<PartialDentureRedoPartLength>;
};

export type NullableEnumPartialDentureRedoPartProximalContactFieldUpdateOperationsInput = {
  set?: InputMaybe<PartialDentureRedoPartProximalContact>;
};

export type NullableEnumPartialDentureRedoPartShapeFieldUpdateOperationsInput = {
  set?: InputMaybe<PartialDentureRedoPartShape>;
};

export type NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<RemovableItemOrderType>;
};

export type NullableEnumRetentionTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<RetentionType>;
};

export type NullableEnumSexFieldUpdateOperationsInput = {
  set?: InputMaybe<Sex>;
};

export type NullableEnumWorkflowTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<WorkflowType>;
};

export type NullableEnumwaxUpTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<WaxUpType>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export enum OcclusalContactTightnessV2 {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
  None = 'NONE'
}

export enum OcclusalStainingV2 {
  Dark = 'DARK',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
  None = 'NONE'
}

export type Order = {
  __typename?: 'Order';
  Chat?: Maybe<Array<Chat>>;
  ChatMarkAsUnread?: Maybe<Array<ChatMarkAsUnread>>;
  _count: OrderCount;
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  createdWithWebapp: Scalars['Boolean']['output'];
  deliveryDate?: Maybe<Scalars['Timestamp']['output']>;
  directId?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  history?: Maybe<Array<OrderHistory>>;
  id: Scalars['ID']['output'];
  integrationType?: Maybe<IntegrationType>;
  internalComments?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isBillingDone: Scalars['Boolean']['output'];
  isMailSent: Scalars['Boolean']['output'];
  isPhysicalPrint: Scalars['Boolean']['output'];
  isRush: Scalars['Boolean']['output'];
  lastShippingDate?: Maybe<Scalars['Timestamp']['output']>;
  orderBilling?: Maybe<Array<OrderBilling>>;
  orderComment?: Maybe<Array<OrderComment>>;
  orderDesigns?: Maybe<Array<OrderDesign>>;
  orderReference: Scalars['String']['output'];
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['String']['output']>;
  pickup?: Maybe<Array<Pickup>>;
  products?: Maybe<Array<Product>>;
  provider?: Maybe<UserGroup>;
  providerGroupId?: Maybe<Scalars['String']['output']>;
  redo?: Maybe<Array<Redo>>;
  shippedBackToProviderDate?: Maybe<Scalars['Timestamp']['output']>;
  shippings?: Maybe<Array<ShippingContent>>;
  status: OrderStatus;
  updatedAt: Scalars['Timestamp']['output'];
  user: User;
  userGroup?: Maybe<UserGroup>;
  userGroupId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type OrderBilling = {
  __typename?: 'OrderBilling';
  _count: OrderBillingCount;
  createdAt: Scalars['Timestamp']['output'];
  customBillingEntry?: Maybe<Array<CustomBillingEntry>>;
  discount: Scalars['Decimal']['output'];
  files?: Maybe<Array<File>>;
  id: Scalars['ID']['output'];
  itemBilling?: Maybe<Array<ItemBilling>>;
  order: Order;
  orderId: Scalars['String']['output'];
  priceExcludingVat: Scalars['Decimal']['output'];
  provider?: Maybe<User>;
  providerId?: Maybe<Scalars['String']['output']>;
  status: BillingStatus;
  totalPrice: Scalars['Decimal']['output'];
  totalVat: Scalars['Decimal']['output'];
  type: OrderBillingType;
  updatedAt: Scalars['Timestamp']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type OrderBillingCount = {
  __typename?: 'OrderBillingCount';
  customBillingEntry: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  itemBilling: Scalars['Int']['output'];
};

export type OrderBillingCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customBillingEntry?: InputMaybe<CustomBillingEntryCreateNestedManyWithoutOrderBillingInput>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutOrderBillingInput>;
  order: OrderCreateNestedOneWithoutOrderBillingInput;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  provider?: InputMaybe<UserCreateNestedOneWithoutOrderBillingManufacturerInput>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrderBillingUserInput;
};

export type OrderBillingCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderBillingCreateManyOrderInputEnvelope = {
  data: Array<OrderBillingCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderBillingCreateManyProviderInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderBillingCreateManyProviderInputEnvelope = {
  data: Array<OrderBillingCreateManyProviderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderBillingCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type OrderBillingCreateManyUserInputEnvelope = {
  data: Array<OrderBillingCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderBillingCreateNestedManyWithoutFilesInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutFilesInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutFilesInput>>;
};

export type OrderBillingCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderBillingCreateManyOrderInputEnvelope>;
};

export type OrderBillingCreateNestedManyWithoutProviderInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutProviderInput>>;
  createMany?: InputMaybe<OrderBillingCreateManyProviderInputEnvelope>;
};

export type OrderBillingCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderBillingCreateManyUserInputEnvelope>;
};

export type OrderBillingCreateNestedOneWithoutItemBillingInput = {
  connect?: InputMaybe<OrderBillingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderBillingCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<OrderBillingCreateWithoutItemBillingInput>;
};

export type OrderBillingCreateOrConnectWithoutFilesInput = {
  create: OrderBillingCreateWithoutFilesInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingCreateOrConnectWithoutItemBillingInput = {
  create: OrderBillingCreateWithoutItemBillingInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingCreateOrConnectWithoutOrderInput = {
  create: OrderBillingCreateWithoutOrderInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingCreateOrConnectWithoutProviderInput = {
  create: OrderBillingCreateWithoutProviderInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingCreateOrConnectWithoutUserInput = {
  create: OrderBillingCreateWithoutUserInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingCreateWithoutFilesInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customBillingEntry?: InputMaybe<CustomBillingEntryCreateNestedManyWithoutOrderBillingInput>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutOrderBillingInput>;
  order: OrderCreateNestedOneWithoutOrderBillingInput;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  provider?: InputMaybe<UserCreateNestedOneWithoutOrderBillingManufacturerInput>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrderBillingUserInput;
};

export type OrderBillingCreateWithoutItemBillingInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customBillingEntry?: InputMaybe<CustomBillingEntryCreateNestedManyWithoutOrderBillingInput>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutOrderBillingInput;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  provider?: InputMaybe<UserCreateNestedOneWithoutOrderBillingManufacturerInput>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrderBillingUserInput;
};

export type OrderBillingCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customBillingEntry?: InputMaybe<CustomBillingEntryCreateNestedManyWithoutOrderBillingInput>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutOrderBillingInput>;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  provider?: InputMaybe<UserCreateNestedOneWithoutOrderBillingManufacturerInput>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrderBillingUserInput;
};

export type OrderBillingCreateWithoutProviderInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customBillingEntry?: InputMaybe<CustomBillingEntryCreateNestedManyWithoutOrderBillingInput>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutOrderBillingInput>;
  order: OrderCreateNestedOneWithoutOrderBillingInput;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrderBillingUserInput;
};

export type OrderBillingCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customBillingEntry?: InputMaybe<CustomBillingEntryCreateNestedManyWithoutOrderBillingInput>;
  discount?: InputMaybe<Scalars['Decimal']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderBillingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutOrderBillingInput>;
  order: OrderCreateNestedOneWithoutOrderBillingInput;
  priceExcludingVat?: InputMaybe<Scalars['Decimal']['input']>;
  provider?: InputMaybe<UserCreateNestedOneWithoutOrderBillingManufacturerInput>;
  status?: InputMaybe<BillingStatus>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  totalVat?: InputMaybe<Scalars['Decimal']['input']>;
  type?: InputMaybe<OrderBillingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type OrderBillingListRelationFilter = {
  every?: InputMaybe<OrderBillingWhereInput>;
  none?: InputMaybe<OrderBillingWhereInput>;
  some?: InputMaybe<OrderBillingWhereInput>;
};

export type OrderBillingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderBillingOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  customBillingEntry?: InputMaybe<CustomBillingEntryOrderByRelationAggregateInput>;
  discount?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  itemBilling?: InputMaybe<ItemBillingOrderByRelationAggregateInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  priceExcludingVat?: InputMaybe<SortOrder>;
  provider?: InputMaybe<UserOrderByWithRelationInput>;
  providerId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  totalPrice?: InputMaybe<SortOrder>;
  totalVat?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum OrderBillingScalarFieldEnum {
  CreatedAt = 'createdAt',
  Discount = 'discount',
  Id = 'id',
  OrderId = 'orderId',
  PriceExcludingVat = 'priceExcludingVat',
  ProviderId = 'providerId',
  Status = 'status',
  TotalPrice = 'totalPrice',
  TotalVat = 'totalVat',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type OrderBillingScalarRelationFilter = {
  is?: InputMaybe<OrderBillingWhereInput>;
  isNot?: InputMaybe<OrderBillingWhereInput>;
};

export type OrderBillingScalarWhereInput = {
  AND?: InputMaybe<Array<OrderBillingScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderBillingScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderBillingScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discount?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  priceExcludingVat?: InputMaybe<DecimalFilter>;
  providerId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumBillingStatusFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  type?: InputMaybe<EnumOrderBillingTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export enum OrderBillingType {
  FirstOrder = 'FIRST_ORDER',
  Refabrication = 'REFABRICATION'
}

export type OrderBillingUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customBillingEntry?: InputMaybe<CustomBillingEntryUpdateManyWithoutOrderBillingNestedInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutOrderBillingNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderBillingNestedInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  provider?: InputMaybe<UserUpdateOneWithoutOrderBillingManufacturerNestedInput>;
  status?: InputMaybe<EnumBillingStatusFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderBillingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderBillingUserNestedInput>;
};

export type OrderBillingUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBillingStatusFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderBillingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderBillingUpdateManyWithWhereWithoutFilesInput = {
  data: OrderBillingUpdateManyMutationInput;
  where: OrderBillingScalarWhereInput;
};

export type OrderBillingUpdateManyWithWhereWithoutOrderInput = {
  data: OrderBillingUpdateManyMutationInput;
  where: OrderBillingScalarWhereInput;
};

export type OrderBillingUpdateManyWithWhereWithoutProviderInput = {
  data: OrderBillingUpdateManyMutationInput;
  where: OrderBillingScalarWhereInput;
};

export type OrderBillingUpdateManyWithWhereWithoutUserInput = {
  data: OrderBillingUpdateManyMutationInput;
  where: OrderBillingScalarWhereInput;
};

export type OrderBillingUpdateManyWithoutFilesNestedInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutFilesInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutFilesInput>>;
  delete?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderBillingUpdateWithWhereUniqueWithoutFilesInput>>;
  updateMany?: InputMaybe<Array<OrderBillingUpdateManyWithWhereWithoutFilesInput>>;
  upsert?: InputMaybe<Array<OrderBillingUpsertWithWhereUniqueWithoutFilesInput>>;
};

export type OrderBillingUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderBillingCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderBillingUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderBillingUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderBillingUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderBillingUpdateManyWithoutProviderNestedInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutProviderInput>>;
  createMany?: InputMaybe<OrderBillingCreateManyProviderInputEnvelope>;
  delete?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderBillingUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: InputMaybe<Array<OrderBillingUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: InputMaybe<Array<OrderBillingUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type OrderBillingUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderBillingCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderBillingCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderBillingCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderBillingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderBillingWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderBillingUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<OrderBillingUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<OrderBillingUpsertWithWhereUniqueWithoutUserInput>>;
};

export type OrderBillingUpdateOneRequiredWithoutItemBillingNestedInput = {
  connect?: InputMaybe<OrderBillingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderBillingCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<OrderBillingCreateWithoutItemBillingInput>;
  update?: InputMaybe<OrderBillingUpdateToOneWithWhereWithoutItemBillingInput>;
  upsert?: InputMaybe<OrderBillingUpsertWithoutItemBillingInput>;
};

export type OrderBillingUpdateToOneWithWhereWithoutItemBillingInput = {
  data: OrderBillingUpdateWithoutItemBillingInput;
  where?: InputMaybe<OrderBillingWhereInput>;
};

export type OrderBillingUpdateWithWhereUniqueWithoutFilesInput = {
  data: OrderBillingUpdateWithoutFilesInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderBillingUpdateWithoutOrderInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpdateWithWhereUniqueWithoutProviderInput = {
  data: OrderBillingUpdateWithoutProviderInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpdateWithWhereUniqueWithoutUserInput = {
  data: OrderBillingUpdateWithoutUserInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpdateWithoutFilesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customBillingEntry?: InputMaybe<CustomBillingEntryUpdateManyWithoutOrderBillingNestedInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutOrderBillingNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderBillingNestedInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  provider?: InputMaybe<UserUpdateOneWithoutOrderBillingManufacturerNestedInput>;
  status?: InputMaybe<EnumBillingStatusFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderBillingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderBillingUserNestedInput>;
};

export type OrderBillingUpdateWithoutItemBillingInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customBillingEntry?: InputMaybe<CustomBillingEntryUpdateManyWithoutOrderBillingNestedInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderBillingNestedInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  provider?: InputMaybe<UserUpdateOneWithoutOrderBillingManufacturerNestedInput>;
  status?: InputMaybe<EnumBillingStatusFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderBillingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderBillingUserNestedInput>;
};

export type OrderBillingUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customBillingEntry?: InputMaybe<CustomBillingEntryUpdateManyWithoutOrderBillingNestedInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutOrderBillingNestedInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  provider?: InputMaybe<UserUpdateOneWithoutOrderBillingManufacturerNestedInput>;
  status?: InputMaybe<EnumBillingStatusFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderBillingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderBillingUserNestedInput>;
};

export type OrderBillingUpdateWithoutProviderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customBillingEntry?: InputMaybe<CustomBillingEntryUpdateManyWithoutOrderBillingNestedInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutOrderBillingNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderBillingNestedInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBillingStatusFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderBillingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrderBillingUserNestedInput>;
};

export type OrderBillingUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customBillingEntry?: InputMaybe<CustomBillingEntryUpdateManyWithoutOrderBillingNestedInput>;
  discount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderBillingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutOrderBillingNestedInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderBillingNestedInput>;
  priceExcludingVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  provider?: InputMaybe<UserUpdateOneWithoutOrderBillingManufacturerNestedInput>;
  status?: InputMaybe<EnumBillingStatusFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  totalVat?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderBillingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderBillingUpsertWithWhereUniqueWithoutFilesInput = {
  create: OrderBillingCreateWithoutFilesInput;
  update: OrderBillingUpdateWithoutFilesInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderBillingCreateWithoutOrderInput;
  update: OrderBillingUpdateWithoutOrderInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpsertWithWhereUniqueWithoutProviderInput = {
  create: OrderBillingCreateWithoutProviderInput;
  update: OrderBillingUpdateWithoutProviderInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpsertWithWhereUniqueWithoutUserInput = {
  create: OrderBillingCreateWithoutUserInput;
  update: OrderBillingUpdateWithoutUserInput;
  where: OrderBillingWhereUniqueInput;
};

export type OrderBillingUpsertWithoutItemBillingInput = {
  create: OrderBillingCreateWithoutItemBillingInput;
  update: OrderBillingUpdateWithoutItemBillingInput;
  where?: InputMaybe<OrderBillingWhereInput>;
};

export type OrderBillingWhereInput = {
  AND?: InputMaybe<Array<OrderBillingWhereInput>>;
  NOT?: InputMaybe<Array<OrderBillingWhereInput>>;
  OR?: InputMaybe<Array<OrderBillingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customBillingEntry?: InputMaybe<CustomBillingEntryListRelationFilter>;
  discount?: InputMaybe<DecimalFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  priceExcludingVat?: InputMaybe<DecimalFilter>;
  provider?: InputMaybe<UserNullableScalarRelationFilter>;
  providerId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumBillingStatusFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  type?: InputMaybe<EnumOrderBillingTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type OrderBillingWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderBillingWhereInput>>;
  NOT?: InputMaybe<Array<OrderBillingWhereInput>>;
  OR?: InputMaybe<Array<OrderBillingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customBillingEntry?: InputMaybe<CustomBillingEntryListRelationFilter>;
  discount?: InputMaybe<DecimalFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  priceExcludingVat?: InputMaybe<DecimalFilter>;
  provider?: InputMaybe<UserNullableScalarRelationFilter>;
  providerId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumBillingStatusFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  totalVat?: InputMaybe<DecimalFilter>;
  type?: InputMaybe<EnumOrderBillingTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type OrderByMonth = {
  __typename?: 'OrderByMonth';
  month: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type OrderByWeek = {
  __typename?: 'OrderByWeek';
  total: Scalars['Int']['output'];
  week: Scalars['String']['output'];
};

export type OrderComment = {
  __typename?: 'OrderComment';
  _count: OrderCommentCount;
  comment: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  files?: Maybe<Array<File>>;
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  translatedComment?: Maybe<Scalars['String']['output']>;
  type: CommentType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OrderCommentCount = {
  __typename?: 'OrderCommentCount';
  files: Scalars['Int']['output'];
};

export type OrderCommentCreateInput = {
  comment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderCommentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutOrderCommentInput;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  translatedComment?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CommentType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type OrderCommentCreateManyOrderInput = {
  comment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  translatedComment?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CommentType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type OrderCommentCreateManyOrderInputEnvelope = {
  data: Array<OrderCommentCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCommentCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderCommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCommentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderCommentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderCommentCreateManyOrderInputEnvelope>;
};

export type OrderCommentCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<OrderCommentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCommentCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<OrderCommentCreateWithoutFilesInput>;
};

export type OrderCommentCreateOrConnectWithoutFilesInput = {
  create: OrderCommentCreateWithoutFilesInput;
  where: OrderCommentWhereUniqueInput;
};

export type OrderCommentCreateOrConnectWithoutOrderInput = {
  create: OrderCommentCreateWithoutOrderInput;
  where: OrderCommentWhereUniqueInput;
};

export type OrderCommentCreateWithoutFilesInput = {
  comment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutOrderCommentInput;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  translatedComment?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CommentType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type OrderCommentCreateWithoutOrderInput = {
  comment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderCommentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  translatedComment?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CommentType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type OrderCommentListRelationFilter = {
  every?: InputMaybe<OrderCommentWhereInput>;
  none?: InputMaybe<OrderCommentWhereInput>;
  some?: InputMaybe<OrderCommentWhereInput>;
};

export type OrderCommentNullableScalarRelationFilter = {
  is?: InputMaybe<OrderCommentWhereInput>;
  isNot?: InputMaybe<OrderCommentWhereInput>;
};

export type OrderCommentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderCommentOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  read?: InputMaybe<SortOrder>;
  translatedComment?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrderCommentScalarWhereInput = {
  AND?: InputMaybe<Array<OrderCommentScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderCommentScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderCommentScalarWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  read?: InputMaybe<BoolFilter>;
  translatedComment?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumCommentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderCommentUpdateInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderCommentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderCommentNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  translatedComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCommentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderCommentUpdateManyMutationInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  translatedComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCommentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderCommentUpdateManyWithWhereWithoutOrderInput = {
  data: OrderCommentUpdateManyMutationInput;
  where: OrderCommentScalarWhereInput;
};

export type OrderCommentUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderCommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCommentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderCommentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderCommentCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderCommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderCommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderCommentWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderCommentWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderCommentUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderCommentUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderCommentUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderCommentUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<OrderCommentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCommentCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<OrderCommentCreateWithoutFilesInput>;
  delete?: InputMaybe<OrderCommentWhereInput>;
  disconnect?: InputMaybe<OrderCommentWhereInput>;
  update?: InputMaybe<OrderCommentUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<OrderCommentUpsertWithoutFilesInput>;
};

export type OrderCommentUpdateToOneWithWhereWithoutFilesInput = {
  data: OrderCommentUpdateWithoutFilesInput;
  where?: InputMaybe<OrderCommentWhereInput>;
};

export type OrderCommentUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderCommentUpdateWithoutOrderInput;
  where: OrderCommentWhereUniqueInput;
};

export type OrderCommentUpdateWithoutFilesInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutOrderCommentNestedInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  translatedComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCommentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderCommentUpdateWithoutOrderInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderCommentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  read?: InputMaybe<BoolFieldUpdateOperationsInput>;
  translatedComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCommentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderCommentUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderCommentCreateWithoutOrderInput;
  update: OrderCommentUpdateWithoutOrderInput;
  where: OrderCommentWhereUniqueInput;
};

export type OrderCommentUpsertWithoutFilesInput = {
  create: OrderCommentCreateWithoutFilesInput;
  update: OrderCommentUpdateWithoutFilesInput;
  where?: InputMaybe<OrderCommentWhereInput>;
};

export type OrderCommentV2 = {
  __typename?: 'OrderCommentV2';
  comment: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  files: Array<FileV2>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type OrderCommentWhereInput = {
  AND?: InputMaybe<Array<OrderCommentWhereInput>>;
  NOT?: InputMaybe<Array<OrderCommentWhereInput>>;
  OR?: InputMaybe<Array<OrderCommentWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  read?: InputMaybe<BoolFilter>;
  translatedComment?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumCommentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderCommentWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderCommentWhereInput>>;
  NOT?: InputMaybe<Array<OrderCommentWhereInput>>;
  OR?: InputMaybe<Array<OrderCommentWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  read?: InputMaybe<BoolFilter>;
  translatedComment?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumCommentTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderCount = {
  __typename?: 'OrderCount';
  Chat: Scalars['Int']['output'];
  ChatMarkAsUnread: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  history: Scalars['Int']['output'];
  orderBilling: Scalars['Int']['output'];
  orderComment: Scalars['Int']['output'];
  orderDesigns: Scalars['Int']['output'];
  pickup: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
  redo: Scalars['Int']['output'];
  shippings: Scalars['Int']['output'];
};

export type OrderCreateInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateManyAddressInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderReference: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  providerGroupId?: InputMaybe<Scalars['String']['input']>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderCreateManyAddressInputEnvelope = {
  data: Array<OrderCreateManyAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyPatientInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderReference: Scalars['String']['input'];
  providerGroupId?: InputMaybe<Scalars['String']['input']>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderCreateManyPatientInputEnvelope = {
  data: Array<OrderCreateManyPatientInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyProviderInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderReference: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderCreateManyProviderInputEnvelope = {
  data: Array<OrderCreateManyProviderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyUserGroupInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderReference: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  providerGroupId?: InputMaybe<Scalars['String']['input']>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userId: Scalars['String']['input'];
};

export type OrderCreateManyUserGroupInputEnvelope = {
  data: Array<OrderCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyUserInput = {
  addressId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderReference: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  providerGroupId?: InputMaybe<Scalars['String']['input']>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCreateManyUserInputEnvelope = {
  data: Array<OrderCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateNestedManyWithoutAddressInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutAddressInput>>;
  createMany?: InputMaybe<OrderCreateManyAddressInputEnvelope>;
};

export type OrderCreateNestedManyWithoutPatientInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutPatientInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutPatientInput>>;
  createMany?: InputMaybe<OrderCreateManyPatientInputEnvelope>;
};

export type OrderCreateNestedManyWithoutProviderInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutProviderInput>>;
  createMany?: InputMaybe<OrderCreateManyProviderInputEnvelope>;
};

export type OrderCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<OrderCreateManyUserGroupInputEnvelope>;
};

export type OrderCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderCreateManyUserInputEnvelope>;
};

export type OrderCreateNestedOneWithoutChatInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutChatInput>;
  create?: InputMaybe<OrderCreateWithoutChatInput>;
};

export type OrderCreateNestedOneWithoutChatMarkAsUnreadInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutChatMarkAsUnreadInput>;
  create?: InputMaybe<OrderCreateWithoutChatMarkAsUnreadInput>;
};

export type OrderCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<OrderCreateWithoutFilesInput>;
};

export type OrderCreateNestedOneWithoutHistoryInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutHistoryInput>;
  create?: InputMaybe<OrderCreateWithoutHistoryInput>;
};

export type OrderCreateNestedOneWithoutOrderBillingInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutOrderBillingInput>;
  create?: InputMaybe<OrderCreateWithoutOrderBillingInput>;
};

export type OrderCreateNestedOneWithoutOrderCommentInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutOrderCommentInput>;
  create?: InputMaybe<OrderCreateWithoutOrderCommentInput>;
};

export type OrderCreateNestedOneWithoutPickupInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPickupInput>;
  create?: InputMaybe<OrderCreateWithoutPickupInput>;
};

export type OrderCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<OrderCreateWithoutProductsInput>;
};

export type OrderCreateNestedOneWithoutShippingsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutShippingsInput>;
  create?: InputMaybe<OrderCreateWithoutShippingsInput>;
};

export type OrderCreateOrConnectWithoutAddressInput = {
  create: OrderCreateWithoutAddressInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutChatInput = {
  create: OrderCreateWithoutChatInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutChatMarkAsUnreadInput = {
  create: OrderCreateWithoutChatMarkAsUnreadInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutFilesInput = {
  create: OrderCreateWithoutFilesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutHistoryInput = {
  create: OrderCreateWithoutHistoryInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutOrderBillingInput = {
  create: OrderCreateWithoutOrderBillingInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutOrderCommentInput = {
  create: OrderCreateWithoutOrderCommentInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPatientInput = {
  create: OrderCreateWithoutPatientInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPickupInput = {
  create: OrderCreateWithoutPickupInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutProductsInput = {
  create: OrderCreateWithoutProductsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutProviderInput = {
  create: OrderCreateWithoutProviderInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutShippingsInput = {
  create: OrderCreateWithoutShippingsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutUserGroupInput = {
  create: OrderCreateWithoutUserGroupInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutUserInput = {
  create: OrderCreateWithoutUserInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutAddressInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutChatInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutChatMarkAsUnreadInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutFilesInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutHistoryInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutOrderBillingInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutOrderCommentInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutPatientInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutPickupInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutProductsInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutProviderInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutShippingsInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderCreateWithoutUserGroupInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  user: UserCreateNestedOneWithoutOrdersInput;
};

export type OrderCreateWithoutUserInput = {
  Chat?: InputMaybe<ChatCreateNestedManyWithoutOrderInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutOrderInput>;
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdWithWebapp?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileCreateNestedManyWithoutOrderInput>;
  history?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  internalComments?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBillingDone?: InputMaybe<Scalars['Boolean']['input']>;
  isMailSent?: InputMaybe<Scalars['Boolean']['input']>;
  isPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isRush?: InputMaybe<Scalars['Boolean']['input']>;
  lastShippingDate?: InputMaybe<Scalars['Timestamp']['input']>;
  orderBilling?: InputMaybe<OrderBillingCreateNestedManyWithoutOrderInput>;
  orderComment?: InputMaybe<OrderCommentCreateNestedManyWithoutOrderInput>;
  orderReference: Scalars['String']['input'];
  patient?: InputMaybe<PatientCreateNestedOneWithoutOrderInput>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutOrderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutOrderInput>;
  provider?: InputMaybe<UserGroupCreateNestedOneWithoutProviderOrdersInput>;
  redo?: InputMaybe<RedoCreateNestedManyWithoutOrderInput>;
  shippedBackToProviderDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutClinicOrdersInput>;
};

export type OrderDesign = {
  __typename?: 'OrderDesign';
  _count: OrderDesignCount;
  createdAt: Scalars['Timestamp']['output'];
  expirationDate?: Maybe<Scalars['Timestamp']['output']>;
  filenames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  orderDesignComments: Array<OrderDesignCommentModel>;
  orderDesignHistory?: Maybe<Array<OrderDesignHistoryRecord>>;
  orderId: Scalars['String']['output'];
  status: OrderDesignStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OrderDesignAttachmentModel = {
  __typename?: 'OrderDesignAttachmentModel';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type OrderDesignCommentModel = {
  __typename?: 'OrderDesignCommentModel';
  attachments: Array<OrderDesignAttachmentModel>;
  author: User;
  authorId: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  orderDesignId: Scalars['String']['output'];
  translatedComment?: Maybe<Scalars['String']['output']>;
};

export type OrderDesignCount = {
  __typename?: 'OrderDesignCount';
  orderDesignComments: Scalars['Int']['output'];
  orderDesignHistory: Scalars['Int']['output'];
};

export type OrderDesignHistoryRecord = {
  __typename?: 'OrderDesignHistoryRecord';
  changedAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  orderDesignId: Scalars['String']['output'];
  status: OrderDesignStatus;
};

export enum OrderDesignReview {
  Rejected = 'REJECTED',
  Validated = 'VALIDATED'
}

/** ---------------------------------- Order Designs --------------------------------- /// */
export enum OrderDesignStatus {
  AutomaticallyValidated = 'AUTOMATICALLY_VALIDATED',
  Draft = 'DRAFT',
  Opened = 'OPENED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Validated = 'VALIDATED'
}

export type OrderDesignWithOrders = {
  __typename?: 'OrderDesignWithOrders';
  _count: OrderDesignCount;
  createdAt: Scalars['Timestamp']['output'];
  expirationDate?: Maybe<Scalars['Timestamp']['output']>;
  filenames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  order: Order;
  orderDesignComments: Array<OrderDesignCommentModel>;
  orderDesignHistory?: Maybe<Array<OrderDesignHistoryRecord>>;
  orderId: Scalars['String']['output'];
  status: OrderDesignStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OrderEstimatedDeliveryDate = {
  __typename?: 'OrderEstimatedDeliveryDate';
  bankHolidays: Array<BankHoliday>;
  deliveryDate: Scalars['Timestamp']['output'];
  minimalRushDeliveryDate: Scalars['Timestamp']['output'];
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  action?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  status?: Maybe<OrderStatus>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OrderHistoryCreateManyOrderInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderHistoryCreateManyOrderInputEnvelope = {
  data: Array<OrderHistoryCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderHistoryCreateManyUserInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  status?: InputMaybe<OrderStatus>;
};

export type OrderHistoryCreateManyUserInputEnvelope = {
  data: Array<OrderHistoryCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderHistoryCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderHistoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderHistoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderHistoryCreateManyOrderInputEnvelope>;
};

export type OrderHistoryCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderHistoryCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderHistoryCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderHistoryCreateManyUserInputEnvelope>;
};

export type OrderHistoryCreateOrConnectWithoutOrderInput = {
  create: OrderHistoryCreateWithoutOrderInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryCreateOrConnectWithoutUserInput = {
  create: OrderHistoryCreateWithoutUserInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryCreateWithoutOrderInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  user?: InputMaybe<UserCreateNestedOneWithoutOrderHistoryInput>;
};

export type OrderHistoryCreateWithoutUserInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutHistoryInput;
  status?: InputMaybe<OrderStatus>;
};

export type OrderHistoryListRelationFilter = {
  every?: InputMaybe<OrderHistoryWhereInput>;
  none?: InputMaybe<OrderHistoryWhereInput>;
  some?: InputMaybe<OrderHistoryWhereInput>;
};

export type OrderHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  action?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumOrderStatusNullableFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type OrderHistoryUpdateManyMutationInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
};

export type OrderHistoryUpdateManyWithWhereWithoutOrderInput = {
  data: OrderHistoryUpdateManyMutationInput;
  where: OrderHistoryScalarWhereInput;
};

export type OrderHistoryUpdateManyWithWhereWithoutUserInput = {
  data: OrderHistoryUpdateManyMutationInput;
  where: OrderHistoryScalarWhereInput;
};

export type OrderHistoryUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderHistoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderHistoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderHistoryCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderHistoryUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderHistoryUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderHistoryUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderHistoryUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderHistoryCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderHistoryCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderHistoryCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderHistoryUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<OrderHistoryUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<OrderHistoryUpsertWithWhereUniqueWithoutUserInput>>;
};

export type OrderHistoryUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderHistoryUpdateWithoutOrderInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryUpdateWithWhereUniqueWithoutUserInput = {
  data: OrderHistoryUpdateWithoutUserInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryUpdateWithoutOrderInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutOrderHistoryNestedInput>;
};

export type OrderHistoryUpdateWithoutUserInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutHistoryNestedInput>;
  status?: InputMaybe<NullableEnumOrderStatusFieldUpdateOperationsInput>;
};

export type OrderHistoryUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderHistoryCreateWithoutOrderInput;
  update: OrderHistoryUpdateWithoutOrderInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryUpsertWithWhereUniqueWithoutUserInput = {
  create: OrderHistoryCreateWithoutUserInput;
  update: OrderHistoryUpdateWithoutUserInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryWhereInput = {
  AND?: InputMaybe<Array<OrderHistoryWhereInput>>;
  NOT?: InputMaybe<Array<OrderHistoryWhereInput>>;
  OR?: InputMaybe<Array<OrderHistoryWhereInput>>;
  action?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumOrderStatusNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type OrderHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderHistoryWhereInput>>;
  NOT?: InputMaybe<Array<OrderHistoryWhereInput>>;
  OR?: InputMaybe<Array<OrderHistoryWhereInput>>;
  action?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  details?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  status?: InputMaybe<EnumOrderStatusNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<UuidNullableFilter>;
};

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderModel = {
  __typename?: 'OrderModel';
  comments: Array<OrderCommentV2>;
  confirmedAt?: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  deliveryDate?: Maybe<Scalars['Timestamp']['output']>;
  dentalOffice: DentalOffice;
  dentist: Dentist;
  files: Array<FileV2>;
  id: Scalars['String']['output'];
  isRush: Scalars['Boolean']['output'];
  patient?: Maybe<PatientModel>;
  products: Array<ProductModel>;
  reference: Scalars['String']['output'];
  status: OrderStatusV2;
  updatedAt: Scalars['Timestamp']['output'];
};

export type OrderNullableScalarRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationInput = {
  Chat?: InputMaybe<ChatOrderByRelationAggregateInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadOrderByRelationAggregateInput>;
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrderInput>;
  comment?: InputMaybe<SortOrderInput>;
  confirmedAt?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdWithWebapp?: InputMaybe<SortOrder>;
  deliveryDate?: InputMaybe<SortOrderInput>;
  directId?: InputMaybe<SortOrderInput>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  history?: InputMaybe<OrderHistoryOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  integrationType?: InputMaybe<SortOrderInput>;
  internalComments?: InputMaybe<SortOrderInput>;
  isArchived?: InputMaybe<SortOrder>;
  isBillingDone?: InputMaybe<SortOrder>;
  isMailSent?: InputMaybe<SortOrder>;
  isPhysicalPrint?: InputMaybe<SortOrder>;
  isRush?: InputMaybe<SortOrder>;
  lastShippingDate?: InputMaybe<SortOrderInput>;
  orderBilling?: InputMaybe<OrderBillingOrderByRelationAggregateInput>;
  orderComment?: InputMaybe<OrderCommentOrderByRelationAggregateInput>;
  orderReference?: InputMaybe<SortOrder>;
  patient?: InputMaybe<PatientOrderByWithRelationInput>;
  patientId?: InputMaybe<SortOrderInput>;
  pickup?: InputMaybe<PickupOrderByRelationAggregateInput>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
  provider?: InputMaybe<UserGroupOrderByWithRelationInput>;
  providerGroupId?: InputMaybe<SortOrderInput>;
  redo?: InputMaybe<RedoOrderByRelationAggregateInput>;
  shippedBackToProviderDate?: InputMaybe<SortOrderInput>;
  shippings?: InputMaybe<ShippingContentOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userGroup?: InputMaybe<UserGroupOrderByWithRelationInput>;
  userGroupId?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  orders: Array<Order>;
  totalCount: Scalars['Float']['output'];
};

export enum OrderScalarFieldEnum {
  AddressId = 'addressId',
  Comment = 'comment',
  ConfirmedAt = 'confirmedAt',
  CreatedAt = 'createdAt',
  CreatedWithWebapp = 'createdWithWebapp',
  DeliveryDate = 'deliveryDate',
  DirectId = 'directId',
  Id = 'id',
  IntegrationType = 'integrationType',
  InternalComments = 'internalComments',
  IsArchived = 'isArchived',
  IsBillingDone = 'isBillingDone',
  IsMailSent = 'isMailSent',
  IsPhysicalPrint = 'isPhysicalPrint',
  IsRush = 'isRush',
  LastShippingDate = 'lastShippingDate',
  OrderReference = 'orderReference',
  PatientId = 'patientId',
  ProviderGroupId = 'providerGroupId',
  ShippedBackToProviderDate = 'shippedBackToProviderDate',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserGroupId = 'userGroupId',
  UserId = 'userId'
}

export type OrderScalarRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  addressId?: InputMaybe<UuidNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  confirmedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdWithWebapp?: InputMaybe<BoolFilter>;
  deliveryDate?: InputMaybe<DateTimeNullableFilter>;
  directId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  integrationType?: InputMaybe<EnumIntegrationTypeNullableFilter>;
  internalComments?: InputMaybe<StringNullableFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  isBillingDone?: InputMaybe<BoolFilter>;
  isMailSent?: InputMaybe<BoolFilter>;
  isPhysicalPrint?: InputMaybe<BoolFilter>;
  isRush?: InputMaybe<BoolFilter>;
  lastShippingDate?: InputMaybe<DateTimeNullableFilter>;
  orderReference?: InputMaybe<StringFilter>;
  patientId?: InputMaybe<UuidNullableFilter>;
  providerGroupId?: InputMaybe<UuidNullableFilter>;
  shippedBackToProviderDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export enum OrderStatus {
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  NeedToBeProcessed = 'NEED_TO_BE_PROCESSED',
  OnHold = 'ON_HOLD',
  OpsShippingToday = 'OPS_SHIPPING_TODAY',
  Producing = 'PRODUCING',
  ProducingInTransit = 'PRODUCING_IN_TRANSIT',
  Shipped = 'SHIPPED',
  ShippedBackFromDoctor = 'SHIPPED_BACK_FROM_DOCTOR',
  WaitingForProduction = 'WAITING_FOR_PRODUCTION'
}

/** The status of an order for the dentist, derived from its production status and the statuses of its designs */
export enum OrderStatusV2 {
  AwaitingValidation = 'AWAITING_VALIDATION',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  InDesign = 'IN_DESIGN',
  InProduction = 'IN_PRODUCTION',
  InProgress = 'IN_PROGRESS',
  ReturnRequested = 'RETURN_REQUESTED',
  Shipped = 'SHIPPED'
}

export type OrderStatusV2FilterInput = {
  excluded?: InputMaybe<Array<OrderStatusV2>>;
  included?: InputMaybe<Array<OrderStatusV2>>;
};

export type OrderUpdateInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateManyMutationInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateManyWithWhereWithoutAddressInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutPatientInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutProviderInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutUserGroupInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutUserInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithoutAddressNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutAddressInput>>;
  createMany?: InputMaybe<OrderCreateManyAddressInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutAddressInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutAddressInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutAddressInput>>;
};

export type OrderUpdateManyWithoutPatientNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutPatientInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutPatientInput>>;
  createMany?: InputMaybe<OrderCreateManyPatientInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutPatientInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutPatientInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutPatientInput>>;
};

export type OrderUpdateManyWithoutProviderNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutProviderInput>>;
  createMany?: InputMaybe<OrderCreateManyProviderInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type OrderUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<OrderCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type OrderUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutUserInput>>;
  createMany?: InputMaybe<OrderCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutUserInput>>;
};

export type OrderUpdateOneRequiredWithoutHistoryNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutHistoryInput>;
  create?: InputMaybe<OrderCreateWithoutHistoryInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutHistoryInput>;
  upsert?: InputMaybe<OrderUpsertWithoutHistoryInput>;
};

export type OrderUpdateOneRequiredWithoutOrderBillingNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutOrderBillingInput>;
  create?: InputMaybe<OrderCreateWithoutOrderBillingInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutOrderBillingInput>;
  upsert?: InputMaybe<OrderUpsertWithoutOrderBillingInput>;
};

export type OrderUpdateOneRequiredWithoutOrderCommentNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutOrderCommentInput>;
  create?: InputMaybe<OrderCreateWithoutOrderCommentInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutOrderCommentInput>;
  upsert?: InputMaybe<OrderUpsertWithoutOrderCommentInput>;
};

export type OrderUpdateOneRequiredWithoutPickupNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPickupInput>;
  create?: InputMaybe<OrderCreateWithoutPickupInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutPickupInput>;
  upsert?: InputMaybe<OrderUpsertWithoutPickupInput>;
};

export type OrderUpdateOneRequiredWithoutProductsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<OrderCreateWithoutProductsInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutProductsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutProductsInput>;
};

export type OrderUpdateOneRequiredWithoutShippingsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutShippingsInput>;
  create?: InputMaybe<OrderCreateWithoutShippingsInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutShippingsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutShippingsInput>;
};

export type OrderUpdateOneWithoutChatMarkAsUnreadNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutChatMarkAsUnreadInput>;
  create?: InputMaybe<OrderCreateWithoutChatMarkAsUnreadInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutChatMarkAsUnreadInput>;
  upsert?: InputMaybe<OrderUpsertWithoutChatMarkAsUnreadInput>;
};

export type OrderUpdateOneWithoutChatNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutChatInput>;
  create?: InputMaybe<OrderCreateWithoutChatInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutChatInput>;
  upsert?: InputMaybe<OrderUpsertWithoutChatInput>;
};

export type OrderUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<OrderCreateWithoutFilesInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutFilesInput>;
};

export type OrderUpdateToOneWithWhereWithoutChatInput = {
  data: OrderUpdateWithoutChatInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutChatMarkAsUnreadInput = {
  data: OrderUpdateWithoutChatMarkAsUnreadInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutFilesInput = {
  data: OrderUpdateWithoutFilesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutHistoryInput = {
  data: OrderUpdateWithoutHistoryInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutOrderBillingInput = {
  data: OrderUpdateWithoutOrderBillingInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutOrderCommentInput = {
  data: OrderUpdateWithoutOrderCommentInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutPickupInput = {
  data: OrderUpdateWithoutPickupInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutProductsInput = {
  data: OrderUpdateWithoutProductsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutShippingsInput = {
  data: OrderUpdateWithoutShippingsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateWithWhereUniqueWithoutAddressInput = {
  data: OrderUpdateWithoutAddressInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutPatientInput = {
  data: OrderUpdateWithoutPatientInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutProviderInput = {
  data: OrderUpdateWithoutProviderInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: OrderUpdateWithoutUserGroupInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutUserInput = {
  data: OrderUpdateWithoutUserInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithoutAddressInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutChatInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutChatMarkAsUnreadInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutFilesInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutHistoryInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutOrderBillingInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutOrderCommentInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutPatientInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutPickupInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutProductsInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutProviderInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutShippingsInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpdateWithoutUserGroupInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutOrdersNestedInput>;
};

export type OrderUpdateWithoutUserInput = {
  Chat?: InputMaybe<ChatUpdateManyWithoutOrderNestedInput>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutOrderNestedInput>;
  address?: InputMaybe<AddressUpdateOneWithoutOrderNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdWithWebapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  files?: InputMaybe<FileUpdateManyWithoutOrderNestedInput>;
  history?: InputMaybe<OrderHistoryUpdateManyWithoutOrderNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  integrationType?: InputMaybe<NullableEnumIntegrationTypeFieldUpdateOperationsInput>;
  internalComments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isArchived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBillingDone?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isRush?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastShippingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderBilling?: InputMaybe<OrderBillingUpdateManyWithoutOrderNestedInput>;
  orderComment?: InputMaybe<OrderCommentUpdateManyWithoutOrderNestedInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
  patient?: InputMaybe<PatientUpdateOneWithoutOrderNestedInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutOrderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutOrderNestedInput>;
  provider?: InputMaybe<UserGroupUpdateOneWithoutProviderOrdersNestedInput>;
  redo?: InputMaybe<RedoUpdateManyWithoutOrderNestedInput>;
  shippedBackToProviderDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutClinicOrdersNestedInput>;
};

export type OrderUpsertWithWhereUniqueWithoutAddressInput = {
  create: OrderCreateWithoutAddressInput;
  update: OrderUpdateWithoutAddressInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutPatientInput = {
  create: OrderCreateWithoutPatientInput;
  update: OrderUpdateWithoutPatientInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutProviderInput = {
  create: OrderCreateWithoutProviderInput;
  update: OrderUpdateWithoutProviderInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: OrderCreateWithoutUserGroupInput;
  update: OrderUpdateWithoutUserGroupInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutUserInput = {
  create: OrderCreateWithoutUserInput;
  update: OrderUpdateWithoutUserInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithoutChatInput = {
  create: OrderCreateWithoutChatInput;
  update: OrderUpdateWithoutChatInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutChatMarkAsUnreadInput = {
  create: OrderCreateWithoutChatMarkAsUnreadInput;
  update: OrderUpdateWithoutChatMarkAsUnreadInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutFilesInput = {
  create: OrderCreateWithoutFilesInput;
  update: OrderUpdateWithoutFilesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutHistoryInput = {
  create: OrderCreateWithoutHistoryInput;
  update: OrderUpdateWithoutHistoryInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutOrderBillingInput = {
  create: OrderCreateWithoutOrderBillingInput;
  update: OrderUpdateWithoutOrderBillingInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutOrderCommentInput = {
  create: OrderCreateWithoutOrderCommentInput;
  update: OrderUpdateWithoutOrderCommentInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutPickupInput = {
  create: OrderCreateWithoutPickupInput;
  update: OrderUpdateWithoutPickupInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutProductsInput = {
  create: OrderCreateWithoutProductsInput;
  update: OrderUpdateWithoutProductsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutShippingsInput = {
  create: OrderCreateWithoutShippingsInput;
  update: OrderUpdateWithoutShippingsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  Chat?: InputMaybe<ChatListRelationFilter>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadListRelationFilter>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<UuidNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  confirmedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdWithWebapp?: InputMaybe<BoolFilter>;
  deliveryDate?: InputMaybe<DateTimeNullableFilter>;
  directId?: InputMaybe<StringNullableFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  history?: InputMaybe<OrderHistoryListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  integrationType?: InputMaybe<EnumIntegrationTypeNullableFilter>;
  internalComments?: InputMaybe<StringNullableFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  isBillingDone?: InputMaybe<BoolFilter>;
  isMailSent?: InputMaybe<BoolFilter>;
  isPhysicalPrint?: InputMaybe<BoolFilter>;
  isRush?: InputMaybe<BoolFilter>;
  lastShippingDate?: InputMaybe<DateTimeNullableFilter>;
  orderBilling?: InputMaybe<OrderBillingListRelationFilter>;
  orderComment?: InputMaybe<OrderCommentListRelationFilter>;
  orderReference?: InputMaybe<StringFilter>;
  patient?: InputMaybe<PatientNullableScalarRelationFilter>;
  patientId?: InputMaybe<UuidNullableFilter>;
  pickup?: InputMaybe<PickupListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  provider?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  providerGroupId?: InputMaybe<UuidNullableFilter>;
  redo?: InputMaybe<RedoListRelationFilter>;
  shippedBackToProviderDate?: InputMaybe<DateTimeNullableFilter>;
  shippings?: InputMaybe<ShippingContentListRelationFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type OrderWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  Chat?: InputMaybe<ChatListRelationFilter>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadListRelationFilter>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<UuidNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  confirmedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdWithWebapp?: InputMaybe<BoolFilter>;
  deliveryDate?: InputMaybe<DateTimeNullableFilter>;
  directId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<FileListRelationFilter>;
  history?: InputMaybe<OrderHistoryListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<EnumIntegrationTypeNullableFilter>;
  internalComments?: InputMaybe<StringNullableFilter>;
  isArchived?: InputMaybe<BoolFilter>;
  isBillingDone?: InputMaybe<BoolFilter>;
  isMailSent?: InputMaybe<BoolFilter>;
  isPhysicalPrint?: InputMaybe<BoolFilter>;
  isRush?: InputMaybe<BoolFilter>;
  lastShippingDate?: InputMaybe<DateTimeNullableFilter>;
  orderBilling?: InputMaybe<OrderBillingListRelationFilter>;
  orderComment?: InputMaybe<OrderCommentListRelationFilter>;
  orderReference?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<PatientNullableScalarRelationFilter>;
  patientId?: InputMaybe<UuidNullableFilter>;
  pickup?: InputMaybe<PickupListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  provider?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  providerGroupId?: InputMaybe<UuidNullableFilter>;
  redo?: InputMaybe<RedoListRelationFilter>;
  shippedBackToProviderDate?: InputMaybe<DateTimeNullableFilter>;
  shippings?: InputMaybe<ShippingContentListRelationFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserScalarRelationFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type OrdersFilterInput = {
  delivered?: InputMaybe<DateFilterInput>;
  status?: InputMaybe<OrderStatusV2FilterInput>;
};

export type OrdersListFilterInput = {
  dentistId?: InputMaybe<Scalars['String']['input']>;
  /** Words matched against the reference and the patient name */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatusV2FilterInput>;
};

/** The order in which a list of orders is returned */
export enum OrdersSortV2 {
  DeliveryDate = 'DELIVERY_DATE',
  LastActivity = 'LAST_ACTIVITY',
  Newest = 'NEWEST'
}

export type OrdersV2Paginated = {
  __typename?: 'OrdersV2Paginated';
  nodes: Array<OrderModel>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedOrderDesigns = {
  __typename?: 'PaginatedOrderDesigns';
  rows: Array<OrderDesignWithOrders>;
  totalCount: Scalars['Int']['output'];
};

export type PartialDenture = {
  __typename?: 'PartialDenture';
  _count: PartialDentureCount;
  customTray: Scalars['Boolean']['output'];
  hooks?: Maybe<Array<PartialDentureHook>>;
  hooksTeeth?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  lingualMetalBand: Scalars['Boolean']['output'];
  metalMesh: Scalars['Boolean']['output'];
  missingTeeth?: Maybe<Array<Scalars['Int']['output']>>;
  palatalMetalBand: Scalars['Boolean']['output'];
  partialDentureRedoPart?: Maybe<Array<PartialDentureRedoPart>>;
  removableItem?: Maybe<RemovableItem>;
  removableItemId?: Maybe<Scalars['String']['output']>;
};

export type PartialDentureCount = {
  __typename?: 'PartialDentureCount';
  hooks: Scalars['Int']['output'];
  partialDentureRedoPart: Scalars['Int']['output'];
};

export type PartialDentureCreateNestedOneWithoutHooksInput = {
  connect?: InputMaybe<PartialDentureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PartialDentureCreateOrConnectWithoutHooksInput>;
  create?: InputMaybe<PartialDentureCreateWithoutHooksInput>;
};

export type PartialDentureCreateNestedOneWithoutRemovableItemInput = {
  connect?: InputMaybe<PartialDentureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PartialDentureCreateOrConnectWithoutRemovableItemInput>;
  create?: InputMaybe<PartialDentureCreateWithoutRemovableItemInput>;
};

export type PartialDentureCreateOrConnectWithoutHooksInput = {
  create: PartialDentureCreateWithoutHooksInput;
  where: PartialDentureWhereUniqueInput;
};

export type PartialDentureCreateOrConnectWithoutRemovableItemInput = {
  create: PartialDentureCreateWithoutRemovableItemInput;
  where: PartialDentureWhereUniqueInput;
};

export type PartialDentureCreateWithoutHooksInput = {
  customTray?: InputMaybe<Scalars['Boolean']['input']>;
  hooksTeeth?: InputMaybe<PartialDentureCreatehooksTeethInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  lingualMetalBand?: InputMaybe<Scalars['Boolean']['input']>;
  metalMesh?: InputMaybe<Scalars['Boolean']['input']>;
  missingTeeth?: InputMaybe<PartialDentureCreatemissingTeethInput>;
  palatalMetalBand?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureRedoPart?: InputMaybe<PartialDentureRedoPartCreateNestedManyWithoutPartialDentureInput>;
  removableItem?: InputMaybe<RemovableItemCreateNestedOneWithoutPartialDentureInput>;
  removableItemId?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDentureCreateWithoutRemovableItemInput = {
  customTray?: InputMaybe<Scalars['Boolean']['input']>;
  hooks?: InputMaybe<PartialDentureHookCreateNestedManyWithoutPartialDentureInput>;
  hooksTeeth?: InputMaybe<PartialDentureCreatehooksTeethInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  lingualMetalBand?: InputMaybe<Scalars['Boolean']['input']>;
  metalMesh?: InputMaybe<Scalars['Boolean']['input']>;
  missingTeeth?: InputMaybe<PartialDentureCreatemissingTeethInput>;
  palatalMetalBand?: InputMaybe<Scalars['Boolean']['input']>;
  partialDentureRedoPart?: InputMaybe<PartialDentureRedoPartCreateNestedManyWithoutPartialDentureInput>;
  removableItemId?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDentureCreatehooksTeethInput = {
  set: Array<Scalars['Int']['input']>;
};

export type PartialDentureCreatemissingTeethInput = {
  set: Array<Scalars['Int']['input']>;
};

export type PartialDentureHook = {
  __typename?: 'PartialDentureHook';
  hooksMaterial?: Maybe<ItemMaterial>;
  hooksMaterialId?: Maybe<Scalars['String']['output']>;
  hooksPosition?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  partialDenture: PartialDenture;
  partialDentureId: Scalars['String']['output'];
};

export type PartialDentureHookCreateManyHooksMaterialInput = {
  hooksPosition?: InputMaybe<PartialDentureHookCreatehooksPositionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  partialDentureId: Scalars['String']['input'];
};

export type PartialDentureHookCreateManyHooksMaterialInputEnvelope = {
  data: Array<PartialDentureHookCreateManyHooksMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialDentureHookCreateManyPartialDentureInput = {
  hooksMaterialId?: InputMaybe<Scalars['String']['input']>;
  hooksPosition?: InputMaybe<PartialDentureHookCreatehooksPositionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDentureHookCreateManyPartialDentureInputEnvelope = {
  data: Array<PartialDentureHookCreateManyPartialDentureInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialDentureHookCreateNestedManyWithoutHooksMaterialInput = {
  connect?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PartialDentureHookCreateOrConnectWithoutHooksMaterialInput>>;
  create?: InputMaybe<Array<PartialDentureHookCreateWithoutHooksMaterialInput>>;
  createMany?: InputMaybe<PartialDentureHookCreateManyHooksMaterialInputEnvelope>;
};

export type PartialDentureHookCreateNestedManyWithoutPartialDentureInput = {
  connect?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PartialDentureHookCreateOrConnectWithoutPartialDentureInput>>;
  create?: InputMaybe<Array<PartialDentureHookCreateWithoutPartialDentureInput>>;
  createMany?: InputMaybe<PartialDentureHookCreateManyPartialDentureInputEnvelope>;
};

export type PartialDentureHookCreateOrConnectWithoutHooksMaterialInput = {
  create: PartialDentureHookCreateWithoutHooksMaterialInput;
  where: PartialDentureHookWhereUniqueInput;
};

export type PartialDentureHookCreateOrConnectWithoutPartialDentureInput = {
  create: PartialDentureHookCreateWithoutPartialDentureInput;
  where: PartialDentureHookWhereUniqueInput;
};

export type PartialDentureHookCreateWithoutHooksMaterialInput = {
  hooksPosition?: InputMaybe<PartialDentureHookCreatehooksPositionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  partialDenture: PartialDentureCreateNestedOneWithoutHooksInput;
};

export type PartialDentureHookCreateWithoutPartialDentureInput = {
  hooksMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutPartialDentureHookModelInput>;
  hooksPosition?: InputMaybe<PartialDentureHookCreatehooksPositionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDentureHookCreatehooksPositionInput = {
  set: Array<Scalars['Int']['input']>;
};

export type PartialDentureHookListRelationFilter = {
  every?: InputMaybe<PartialDentureHookWhereInput>;
  none?: InputMaybe<PartialDentureHookWhereInput>;
  some?: InputMaybe<PartialDentureHookWhereInput>;
};

export type PartialDentureHookOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PartialDentureHookScalarWhereInput = {
  AND?: InputMaybe<Array<PartialDentureHookScalarWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureHookScalarWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureHookScalarWhereInput>>;
  hooksMaterialId?: InputMaybe<StringNullableFilter>;
  hooksPosition?: InputMaybe<IntNullableListFilter>;
  id?: InputMaybe<UuidFilter>;
  partialDentureId?: InputMaybe<UuidFilter>;
};

export type PartialDentureHookUpdateManyMutationInput = {
  hooksPosition?: InputMaybe<PartialDentureHookUpdatehooksPositionInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PartialDentureHookUpdateManyWithWhereWithoutHooksMaterialInput = {
  data: PartialDentureHookUpdateManyMutationInput;
  where: PartialDentureHookScalarWhereInput;
};

export type PartialDentureHookUpdateManyWithWhereWithoutPartialDentureInput = {
  data: PartialDentureHookUpdateManyMutationInput;
  where: PartialDentureHookScalarWhereInput;
};

export type PartialDentureHookUpdateManyWithoutHooksMaterialNestedInput = {
  connect?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PartialDentureHookCreateOrConnectWithoutHooksMaterialInput>>;
  create?: InputMaybe<Array<PartialDentureHookCreateWithoutHooksMaterialInput>>;
  createMany?: InputMaybe<PartialDentureHookCreateManyHooksMaterialInputEnvelope>;
  delete?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PartialDentureHookScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  set?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  update?: InputMaybe<Array<PartialDentureHookUpdateWithWhereUniqueWithoutHooksMaterialInput>>;
  updateMany?: InputMaybe<Array<PartialDentureHookUpdateManyWithWhereWithoutHooksMaterialInput>>;
  upsert?: InputMaybe<Array<PartialDentureHookUpsertWithWhereUniqueWithoutHooksMaterialInput>>;
};

export type PartialDentureHookUpdateManyWithoutPartialDentureNestedInput = {
  connect?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PartialDentureHookCreateOrConnectWithoutPartialDentureInput>>;
  create?: InputMaybe<Array<PartialDentureHookCreateWithoutPartialDentureInput>>;
  createMany?: InputMaybe<PartialDentureHookCreateManyPartialDentureInputEnvelope>;
  delete?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PartialDentureHookScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  set?: InputMaybe<Array<PartialDentureHookWhereUniqueInput>>;
  update?: InputMaybe<Array<PartialDentureHookUpdateWithWhereUniqueWithoutPartialDentureInput>>;
  updateMany?: InputMaybe<Array<PartialDentureHookUpdateManyWithWhereWithoutPartialDentureInput>>;
  upsert?: InputMaybe<Array<PartialDentureHookUpsertWithWhereUniqueWithoutPartialDentureInput>>;
};

export type PartialDentureHookUpdateWithWhereUniqueWithoutHooksMaterialInput = {
  data: PartialDentureHookUpdateWithoutHooksMaterialInput;
  where: PartialDentureHookWhereUniqueInput;
};

export type PartialDentureHookUpdateWithWhereUniqueWithoutPartialDentureInput = {
  data: PartialDentureHookUpdateWithoutPartialDentureInput;
  where: PartialDentureHookWhereUniqueInput;
};

export type PartialDentureHookUpdateWithoutHooksMaterialInput = {
  hooksPosition?: InputMaybe<PartialDentureHookUpdatehooksPositionInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<PartialDentureUpdateOneRequiredWithoutHooksNestedInput>;
};

export type PartialDentureHookUpdateWithoutPartialDentureInput = {
  hooksMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutPartialDentureHookModelNestedInput>;
  hooksPosition?: InputMaybe<PartialDentureHookUpdatehooksPositionInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PartialDentureHookUpdatehooksPositionInput = {
  push?: InputMaybe<Array<Scalars['Int']['input']>>;
  set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PartialDentureHookUpsertWithWhereUniqueWithoutHooksMaterialInput = {
  create: PartialDentureHookCreateWithoutHooksMaterialInput;
  update: PartialDentureHookUpdateWithoutHooksMaterialInput;
  where: PartialDentureHookWhereUniqueInput;
};

export type PartialDentureHookUpsertWithWhereUniqueWithoutPartialDentureInput = {
  create: PartialDentureHookCreateWithoutPartialDentureInput;
  update: PartialDentureHookUpdateWithoutPartialDentureInput;
  where: PartialDentureHookWhereUniqueInput;
};

export type PartialDentureHookWhereInput = {
  AND?: InputMaybe<Array<PartialDentureHookWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureHookWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureHookWhereInput>>;
  hooksMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  hooksMaterialId?: InputMaybe<StringNullableFilter>;
  hooksPosition?: InputMaybe<IntNullableListFilter>;
  id?: InputMaybe<UuidFilter>;
  partialDenture?: InputMaybe<PartialDentureScalarRelationFilter>;
  partialDentureId?: InputMaybe<UuidFilter>;
};

export type PartialDentureHookWhereUniqueInput = {
  AND?: InputMaybe<Array<PartialDentureHookWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureHookWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureHookWhereInput>>;
  hooksMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  hooksMaterialId?: InputMaybe<StringNullableFilter>;
  hooksPosition?: InputMaybe<IntNullableListFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  partialDenture?: InputMaybe<PartialDentureScalarRelationFilter>;
  partialDentureId?: InputMaybe<UuidFilter>;
};

export type PartialDentureNullableScalarRelationFilter = {
  is?: InputMaybe<PartialDentureWhereInput>;
  isNot?: InputMaybe<PartialDentureWhereInput>;
};

export type PartialDentureOrderByWithRelationInput = {
  customTray?: InputMaybe<SortOrder>;
  hooks?: InputMaybe<PartialDentureHookOrderByRelationAggregateInput>;
  hooksTeeth?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lingualMetalBand?: InputMaybe<SortOrder>;
  metalMesh?: InputMaybe<SortOrder>;
  missingTeeth?: InputMaybe<SortOrder>;
  palatalMetalBand?: InputMaybe<SortOrder>;
  partialDentureRedoPart?: InputMaybe<PartialDentureRedoPartOrderByRelationAggregateInput>;
  removableItem?: InputMaybe<RemovableItemOrderByWithRelationInput>;
  removableItemId?: InputMaybe<SortOrderInput>;
};

export type PartialDentureRedoPart = {
  __typename?: 'PartialDentureRedoPart';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  length?: Maybe<PartialDentureRedoPartLength>;
  partialDenture: PartialDenture;
  partialDentureId: Scalars['String']['output'];
  proximalContact?: Maybe<PartialDentureRedoPartProximalContact>;
  shape?: Maybe<PartialDentureRedoPartShape>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type PartialDentureRedoPartCreateManyPartialDentureInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<PartialDentureRedoPartLength>;
  proximalContact?: InputMaybe<PartialDentureRedoPartProximalContact>;
  shape?: InputMaybe<PartialDentureRedoPartShape>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type PartialDentureRedoPartCreateManyPartialDentureInputEnvelope = {
  data: Array<PartialDentureRedoPartCreateManyPartialDentureInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialDentureRedoPartCreateNestedManyWithoutPartialDentureInput = {
  connect?: InputMaybe<Array<PartialDentureRedoPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PartialDentureRedoPartCreateOrConnectWithoutPartialDentureInput>>;
  create?: InputMaybe<Array<PartialDentureRedoPartCreateWithoutPartialDentureInput>>;
  createMany?: InputMaybe<PartialDentureRedoPartCreateManyPartialDentureInputEnvelope>;
};

export type PartialDentureRedoPartCreateOrConnectWithoutPartialDentureInput = {
  create: PartialDentureRedoPartCreateWithoutPartialDentureInput;
  where: PartialDentureRedoPartWhereUniqueInput;
};

export type PartialDentureRedoPartCreateWithoutPartialDentureInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<PartialDentureRedoPartLength>;
  proximalContact?: InputMaybe<PartialDentureRedoPartProximalContact>;
  shape?: InputMaybe<PartialDentureRedoPartShape>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum PartialDentureRedoPartLength {
  TooLong = 'TOO_LONG',
  TooShort = 'TOO_SHORT'
}

export type PartialDentureRedoPartListRelationFilter = {
  every?: InputMaybe<PartialDentureRedoPartWhereInput>;
  none?: InputMaybe<PartialDentureRedoPartWhereInput>;
  some?: InputMaybe<PartialDentureRedoPartWhereInput>;
};

export type PartialDentureRedoPartOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum PartialDentureRedoPartProximalContact {
  Insufficient = 'INSUFFICIENT',
  TooTight = 'TOO_TIGHT'
}

export type PartialDentureRedoPartScalarWhereInput = {
  AND?: InputMaybe<Array<PartialDentureRedoPartScalarWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureRedoPartScalarWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureRedoPartScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  length?: InputMaybe<EnumPartialDentureRedoPartLengthNullableFilter>;
  partialDentureId?: InputMaybe<UuidFilter>;
  proximalContact?: InputMaybe<EnumPartialDentureRedoPartProximalContactNullableFilter>;
  shape?: InputMaybe<EnumPartialDentureRedoPartShapeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum PartialDentureRedoPartShape {
  TooNarrow = 'TOO_NARROW',
  TooWide = 'TOO_WIDE'
}

export type PartialDentureRedoPartUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  length?: InputMaybe<NullableEnumPartialDentureRedoPartLengthFieldUpdateOperationsInput>;
  proximalContact?: InputMaybe<NullableEnumPartialDentureRedoPartProximalContactFieldUpdateOperationsInput>;
  shape?: InputMaybe<NullableEnumPartialDentureRedoPartShapeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PartialDentureRedoPartUpdateManyWithWhereWithoutPartialDentureInput = {
  data: PartialDentureRedoPartUpdateManyMutationInput;
  where: PartialDentureRedoPartScalarWhereInput;
};

export type PartialDentureRedoPartUpdateManyWithoutPartialDentureNestedInput = {
  connect?: InputMaybe<Array<PartialDentureRedoPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PartialDentureRedoPartCreateOrConnectWithoutPartialDentureInput>>;
  create?: InputMaybe<Array<PartialDentureRedoPartCreateWithoutPartialDentureInput>>;
  createMany?: InputMaybe<PartialDentureRedoPartCreateManyPartialDentureInputEnvelope>;
  delete?: InputMaybe<Array<PartialDentureRedoPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PartialDentureRedoPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PartialDentureRedoPartWhereUniqueInput>>;
  set?: InputMaybe<Array<PartialDentureRedoPartWhereUniqueInput>>;
  update?: InputMaybe<Array<PartialDentureRedoPartUpdateWithWhereUniqueWithoutPartialDentureInput>>;
  updateMany?: InputMaybe<Array<PartialDentureRedoPartUpdateManyWithWhereWithoutPartialDentureInput>>;
  upsert?: InputMaybe<Array<PartialDentureRedoPartUpsertWithWhereUniqueWithoutPartialDentureInput>>;
};

export type PartialDentureRedoPartUpdateWithWhereUniqueWithoutPartialDentureInput = {
  data: PartialDentureRedoPartUpdateWithoutPartialDentureInput;
  where: PartialDentureRedoPartWhereUniqueInput;
};

export type PartialDentureRedoPartUpdateWithoutPartialDentureInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  length?: InputMaybe<NullableEnumPartialDentureRedoPartLengthFieldUpdateOperationsInput>;
  proximalContact?: InputMaybe<NullableEnumPartialDentureRedoPartProximalContactFieldUpdateOperationsInput>;
  shape?: InputMaybe<NullableEnumPartialDentureRedoPartShapeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PartialDentureRedoPartUpsertWithWhereUniqueWithoutPartialDentureInput = {
  create: PartialDentureRedoPartCreateWithoutPartialDentureInput;
  update: PartialDentureRedoPartUpdateWithoutPartialDentureInput;
  where: PartialDentureRedoPartWhereUniqueInput;
};

export type PartialDentureRedoPartWhereInput = {
  AND?: InputMaybe<Array<PartialDentureRedoPartWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureRedoPartWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureRedoPartWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  length?: InputMaybe<EnumPartialDentureRedoPartLengthNullableFilter>;
  partialDenture?: InputMaybe<PartialDentureScalarRelationFilter>;
  partialDentureId?: InputMaybe<UuidFilter>;
  proximalContact?: InputMaybe<EnumPartialDentureRedoPartProximalContactNullableFilter>;
  shape?: InputMaybe<EnumPartialDentureRedoPartShapeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PartialDentureRedoPartWhereUniqueInput = {
  AND?: InputMaybe<Array<PartialDentureRedoPartWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureRedoPartWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureRedoPartWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<EnumPartialDentureRedoPartLengthNullableFilter>;
  partialDenture?: InputMaybe<PartialDentureScalarRelationFilter>;
  partialDentureId?: InputMaybe<UuidFilter>;
  proximalContact?: InputMaybe<EnumPartialDentureRedoPartProximalContactNullableFilter>;
  shape?: InputMaybe<EnumPartialDentureRedoPartShapeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PartialDentureScalarRelationFilter = {
  is?: InputMaybe<PartialDentureWhereInput>;
  isNot?: InputMaybe<PartialDentureWhereInput>;
};

export type PartialDentureUpdateOneRequiredWithoutHooksNestedInput = {
  connect?: InputMaybe<PartialDentureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PartialDentureCreateOrConnectWithoutHooksInput>;
  create?: InputMaybe<PartialDentureCreateWithoutHooksInput>;
  update?: InputMaybe<PartialDentureUpdateToOneWithWhereWithoutHooksInput>;
  upsert?: InputMaybe<PartialDentureUpsertWithoutHooksInput>;
};

export type PartialDentureUpdateOneWithoutRemovableItemNestedInput = {
  connect?: InputMaybe<PartialDentureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PartialDentureCreateOrConnectWithoutRemovableItemInput>;
  create?: InputMaybe<PartialDentureCreateWithoutRemovableItemInput>;
  delete?: InputMaybe<PartialDentureWhereInput>;
  disconnect?: InputMaybe<PartialDentureWhereInput>;
  update?: InputMaybe<PartialDentureUpdateToOneWithWhereWithoutRemovableItemInput>;
  upsert?: InputMaybe<PartialDentureUpsertWithoutRemovableItemInput>;
};

export type PartialDentureUpdateToOneWithWhereWithoutHooksInput = {
  data: PartialDentureUpdateWithoutHooksInput;
  where?: InputMaybe<PartialDentureWhereInput>;
};

export type PartialDentureUpdateToOneWithWhereWithoutRemovableItemInput = {
  data: PartialDentureUpdateWithoutRemovableItemInput;
  where?: InputMaybe<PartialDentureWhereInput>;
};

export type PartialDentureUpdateWithoutHooksInput = {
  customTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hooksTeeth?: InputMaybe<PartialDentureUpdatehooksTeethInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lingualMetalBand?: InputMaybe<BoolFieldUpdateOperationsInput>;
  metalMesh?: InputMaybe<BoolFieldUpdateOperationsInput>;
  missingTeeth?: InputMaybe<PartialDentureUpdatemissingTeethInput>;
  palatalMetalBand?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureRedoPart?: InputMaybe<PartialDentureRedoPartUpdateManyWithoutPartialDentureNestedInput>;
  removableItem?: InputMaybe<RemovableItemUpdateOneWithoutPartialDentureNestedInput>;
  removableItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PartialDentureUpdateWithoutRemovableItemInput = {
  customTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hooks?: InputMaybe<PartialDentureHookUpdateManyWithoutPartialDentureNestedInput>;
  hooksTeeth?: InputMaybe<PartialDentureUpdatehooksTeethInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lingualMetalBand?: InputMaybe<BoolFieldUpdateOperationsInput>;
  metalMesh?: InputMaybe<BoolFieldUpdateOperationsInput>;
  missingTeeth?: InputMaybe<PartialDentureUpdatemissingTeethInput>;
  palatalMetalBand?: InputMaybe<BoolFieldUpdateOperationsInput>;
  partialDentureRedoPart?: InputMaybe<PartialDentureRedoPartUpdateManyWithoutPartialDentureNestedInput>;
  removableItemId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PartialDentureUpdatehooksTeethInput = {
  push?: InputMaybe<Array<Scalars['Int']['input']>>;
  set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PartialDentureUpdatemissingTeethInput = {
  push?: InputMaybe<Array<Scalars['Int']['input']>>;
  set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PartialDentureUpsertWithoutHooksInput = {
  create: PartialDentureCreateWithoutHooksInput;
  update: PartialDentureUpdateWithoutHooksInput;
  where?: InputMaybe<PartialDentureWhereInput>;
};

export type PartialDentureUpsertWithoutRemovableItemInput = {
  create: PartialDentureCreateWithoutRemovableItemInput;
  update: PartialDentureUpdateWithoutRemovableItemInput;
  where?: InputMaybe<PartialDentureWhereInput>;
};

export type PartialDentureWhereInput = {
  AND?: InputMaybe<Array<PartialDentureWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureWhereInput>>;
  customTray?: InputMaybe<BoolFilter>;
  hooks?: InputMaybe<PartialDentureHookListRelationFilter>;
  hooksTeeth?: InputMaybe<IntNullableListFilter>;
  id?: InputMaybe<UuidFilter>;
  lingualMetalBand?: InputMaybe<BoolFilter>;
  metalMesh?: InputMaybe<BoolFilter>;
  missingTeeth?: InputMaybe<IntNullableListFilter>;
  palatalMetalBand?: InputMaybe<BoolFilter>;
  partialDentureRedoPart?: InputMaybe<PartialDentureRedoPartListRelationFilter>;
  removableItem?: InputMaybe<RemovableItemNullableScalarRelationFilter>;
  removableItemId?: InputMaybe<UuidNullableFilter>;
};

export type PartialDentureWhereUniqueInput = {
  AND?: InputMaybe<Array<PartialDentureWhereInput>>;
  NOT?: InputMaybe<Array<PartialDentureWhereInput>>;
  OR?: InputMaybe<Array<PartialDentureWhereInput>>;
  customTray?: InputMaybe<BoolFilter>;
  hooks?: InputMaybe<PartialDentureHookListRelationFilter>;
  hooksTeeth?: InputMaybe<IntNullableListFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lingualMetalBand?: InputMaybe<BoolFilter>;
  metalMesh?: InputMaybe<BoolFilter>;
  missingTeeth?: InputMaybe<IntNullableListFilter>;
  palatalMetalBand?: InputMaybe<BoolFilter>;
  partialDentureRedoPart?: InputMaybe<PartialDentureRedoPartListRelationFilter>;
  removableItem?: InputMaybe<RemovableItemNullableScalarRelationFilter>;
  removableItemId?: InputMaybe<UuidNullableFilter>;
};

export type Patient = {
  __typename?: 'Patient';
  _count: PatientCount;
  birthdate?: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  dentist: User;
  dentistId: Scalars['String']['output'];
  directId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  order?: Maybe<Array<Order>>;
  sex?: Maybe<Sex>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type PatientCount = {
  __typename?: 'PatientCount';
  order: Scalars['Int']['output'];
};

export type PatientCreateInput = {
  birthdate?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentist: UserCreateNestedOneWithoutPatientsInput;
  directId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedManyWithoutPatientInput>;
  sex?: InputMaybe<Sex>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type PatientCreateManyDentistInput = {
  birthdate?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  sex?: InputMaybe<Sex>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type PatientCreateManyDentistInputEnvelope = {
  data: Array<PatientCreateManyDentistInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientCreateNestedManyWithoutDentistInput = {
  connect?: InputMaybe<Array<PatientWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PatientCreateOrConnectWithoutDentistInput>>;
  create?: InputMaybe<Array<PatientCreateWithoutDentistInput>>;
  createMany?: InputMaybe<PatientCreateManyDentistInputEnvelope>;
};

export type PatientCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<PatientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PatientCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<PatientCreateWithoutOrderInput>;
};

export type PatientCreateOrConnectWithoutDentistInput = {
  create: PatientCreateWithoutDentistInput;
  where: PatientWhereUniqueInput;
};

export type PatientCreateOrConnectWithoutOrderInput = {
  create: PatientCreateWithoutOrderInput;
  where: PatientWhereUniqueInput;
};

export type PatientCreateWithoutDentistInput = {
  birthdate?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  directId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  order?: InputMaybe<OrderCreateNestedManyWithoutPatientInput>;
  sex?: InputMaybe<Sex>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type PatientCreateWithoutOrderInput = {
  birthdate?: InputMaybe<Scalars['Timestamp']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentist: UserCreateNestedOneWithoutPatientsInput;
  directId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  sex?: InputMaybe<Sex>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type PatientListRelationFilter = {
  every?: InputMaybe<PatientWhereInput>;
  none?: InputMaybe<PatientWhereInput>;
  some?: InputMaybe<PatientWhereInput>;
};

export type PatientModel = {
  __typename?: 'PatientModel';
  birthDate?: Maybe<Scalars['Timestamp']['output']>;
  dentistId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  sex?: Maybe<SexV2>;
};

export type PatientNullableScalarRelationFilter = {
  is?: InputMaybe<PatientWhereInput>;
  isNot?: InputMaybe<PatientWhereInput>;
};

export type PatientOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PatientOrderByWithRelationInput = {
  birthdate?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  dentist?: InputMaybe<UserOrderByWithRelationInput>;
  dentistId?: InputMaybe<SortOrder>;
  directId?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByRelationAggregateInput>;
  sex?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PatientScalarFieldEnum {
  Birthdate = 'birthdate',
  CreatedAt = 'createdAt',
  DentistId = 'dentistId',
  DirectId = 'directId',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  Sex = 'sex',
  UpdatedAt = 'updatedAt'
}

export type PatientScalarWhereInput = {
  AND?: InputMaybe<Array<PatientScalarWhereInput>>;
  NOT?: InputMaybe<Array<PatientScalarWhereInput>>;
  OR?: InputMaybe<Array<PatientScalarWhereInput>>;
  birthdate?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentistId?: InputMaybe<UuidFilter>;
  directId?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  lastName?: InputMaybe<StringFilter>;
  sex?: InputMaybe<EnumSexNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PatientUpdateInput = {
  birthdate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentist?: InputMaybe<UserUpdateOneRequiredWithoutPatientsNestedInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateManyWithoutPatientNestedInput>;
  sex?: InputMaybe<NullableEnumSexFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PatientUpdateManyMutationInput = {
  birthdate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  sex?: InputMaybe<NullableEnumSexFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PatientUpdateManyWithWhereWithoutDentistInput = {
  data: PatientUpdateManyMutationInput;
  where: PatientScalarWhereInput;
};

export type PatientUpdateManyWithoutDentistNestedInput = {
  connect?: InputMaybe<Array<PatientWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PatientCreateOrConnectWithoutDentistInput>>;
  create?: InputMaybe<Array<PatientCreateWithoutDentistInput>>;
  createMany?: InputMaybe<PatientCreateManyDentistInputEnvelope>;
  delete?: InputMaybe<Array<PatientWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PatientScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PatientWhereUniqueInput>>;
  set?: InputMaybe<Array<PatientWhereUniqueInput>>;
  update?: InputMaybe<Array<PatientUpdateWithWhereUniqueWithoutDentistInput>>;
  updateMany?: InputMaybe<Array<PatientUpdateManyWithWhereWithoutDentistInput>>;
  upsert?: InputMaybe<Array<PatientUpsertWithWhereUniqueWithoutDentistInput>>;
};

export type PatientUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<PatientWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PatientCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<PatientCreateWithoutOrderInput>;
  delete?: InputMaybe<PatientWhereInput>;
  disconnect?: InputMaybe<PatientWhereInput>;
  update?: InputMaybe<PatientUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<PatientUpsertWithoutOrderInput>;
};

export type PatientUpdateToOneWithWhereWithoutOrderInput = {
  data: PatientUpdateWithoutOrderInput;
  where?: InputMaybe<PatientWhereInput>;
};

export type PatientUpdateWithWhereUniqueWithoutDentistInput = {
  data: PatientUpdateWithoutDentistInput;
  where: PatientWhereUniqueInput;
};

export type PatientUpdateWithoutDentistInput = {
  birthdate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateManyWithoutPatientNestedInput>;
  sex?: InputMaybe<NullableEnumSexFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PatientUpdateWithoutOrderInput = {
  birthdate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentist?: InputMaybe<UserUpdateOneRequiredWithoutPatientsNestedInput>;
  directId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  sex?: InputMaybe<NullableEnumSexFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PatientUpsertWithWhereUniqueWithoutDentistInput = {
  create: PatientCreateWithoutDentistInput;
  update: PatientUpdateWithoutDentistInput;
  where: PatientWhereUniqueInput;
};

export type PatientUpsertWithoutOrderInput = {
  create: PatientCreateWithoutOrderInput;
  update: PatientUpdateWithoutOrderInput;
  where?: InputMaybe<PatientWhereInput>;
};

export type PatientWhereInput = {
  AND?: InputMaybe<Array<PatientWhereInput>>;
  NOT?: InputMaybe<Array<PatientWhereInput>>;
  OR?: InputMaybe<Array<PatientWhereInput>>;
  birthdate?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentist?: InputMaybe<UserScalarRelationFilter>;
  dentistId?: InputMaybe<UuidFilter>;
  directId?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  lastName?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderListRelationFilter>;
  sex?: InputMaybe<EnumSexNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PatientWhereUniqueInput = {
  AND?: InputMaybe<Array<PatientWhereInput>>;
  NOT?: InputMaybe<Array<PatientWhereInput>>;
  OR?: InputMaybe<Array<PatientWhereInput>>;
  birthdate?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentist?: InputMaybe<UserScalarRelationFilter>;
  dentistId?: InputMaybe<UuidFilter>;
  directId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderListRelationFilter>;
  sex?: InputMaybe<EnumSexNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Pickup = {
  __typename?: 'Pickup';
  agencyLocation?: Maybe<Scalars['String']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  confirmationCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  readyTime?: Maybe<Scalars['String']['output']>;
  scheduledDate: Scalars['Timestamp']['output'];
  shipping?: Maybe<Shipping>;
  shippingId?: Maybe<Scalars['String']['output']>;
  status: PickupStatus;
};

export type PickupAvailabilitiesDto = {
  __typename?: 'PickupAvailabilitiesDTO';
  latestTimeOptions: Array<Scalars['String']['output']>;
  pickupDate: Scalars['String']['output'];
  readyTimeOptions: Array<Scalars['String']['output']>;
};

export enum PickupCarrierV2 {
  Bip = 'BIP',
  Ciblex = 'CIBLEX',
  FedexTnt = 'FEDEX_TNT',
  Sterne = 'STERNE',
  Ups = 'UPS'
}

export type PickupCreateManyOrderInput = {
  agencyLocation?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  readyTime?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shippingId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PickupStatus>;
};

export type PickupCreateManyOrderInputEnvelope = {
  data: Array<PickupCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PickupCreateManyShippingInput = {
  agencyLocation?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  readyTime?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<PickupStatus>;
};

export type PickupCreateManyShippingInputEnvelope = {
  data: Array<PickupCreateManyShippingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PickupCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<PickupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PickupCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PickupCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PickupCreateManyOrderInputEnvelope>;
};

export type PickupCreateNestedManyWithoutShippingInput = {
  connect?: InputMaybe<Array<PickupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PickupCreateOrConnectWithoutShippingInput>>;
  create?: InputMaybe<Array<PickupCreateWithoutShippingInput>>;
  createMany?: InputMaybe<PickupCreateManyShippingInputEnvelope>;
};

export type PickupCreateNestedOneWithoutFileInput = {
  connect?: InputMaybe<PickupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PickupCreateOrConnectWithoutFileInput>;
  create?: InputMaybe<PickupCreateWithoutFileInput>;
};

export type PickupCreateOrConnectWithoutFileInput = {
  create: PickupCreateWithoutFileInput;
  where: PickupWhereUniqueInput;
};

export type PickupCreateOrConnectWithoutOrderInput = {
  create: PickupCreateWithoutOrderInput;
  where: PickupWhereUniqueInput;
};

export type PickupCreateOrConnectWithoutShippingInput = {
  create: PickupCreateWithoutShippingInput;
  where: PickupWhereUniqueInput;
};

export type PickupCreateWithoutFileInput = {
  agencyLocation?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutPickupInput;
  readyTime?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedOneWithoutPickupInput>;
  status?: InputMaybe<PickupStatus>;
};

export type PickupCreateWithoutOrderInput = {
  agencyLocation?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  file?: InputMaybe<FileCreateNestedOneWithoutPickupInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  readyTime?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['Timestamp']['input']>;
  shipping?: InputMaybe<ShippingCreateNestedOneWithoutPickupInput>;
  status?: InputMaybe<PickupStatus>;
};

export type PickupCreateWithoutShippingInput = {
  agencyLocation?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  file?: InputMaybe<FileCreateNestedOneWithoutPickupInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutPickupInput;
  readyTime?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<PickupStatus>;
};

export type PickupListRelationFilter = {
  every?: InputMaybe<PickupWhereInput>;
  none?: InputMaybe<PickupWhereInput>;
  some?: InputMaybe<PickupWhereInput>;
};

export type PickupNullableScalarRelationFilter = {
  is?: InputMaybe<PickupWhereInput>;
  isNot?: InputMaybe<PickupWhereInput>;
};

export type PickupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PickupOrderByWithRelationInput = {
  agencyLocation?: InputMaybe<SortOrderInput>;
  closingTime?: InputMaybe<SortOrderInput>;
  comment?: InputMaybe<SortOrderInput>;
  confirmationCode?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderByWithRelationInput>;
  fileId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  readyTime?: InputMaybe<SortOrderInput>;
  scheduledDate?: InputMaybe<SortOrder>;
  shipping?: InputMaybe<ShippingOrderByWithRelationInput>;
  shippingId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
};

export type PickupScalarWhereInput = {
  AND?: InputMaybe<Array<PickupScalarWhereInput>>;
  NOT?: InputMaybe<Array<PickupScalarWhereInput>>;
  OR?: InputMaybe<Array<PickupScalarWhereInput>>;
  agencyLocation?: InputMaybe<StringNullableFilter>;
  closingTime?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  confirmationCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  readyTime?: InputMaybe<StringNullableFilter>;
  scheduledDate?: InputMaybe<DateTimeFilter>;
  shippingId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumPickupStatusFilter>;
};

export enum PickupStatus {
  Aborted = 'ABORTED',
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

export type PickupUpdateInput = {
  agencyLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closingTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneWithoutPickupNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutPickupNestedInput>;
  readyTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateOneWithoutPickupNestedInput>;
  status?: InputMaybe<EnumPickupStatusFieldUpdateOperationsInput>;
};

export type PickupUpdateManyMutationInput = {
  agencyLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closingTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readyTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPickupStatusFieldUpdateOperationsInput>;
};

export type PickupUpdateManyWithWhereWithoutOrderInput = {
  data: PickupUpdateManyMutationInput;
  where: PickupScalarWhereInput;
};

export type PickupUpdateManyWithWhereWithoutShippingInput = {
  data: PickupUpdateManyMutationInput;
  where: PickupScalarWhereInput;
};

export type PickupUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<PickupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PickupCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PickupCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PickupCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<PickupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PickupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PickupWhereUniqueInput>>;
  set?: InputMaybe<Array<PickupWhereUniqueInput>>;
  update?: InputMaybe<Array<PickupUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<PickupUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<PickupUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type PickupUpdateManyWithoutShippingNestedInput = {
  connect?: InputMaybe<Array<PickupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PickupCreateOrConnectWithoutShippingInput>>;
  create?: InputMaybe<Array<PickupCreateWithoutShippingInput>>;
  createMany?: InputMaybe<PickupCreateManyShippingInputEnvelope>;
  delete?: InputMaybe<Array<PickupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PickupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PickupWhereUniqueInput>>;
  set?: InputMaybe<Array<PickupWhereUniqueInput>>;
  update?: InputMaybe<Array<PickupUpdateWithWhereUniqueWithoutShippingInput>>;
  updateMany?: InputMaybe<Array<PickupUpdateManyWithWhereWithoutShippingInput>>;
  upsert?: InputMaybe<Array<PickupUpsertWithWhereUniqueWithoutShippingInput>>;
};

export type PickupUpdateOneWithoutFileNestedInput = {
  connect?: InputMaybe<PickupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PickupCreateOrConnectWithoutFileInput>;
  create?: InputMaybe<PickupCreateWithoutFileInput>;
  delete?: InputMaybe<PickupWhereInput>;
  disconnect?: InputMaybe<PickupWhereInput>;
  update?: InputMaybe<PickupUpdateToOneWithWhereWithoutFileInput>;
  upsert?: InputMaybe<PickupUpsertWithoutFileInput>;
};

export type PickupUpdateToOneWithWhereWithoutFileInput = {
  data: PickupUpdateWithoutFileInput;
  where?: InputMaybe<PickupWhereInput>;
};

export type PickupUpdateWithWhereUniqueWithoutOrderInput = {
  data: PickupUpdateWithoutOrderInput;
  where: PickupWhereUniqueInput;
};

export type PickupUpdateWithWhereUniqueWithoutShippingInput = {
  data: PickupUpdateWithoutShippingInput;
  where: PickupWhereUniqueInput;
};

export type PickupUpdateWithoutFileInput = {
  agencyLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closingTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutPickupNestedInput>;
  readyTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateOneWithoutPickupNestedInput>;
  status?: InputMaybe<EnumPickupStatusFieldUpdateOperationsInput>;
};

export type PickupUpdateWithoutOrderInput = {
  agencyLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closingTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneWithoutPickupNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readyTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateOneWithoutPickupNestedInput>;
  status?: InputMaybe<EnumPickupStatusFieldUpdateOperationsInput>;
};

export type PickupUpdateWithoutShippingInput = {
  agencyLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closingTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneWithoutPickupNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutPickupNestedInput>;
  readyTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  scheduledDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPickupStatusFieldUpdateOperationsInput>;
};

export type PickupUpsertWithWhereUniqueWithoutOrderInput = {
  create: PickupCreateWithoutOrderInput;
  update: PickupUpdateWithoutOrderInput;
  where: PickupWhereUniqueInput;
};

export type PickupUpsertWithWhereUniqueWithoutShippingInput = {
  create: PickupCreateWithoutShippingInput;
  update: PickupUpdateWithoutShippingInput;
  where: PickupWhereUniqueInput;
};

export type PickupUpsertWithoutFileInput = {
  create: PickupCreateWithoutFileInput;
  update: PickupUpdateWithoutFileInput;
  where?: InputMaybe<PickupWhereInput>;
};

export type PickupWhereInput = {
  AND?: InputMaybe<Array<PickupWhereInput>>;
  NOT?: InputMaybe<Array<PickupWhereInput>>;
  OR?: InputMaybe<Array<PickupWhereInput>>;
  agencyLocation?: InputMaybe<StringNullableFilter>;
  closingTime?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  confirmationCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<FileNullableScalarRelationFilter>;
  fileId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  readyTime?: InputMaybe<StringNullableFilter>;
  scheduledDate?: InputMaybe<DateTimeFilter>;
  shipping?: InputMaybe<ShippingNullableScalarRelationFilter>;
  shippingId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumPickupStatusFilter>;
};

export type PickupWhereUniqueInput = {
  AND?: InputMaybe<Array<PickupWhereInput>>;
  NOT?: InputMaybe<Array<PickupWhereInput>>;
  OR?: InputMaybe<Array<PickupWhereInput>>;
  agencyLocation?: InputMaybe<StringNullableFilter>;
  closingTime?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  confirmationCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<FileNullableScalarRelationFilter>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  readyTime?: InputMaybe<StringNullableFilter>;
  scheduledDate?: InputMaybe<DateTimeFilter>;
  shipping?: InputMaybe<ShippingNullableScalarRelationFilter>;
  shippingId?: InputMaybe<UuidNullableFilter>;
  status?: InputMaybe<EnumPickupStatusFilter>;
};

export type PresignedUploadResponse = {
  __typename?: 'PresignedUploadResponse';
  fields: Scalars['JSON']['output'];
  fileId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export enum PricePlanV2 {
  Aggressive = 'AGGRESSIVE',
  Base = 'BASE',
  Bronze = 'BRONZE',
  Center = 'CENTER',
  Gold = 'GOLD',
  Silver = 'SILVER'
}

export enum PricingType {
  Aggressive = 'AGGRESSIVE',
  Base = 'BASE',
  Bronze = 'BRONZE',
  Center = 'CENTER',
  Gold = 'GOLD',
  Silver = 'SILVER'
}

export type Product = {
  __typename?: 'Product';
  _count: ProductCount;
  anatomyItem?: Maybe<Array<AnatomyItem>>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  hasIndividualItemCaracteristics: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  implantItem?: Maybe<Array<ImplantItem>>;
  itemPreferences?: Maybe<Scalars['JSON']['output']>;
  order: Order;
  orderId: Scalars['String']['output'];
  productType: ItemType;
  removableItem?: Maybe<Array<RemovableItem>>;
  teeth?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ProductCount = {
  __typename?: 'ProductCount';
  anatomyItem: Scalars['Int']['output'];
  implantItem: Scalars['Int']['output'];
  removableItem: Scalars['Int']['output'];
};

export type ProductCreateInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutProductInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  hasIndividualItemCaracteristics?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutProductInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order: OrderCreateNestedOneWithoutProductsInput;
  productType: ItemType;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutProductInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductCreateManyOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  hasIndividualItemCaracteristics?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  productType: ItemType;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductCreateManyOrderInputEnvelope = {
  data: Array<ProductCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ProductCreateManyOrderInputEnvelope>;
};

export type ProductCreateNestedOneWithoutAnatomyItemInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutAnatomyItemInput>;
  create?: InputMaybe<ProductCreateWithoutAnatomyItemInput>;
};

export type ProductCreateNestedOneWithoutImplantItemInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ProductCreateWithoutImplantItemInput>;
};

export type ProductCreateNestedOneWithoutRemovableItemInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutRemovableItemInput>;
  create?: InputMaybe<ProductCreateWithoutRemovableItemInput>;
};

export type ProductCreateOrConnectWithoutAnatomyItemInput = {
  create: ProductCreateWithoutAnatomyItemInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutImplantItemInput = {
  create: ProductCreateWithoutImplantItemInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutOrderInput = {
  create: ProductCreateWithoutOrderInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutRemovableItemInput = {
  create: ProductCreateWithoutRemovableItemInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutAnatomyItemInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  hasIndividualItemCaracteristics?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutProductInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order: OrderCreateNestedOneWithoutProductsInput;
  productType: ItemType;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutProductInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductCreateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutProductInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  hasIndividualItemCaracteristics?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order: OrderCreateNestedOneWithoutProductsInput;
  productType: ItemType;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutProductInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductCreateWithoutOrderInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutProductInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  hasIndividualItemCaracteristics?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutProductInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  productType: ItemType;
  removableItem?: InputMaybe<RemovableItemCreateNestedManyWithoutProductInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductCreateWithoutRemovableItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemCreateNestedManyWithoutProductInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  hasIndividualItemCaracteristics?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemCreateNestedManyWithoutProductInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order: OrderCreateNestedOneWithoutProductsInput;
  productType: ItemType;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductListRelationFilter = {
  every?: InputMaybe<ProductWhereInput>;
  none?: InputMaybe<ProductWhereInput>;
  some?: InputMaybe<ProductWhereInput>;
};

export type ProductModel = {
  __typename?: 'ProductModel';
  id: Scalars['String']['output'];
  itemPreferences?: Maybe<ItemPreferencesModel>;
  items: Array<ItemV2>;
  order: OrderModel;
  teeth: Array<Scalars['Int']['output']>;
  type: ProductTypeV2;
};

export type ProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithRelationInput = {
  anatomyItem?: InputMaybe<AnatomyItemOrderByRelationAggregateInput>;
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  hasIndividualItemCaracteristics?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  implantItem?: InputMaybe<ImplantItemOrderByRelationAggregateInput>;
  itemPreferences?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  productType?: InputMaybe<SortOrder>;
  removableItem?: InputMaybe<RemovableItemOrderByRelationAggregateInput>;
  teeth?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProductPreferenceTypeEnum {
  FixedProsthesisPreferences = 'FIXED_PROSTHESIS_PREFERENCES',
  RemovableProsthesisPreferences = 'REMOVABLE_PROSTHESIS_PREFERENCES'
}

export type ProductPreferences = {
  __typename?: 'ProductPreferences';
  _count: ProductPreferencesCount;
  createdAt: Scalars['Timestamp']['output'];
  dentist: User;
  dentistId: Scalars['String']['output'];
  fixedProsthesisPreferences?: Maybe<Array<FixedProsthesisPreferences>>;
  id: Scalars['ID']['output'];
  productPreferenceType: ProductPreferenceTypeEnum;
  removableProsthesisPreferences?: Maybe<Array<RemovableProsthesisPreferences>>;
  shadeType: ItemShadeType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ProductPreferencesCount = {
  __typename?: 'ProductPreferencesCount';
  fixedProsthesisPreferences: Scalars['Int']['output'];
  removableProsthesisPreferences: Scalars['Int']['output'];
};

export type ProductPreferencesCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentist: UserCreateNestedOneWithoutProductPreferencesInput;
  fixedProsthesisPreferences?: InputMaybe<FixedProsthesisPreferencesCreateNestedManyWithoutProductPreferencesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  productPreferenceType?: InputMaybe<ProductPreferenceTypeEnum>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesCreateNestedManyWithoutProductPreferencesInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductPreferencesCreateManyDentistInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  productPreferenceType?: InputMaybe<ProductPreferenceTypeEnum>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductPreferencesCreateManyDentistInputEnvelope = {
  data: Array<ProductPreferencesCreateManyDentistInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPreferencesCreateNestedManyWithoutDentistInput = {
  connect?: InputMaybe<Array<ProductPreferencesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPreferencesCreateOrConnectWithoutDentistInput>>;
  create?: InputMaybe<Array<ProductPreferencesCreateWithoutDentistInput>>;
  createMany?: InputMaybe<ProductPreferencesCreateManyDentistInputEnvelope>;
};

export type ProductPreferencesCreateNestedOneWithoutFixedProsthesisPreferencesInput = {
  connect?: InputMaybe<ProductPreferencesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductPreferencesCreateOrConnectWithoutFixedProsthesisPreferencesInput>;
  create?: InputMaybe<ProductPreferencesCreateWithoutFixedProsthesisPreferencesInput>;
};

export type ProductPreferencesCreateOrConnectWithoutDentistInput = {
  create: ProductPreferencesCreateWithoutDentistInput;
  where: ProductPreferencesWhereUniqueInput;
};

export type ProductPreferencesCreateOrConnectWithoutFixedProsthesisPreferencesInput = {
  create: ProductPreferencesCreateWithoutFixedProsthesisPreferencesInput;
  where: ProductPreferencesWhereUniqueInput;
};

export type ProductPreferencesCreateWithoutDentistInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fixedProsthesisPreferences?: InputMaybe<FixedProsthesisPreferencesCreateNestedManyWithoutProductPreferencesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  productPreferenceType?: InputMaybe<ProductPreferenceTypeEnum>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesCreateNestedManyWithoutProductPreferencesInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductPreferencesCreateWithoutFixedProsthesisPreferencesInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentist: UserCreateNestedOneWithoutProductPreferencesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  productPreferenceType?: InputMaybe<ProductPreferenceTypeEnum>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesCreateNestedManyWithoutProductPreferencesInput>;
  shadeType?: InputMaybe<ItemShadeType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ProductPreferencesListRelationFilter = {
  every?: InputMaybe<ProductPreferencesWhereInput>;
  none?: InputMaybe<ProductPreferencesWhereInput>;
  some?: InputMaybe<ProductPreferencesWhereInput>;
};

export type ProductPreferencesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductPreferencesOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  dentist?: InputMaybe<UserOrderByWithRelationInput>;
  dentistId?: InputMaybe<SortOrder>;
  fixedProsthesisPreferences?: InputMaybe<FixedProsthesisPreferencesOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  productPreferenceType?: InputMaybe<SortOrder>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesOrderByRelationAggregateInput>;
  shadeType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProductPreferencesScalarFieldEnum {
  CreatedAt = 'createdAt',
  DentistId = 'dentistId',
  Id = 'id',
  ProductPreferenceType = 'productPreferenceType',
  ShadeType = 'shadeType',
  UpdatedAt = 'updatedAt'
}

export type ProductPreferencesScalarRelationFilter = {
  is?: InputMaybe<ProductPreferencesWhereInput>;
  isNot?: InputMaybe<ProductPreferencesWhereInput>;
};

export type ProductPreferencesScalarWhereInput = {
  AND?: InputMaybe<Array<ProductPreferencesScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductPreferencesScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductPreferencesScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentistId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  productPreferenceType?: InputMaybe<EnumProductPreferenceTypeEnumFilter>;
  shadeType?: InputMaybe<EnumItemShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductPreferencesUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentist?: InputMaybe<UserUpdateOneRequiredWithoutProductPreferencesNestedInput>;
  fixedProsthesisPreferences?: InputMaybe<FixedProsthesisPreferencesUpdateManyWithoutProductPreferencesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferenceType?: InputMaybe<EnumProductPreferenceTypeEnumFieldUpdateOperationsInput>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesUpdateManyWithoutProductPreferencesNestedInput>;
  shadeType?: InputMaybe<EnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductPreferencesUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferenceType?: InputMaybe<EnumProductPreferenceTypeEnumFieldUpdateOperationsInput>;
  shadeType?: InputMaybe<EnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductPreferencesUpdateManyWithWhereWithoutDentistInput = {
  data: ProductPreferencesUpdateManyMutationInput;
  where: ProductPreferencesScalarWhereInput;
};

export type ProductPreferencesUpdateManyWithoutDentistNestedInput = {
  connect?: InputMaybe<Array<ProductPreferencesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPreferencesCreateOrConnectWithoutDentistInput>>;
  create?: InputMaybe<Array<ProductPreferencesCreateWithoutDentistInput>>;
  createMany?: InputMaybe<ProductPreferencesCreateManyDentistInputEnvelope>;
  delete?: InputMaybe<Array<ProductPreferencesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductPreferencesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductPreferencesWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductPreferencesWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductPreferencesUpdateWithWhereUniqueWithoutDentistInput>>;
  updateMany?: InputMaybe<Array<ProductPreferencesUpdateManyWithWhereWithoutDentistInput>>;
  upsert?: InputMaybe<Array<ProductPreferencesUpsertWithWhereUniqueWithoutDentistInput>>;
};

export type ProductPreferencesUpdateOneRequiredWithoutFixedProsthesisPreferencesNestedInput = {
  connect?: InputMaybe<ProductPreferencesWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductPreferencesCreateOrConnectWithoutFixedProsthesisPreferencesInput>;
  create?: InputMaybe<ProductPreferencesCreateWithoutFixedProsthesisPreferencesInput>;
  update?: InputMaybe<ProductPreferencesUpdateToOneWithWhereWithoutFixedProsthesisPreferencesInput>;
  upsert?: InputMaybe<ProductPreferencesUpsertWithoutFixedProsthesisPreferencesInput>;
};

export type ProductPreferencesUpdateToOneWithWhereWithoutFixedProsthesisPreferencesInput = {
  data: ProductPreferencesUpdateWithoutFixedProsthesisPreferencesInput;
  where?: InputMaybe<ProductPreferencesWhereInput>;
};

export type ProductPreferencesUpdateWithWhereUniqueWithoutDentistInput = {
  data: ProductPreferencesUpdateWithoutDentistInput;
  where: ProductPreferencesWhereUniqueInput;
};

export type ProductPreferencesUpdateWithoutDentistInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  fixedProsthesisPreferences?: InputMaybe<FixedProsthesisPreferencesUpdateManyWithoutProductPreferencesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferenceType?: InputMaybe<EnumProductPreferenceTypeEnumFieldUpdateOperationsInput>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesUpdateManyWithoutProductPreferencesNestedInput>;
  shadeType?: InputMaybe<EnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductPreferencesUpdateWithoutFixedProsthesisPreferencesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentist?: InputMaybe<UserUpdateOneRequiredWithoutProductPreferencesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferenceType?: InputMaybe<EnumProductPreferenceTypeEnumFieldUpdateOperationsInput>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesUpdateManyWithoutProductPreferencesNestedInput>;
  shadeType?: InputMaybe<EnumItemShadeTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductPreferencesUpsertWithWhereUniqueWithoutDentistInput = {
  create: ProductPreferencesCreateWithoutDentistInput;
  update: ProductPreferencesUpdateWithoutDentistInput;
  where: ProductPreferencesWhereUniqueInput;
};

export type ProductPreferencesUpsertWithoutFixedProsthesisPreferencesInput = {
  create: ProductPreferencesCreateWithoutFixedProsthesisPreferencesInput;
  update: ProductPreferencesUpdateWithoutFixedProsthesisPreferencesInput;
  where?: InputMaybe<ProductPreferencesWhereInput>;
};

export type ProductPreferencesWhereInput = {
  AND?: InputMaybe<Array<ProductPreferencesWhereInput>>;
  NOT?: InputMaybe<Array<ProductPreferencesWhereInput>>;
  OR?: InputMaybe<Array<ProductPreferencesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentist?: InputMaybe<UserScalarRelationFilter>;
  dentistId?: InputMaybe<UuidFilter>;
  fixedProsthesisPreferences?: InputMaybe<FixedProsthesisPreferencesListRelationFilter>;
  id?: InputMaybe<UuidFilter>;
  productPreferenceType?: InputMaybe<EnumProductPreferenceTypeEnumFilter>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesListRelationFilter>;
  shadeType?: InputMaybe<EnumItemShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductPreferencesWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductPreferencesWhereInput>>;
  NOT?: InputMaybe<Array<ProductPreferencesWhereInput>>;
  OR?: InputMaybe<Array<ProductPreferencesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentist?: InputMaybe<UserScalarRelationFilter>;
  dentistId?: InputMaybe<UuidFilter>;
  fixedProsthesisPreferences?: InputMaybe<FixedProsthesisPreferencesListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  productPreferenceType?: InputMaybe<EnumProductPreferenceTypeEnumFilter>;
  removableProsthesisPreferences?: InputMaybe<RemovableProsthesisPreferencesListRelationFilter>;
  shadeType?: InputMaybe<EnumItemShadeTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ProductScalarFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  HasIndividualItemCaracteristics = 'hasIndividualItemCaracteristics',
  Id = 'id',
  ItemPreferences = 'itemPreferences',
  OrderId = 'orderId',
  ProductType = 'productType',
  Teeth = 'teeth',
  UpdatedAt = 'updatedAt'
}

export type ProductScalarRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductScalarWhereInput = {
  AND?: InputMaybe<Array<ProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  itemPreferences?: InputMaybe<JsonNullableFilter>;
  orderId?: InputMaybe<UuidFilter>;
  productType?: InputMaybe<EnumItemTypeFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ProductTypeV2 {
  Abutment = 'ABUTMENT',
  AddingTeethOnExistingDenture = 'ADDING_TEETH_ON_EXISTING_DENTURE',
  AdditionalImpressionForRemovableProsthesis = 'ADDITIONAL_IMPRESSION_FOR_REMOVABLE_PROSTHESIS',
  BleachingTray = 'BLEACHING_TRAY',
  Bridge = 'BRIDGE',
  BridgeImplant = 'BRIDGE_IMPLANT',
  BridgePontic = 'BRIDGE_PONTIC',
  Crown = 'CROWN',
  CustomAbutment = 'CUSTOM_ABUTMENT',
  CustomTray = 'CUSTOM_TRAY',
  DentureRepair = 'DENTURE_REPAIR',
  FullDenture = 'FULL_DENTURE',
  FullDentureWaxBite = 'FULL_DENTURE_WAX_BITE',
  ImmediateDenture = 'IMMEDIATE_DENTURE',
  Implant = 'IMPLANT',
  ImplantCrown = 'IMPLANT_CROWN',
  Inlay = 'INLAY',
  InlayCore = 'INLAY_CORE',
  Lay = 'LAY',
  MetalMesh = 'METAL_MESH',
  Model = 'MODEL',
  NightGuard = 'NIGHT_GUARD',
  Onlay = 'ONLAY',
  OrthoModel = 'ORTHO_MODEL',
  Overlay = 'OVERLAY',
  PartialDenture = 'PARTIAL_DENTURE',
  PostAndCoreRetainedCrown = 'POST_AND_CORE_RETAINED_CROWN',
  RemovableDenture = 'REMOVABLE_DENTURE',
  Retainer = 'RETAINER',
  RetentionWire = 'RETENTION_WIRE',
  RichmondCrown = 'RICHMOND_CROWN',
  ScanOnly = 'SCAN_ONLY',
  SpaceMaintainer = 'SPACE_MAINTAINER',
  Splint = 'SPLINT',
  SplintedCrown = 'SPLINTED_CROWN',
  SplintedCrownImplant = 'SPLINTED_CROWN_IMPLANT',
  Veneer = 'VENEER',
  WaxBite = 'WAX_BITE',
  WaxUp = 'WAX_UP'
}

export type ProductUpdateInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutProductNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutProductNestedInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutProductsNestedInput>;
  productType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutProductNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateManyMutationInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  productType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateManyWithWhereWithoutOrderInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ProductCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ProductUpdateOneRequiredWithoutAnatomyItemNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutAnatomyItemInput>;
  create?: InputMaybe<ProductCreateWithoutAnatomyItemInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutAnatomyItemInput>;
  upsert?: InputMaybe<ProductUpsertWithoutAnatomyItemInput>;
};

export type ProductUpdateOneRequiredWithoutImplantItemNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutImplantItemInput>;
  create?: InputMaybe<ProductCreateWithoutImplantItemInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutImplantItemInput>;
  upsert?: InputMaybe<ProductUpsertWithoutImplantItemInput>;
};

export type ProductUpdateOneRequiredWithoutRemovableItemNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutRemovableItemInput>;
  create?: InputMaybe<ProductCreateWithoutRemovableItemInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutRemovableItemInput>;
  upsert?: InputMaybe<ProductUpsertWithoutRemovableItemInput>;
};

export type ProductUpdateToOneWithWhereWithoutAnatomyItemInput = {
  data: ProductUpdateWithoutAnatomyItemInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutImplantItemInput = {
  data: ProductUpdateWithoutImplantItemInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutRemovableItemInput = {
  data: ProductUpdateWithoutRemovableItemInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateWithWhereUniqueWithoutOrderInput = {
  data: ProductUpdateWithoutOrderInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithoutAnatomyItemInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutProductNestedInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutProductsNestedInput>;
  productType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutProductNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutImplantItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutProductNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutProductsNestedInput>;
  productType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutProductNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutOrderInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutProductNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutProductNestedInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  productType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  removableItem?: InputMaybe<RemovableItemUpdateManyWithoutProductNestedInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutRemovableItemInput = {
  anatomyItem?: InputMaybe<AnatomyItemUpdateManyWithoutProductNestedInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  implantItem?: InputMaybe<ImplantItemUpdateManyWithoutProductNestedInput>;
  itemPreferences?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutProductsNestedInput>;
  productType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpsertWithWhereUniqueWithoutOrderInput = {
  create: ProductCreateWithoutOrderInput;
  update: ProductUpdateWithoutOrderInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithoutAnatomyItemInput = {
  create: ProductCreateWithoutAnatomyItemInput;
  update: ProductUpdateWithoutAnatomyItemInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutImplantItemInput = {
  create: ProductCreateWithoutImplantItemInput;
  update: ProductUpdateWithoutImplantItemInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutRemovableItemInput = {
  create: ProductCreateWithoutRemovableItemInput;
  update: ProductUpdateWithoutRemovableItemInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemListRelationFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  itemPreferences?: InputMaybe<JsonNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  productType?: InputMaybe<EnumItemTypeFilter>;
  removableItem?: InputMaybe<RemovableItemListRelationFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  anatomyItem?: InputMaybe<AnatomyItemListRelationFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  hasIndividualItemCaracteristics?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  implantItem?: InputMaybe<ImplantItemListRelationFilter>;
  itemPreferences?: InputMaybe<JsonNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  productType?: InputMaybe<EnumItemTypeFilter>;
  removableItem?: InputMaybe<RemovableItemListRelationFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderMaterialTraceability = {
  __typename?: 'ProviderMaterialTraceability';
  id: Scalars['ID']['output'];
  materialTraceability: MaterialTraceability;
  materialTraceabilityId: Scalars['String']['output'];
  userGroup: UserGroup;
  userGroupId: Scalars['String']['output'];
};

export type ProviderMaterialTraceabilityCreateManyMaterialTraceabilityInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  userGroupId: Scalars['String']['input'];
};

export type ProviderMaterialTraceabilityCreateManyMaterialTraceabilityInputEnvelope = {
  data: Array<ProviderMaterialTraceabilityCreateManyMaterialTraceabilityInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderMaterialTraceabilityCreateManyUserGroupInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  materialTraceabilityId: Scalars['String']['input'];
};

export type ProviderMaterialTraceabilityCreateManyUserGroupInputEnvelope = {
  data: Array<ProviderMaterialTraceabilityCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderMaterialTraceabilityCreateNestedManyWithoutMaterialTraceabilityInput = {
  connect?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderMaterialTraceabilityCreateOrConnectWithoutMaterialTraceabilityInput>>;
  create?: InputMaybe<Array<ProviderMaterialTraceabilityCreateWithoutMaterialTraceabilityInput>>;
  createMany?: InputMaybe<ProviderMaterialTraceabilityCreateManyMaterialTraceabilityInputEnvelope>;
};

export type ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderMaterialTraceabilityCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ProviderMaterialTraceabilityCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ProviderMaterialTraceabilityCreateManyUserGroupInputEnvelope>;
};

export type ProviderMaterialTraceabilityCreateOrConnectWithoutMaterialTraceabilityInput = {
  create: ProviderMaterialTraceabilityCreateWithoutMaterialTraceabilityInput;
  where: ProviderMaterialTraceabilityWhereUniqueInput;
};

export type ProviderMaterialTraceabilityCreateOrConnectWithoutUserGroupInput = {
  create: ProviderMaterialTraceabilityCreateWithoutUserGroupInput;
  where: ProviderMaterialTraceabilityWhereUniqueInput;
};

export type ProviderMaterialTraceabilityCreateWithoutMaterialTraceabilityInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  userGroup: UserGroupCreateNestedOneWithoutAvailableMaterialTraceabilitiesInput;
};

export type ProviderMaterialTraceabilityCreateWithoutUserGroupInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  materialTraceability: MaterialTraceabilityCreateNestedOneWithoutProviderMaterialTraceabilityInput;
};

export type ProviderMaterialTraceabilityListRelationFilter = {
  every?: InputMaybe<ProviderMaterialTraceabilityWhereInput>;
  none?: InputMaybe<ProviderMaterialTraceabilityWhereInput>;
  some?: InputMaybe<ProviderMaterialTraceabilityWhereInput>;
};

export type ProviderMaterialTraceabilityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProviderMaterialTraceabilityScalarWhereInput = {
  AND?: InputMaybe<Array<ProviderMaterialTraceabilityScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProviderMaterialTraceabilityScalarWhereInput>>;
  OR?: InputMaybe<Array<ProviderMaterialTraceabilityScalarWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  materialTraceabilityId?: InputMaybe<UuidFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type ProviderMaterialTraceabilityUnique_Provider_Material_TraceabilityCompoundUniqueInput = {
  materialTraceabilityId: Scalars['String']['input'];
  userGroupId: Scalars['String']['input'];
};

export type ProviderMaterialTraceabilityUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProviderMaterialTraceabilityUpdateManyWithWhereWithoutMaterialTraceabilityInput = {
  data: ProviderMaterialTraceabilityUpdateManyMutationInput;
  where: ProviderMaterialTraceabilityScalarWhereInput;
};

export type ProviderMaterialTraceabilityUpdateManyWithWhereWithoutUserGroupInput = {
  data: ProviderMaterialTraceabilityUpdateManyMutationInput;
  where: ProviderMaterialTraceabilityScalarWhereInput;
};

export type ProviderMaterialTraceabilityUpdateManyWithoutMaterialTraceabilityNestedInput = {
  connect?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderMaterialTraceabilityCreateOrConnectWithoutMaterialTraceabilityInput>>;
  create?: InputMaybe<Array<ProviderMaterialTraceabilityCreateWithoutMaterialTraceabilityInput>>;
  createMany?: InputMaybe<ProviderMaterialTraceabilityCreateManyMaterialTraceabilityInputEnvelope>;
  delete?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderMaterialTraceabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderMaterialTraceabilityUpdateWithWhereUniqueWithoutMaterialTraceabilityInput>>;
  updateMany?: InputMaybe<Array<ProviderMaterialTraceabilityUpdateManyWithWhereWithoutMaterialTraceabilityInput>>;
  upsert?: InputMaybe<Array<ProviderMaterialTraceabilityUpsertWithWhereUniqueWithoutMaterialTraceabilityInput>>;
};

export type ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderMaterialTraceabilityCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ProviderMaterialTraceabilityCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ProviderMaterialTraceabilityCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderMaterialTraceabilityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderMaterialTraceabilityWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderMaterialTraceabilityUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<ProviderMaterialTraceabilityUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<ProviderMaterialTraceabilityUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type ProviderMaterialTraceabilityUpdateWithWhereUniqueWithoutMaterialTraceabilityInput = {
  data: ProviderMaterialTraceabilityUpdateWithoutMaterialTraceabilityInput;
  where: ProviderMaterialTraceabilityWhereUniqueInput;
};

export type ProviderMaterialTraceabilityUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: ProviderMaterialTraceabilityUpdateWithoutUserGroupInput;
  where: ProviderMaterialTraceabilityWhereUniqueInput;
};

export type ProviderMaterialTraceabilityUpdateWithoutMaterialTraceabilityInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneRequiredWithoutAvailableMaterialTraceabilitiesNestedInput>;
};

export type ProviderMaterialTraceabilityUpdateWithoutUserGroupInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  materialTraceability?: InputMaybe<MaterialTraceabilityUpdateOneRequiredWithoutProviderMaterialTraceabilityNestedInput>;
};

export type ProviderMaterialTraceabilityUpsertWithWhereUniqueWithoutMaterialTraceabilityInput = {
  create: ProviderMaterialTraceabilityCreateWithoutMaterialTraceabilityInput;
  update: ProviderMaterialTraceabilityUpdateWithoutMaterialTraceabilityInput;
  where: ProviderMaterialTraceabilityWhereUniqueInput;
};

export type ProviderMaterialTraceabilityUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: ProviderMaterialTraceabilityCreateWithoutUserGroupInput;
  update: ProviderMaterialTraceabilityUpdateWithoutUserGroupInput;
  where: ProviderMaterialTraceabilityWhereUniqueInput;
};

export type ProviderMaterialTraceabilityWhereInput = {
  AND?: InputMaybe<Array<ProviderMaterialTraceabilityWhereInput>>;
  NOT?: InputMaybe<Array<ProviderMaterialTraceabilityWhereInput>>;
  OR?: InputMaybe<Array<ProviderMaterialTraceabilityWhereInput>>;
  id?: InputMaybe<UuidFilter>;
  materialTraceability?: InputMaybe<MaterialTraceabilityScalarRelationFilter>;
  materialTraceabilityId?: InputMaybe<UuidFilter>;
  userGroup?: InputMaybe<UserGroupScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type ProviderMaterialTraceabilityWhereUniqueInput = {
  AND?: InputMaybe<Array<ProviderMaterialTraceabilityWhereInput>>;
  NOT?: InputMaybe<Array<ProviderMaterialTraceabilityWhereInput>>;
  OR?: InputMaybe<Array<ProviderMaterialTraceabilityWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  materialTraceability?: InputMaybe<MaterialTraceabilityScalarRelationFilter>;
  materialTraceabilityId?: InputMaybe<UuidFilter>;
  unique_provider_material_traceability?: InputMaybe<ProviderMaterialTraceabilityUnique_Provider_Material_TraceabilityCompoundUniqueInput>;
  userGroup?: InputMaybe<UserGroupScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export enum ProximalContactTightnessV2 {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
  None = 'NONE'
}

export type Query = {
  __typename?: 'Query';
  address: Address;
  anatomyItem: AnatomyItem;
  anatomyItems: Array<AnatomyItem>;
  checkBipConfiguration: Scalars['Boolean']['output'];
  dsCoreAuthorizationUrl: Scalars['String']['output'];
  file: File;
  findGingivaShades: Array<ItemShadeModel>;
  findItemMaterialsByItemType: Array<ItemMaterialModel>;
  findItemShadesByItemType: Array<ItemShadeModel>;
  findManyProductsOfOrderWhere: Array<Product>;
  findProductByUniqueAttribute: Product;
  fixedProsthesisPreferences: Array<FixedProsthesisPreferences>;
  getAccountProductPreferences: Array<ProductPreferences>;
  getAllAddressesOfUser: Array<Address>;
  getAllChatsOfOrder: ChatResponse;
  getAllClientBilling: Array<ClientBilling>;
  getAllGroups: Array<UserGroup>;
  getAllImplantReferences: Array<ImplantReference>;
  getAllItemMaterials: Array<ItemMaterial>;
  getAllItemPrices: Array<ItemPrice>;
  getAllItemShades: Array<ItemShade>;
  getAllMaterialTraceability: Array<MaterialTraceability>;
  getAllOrdersForStaff: OrderResponse;
  getAllProviders: Array<UserGroup>;
  getAnalytics: Get_Analytics_Dto;
  getBankHoliday: Array<BankHoliday>;
  getBankHolidays: Array<BankHolidaysModel>;
  getClientBillingWhere: Array<ClientBilling>;
  getClientBillingWhereUnique: ClientBilling;
  getDentistMainAddress: Address;
  getDentists: DentistsV2Paginated;
  getDesignReviewNotifications: DesignReviewNotificationsResponse;
  getEstimatedDeliveryDate: EstimatedDeliveryDate;
  getFilesByOrderCommentId: Array<FileV2>;
  getFilesOfOrder: Array<File>;
  getHelpMsgSliceByOrder: HelpMessageResponse;
  getImplantReferenceById?: Maybe<ImplantReferenceV2>;
  getImplantReferenceWhereUnique: ImplantReference;
  getImplantReferencesWhere: Array<ImplantReference>;
  getInProgressOrderDesign?: Maybe<OrderDesign>;
  getItemMaterialWhereUnique: ItemMaterial;
  getItemMaterialsByIds: Array<ItemMaterialModel>;
  getItemMaterialsWhere: Array<ItemMaterial>;
  getItemPriceWhereUnique: ItemPrice;
  getItemPricesWhere: Array<ItemPrice>;
  getItemShadeWhereUnique: ItemShade;
  getItemShadesByIds: Array<ItemShadeModel>;
  getItemShadesWhere: Array<ItemShade>;
  getLastUnreadOfEachOrder?: Maybe<ChatResponse>;
  getManagedUserGroupOfUser: UserGroup;
  getManyOrdersOfUser: Array<Order>;
  getManyUsers: Array<User>;
  getMaterialTraceabilityWhere: Array<MaterialTraceability>;
  getMaterialTraceabilityWhereUnique: MaterialTraceability;
  getNotificationCount?: Maybe<NotificationResponse>;
  getNotificationSubscriptions: Array<NotificationSubscription>;
  getOrderById: OrderModel;
  getOrderByUniqueAttribute: Order;
  getOrderDeliveryInfo?: Maybe<Array<FedexDeliveryEvent>>;
  getOrderDesign: OrderDesign;
  getOrderDesignFile: Scalars['String']['output'];
  getOrderDesignFiles: Array<Scalars['String']['output']>;
  getOrderDesigns: PaginatedOrderDesigns;
  getOrderDesignsByOrderId: Array<OrderDesign>;
  getOrderEstimatedDeliveryDate: OrderEstimatedDeliveryDate;
  getOrderHelpFiles: Array<File>;
  getOrdersByDentalOfficeId: OrdersV2Paginated;
  getOrdersByDentistId: OrdersV2Paginated;
  getOrdersCountByDentalOfficeId: Scalars['Int']['output'];
  getOrdersCountByDentistId: Scalars['Int']['output'];
  getOrdersListByDentalOfficeId: Array<OrderModel>;
  getOrdersListCountByDentalOfficeId: Scalars['Int']['output'];
  getPickupAvailability: Array<PickupAvailabilitiesDto>;
  getPickupByDate: GetPickupsDto;
  getPresignedFileDownloadUrl: Scalars['String']['output'];
  getPresignedFileUploadUrl: Scalars['String']['output'];
  getProductById?: Maybe<ProductModel>;
  getScanPostCatalog: ScanPostCatalog;
  getScanPostsData: Scalars['JSONObject']['output'];
  getSignedDownloadUrlsFromKeys: FilesResponse;
  getTodayShipping: Array<TodayShippings>;
  getTodayShippingByClinicId: Array<Shipping>;
  getTodayShippingByDeliveryCarrier: Array<ToShip>;
  getTodayShippingData: Array<TodayShippingsData>;
  getUnhandledExternalCases: Array<ExternalCase>;
  getUniqueItemBilling: ItemBilling;
  getUniqueOrderBilling: OrderBilling;
  getUniqueProductPreference: ProductPreferences;
  getUserGroupsWhere: Array<UserGroup>;
  getUserGroupsWhereUnique: UserGroup;
  getUserItemBilling: Array<ItemBilling>;
  getUserNotificationsCount: Scalars['Float']['output'];
  getUserOrderBilling: Array<OrderBilling>;
  getUserProductPreferences: ProductPreferences;
  implantItem: ImplantItem;
  implantItems: Array<ImplantItem>;
  isServer: Scalars['Boolean']['output'];
  listImplantReferences: Array<ImplantReferenceV2>;
  patient: Patient;
  patients: Array<Patient>;
  refreshTodayShipping: Array<TodayShippings>;
  removableItem: RemovableItem;
  removableItems: Array<RemovableItem>;
  uniqueFixedProsthesisPreferences: FixedProsthesisPreferences;
  user: User;
  users: Array<User>;
};


export type QueryAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type QueryAnatomyItemArgs = {
  where: AnatomyItemWhereUniqueInput;
};


export type QueryAnatomyItemsArgs = {
  cursor?: InputMaybe<AnatomyItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnatomyItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnatomyItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnatomyItemWhereInput>;
};


export type QueryCheckBipConfigurationArgs = {
  clinicNumber: Scalars['String']['input'];
};


export type QueryDsCoreAuthorizationUrlArgs = {
  codeChallenge: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type QueryFileArgs = {
  where: FileWhereUniqueInput;
};


export type QueryFindItemMaterialsByItemTypeArgs = {
  itemType: ItemTypeV2;
};


export type QueryFindItemShadesByItemTypeArgs = {
  itemType: ItemTypeV2;
};


export type QueryFindManyProductsOfOrderWhereArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  orderId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryFindProductByUniqueAttributeArgs = {
  where: ProductWhereUniqueInput;
};


export type QueryFixedProsthesisPreferencesArgs = {
  cursor?: InputMaybe<FixedProsthesisPreferencesWhereUniqueInput>;
  distinct?: InputMaybe<Array<FixedProsthesisPreferencesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FixedProsthesisPreferencesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FixedProsthesisPreferencesWhereInput>;
};


export type QueryGetAllAddressesOfUserArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryGetAllChatsOfOrderArgs = {
  cursor?: InputMaybe<ChatWhereUniqueInput>;
  distinct?: InputMaybe<Array<ChatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ChatOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
};


export type QueryGetAllGroupsArgs = {
  cursor?: InputMaybe<UserGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserGroupWhereInput>;
};


export type QueryGetAllOrdersForStaffArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryGetBankHolidayArgs = {
  cursor?: InputMaybe<BankHolidayWhereUniqueInput>;
  distinct?: InputMaybe<Array<BankHolidayScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BankHolidayOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BankHolidayWhereInput>;
};


export type QueryGetBankHolidaysArgs = {
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
};


export type QueryGetClientBillingWhereArgs = {
  cursor?: InputMaybe<ClientBillingWhereUniqueInput>;
  distinct?: InputMaybe<Array<ClientBillingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ClientBillingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ClientBillingWhereInput>;
};


export type QueryGetClientBillingWhereUniqueArgs = {
  where: ClientBillingWhereUniqueInput;
};


export type QueryGetDentistsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDesignReviewNotificationsArgs = {
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEstimatedDeliveryDateArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetFilesByOrderCommentIdArgs = {
  orderCommentId: Scalars['String']['input'];
};


export type QueryGetFilesOfOrderArgs = {
  cursor?: InputMaybe<FileWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FileWhereInput>;
};


export type QueryGetHelpMsgSliceByOrderArgs = {
  args: HelpMessageInput;
};


export type QueryGetImplantReferenceByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetImplantReferenceWhereUniqueArgs = {
  where: ImplantReferenceWhereUniqueInput;
};


export type QueryGetInProgressOrderDesignArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetItemMaterialWhereUniqueArgs = {
  where: ItemMaterialWhereUniqueInput;
};


export type QueryGetItemMaterialsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryGetItemMaterialsWhereArgs = {
  cursor?: InputMaybe<ItemMaterialWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemMaterialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemMaterialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemMaterialWhereInput>;
};


export type QueryGetItemPriceWhereUniqueArgs = {
  where: ItemPriceWhereUniqueInput;
};


export type QueryGetItemPricesWhereArgs = {
  cursor?: InputMaybe<ItemPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemPriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemPriceWhereInput>;
};


export type QueryGetItemShadeWhereUniqueArgs = {
  where: ItemShadeWhereUniqueInput;
};


export type QueryGetItemShadesByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryGetItemShadesWhereArgs = {
  cursor?: InputMaybe<ItemShadeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemShadeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemShadeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemShadeWhereInput>;
};


export type QueryGetLastUnreadOfEachOrderArgs = {
  args: ChatInput;
};


export type QueryGetManyOrdersOfUserArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryGetManyUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryGetMaterialTraceabilityWhereArgs = {
  cursor?: InputMaybe<MaterialTraceabilityWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialTraceabilityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialTraceabilityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialTraceabilityWhereInput>;
};


export type QueryGetMaterialTraceabilityWhereUniqueArgs = {
  where: MaterialTraceabilityWhereUniqueInput;
};


export type QueryGetNotificationSubscriptionsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrderByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOrderByUniqueAttributeArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryGetOrderDeliveryInfoArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetOrderDesignArgs = {
  orderDesignId: Scalars['String']['input'];
};


export type QueryGetOrderDesignFileArgs = {
  filename: Scalars['String']['input'];
  orderDesignId: Scalars['String']['input'];
};


export type QueryGetOrderDesignFilesArgs = {
  orderDesignId: Scalars['String']['input'];
};


export type QueryGetOrderDesignsArgs = {
  onlyUntranslatedComment?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<OrderDesignStatus>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOrderDesignsByOrderIdArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetOrderEstimatedDeliveryDateArgs = {
  orderId: Scalars['String']['input'];
  useConfirmedAtAsReferenceDate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetOrderHelpFilesArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetOrdersByDentalOfficeIdArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dentalOfficeId: Scalars['String']['input'];
  filter?: InputMaybe<OrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrdersSortV2>;
};


export type QueryGetOrdersByDentistIdArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dentistId: Scalars['String']['input'];
  filter?: InputMaybe<OrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrdersSortV2>;
};


export type QueryGetOrdersCountByDentalOfficeIdArgs = {
  dentalOfficeId: Scalars['String']['input'];
  filter?: InputMaybe<OrdersFilterInput>;
};


export type QueryGetOrdersCountByDentistIdArgs = {
  dentistId: Scalars['String']['input'];
  filter?: InputMaybe<OrdersFilterInput>;
};


export type QueryGetOrdersListByDentalOfficeIdArgs = {
  dentalOfficeId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrdersListFilterInput>;
  skip: Scalars['Int']['input'];
  sort?: InputMaybe<OrdersSortV2>;
  take: Scalars['Int']['input'];
};


export type QueryGetOrdersListCountByDentalOfficeIdArgs = {
  dentalOfficeId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrdersListFilterInput>;
};


export type QueryGetPickupAvailabilityArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryGetPickupByDateArgs = {
  selectedDate: Scalars['Timestamp']['input'];
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};


export type QueryGetPresignedFileDownloadUrlArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetPresignedFileUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryGetProductByIdArgs = {
  productId: Scalars['String']['input'];
};


export type QueryGetSignedDownloadUrlsFromKeysArgs = {
  args: FilesInput;
};


export type QueryGetTodayShippingArgs = {
  selectedDate: Scalars['Timestamp']['input'];
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};


export type QueryGetTodayShippingByClinicIdArgs = {
  userGroupId: Scalars['String']['input'];
};


export type QueryGetTodayShippingByDeliveryCarrierArgs = {
  deliveryCarrier: Scalars['String']['input'];
  filters?: InputMaybe<ShippingFiltersInput>;
  selectedDate: Scalars['Timestamp']['input'];
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};


export type QueryGetUniqueItemBillingArgs = {
  where: ItemBillingWhereUniqueInput;
};


export type QueryGetUniqueOrderBillingArgs = {
  where: OrderBillingWhereUniqueInput;
};


export type QueryGetUniqueProductPreferenceArgs = {
  where: ProductPreferencesWhereUniqueInput;
};


export type QueryGetUserGroupsWhereArgs = {
  cursor?: InputMaybe<UserGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserGroupWhereInput>;
};


export type QueryGetUserGroupsWhereUniqueArgs = {
  where: UserGroupWhereUniqueInput;
};


export type QueryGetUserItemBillingArgs = {
  orderBillingId: Scalars['String']['input'];
};


export type QueryGetUserOrderBillingArgs = {
  cursor?: InputMaybe<OrderBillingWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderBillingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderBillingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderBillingWhereInput>;
};


export type QueryGetUserProductPreferencesArgs = {
  cursor?: InputMaybe<ProductPreferencesWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductPreferencesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductPreferencesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductPreferencesWhereInput>;
};


export type QueryImplantItemArgs = {
  where: ImplantItemWhereUniqueInput;
};


export type QueryImplantItemsArgs = {
  cursor?: InputMaybe<ImplantItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ImplantItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ImplantItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImplantItemWhereInput>;
};


export type QueryPatientArgs = {
  where: PatientWhereUniqueInput;
};


export type QueryPatientsArgs = {
  cursor?: InputMaybe<PatientWhereUniqueInput>;
  distinct?: InputMaybe<Array<PatientScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PatientOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PatientWhereInput>;
};


export type QueryRemovableItemArgs = {
  where: RemovableItemWhereUniqueInput;
};


export type QueryRemovableItemsArgs = {
  cursor?: InputMaybe<RemovableItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<RemovableItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RemovableItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RemovableItemWhereInput>;
};


export type QueryUniqueFixedProsthesisPreferencesArgs = {
  where: FixedProsthesisPreferencesWhereUniqueInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Redo = {
  __typename?: 'Redo';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  oldDeliveryDate: Scalars['Timestamp']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
};

export type RedoCreateManyOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  oldDeliveryDate: Scalars['Timestamp']['input'];
  orderReference: Scalars['String']['input'];
};

export type RedoCreateManyOrderInputEnvelope = {
  data: Array<RedoCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedoCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<RedoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedoCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<RedoCreateWithoutOrderInput>>;
  createMany?: InputMaybe<RedoCreateManyOrderInputEnvelope>;
};

export type RedoCreateOrConnectWithoutOrderInput = {
  create: RedoCreateWithoutOrderInput;
  where: RedoWhereUniqueInput;
};

export type RedoCreateWithoutOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  oldDeliveryDate: Scalars['Timestamp']['input'];
  orderReference: Scalars['String']['input'];
};

export type RedoListRelationFilter = {
  every?: InputMaybe<RedoWhereInput>;
  none?: InputMaybe<RedoWhereInput>;
  some?: InputMaybe<RedoWhereInput>;
};

export type RedoOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RedoOrderDto = {
  __typename?: 'RedoOrderDTO';
  file: Scalars['String']['output'];
  newDeliveryDate: Scalars['String']['output'];
};

export type RedoScalarWhereInput = {
  AND?: InputMaybe<Array<RedoScalarWhereInput>>;
  NOT?: InputMaybe<Array<RedoScalarWhereInput>>;
  OR?: InputMaybe<Array<RedoScalarWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  oldDeliveryDate?: InputMaybe<DateTimeFilter>;
  orderId?: InputMaybe<UuidFilter>;
  orderReference?: InputMaybe<StringFilter>;
};

export type RedoUpdateManyMutationInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldDeliveryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RedoUpdateManyWithWhereWithoutOrderInput = {
  data: RedoUpdateManyMutationInput;
  where: RedoScalarWhereInput;
};

export type RedoUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<RedoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedoCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<RedoCreateWithoutOrderInput>>;
  createMany?: InputMaybe<RedoCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<RedoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedoWhereUniqueInput>>;
  set?: InputMaybe<Array<RedoWhereUniqueInput>>;
  update?: InputMaybe<Array<RedoUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<RedoUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<RedoUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type RedoUpdateWithWhereUniqueWithoutOrderInput = {
  data: RedoUpdateWithoutOrderInput;
  where: RedoWhereUniqueInput;
};

export type RedoUpdateWithoutOrderInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  oldDeliveryDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderReference?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RedoUpsertWithWhereUniqueWithoutOrderInput = {
  create: RedoCreateWithoutOrderInput;
  update: RedoUpdateWithoutOrderInput;
  where: RedoWhereUniqueInput;
};

export type RedoWhereInput = {
  AND?: InputMaybe<Array<RedoWhereInput>>;
  NOT?: InputMaybe<Array<RedoWhereInput>>;
  OR?: InputMaybe<Array<RedoWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  oldDeliveryDate?: InputMaybe<DateTimeFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  orderReference?: InputMaybe<StringFilter>;
};

export type RedoWhereUniqueInput = {
  AND?: InputMaybe<Array<RedoWhereInput>>;
  NOT?: InputMaybe<Array<RedoWhereInput>>;
  OR?: InputMaybe<Array<RedoWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  oldDeliveryDate?: InputMaybe<DateTimeFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  orderReference?: InputMaybe<StringFilter>;
};

export type ReferencedImplantCharacteristicsModel = {
  __typename?: 'ReferencedImplantCharacteristicsModel';
  implantPlatform: Scalars['String']['output'];
  implantReference: ImplantReferenceV2;
  scanBodyReference: Scalars['String']['output'];
};

export type RefreshPastilleInput = {
  currentStatus?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  previousStatus?: InputMaybe<Scalars['String']['input']>;
  previousUserGroupId?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type RemovableItem = {
  __typename?: 'RemovableItem';
  _count: RemovableItemCount;
  createdAt: Scalars['Timestamp']['output'];
  dentistNotes?: Maybe<Scalars['String']['output']>;
  fullDentureOrderType?: Maybe<RemovableItemOrderType>;
  gingivaShade?: Maybe<ItemShade>;
  gingivaShadeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imprintType?: Maybe<ImprintType>;
  individualImpressionTray: Scalars['Boolean']['output'];
  isBimaxillarySeparated: Scalars['Boolean']['output'];
  isBothJaws: Scalars['Boolean']['output'];
  isReplacement: Scalars['Boolean']['output'];
  itemBilling?: Maybe<Array<ItemBilling>>;
  itemMaterial?: Maybe<ItemMaterial>;
  itemMaterialId?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<ItemType>;
  linkToExistingOrder: Scalars['Boolean']['output'];
  linkedOrderId?: Maybe<Scalars['String']['output']>;
  partialDenture?: Maybe<PartialDenture>;
  partialDentureId?: Maybe<Scalars['String']['output']>;
  partialDentureOrderType?: Maybe<RemovableItemOrderType>;
  product: Product;
  productId: Scalars['String']['output'];
  rdv2Choice?: Maybe<Scalars['String']['output']>;
  rdvNumber?: Maybe<Scalars['Int']['output']>;
  returnMethod?: Maybe<Scalars['String']['output']>;
  teeth?: Maybe<Scalars['JSON']['output']>;
  teethShade?: Maybe<ItemShade>;
  teethShadeId?: Maybe<Scalars['String']['output']>;
  teethToManufacture?: Maybe<Array<Scalars['Int']['output']>>;
  updatedAt: Scalars['Timestamp']['output'];
  waxUpType?: Maybe<WaxUpType>;
  workflowType?: Maybe<WorkflowType>;
};

export type RemovableItemCount = {
  __typename?: 'RemovableItemCount';
  itemBilling: Scalars['Int']['output'];
};

export type RemovableItemCreateInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemGingivaInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutRemovableItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutRemovableItemInput>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDenture?: InputMaybe<PartialDentureCreateNestedOneWithoutRemovableItemInput>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  product: ProductCreateNestedOneWithoutRemovableItemInput;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemTeethInput>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateManyGingivaShadeInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDentureId?: InputMaybe<Scalars['String']['input']>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  productId: Scalars['String']['input'];
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShadeId?: InputMaybe<Scalars['String']['input']>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateManyGingivaShadeInputEnvelope = {
  data: Array<RemovableItemCreateManyGingivaShadeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemovableItemCreateManyItemMaterialInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShadeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDentureId?: InputMaybe<Scalars['String']['input']>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  productId: Scalars['String']['input'];
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShadeId?: InputMaybe<Scalars['String']['input']>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateManyItemMaterialInputEnvelope = {
  data: Array<RemovableItemCreateManyItemMaterialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemovableItemCreateManyProductInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShadeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDentureId?: InputMaybe<Scalars['String']['input']>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShadeId?: InputMaybe<Scalars['String']['input']>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateManyProductInputEnvelope = {
  data: Array<RemovableItemCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemovableItemCreateManyTeethShadeInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShadeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterialId?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDentureId?: InputMaybe<Scalars['String']['input']>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  productId: Scalars['String']['input'];
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateManyTeethShadeInputEnvelope = {
  data: Array<RemovableItemCreateManyTeethShadeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemovableItemCreateNestedManyWithoutGingivaShadeInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutGingivaShadeInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutGingivaShadeInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyGingivaShadeInputEnvelope>;
};

export type RemovableItemCreateNestedManyWithoutItemMaterialInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyItemMaterialInputEnvelope>;
};

export type RemovableItemCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyProductInputEnvelope>;
};

export type RemovableItemCreateNestedManyWithoutTeethShadeInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutTeethShadeInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutTeethShadeInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyTeethShadeInputEnvelope>;
};

export type RemovableItemCreateNestedOneWithoutItemBillingInput = {
  connect?: InputMaybe<RemovableItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RemovableItemCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<RemovableItemCreateWithoutItemBillingInput>;
};

export type RemovableItemCreateNestedOneWithoutPartialDentureInput = {
  connect?: InputMaybe<RemovableItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RemovableItemCreateOrConnectWithoutPartialDentureInput>;
  create?: InputMaybe<RemovableItemCreateWithoutPartialDentureInput>;
};

export type RemovableItemCreateOrConnectWithoutGingivaShadeInput = {
  create: RemovableItemCreateWithoutGingivaShadeInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemCreateOrConnectWithoutItemBillingInput = {
  create: RemovableItemCreateWithoutItemBillingInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemCreateOrConnectWithoutItemMaterialInput = {
  create: RemovableItemCreateWithoutItemMaterialInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemCreateOrConnectWithoutPartialDentureInput = {
  create: RemovableItemCreateWithoutPartialDentureInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemCreateOrConnectWithoutProductInput = {
  create: RemovableItemCreateWithoutProductInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemCreateOrConnectWithoutTeethShadeInput = {
  create: RemovableItemCreateWithoutTeethShadeInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemCreateWithoutGingivaShadeInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutRemovableItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutRemovableItemInput>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDenture?: InputMaybe<PartialDentureCreateNestedOneWithoutRemovableItemInput>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  product: ProductCreateNestedOneWithoutRemovableItemInput;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemTeethInput>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateWithoutItemBillingInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemGingivaInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutRemovableItemInput>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDenture?: InputMaybe<PartialDentureCreateNestedOneWithoutRemovableItemInput>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  product: ProductCreateNestedOneWithoutRemovableItemInput;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemTeethInput>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateWithoutItemMaterialInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemGingivaInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutRemovableItemInput>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDenture?: InputMaybe<PartialDentureCreateNestedOneWithoutRemovableItemInput>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  product: ProductCreateNestedOneWithoutRemovableItemInput;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemTeethInput>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateWithoutPartialDentureInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemGingivaInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutRemovableItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutRemovableItemInput>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  product: ProductCreateNestedOneWithoutRemovableItemInput;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemTeethInput>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateWithoutProductInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemGingivaInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutRemovableItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutRemovableItemInput>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDenture?: InputMaybe<PartialDentureCreateNestedOneWithoutRemovableItemInput>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemTeethInput>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateWithoutTeethShadeInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  dentistNotes?: InputMaybe<Scalars['String']['input']>;
  fullDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  gingivaShade?: InputMaybe<ItemShadeCreateNestedOneWithoutRemovableItemGingivaInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<ImprintType>;
  individualImpressionTray?: InputMaybe<Scalars['Boolean']['input']>;
  isBimaxillarySeparated?: InputMaybe<Scalars['Boolean']['input']>;
  isBothJaws?: InputMaybe<Scalars['Boolean']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  itemBilling?: InputMaybe<ItemBillingCreateNestedManyWithoutRemovableItemInput>;
  itemMaterial?: InputMaybe<ItemMaterialCreateNestedOneWithoutRemovableItemInput>;
  itemType?: InputMaybe<ItemType>;
  linkToExistingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOrderId?: InputMaybe<Scalars['String']['input']>;
  partialDenture?: InputMaybe<PartialDentureCreateNestedOneWithoutRemovableItemInput>;
  partialDentureOrderType?: InputMaybe<RemovableItemOrderType>;
  product: ProductCreateNestedOneWithoutRemovableItemInput;
  rdv2Choice?: InputMaybe<Scalars['String']['input']>;
  rdvNumber?: InputMaybe<Scalars['Int']['input']>;
  returnMethod?: InputMaybe<Scalars['String']['input']>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethToManufacture?: InputMaybe<RemovableItemCreateteethToManufactureInput>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  waxUpType?: InputMaybe<WaxUpType>;
  workflowType?: InputMaybe<WorkflowType>;
};

export type RemovableItemCreateteethToManufactureInput = {
  set: Array<Scalars['Int']['input']>;
};

export type RemovableItemListRelationFilter = {
  every?: InputMaybe<RemovableItemWhereInput>;
  none?: InputMaybe<RemovableItemWhereInput>;
  some?: InputMaybe<RemovableItemWhereInput>;
};

export type RemovableItemNullableScalarRelationFilter = {
  is?: InputMaybe<RemovableItemWhereInput>;
  isNot?: InputMaybe<RemovableItemWhereInput>;
};

export type RemovableItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RemovableItemOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  dentistNotes?: InputMaybe<SortOrderInput>;
  fullDentureOrderType?: InputMaybe<SortOrderInput>;
  gingivaShade?: InputMaybe<ItemShadeOrderByWithRelationInput>;
  gingivaShadeId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imprintType?: InputMaybe<SortOrderInput>;
  individualImpressionTray?: InputMaybe<SortOrder>;
  isBimaxillarySeparated?: InputMaybe<SortOrder>;
  isBothJaws?: InputMaybe<SortOrder>;
  isReplacement?: InputMaybe<SortOrder>;
  itemBilling?: InputMaybe<ItemBillingOrderByRelationAggregateInput>;
  itemMaterial?: InputMaybe<ItemMaterialOrderByWithRelationInput>;
  itemMaterialId?: InputMaybe<SortOrderInput>;
  itemType?: InputMaybe<SortOrderInput>;
  linkToExistingOrder?: InputMaybe<SortOrder>;
  linkedOrderId?: InputMaybe<SortOrderInput>;
  partialDenture?: InputMaybe<PartialDentureOrderByWithRelationInput>;
  partialDentureId?: InputMaybe<SortOrderInput>;
  partialDentureOrderType?: InputMaybe<SortOrderInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  rdv2Choice?: InputMaybe<SortOrderInput>;
  rdvNumber?: InputMaybe<SortOrderInput>;
  returnMethod?: InputMaybe<SortOrderInput>;
  teeth?: InputMaybe<SortOrderInput>;
  teethShade?: InputMaybe<ItemShadeOrderByWithRelationInput>;
  teethShadeId?: InputMaybe<SortOrderInput>;
  teethToManufacture?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  waxUpType?: InputMaybe<SortOrderInput>;
  workflowType?: InputMaybe<SortOrderInput>;
};

export enum RemovableItemOrderType {
  Final = 'FINAL',
  TryIn = 'TRY_IN',
  WaxBite = 'WAX_BITE'
}

export enum RemovableItemScalarFieldEnum {
  CreatedAt = 'createdAt',
  DentistNotes = 'dentistNotes',
  FullDentureOrderType = 'fullDentureOrderType',
  GingivaShadeId = 'gingivaShadeId',
  Id = 'id',
  ImprintType = 'imprintType',
  IndividualImpressionTray = 'individualImpressionTray',
  IsBimaxillarySeparated = 'isBimaxillarySeparated',
  IsBothJaws = 'isBothJaws',
  IsReplacement = 'isReplacement',
  ItemMaterialId = 'itemMaterialId',
  ItemType = 'itemType',
  LinkToExistingOrder = 'linkToExistingOrder',
  LinkedOrderId = 'linkedOrderId',
  PartialDentureId = 'partialDentureId',
  PartialDentureOrderType = 'partialDentureOrderType',
  ProductId = 'productId',
  Rdv2Choice = 'rdv2Choice',
  RdvNumber = 'rdvNumber',
  ReturnMethod = 'returnMethod',
  Teeth = 'teeth',
  TeethShadeId = 'teethShadeId',
  TeethToManufacture = 'teethToManufacture',
  UpdatedAt = 'updatedAt',
  WaxUpType = 'waxUpType',
  WorkflowType = 'workflowType'
}

export type RemovableItemScalarWhereInput = {
  AND?: InputMaybe<Array<RemovableItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<RemovableItemScalarWhereInput>>;
  OR?: InputMaybe<Array<RemovableItemScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentistNotes?: InputMaybe<StringNullableFilter>;
  fullDentureOrderType?: InputMaybe<EnumRemovableItemOrderTypeNullableFilter>;
  gingivaShadeId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imprintType?: InputMaybe<EnumImprintTypeNullableFilter>;
  individualImpressionTray?: InputMaybe<BoolFilter>;
  isBimaxillarySeparated?: InputMaybe<BoolFilter>;
  isBothJaws?: InputMaybe<BoolFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  linkToExistingOrder?: InputMaybe<BoolFilter>;
  linkedOrderId?: InputMaybe<UuidNullableFilter>;
  partialDentureId?: InputMaybe<UuidNullableFilter>;
  partialDentureOrderType?: InputMaybe<EnumRemovableItemOrderTypeNullableFilter>;
  productId?: InputMaybe<UuidFilter>;
  rdv2Choice?: InputMaybe<StringNullableFilter>;
  rdvNumber?: InputMaybe<IntNullableFilter>;
  returnMethod?: InputMaybe<StringNullableFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethShadeId?: InputMaybe<StringNullableFilter>;
  teethToManufacture?: InputMaybe<IntNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  waxUpType?: InputMaybe<EnumwaxUpTypeNullableFilter>;
  workflowType?: InputMaybe<EnumWorkflowTypeNullableFilter>;
};

export type RemovableItemUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  gingivaShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemGingivaNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutRemovableItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutRemovableItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<PartialDentureUpdateOneWithoutRemovableItemNestedInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutRemovableItemNestedInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemTeethNestedInput>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateManyWithWhereWithoutGingivaShadeInput = {
  data: RemovableItemUpdateManyMutationInput;
  where: RemovableItemScalarWhereInput;
};

export type RemovableItemUpdateManyWithWhereWithoutItemMaterialInput = {
  data: RemovableItemUpdateManyMutationInput;
  where: RemovableItemScalarWhereInput;
};

export type RemovableItemUpdateManyWithWhereWithoutProductInput = {
  data: RemovableItemUpdateManyMutationInput;
  where: RemovableItemScalarWhereInput;
};

export type RemovableItemUpdateManyWithWhereWithoutTeethShadeInput = {
  data: RemovableItemUpdateManyMutationInput;
  where: RemovableItemScalarWhereInput;
};

export type RemovableItemUpdateManyWithoutGingivaShadeNestedInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutGingivaShadeInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutGingivaShadeInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyGingivaShadeInputEnvelope>;
  delete?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RemovableItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  set?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  update?: InputMaybe<Array<RemovableItemUpdateWithWhereUniqueWithoutGingivaShadeInput>>;
  updateMany?: InputMaybe<Array<RemovableItemUpdateManyWithWhereWithoutGingivaShadeInput>>;
  upsert?: InputMaybe<Array<RemovableItemUpsertWithWhereUniqueWithoutGingivaShadeInput>>;
};

export type RemovableItemUpdateManyWithoutItemMaterialNestedInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutItemMaterialInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutItemMaterialInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyItemMaterialInputEnvelope>;
  delete?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RemovableItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  set?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  update?: InputMaybe<Array<RemovableItemUpdateWithWhereUniqueWithoutItemMaterialInput>>;
  updateMany?: InputMaybe<Array<RemovableItemUpdateManyWithWhereWithoutItemMaterialInput>>;
  upsert?: InputMaybe<Array<RemovableItemUpsertWithWhereUniqueWithoutItemMaterialInput>>;
};

export type RemovableItemUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RemovableItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  set?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  update?: InputMaybe<Array<RemovableItemUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<RemovableItemUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<RemovableItemUpsertWithWhereUniqueWithoutProductInput>>;
};

export type RemovableItemUpdateManyWithoutTeethShadeNestedInput = {
  connect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableItemCreateOrConnectWithoutTeethShadeInput>>;
  create?: InputMaybe<Array<RemovableItemCreateWithoutTeethShadeInput>>;
  createMany?: InputMaybe<RemovableItemCreateManyTeethShadeInputEnvelope>;
  delete?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RemovableItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  set?: InputMaybe<Array<RemovableItemWhereUniqueInput>>;
  update?: InputMaybe<Array<RemovableItemUpdateWithWhereUniqueWithoutTeethShadeInput>>;
  updateMany?: InputMaybe<Array<RemovableItemUpdateManyWithWhereWithoutTeethShadeInput>>;
  upsert?: InputMaybe<Array<RemovableItemUpsertWithWhereUniqueWithoutTeethShadeInput>>;
};

export type RemovableItemUpdateOneWithoutItemBillingNestedInput = {
  connect?: InputMaybe<RemovableItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RemovableItemCreateOrConnectWithoutItemBillingInput>;
  create?: InputMaybe<RemovableItemCreateWithoutItemBillingInput>;
  delete?: InputMaybe<RemovableItemWhereInput>;
  disconnect?: InputMaybe<RemovableItemWhereInput>;
  update?: InputMaybe<RemovableItemUpdateToOneWithWhereWithoutItemBillingInput>;
  upsert?: InputMaybe<RemovableItemUpsertWithoutItemBillingInput>;
};

export type RemovableItemUpdateOneWithoutPartialDentureNestedInput = {
  connect?: InputMaybe<RemovableItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RemovableItemCreateOrConnectWithoutPartialDentureInput>;
  create?: InputMaybe<RemovableItemCreateWithoutPartialDentureInput>;
  delete?: InputMaybe<RemovableItemWhereInput>;
  disconnect?: InputMaybe<RemovableItemWhereInput>;
  update?: InputMaybe<RemovableItemUpdateToOneWithWhereWithoutPartialDentureInput>;
  upsert?: InputMaybe<RemovableItemUpsertWithoutPartialDentureInput>;
};

export type RemovableItemUpdateToOneWithWhereWithoutItemBillingInput = {
  data: RemovableItemUpdateWithoutItemBillingInput;
  where?: InputMaybe<RemovableItemWhereInput>;
};

export type RemovableItemUpdateToOneWithWhereWithoutPartialDentureInput = {
  data: RemovableItemUpdateWithoutPartialDentureInput;
  where?: InputMaybe<RemovableItemWhereInput>;
};

export type RemovableItemUpdateWithWhereUniqueWithoutGingivaShadeInput = {
  data: RemovableItemUpdateWithoutGingivaShadeInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpdateWithWhereUniqueWithoutItemMaterialInput = {
  data: RemovableItemUpdateWithoutItemMaterialInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpdateWithWhereUniqueWithoutProductInput = {
  data: RemovableItemUpdateWithoutProductInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpdateWithWhereUniqueWithoutTeethShadeInput = {
  data: RemovableItemUpdateWithoutTeethShadeInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpdateWithoutGingivaShadeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutRemovableItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutRemovableItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<PartialDentureUpdateOneWithoutRemovableItemNestedInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutRemovableItemNestedInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemTeethNestedInput>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateWithoutItemBillingInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  gingivaShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemGingivaNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutRemovableItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<PartialDentureUpdateOneWithoutRemovableItemNestedInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutRemovableItemNestedInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemTeethNestedInput>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateWithoutItemMaterialInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  gingivaShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemGingivaNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutRemovableItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<PartialDentureUpdateOneWithoutRemovableItemNestedInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutRemovableItemNestedInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemTeethNestedInput>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateWithoutPartialDentureInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  gingivaShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemGingivaNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutRemovableItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutRemovableItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutRemovableItemNestedInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemTeethNestedInput>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateWithoutProductInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  gingivaShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemGingivaNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutRemovableItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutRemovableItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<PartialDentureUpdateOneWithoutRemovableItemNestedInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemTeethNestedInput>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateWithoutTeethShadeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dentistNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  gingivaShade?: InputMaybe<ItemShadeUpdateOneWithoutRemovableItemGingivaNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imprintType?: InputMaybe<NullableEnumImprintTypeFieldUpdateOperationsInput>;
  individualImpressionTray?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBimaxillarySeparated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isBothJaws?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isReplacement?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemBilling?: InputMaybe<ItemBillingUpdateManyWithoutRemovableItemNestedInput>;
  itemMaterial?: InputMaybe<ItemMaterialUpdateOneWithoutRemovableItemNestedInput>;
  itemType?: InputMaybe<NullableEnumItemTypeFieldUpdateOperationsInput>;
  linkToExistingOrder?: InputMaybe<BoolFieldUpdateOperationsInput>;
  linkedOrderId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  partialDenture?: InputMaybe<PartialDentureUpdateOneWithoutRemovableItemNestedInput>;
  partialDentureOrderType?: InputMaybe<NullableEnumRemovableItemOrderTypeFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutRemovableItemNestedInput>;
  rdv2Choice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rdvNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  returnMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  teeth?: InputMaybe<Scalars['JSON']['input']>;
  teethToManufacture?: InputMaybe<RemovableItemUpdateteethToManufactureInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  waxUpType?: InputMaybe<NullableEnumwaxUpTypeFieldUpdateOperationsInput>;
  workflowType?: InputMaybe<NullableEnumWorkflowTypeFieldUpdateOperationsInput>;
};

export type RemovableItemUpdateteethToManufactureInput = {
  push?: InputMaybe<Array<Scalars['Int']['input']>>;
  set?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RemovableItemUpsertWithWhereUniqueWithoutGingivaShadeInput = {
  create: RemovableItemCreateWithoutGingivaShadeInput;
  update: RemovableItemUpdateWithoutGingivaShadeInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpsertWithWhereUniqueWithoutItemMaterialInput = {
  create: RemovableItemCreateWithoutItemMaterialInput;
  update: RemovableItemUpdateWithoutItemMaterialInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpsertWithWhereUniqueWithoutProductInput = {
  create: RemovableItemCreateWithoutProductInput;
  update: RemovableItemUpdateWithoutProductInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpsertWithWhereUniqueWithoutTeethShadeInput = {
  create: RemovableItemCreateWithoutTeethShadeInput;
  update: RemovableItemUpdateWithoutTeethShadeInput;
  where: RemovableItemWhereUniqueInput;
};

export type RemovableItemUpsertWithoutItemBillingInput = {
  create: RemovableItemCreateWithoutItemBillingInput;
  update: RemovableItemUpdateWithoutItemBillingInput;
  where?: InputMaybe<RemovableItemWhereInput>;
};

export type RemovableItemUpsertWithoutPartialDentureInput = {
  create: RemovableItemCreateWithoutPartialDentureInput;
  update: RemovableItemUpdateWithoutPartialDentureInput;
  where?: InputMaybe<RemovableItemWhereInput>;
};

export type RemovableItemWhereInput = {
  AND?: InputMaybe<Array<RemovableItemWhereInput>>;
  NOT?: InputMaybe<Array<RemovableItemWhereInput>>;
  OR?: InputMaybe<Array<RemovableItemWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentistNotes?: InputMaybe<StringNullableFilter>;
  fullDentureOrderType?: InputMaybe<EnumRemovableItemOrderTypeNullableFilter>;
  gingivaShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  gingivaShadeId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  imprintType?: InputMaybe<EnumImprintTypeNullableFilter>;
  individualImpressionTray?: InputMaybe<BoolFilter>;
  isBimaxillarySeparated?: InputMaybe<BoolFilter>;
  isBothJaws?: InputMaybe<BoolFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  linkToExistingOrder?: InputMaybe<BoolFilter>;
  linkedOrderId?: InputMaybe<UuidNullableFilter>;
  partialDenture?: InputMaybe<PartialDentureNullableScalarRelationFilter>;
  partialDentureId?: InputMaybe<UuidNullableFilter>;
  partialDentureOrderType?: InputMaybe<EnumRemovableItemOrderTypeNullableFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<UuidFilter>;
  rdv2Choice?: InputMaybe<StringNullableFilter>;
  rdvNumber?: InputMaybe<IntNullableFilter>;
  returnMethod?: InputMaybe<StringNullableFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  teethShadeId?: InputMaybe<StringNullableFilter>;
  teethToManufacture?: InputMaybe<IntNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  waxUpType?: InputMaybe<EnumwaxUpTypeNullableFilter>;
  workflowType?: InputMaybe<EnumWorkflowTypeNullableFilter>;
};

export type RemovableItemWhereUniqueInput = {
  AND?: InputMaybe<Array<RemovableItemWhereInput>>;
  NOT?: InputMaybe<Array<RemovableItemWhereInput>>;
  OR?: InputMaybe<Array<RemovableItemWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dentistNotes?: InputMaybe<StringNullableFilter>;
  fullDentureOrderType?: InputMaybe<EnumRemovableItemOrderTypeNullableFilter>;
  gingivaShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  gingivaShadeId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imprintType?: InputMaybe<EnumImprintTypeNullableFilter>;
  individualImpressionTray?: InputMaybe<BoolFilter>;
  isBimaxillarySeparated?: InputMaybe<BoolFilter>;
  isBothJaws?: InputMaybe<BoolFilter>;
  isReplacement?: InputMaybe<BoolFilter>;
  itemBilling?: InputMaybe<ItemBillingListRelationFilter>;
  itemMaterial?: InputMaybe<ItemMaterialNullableScalarRelationFilter>;
  itemMaterialId?: InputMaybe<StringNullableFilter>;
  itemType?: InputMaybe<EnumItemTypeNullableFilter>;
  linkToExistingOrder?: InputMaybe<BoolFilter>;
  linkedOrderId?: InputMaybe<UuidNullableFilter>;
  partialDenture?: InputMaybe<PartialDentureNullableScalarRelationFilter>;
  partialDentureId?: InputMaybe<Scalars['String']['input']>;
  partialDentureOrderType?: InputMaybe<EnumRemovableItemOrderTypeNullableFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<UuidFilter>;
  rdv2Choice?: InputMaybe<StringNullableFilter>;
  rdvNumber?: InputMaybe<IntNullableFilter>;
  returnMethod?: InputMaybe<StringNullableFilter>;
  teeth?: InputMaybe<JsonNullableFilter>;
  teethShade?: InputMaybe<ItemShadeNullableScalarRelationFilter>;
  teethShadeId?: InputMaybe<StringNullableFilter>;
  teethToManufacture?: InputMaybe<IntNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  waxUpType?: InputMaybe<EnumwaxUpTypeNullableFilter>;
  workflowType?: InputMaybe<EnumWorkflowTypeNullableFilter>;
};

export type RemovableProsthesisPreferences = {
  __typename?: 'RemovableProsthesisPreferences';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  itemType: ItemType;
  productPreferences: ProductPreferences;
  productPreferencesId: Scalars['String']['output'];
  splintHardness: Scalars['String']['output'];
  teethShape: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type RemovableProsthesisPreferencesCreateManyProductPreferencesInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  splintHardness?: InputMaybe<Scalars['String']['input']>;
  teethShape?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type RemovableProsthesisPreferencesCreateManyProductPreferencesInputEnvelope = {
  data: Array<RemovableProsthesisPreferencesCreateManyProductPreferencesInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemovableProsthesisPreferencesCreateNestedManyWithoutProductPreferencesInput = {
  connect?: InputMaybe<Array<RemovableProsthesisPreferencesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableProsthesisPreferencesCreateOrConnectWithoutProductPreferencesInput>>;
  create?: InputMaybe<Array<RemovableProsthesisPreferencesCreateWithoutProductPreferencesInput>>;
  createMany?: InputMaybe<RemovableProsthesisPreferencesCreateManyProductPreferencesInputEnvelope>;
};

export type RemovableProsthesisPreferencesCreateOrConnectWithoutProductPreferencesInput = {
  create: RemovableProsthesisPreferencesCreateWithoutProductPreferencesInput;
  where: RemovableProsthesisPreferencesWhereUniqueInput;
};

export type RemovableProsthesisPreferencesCreateWithoutProductPreferencesInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<ItemType>;
  splintHardness?: InputMaybe<Scalars['String']['input']>;
  teethShape?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type RemovableProsthesisPreferencesListRelationFilter = {
  every?: InputMaybe<RemovableProsthesisPreferencesWhereInput>;
  none?: InputMaybe<RemovableProsthesisPreferencesWhereInput>;
  some?: InputMaybe<RemovableProsthesisPreferencesWhereInput>;
};

export type RemovableProsthesisPreferencesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RemovableProsthesisPreferencesScalarWhereInput = {
  AND?: InputMaybe<Array<RemovableProsthesisPreferencesScalarWhereInput>>;
  NOT?: InputMaybe<Array<RemovableProsthesisPreferencesScalarWhereInput>>;
  OR?: InputMaybe<Array<RemovableProsthesisPreferencesScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  productPreferencesId?: InputMaybe<UuidFilter>;
  splintHardness?: InputMaybe<StringFilter>;
  teethShape?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RemovableProsthesisPreferencesUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  splintHardness?: InputMaybe<StringFieldUpdateOperationsInput>;
  teethShape?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RemovableProsthesisPreferencesUpdateManyWithWhereWithoutProductPreferencesInput = {
  data: RemovableProsthesisPreferencesUpdateManyMutationInput;
  where: RemovableProsthesisPreferencesScalarWhereInput;
};

export type RemovableProsthesisPreferencesUpdateManyWithoutProductPreferencesNestedInput = {
  connect?: InputMaybe<Array<RemovableProsthesisPreferencesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemovableProsthesisPreferencesCreateOrConnectWithoutProductPreferencesInput>>;
  create?: InputMaybe<Array<RemovableProsthesisPreferencesCreateWithoutProductPreferencesInput>>;
  createMany?: InputMaybe<RemovableProsthesisPreferencesCreateManyProductPreferencesInputEnvelope>;
  delete?: InputMaybe<Array<RemovableProsthesisPreferencesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RemovableProsthesisPreferencesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RemovableProsthesisPreferencesWhereUniqueInput>>;
  set?: InputMaybe<Array<RemovableProsthesisPreferencesWhereUniqueInput>>;
  update?: InputMaybe<Array<RemovableProsthesisPreferencesUpdateWithWhereUniqueWithoutProductPreferencesInput>>;
  updateMany?: InputMaybe<Array<RemovableProsthesisPreferencesUpdateManyWithWhereWithoutProductPreferencesInput>>;
  upsert?: InputMaybe<Array<RemovableProsthesisPreferencesUpsertWithWhereUniqueWithoutProductPreferencesInput>>;
};

export type RemovableProsthesisPreferencesUpdateWithWhereUniqueWithoutProductPreferencesInput = {
  data: RemovableProsthesisPreferencesUpdateWithoutProductPreferencesInput;
  where: RemovableProsthesisPreferencesWhereUniqueInput;
};

export type RemovableProsthesisPreferencesUpdateWithoutProductPreferencesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  itemType?: InputMaybe<EnumItemTypeFieldUpdateOperationsInput>;
  splintHardness?: InputMaybe<StringFieldUpdateOperationsInput>;
  teethShape?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RemovableProsthesisPreferencesUpsertWithWhereUniqueWithoutProductPreferencesInput = {
  create: RemovableProsthesisPreferencesCreateWithoutProductPreferencesInput;
  update: RemovableProsthesisPreferencesUpdateWithoutProductPreferencesInput;
  where: RemovableProsthesisPreferencesWhereUniqueInput;
};

export type RemovableProsthesisPreferencesWhereInput = {
  AND?: InputMaybe<Array<RemovableProsthesisPreferencesWhereInput>>;
  NOT?: InputMaybe<Array<RemovableProsthesisPreferencesWhereInput>>;
  OR?: InputMaybe<Array<RemovableProsthesisPreferencesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  productPreferences?: InputMaybe<ProductPreferencesScalarRelationFilter>;
  productPreferencesId?: InputMaybe<UuidFilter>;
  splintHardness?: InputMaybe<StringFilter>;
  teethShape?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RemovableProsthesisPreferencesWhereUniqueInput = {
  AND?: InputMaybe<Array<RemovableProsthesisPreferencesWhereInput>>;
  NOT?: InputMaybe<Array<RemovableProsthesisPreferencesWhereInput>>;
  OR?: InputMaybe<Array<RemovableProsthesisPreferencesWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<EnumItemTypeFilter>;
  productPreferences?: InputMaybe<ProductPreferencesScalarRelationFilter>;
  productPreferencesId?: InputMaybe<UuidFilter>;
  splintHardness?: InputMaybe<StringFilter>;
  teethShape?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum RetentionType {
  CementRetained = 'CEMENT_RETAINED',
  ScrewRetained = 'SCREW_RETAINED'
}

export enum RetentionTypeV2 {
  CementRetained = 'CEMENT_RETAINED',
  ScrewRetained = 'SCREW_RETAINED'
}

export type ScanPost = {
  __typename?: 'ScanPost';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ScanPostCatalog = {
  __typename?: 'ScanPostCatalog';
  scanPosts: Array<ScanPost>;
  types: Array<ScanPostType>;
};

export type ScanPostType = {
  __typename?: 'ScanPostType';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  subLabel?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export enum ScannerReference {
  ThreeshapeTrios_3Wired = 'THREESHAPE_TRIOS_3_WIRED',
  ThreeshapeTrios_5 = 'THREESHAPE_TRIOS_5'
}

export type SendMailToProvider = {
  orderId: Scalars['String']['input'];
  previousProviderGroupId?: InputMaybe<Scalars['String']['input']>;
  sendDeleteCaseEmail: Scalars['Boolean']['input'];
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
  NotIndicated = 'NOT_INDICATED'
}

export enum SexV2 {
  Female = 'FEMALE',
  Male = 'MALE',
  NotIndicated = 'NOT_INDICATED'
}

export type ShadeCharacteristics = MultiShadeCharacteristicsModel | SingleShadeCharacteristicsModel;

export type Shipping = {
  __typename?: 'Shipping';
  _count: ShippingCount;
  createdAt: Scalars['Timestamp']['output'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  masterTrackingNumber?: Maybe<Scalars['String']['output']>;
  pickup?: Maybe<Array<Pickup>>;
  shippingType: ShippingType;
  shippings?: Maybe<Array<ShippingContent>>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  userGroup: UserGroup;
  userGroupId: Scalars['String']['output'];
};

export type ShippingContent = {
  __typename?: 'ShippingContent';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  shipping: Shipping;
  shippingId: Scalars['String']['output'];
};

export type ShippingContentCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shippingId: Scalars['String']['input'];
};

export type ShippingContentCreateManyOrderInputEnvelope = {
  data: Array<ShippingContentCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingContentCreateManyShippingInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export type ShippingContentCreateManyShippingInputEnvelope = {
  data: Array<ShippingContentCreateManyShippingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingContentCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingContentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ShippingContentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ShippingContentCreateManyOrderInputEnvelope>;
};

export type ShippingContentCreateNestedManyWithoutShippingInput = {
  connect?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingContentCreateOrConnectWithoutShippingInput>>;
  create?: InputMaybe<Array<ShippingContentCreateWithoutShippingInput>>;
  createMany?: InputMaybe<ShippingContentCreateManyShippingInputEnvelope>;
};

export type ShippingContentCreateOrConnectWithoutOrderInput = {
  create: ShippingContentCreateWithoutOrderInput;
  where: ShippingContentWhereUniqueInput;
};

export type ShippingContentCreateOrConnectWithoutShippingInput = {
  create: ShippingContentCreateWithoutShippingInput;
  where: ShippingContentWhereUniqueInput;
};

export type ShippingContentCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  shipping: ShippingCreateNestedOneWithoutShippingsInput;
};

export type ShippingContentCreateWithoutShippingInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order: OrderCreateNestedOneWithoutShippingsInput;
};

export type ShippingContentListRelationFilter = {
  every?: InputMaybe<ShippingContentWhereInput>;
  none?: InputMaybe<ShippingContentWhereInput>;
  some?: InputMaybe<ShippingContentWhereInput>;
};

export type ShippingContentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShippingContentScalarWhereInput = {
  AND?: InputMaybe<Array<ShippingContentScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShippingContentScalarWhereInput>>;
  OR?: InputMaybe<Array<ShippingContentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  orderId?: InputMaybe<UuidFilter>;
  shippingId?: InputMaybe<UuidFilter>;
};

export type ShippingContentUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ShippingContentUpdateManyWithWhereWithoutOrderInput = {
  data: ShippingContentUpdateManyMutationInput;
  where: ShippingContentScalarWhereInput;
};

export type ShippingContentUpdateManyWithWhereWithoutShippingInput = {
  data: ShippingContentUpdateManyMutationInput;
  where: ShippingContentScalarWhereInput;
};

export type ShippingContentUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingContentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ShippingContentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ShippingContentCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShippingContentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShippingContentUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ShippingContentUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ShippingContentUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ShippingContentUpdateManyWithoutShippingNestedInput = {
  connect?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingContentCreateOrConnectWithoutShippingInput>>;
  create?: InputMaybe<Array<ShippingContentCreateWithoutShippingInput>>;
  createMany?: InputMaybe<ShippingContentCreateManyShippingInputEnvelope>;
  delete?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShippingContentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  set?: InputMaybe<Array<ShippingContentWhereUniqueInput>>;
  update?: InputMaybe<Array<ShippingContentUpdateWithWhereUniqueWithoutShippingInput>>;
  updateMany?: InputMaybe<Array<ShippingContentUpdateManyWithWhereWithoutShippingInput>>;
  upsert?: InputMaybe<Array<ShippingContentUpsertWithWhereUniqueWithoutShippingInput>>;
};

export type ShippingContentUpdateWithWhereUniqueWithoutOrderInput = {
  data: ShippingContentUpdateWithoutOrderInput;
  where: ShippingContentWhereUniqueInput;
};

export type ShippingContentUpdateWithWhereUniqueWithoutShippingInput = {
  data: ShippingContentUpdateWithoutShippingInput;
  where: ShippingContentWhereUniqueInput;
};

export type ShippingContentUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateOneRequiredWithoutShippingsNestedInput>;
};

export type ShippingContentUpdateWithoutShippingInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutShippingsNestedInput>;
};

export type ShippingContentUpsertWithWhereUniqueWithoutOrderInput = {
  create: ShippingContentCreateWithoutOrderInput;
  update: ShippingContentUpdateWithoutOrderInput;
  where: ShippingContentWhereUniqueInput;
};

export type ShippingContentUpsertWithWhereUniqueWithoutShippingInput = {
  create: ShippingContentCreateWithoutShippingInput;
  update: ShippingContentUpdateWithoutShippingInput;
  where: ShippingContentWhereUniqueInput;
};

export type ShippingContentWhereInput = {
  AND?: InputMaybe<Array<ShippingContentWhereInput>>;
  NOT?: InputMaybe<Array<ShippingContentWhereInput>>;
  OR?: InputMaybe<Array<ShippingContentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<UuidFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  shipping?: InputMaybe<ShippingScalarRelationFilter>;
  shippingId?: InputMaybe<UuidFilter>;
};

export type ShippingContentWhereUniqueInput = {
  AND?: InputMaybe<Array<ShippingContentWhereInput>>;
  NOT?: InputMaybe<Array<ShippingContentWhereInput>>;
  OR?: InputMaybe<Array<ShippingContentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<UuidFilter>;
  shipping?: InputMaybe<ShippingScalarRelationFilter>;
  shippingId?: InputMaybe<UuidFilter>;
};

export type ShippingCount = {
  __typename?: 'ShippingCount';
  pickup: Scalars['Int']['output'];
  shippings: Scalars['Int']['output'];
};

export type ShippingCreateManyFileInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  shippingType?: InputMaybe<ShippingType>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  userGroupId: Scalars['String']['input'];
};

export type ShippingCreateManyFileInputEnvelope = {
  data: Array<ShippingCreateManyFileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingCreateManyUserGroupInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  shippingType?: InputMaybe<ShippingType>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingCreateManyUserGroupInputEnvelope = {
  data: Array<ShippingCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingCreateNestedManyWithoutFileInput = {
  connect?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingCreateOrConnectWithoutFileInput>>;
  create?: InputMaybe<Array<ShippingCreateWithoutFileInput>>;
  createMany?: InputMaybe<ShippingCreateManyFileInputEnvelope>;
};

export type ShippingCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ShippingCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ShippingCreateManyUserGroupInputEnvelope>;
};

export type ShippingCreateNestedOneWithoutPickupInput = {
  connect?: InputMaybe<ShippingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingCreateOrConnectWithoutPickupInput>;
  create?: InputMaybe<ShippingCreateWithoutPickupInput>;
};

export type ShippingCreateNestedOneWithoutShippingsInput = {
  connect?: InputMaybe<ShippingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingCreateOrConnectWithoutShippingsInput>;
  create?: InputMaybe<ShippingCreateWithoutShippingsInput>;
};

export type ShippingCreateOrConnectWithoutFileInput = {
  create: ShippingCreateWithoutFileInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingCreateOrConnectWithoutPickupInput = {
  create: ShippingCreateWithoutPickupInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingCreateOrConnectWithoutShippingsInput = {
  create: ShippingCreateWithoutShippingsInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingCreateOrConnectWithoutUserGroupInput = {
  create: ShippingCreateWithoutUserGroupInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingCreateWithoutFileInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutShippingInput>;
  shippingType?: InputMaybe<ShippingType>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutShippingInput>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  userGroup: UserGroupCreateNestedOneWithoutShippingInput;
};

export type ShippingCreateWithoutPickupInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  file?: InputMaybe<FileCreateNestedOneWithoutShippingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  shippingType?: InputMaybe<ShippingType>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutShippingInput>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  userGroup: UserGroupCreateNestedOneWithoutShippingInput;
};

export type ShippingCreateWithoutShippingsInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  file?: InputMaybe<FileCreateNestedOneWithoutShippingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutShippingInput>;
  shippingType?: InputMaybe<ShippingType>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  userGroup: UserGroupCreateNestedOneWithoutShippingInput;
};

export type ShippingCreateWithoutUserGroupInput = {
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  file?: InputMaybe<FileCreateNestedOneWithoutShippingInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterTrackingNumber?: InputMaybe<Scalars['String']['input']>;
  pickup?: InputMaybe<PickupCreateNestedManyWithoutShippingInput>;
  shippingType?: InputMaybe<ShippingType>;
  shippings?: InputMaybe<ShippingContentCreateNestedManyWithoutShippingInput>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingFiltersInput = {
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  orderReference?: InputMaybe<Scalars['String']['input']>;
  patientFirstname?: InputMaybe<Scalars['String']['input']>;
  patientLastname?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingListRelationFilter = {
  every?: InputMaybe<ShippingWhereInput>;
  none?: InputMaybe<ShippingWhereInput>;
  some?: InputMaybe<ShippingWhereInput>;
};

export type ShippingNullableScalarRelationFilter = {
  is?: InputMaybe<ShippingWhereInput>;
  isNot?: InputMaybe<ShippingWhereInput>;
};

export type ShippingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShippingOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderByWithRelationInput>;
  fileId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  masterTrackingNumber?: InputMaybe<SortOrderInput>;
  pickup?: InputMaybe<PickupOrderByRelationAggregateInput>;
  shippingType?: InputMaybe<SortOrder>;
  shippings?: InputMaybe<ShippingContentOrderByRelationAggregateInput>;
  trackingNumber?: InputMaybe<SortOrderInput>;
  userGroup?: InputMaybe<UserGroupOrderByWithRelationInput>;
  userGroupId?: InputMaybe<SortOrder>;
};

export type ShippingScalarRelationFilter = {
  is?: InputMaybe<ShippingWhereInput>;
  isNot?: InputMaybe<ShippingWhereInput>;
};

export type ShippingScalarWhereInput = {
  AND?: InputMaybe<Array<ShippingScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShippingScalarWhereInput>>;
  OR?: InputMaybe<Array<ShippingScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  fileId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  masterTrackingNumber?: InputMaybe<StringNullableFilter>;
  shippingType?: InputMaybe<EnumShippingTypeFilter>;
  trackingNumber?: InputMaybe<StringNullableFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export enum ShippingType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type ShippingUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  masterTrackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingType?: InputMaybe<EnumShippingTypeFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShippingUpdateManyWithWhereWithoutFileInput = {
  data: ShippingUpdateManyMutationInput;
  where: ShippingScalarWhereInput;
};

export type ShippingUpdateManyWithWhereWithoutUserGroupInput = {
  data: ShippingUpdateManyMutationInput;
  where: ShippingScalarWhereInput;
};

export type ShippingUpdateManyWithoutFileNestedInput = {
  connect?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingCreateOrConnectWithoutFileInput>>;
  create?: InputMaybe<Array<ShippingCreateWithoutFileInput>>;
  createMany?: InputMaybe<ShippingCreateManyFileInputEnvelope>;
  delete?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShippingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  set?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  update?: InputMaybe<Array<ShippingUpdateWithWhereUniqueWithoutFileInput>>;
  updateMany?: InputMaybe<Array<ShippingUpdateManyWithWhereWithoutFileInput>>;
  upsert?: InputMaybe<Array<ShippingUpsertWithWhereUniqueWithoutFileInput>>;
};

export type ShippingUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<ShippingCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<ShippingCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShippingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  set?: InputMaybe<Array<ShippingWhereUniqueInput>>;
  update?: InputMaybe<Array<ShippingUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<ShippingUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<ShippingUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type ShippingUpdateOneRequiredWithoutShippingsNestedInput = {
  connect?: InputMaybe<ShippingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingCreateOrConnectWithoutShippingsInput>;
  create?: InputMaybe<ShippingCreateWithoutShippingsInput>;
  update?: InputMaybe<ShippingUpdateToOneWithWhereWithoutShippingsInput>;
  upsert?: InputMaybe<ShippingUpsertWithoutShippingsInput>;
};

export type ShippingUpdateOneWithoutPickupNestedInput = {
  connect?: InputMaybe<ShippingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingCreateOrConnectWithoutPickupInput>;
  create?: InputMaybe<ShippingCreateWithoutPickupInput>;
  delete?: InputMaybe<ShippingWhereInput>;
  disconnect?: InputMaybe<ShippingWhereInput>;
  update?: InputMaybe<ShippingUpdateToOneWithWhereWithoutPickupInput>;
  upsert?: InputMaybe<ShippingUpsertWithoutPickupInput>;
};

export type ShippingUpdateToOneWithWhereWithoutPickupInput = {
  data: ShippingUpdateWithoutPickupInput;
  where?: InputMaybe<ShippingWhereInput>;
};

export type ShippingUpdateToOneWithWhereWithoutShippingsInput = {
  data: ShippingUpdateWithoutShippingsInput;
  where?: InputMaybe<ShippingWhereInput>;
};

export type ShippingUpdateWithWhereUniqueWithoutFileInput = {
  data: ShippingUpdateWithoutFileInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: ShippingUpdateWithoutUserGroupInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingUpdateWithoutFileInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  masterTrackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutShippingNestedInput>;
  shippingType?: InputMaybe<EnumShippingTypeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutShippingNestedInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneRequiredWithoutShippingNestedInput>;
};

export type ShippingUpdateWithoutPickupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneWithoutShippingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  masterTrackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingType?: InputMaybe<EnumShippingTypeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutShippingNestedInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneRequiredWithoutShippingNestedInput>;
};

export type ShippingUpdateWithoutShippingsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneWithoutShippingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  masterTrackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutShippingNestedInput>;
  shippingType?: InputMaybe<EnumShippingTypeFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneRequiredWithoutShippingNestedInput>;
};

export type ShippingUpdateWithoutUserGroupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneWithoutShippingNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  masterTrackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pickup?: InputMaybe<PickupUpdateManyWithoutShippingNestedInput>;
  shippingType?: InputMaybe<EnumShippingTypeFieldUpdateOperationsInput>;
  shippings?: InputMaybe<ShippingContentUpdateManyWithoutShippingNestedInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShippingUpsertWithWhereUniqueWithoutFileInput = {
  create: ShippingCreateWithoutFileInput;
  update: ShippingUpdateWithoutFileInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: ShippingCreateWithoutUserGroupInput;
  update: ShippingUpdateWithoutUserGroupInput;
  where: ShippingWhereUniqueInput;
};

export type ShippingUpsertWithoutPickupInput = {
  create: ShippingCreateWithoutPickupInput;
  update: ShippingUpdateWithoutPickupInput;
  where?: InputMaybe<ShippingWhereInput>;
};

export type ShippingUpsertWithoutShippingsInput = {
  create: ShippingCreateWithoutShippingsInput;
  update: ShippingUpdateWithoutShippingsInput;
  where?: InputMaybe<ShippingWhereInput>;
};

export type ShippingWhereInput = {
  AND?: InputMaybe<Array<ShippingWhereInput>>;
  NOT?: InputMaybe<Array<ShippingWhereInput>>;
  OR?: InputMaybe<Array<ShippingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<FileNullableScalarRelationFilter>;
  fileId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<UuidFilter>;
  masterTrackingNumber?: InputMaybe<StringNullableFilter>;
  pickup?: InputMaybe<PickupListRelationFilter>;
  shippingType?: InputMaybe<EnumShippingTypeFilter>;
  shippings?: InputMaybe<ShippingContentListRelationFilter>;
  trackingNumber?: InputMaybe<StringNullableFilter>;
  userGroup?: InputMaybe<UserGroupScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type ShippingWhereUniqueInput = {
  AND?: InputMaybe<Array<ShippingWhereInput>>;
  NOT?: InputMaybe<Array<ShippingWhereInput>>;
  OR?: InputMaybe<Array<ShippingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  file?: InputMaybe<FileNullableScalarRelationFilter>;
  fileId?: InputMaybe<UuidNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  masterTrackingNumber?: InputMaybe<StringNullableFilter>;
  pickup?: InputMaybe<PickupListRelationFilter>;
  shippingType?: InputMaybe<EnumShippingTypeFilter>;
  shippings?: InputMaybe<ShippingContentListRelationFilter>;
  trackingNumber?: InputMaybe<StringNullableFilter>;
  userGroup?: InputMaybe<UserGroupScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type SingleShadeCharacteristicsModel = {
  __typename?: 'SingleShadeCharacteristicsModel';
  isMultiShade: Scalars['Boolean']['output'];
  shade: ItemShadeModel;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StandardAbutmentCharacteristicsModel = {
  __typename?: 'StandardAbutmentCharacteristicsModel';
  abutmentPreferences?: Maybe<Scalars['String']['output']>;
  abutmentType: AbutmentTypeV2;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SubscriptionFrequence {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export enum TeethArchV2 {
  Mandibular = 'MANDIBULAR',
  Maxillary = 'MAXILLARY'
}

export enum TeethShadeSide {
  Base = 'BASE',
  Gingival = 'GINGIVAL',
  Incisal = 'INCISAL'
}

export enum TeethShadeType {
  MultiShade = 'MULTI_SHADE',
  SingleShade = 'SINGLE_SHADE'
}

export enum ThreeDModelPricingType {
  Free = 'FREE',
  Full = 'FULL',
  Half = 'HALF'
}

export type ToShip = {
  __typename?: 'ToShip';
  clinicNumber: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  shipping: Array<Shipping>;
};

export type TodayShippings = {
  __typename?: 'TodayShippings';
  carrier: Scalars['String']['output'];
  fileCount?: Maybe<Scalars['Float']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  userGroup: Array<ToShip>;
};

export type TodayShippingsData = {
  __typename?: 'TodayShippingsData';
  carrier: Scalars['String']['output'];
  clinicNumber: Scalars['String']['output'];
  orderCount: Scalars['Float']['output'];
  shippingCount: Scalars['Float']['output'];
};

export type ToothScopedItemV2 = ItemV2 & {
  __typename?: 'ToothScopedItemV2';
  abutmentCharacteristics?: Maybe<AbutmentCharacteristics>;
  id: Scalars['String']['output'];
  implantCharacteristics?: Maybe<ImplantCharacteristics>;
  implantedItemCharacteristics?: Maybe<ImplantedItemCharacteristicsModel>;
  inlayCoreCharacteristics?: Maybe<InlayCoreCharacteristicsModel>;
  materialCharacteristics?: Maybe<MaterialCharacteristicsModel>;
  product: ProductModel;
  scope: ItemScopeV2;
  tooth: Scalars['Float']['output'];
  type: ItemTypeV2;
  waxUpType?: Maybe<WaxUpTypeV2>;
};

export type UnreferencedImplantCharacteristicsModel = {
  __typename?: 'UnreferencedImplantCharacteristicsModel';
  implantBrand: Scalars['String']['output'];
  implantPlatform: Scalars['String']['output'];
  implantSystem: Scalars['String']['output'];
  scanBodyReference: Scalars['String']['output'];
};

export type UpdateOrderProductEntryInput = {
  input: UpdateOrderProductInput;
  productId: Scalars['String']['input'];
};

export type UpdateOrderProductInput = {
  itemPreferences?: InputMaybe<ItemPreferencesInput>;
  items?: InputMaybe<Array<CreateItemInput>>;
  teeth?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<ProductTypeV2>;
};

export type User = {
  __typename?: 'User';
  _count: UserCount;
  addresses?: Maybe<Array<Address>>;
  allowPhysicalPrint: Scalars['Boolean']['output'];
  allowedToEditProviderAccess: Scalars['Boolean']['output'];
  chat?: Maybe<Array<Chat>>;
  clientBilling?: Maybe<ClientBilling>;
  clientBillingId?: Maybe<Scalars['String']['output']>;
  communicateAccount?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  createdGroup?: Maybe<Array<UserGroup>>;
  customDeliveryDateEnabled: Scalars['Boolean']['output'];
  directConnectName?: Maybe<Scalars['String']['output']>;
  directConnectPath?: Maybe<Scalars['String']['output']>;
  dsCoreAccount?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  externalCase?: Maybe<Array<ExternalCase>>;
  files?: Maybe<Array<File>>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isManager: Scalars['Boolean']['output'];
  isServer: Scalars['Boolean']['output'];
  itemPrice?: Maybe<Array<ItemPrice>>;
  lastName: Scalars['String']['output'];
  login?: Maybe<Array<Login>>;
  macAddressComputer?: Maybe<Scalars['String']['output']>;
  managedUserGroup?: Maybe<UserGroup>;
  meditAccount?: Maybe<Scalars['String']['output']>;
  mustChangePassword: Scalars['Boolean']['output'];
  notificationSubscriptions?: Maybe<Array<NotificationSubscription>>;
  notifications?: Maybe<Array<Notification>>;
  orderBillingManufacturer?: Maybe<Array<OrderBilling>>;
  orderBillingUser?: Maybe<Array<OrderBilling>>;
  orderHistory?: Maybe<Array<OrderHistory>>;
  orders?: Maybe<Array<Order>>;
  patients?: Maybe<Array<Patient>>;
  phoneNumber: Scalars['String']['output'];
  productPreferences?: Maybe<Array<ProductPreferences>>;
  role: UserRole;
  shining3dAccount?: Maybe<Scalars['String']['output']>;
  shining3dDoctorId?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  type: UserType;
  updatedAt: Scalars['Timestamp']['output'];
  userGroup?: Maybe<UserGroup>;
  userGroupId?: Maybe<Scalars['String']['output']>;
  userReference?: Maybe<Scalars['String']['output']>;
  usernameComputer?: Maybe<Scalars['String']['output']>;
};

export type UserCount = {
  __typename?: 'UserCount';
  addresses: Scalars['Int']['output'];
  chat: Scalars['Int']['output'];
  createdGroup: Scalars['Int']['output'];
  createdProducts: Scalars['Int']['output'];
  externalCase: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  itemPrice: Scalars['Int']['output'];
  login: Scalars['Int']['output'];
  notificationSubscriptions: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
  orderBillingManufacturer: Scalars['Int']['output'];
  orderBillingUser: Scalars['Int']['output'];
  orderDesignComments: Scalars['Int']['output'];
  orderHistory: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  patients: Scalars['Int']['output'];
  productPreferences: Scalars['Int']['output'];
};

export type UserCreateInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateManyClientBillingInput = {
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateManyClientBillingInputEnvelope = {
  data: Array<UserCreateManyClientBillingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateManyUserGroupInput = {
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  clientBillingId?: InputMaybe<Scalars['String']['input']>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateManyUserGroupInputEnvelope = {
  data: Array<UserCreateManyUserGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreateNestedManyWithoutClientBillingInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutClientBillingInput>>;
  create?: InputMaybe<Array<UserCreateWithoutClientBillingInput>>;
  createMany?: InputMaybe<UserCreateManyClientBillingInputEnvelope>;
};

export type UserCreateNestedManyWithoutUserGroupInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<UserCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<UserCreateManyUserGroupInputEnvelope>;
};

export type UserCreateNestedOneWithoutAddressesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<UserCreateWithoutAddressesInput>;
};

export type UserCreateNestedOneWithoutChatInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutChatInput>;
  create?: InputMaybe<UserCreateWithoutChatInput>;
};

export type UserCreateNestedOneWithoutCreatedGroupInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedGroupInput>;
  create?: InputMaybe<UserCreateWithoutCreatedGroupInput>;
};

export type UserCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserCreateWithoutFilesInput>;
};

export type UserCreateNestedOneWithoutItemPriceInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutItemPriceInput>;
  create?: InputMaybe<UserCreateWithoutItemPriceInput>;
};

export type UserCreateNestedOneWithoutManagedUserGroupInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutManagedUserGroupInput>;
  create?: InputMaybe<UserCreateWithoutManagedUserGroupInput>;
};

export type UserCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<UserCreateWithoutNotificationsInput>;
};

export type UserCreateNestedOneWithoutOrderBillingManufacturerInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderBillingManufacturerInput>;
  create?: InputMaybe<UserCreateWithoutOrderBillingManufacturerInput>;
};

export type UserCreateNestedOneWithoutOrderBillingUserInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderBillingUserInput>;
  create?: InputMaybe<UserCreateWithoutOrderBillingUserInput>;
};

export type UserCreateNestedOneWithoutOrderHistoryInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderHistoryInput>;
  create?: InputMaybe<UserCreateWithoutOrderHistoryInput>;
};

export type UserCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<UserCreateWithoutOrdersInput>;
};

export type UserCreateNestedOneWithoutPatientsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPatientsInput>;
  create?: InputMaybe<UserCreateWithoutPatientsInput>;
};

export type UserCreateNestedOneWithoutProductPreferencesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProductPreferencesInput>;
  create?: InputMaybe<UserCreateWithoutProductPreferencesInput>;
};

export type UserCreateOrConnectWithoutAddressesInput = {
  create: UserCreateWithoutAddressesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChatInput = {
  create: UserCreateWithoutChatInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutClientBillingInput = {
  create: UserCreateWithoutClientBillingInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCreatedGroupInput = {
  create: UserCreateWithoutCreatedGroupInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFilesInput = {
  create: UserCreateWithoutFilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutItemPriceInput = {
  create: UserCreateWithoutItemPriceInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutManagedUserGroupInput = {
  create: UserCreateWithoutManagedUserGroupInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotificationsInput = {
  create: UserCreateWithoutNotificationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrderBillingManufacturerInput = {
  create: UserCreateWithoutOrderBillingManufacturerInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrderBillingUserInput = {
  create: UserCreateWithoutOrderBillingUserInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrderHistoryInput = {
  create: UserCreateWithoutOrderHistoryInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrdersInput = {
  create: UserCreateWithoutOrdersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPatientsInput = {
  create: UserCreateWithoutPatientsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutProductPreferencesInput = {
  create: UserCreateWithoutProductPreferencesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserGroupInput = {
  create: UserCreateWithoutUserGroupInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAddressesInput = {
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutChatInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutClientBillingInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutCreatedGroupInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutFilesInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutItemPriceInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutManagedUserGroupInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutNotificationsInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutOrderBillingManufacturerInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutOrderBillingUserInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutOrderHistoryInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutOrdersInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutPatientsInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutProductPreferencesInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupMembersInput>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserCreateWithoutUserGroupInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserInput>;
  allowPhysicalPrint?: InputMaybe<Scalars['Boolean']['input']>;
  allowedToEditProviderAccess?: InputMaybe<Scalars['Boolean']['input']>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserInput>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdGroup?: InputMaybe<UserGroupCreateNestedManyWithoutCreatedByInput>;
  customDeliveryDateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<Scalars['String']['input']>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalCase?: InputMaybe<ExternalCaseCreateNestedManyWithoutUserInput>;
  files?: InputMaybe<FileCreateNestedManyWithoutUserInput>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isServer?: InputMaybe<Scalars['Boolean']['input']>;
  itemPrice?: InputMaybe<ItemPriceCreateNestedManyWithoutSupplierInput>;
  lastName: Scalars['String']['input'];
  login?: InputMaybe<LoginCreateNestedManyWithoutUserInput>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupCreateNestedOneWithoutGroupManagerInput>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingCreateNestedManyWithoutProviderInput>;
  orderBillingUser?: InputMaybe<OrderBillingCreateNestedManyWithoutUserInput>;
  orderHistory?: InputMaybe<OrderHistoryCreateNestedManyWithoutUserInput>;
  orders?: InputMaybe<OrderCreateNestedManyWithoutUserInput>;
  password: Scalars['String']['input'];
  patients?: InputMaybe<PatientCreateNestedManyWithoutDentistInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productPreferences?: InputMaybe<ProductPreferencesCreateNestedManyWithoutDentistInput>;
  role?: InputMaybe<UserRole>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
  type?: InputMaybe<UserType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  ChatMarkAsUnread?: Maybe<Array<ChatMarkAsUnread>>;
  _count: UserGroupCount;
  addresses?: Maybe<Array<Address>>;
  availableClinic?: Maybe<Array<ClinicProviderAccess>>;
  availableMaterialTraceabilities?: Maybe<Array<ProviderMaterialTraceability>>;
  availableProvider?: Maybe<Array<ClinicProviderAccess>>;
  chat?: Maybe<Array<Chat>>;
  clientBilling?: Maybe<ClientBilling>;
  clientBillingId?: Maybe<Scalars['String']['output']>;
  clinicNumber?: Maybe<Scalars['String']['output']>;
  clinicOrders?: Maybe<Array<Order>>;
  createdAt: Scalars['Timestamp']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  deliveryCarrier: CarrierType;
  description?: Maybe<Scalars['String']['output']>;
  displayPriority?: Maybe<Scalars['Int']['output']>;
  exemptOriginalAbutmentCharge: Scalars['Boolean']['output'];
  groupManager?: Maybe<User>;
  groupManagerId?: Maybe<Scalars['String']['output']>;
  groupMembers?: Maybe<Array<User>>;
  groupType: UserGroupType;
  hidePricesOnPractitionerTraceability: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifications?: Maybe<Array<Notification>>;
  phoneNumber: Scalars['String']['output'];
  pickupCarrier: CarrierType;
  providerOrders?: Maybe<Array<Order>>;
  shipping?: Maybe<Array<Shipping>>;
  status: UserGroupStatus;
  threeDModelPricingType: ThreeDModelPricingType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type UserGroupCount = {
  __typename?: 'UserGroupCount';
  ChatMarkAsUnread: Scalars['Int']['output'];
  addresses: Scalars['Int']['output'];
  availableClinic: Scalars['Int']['output'];
  availableMaterialTraceabilities: Scalars['Int']['output'];
  availableProvider: Scalars['Int']['output'];
  chat: Scalars['Int']['output'];
  clinicOrders: Scalars['Int']['output'];
  groupMembers: Scalars['Int']['output'];
  meditLinkGroup: Scalars['Int']['output'];
  notifications: Scalars['Int']['output'];
  providerOrders: Scalars['Int']['output'];
  shipping: Scalars['Int']['output'];
};

export type UserGroupCreateInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateManyClientBillingInput = {
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManagerId?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateManyClientBillingInputEnvelope = {
  data: Array<UserGroupCreateManyClientBillingInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserGroupCreateManyCreatedByInput = {
  clientBillingId?: InputMaybe<Scalars['String']['input']>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManagerId?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateManyCreatedByInputEnvelope = {
  data: Array<UserGroupCreateManyCreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserGroupCreateNestedManyWithoutClientBillingInput = {
  connect?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserGroupCreateOrConnectWithoutClientBillingInput>>;
  create?: InputMaybe<Array<UserGroupCreateWithoutClientBillingInput>>;
  createMany?: InputMaybe<UserGroupCreateManyClientBillingInputEnvelope>;
};

export type UserGroupCreateNestedManyWithoutCreatedByInput = {
  connect?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserGroupCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserGroupCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserGroupCreateManyCreatedByInputEnvelope>;
};

export type UserGroupCreateNestedOneWithoutAddressesInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<UserGroupCreateWithoutAddressesInput>;
};

export type UserGroupCreateNestedOneWithoutAvailableClinicInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAvailableClinicInput>;
  create?: InputMaybe<UserGroupCreateWithoutAvailableClinicInput>;
};

export type UserGroupCreateNestedOneWithoutAvailableMaterialTraceabilitiesInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAvailableMaterialTraceabilitiesInput>;
  create?: InputMaybe<UserGroupCreateWithoutAvailableMaterialTraceabilitiesInput>;
};

export type UserGroupCreateNestedOneWithoutAvailableProviderInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAvailableProviderInput>;
  create?: InputMaybe<UserGroupCreateWithoutAvailableProviderInput>;
};

export type UserGroupCreateNestedOneWithoutChatInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutChatInput>;
  create?: InputMaybe<UserGroupCreateWithoutChatInput>;
};

export type UserGroupCreateNestedOneWithoutChatMarkAsUnreadInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutChatMarkAsUnreadInput>;
  create?: InputMaybe<UserGroupCreateWithoutChatMarkAsUnreadInput>;
};

export type UserGroupCreateNestedOneWithoutClinicOrdersInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutClinicOrdersInput>;
  create?: InputMaybe<UserGroupCreateWithoutClinicOrdersInput>;
};

export type UserGroupCreateNestedOneWithoutGroupManagerInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutGroupManagerInput>;
  create?: InputMaybe<UserGroupCreateWithoutGroupManagerInput>;
};

export type UserGroupCreateNestedOneWithoutGroupMembersInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutGroupMembersInput>;
  create?: InputMaybe<UserGroupCreateWithoutGroupMembersInput>;
};

export type UserGroupCreateNestedOneWithoutProviderOrdersInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutProviderOrdersInput>;
  create?: InputMaybe<UserGroupCreateWithoutProviderOrdersInput>;
};

export type UserGroupCreateNestedOneWithoutShippingInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutShippingInput>;
  create?: InputMaybe<UserGroupCreateWithoutShippingInput>;
};

export type UserGroupCreateOrConnectWithoutAddressesInput = {
  create: UserGroupCreateWithoutAddressesInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutAvailableClinicInput = {
  create: UserGroupCreateWithoutAvailableClinicInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutAvailableMaterialTraceabilitiesInput = {
  create: UserGroupCreateWithoutAvailableMaterialTraceabilitiesInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutAvailableProviderInput = {
  create: UserGroupCreateWithoutAvailableProviderInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutChatInput = {
  create: UserGroupCreateWithoutChatInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutChatMarkAsUnreadInput = {
  create: UserGroupCreateWithoutChatMarkAsUnreadInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutClientBillingInput = {
  create: UserGroupCreateWithoutClientBillingInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutClinicOrdersInput = {
  create: UserGroupCreateWithoutClinicOrdersInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutCreatedByInput = {
  create: UserGroupCreateWithoutCreatedByInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutGroupManagerInput = {
  create: UserGroupCreateWithoutGroupManagerInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutGroupMembersInput = {
  create: UserGroupCreateWithoutGroupMembersInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutProviderOrdersInput = {
  create: UserGroupCreateWithoutProviderOrdersInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateOrConnectWithoutShippingInput = {
  create: UserGroupCreateWithoutShippingInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupCreateWithoutAddressesInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutAvailableClinicInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutAvailableMaterialTraceabilitiesInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutAvailableProviderInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutChatInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutChatMarkAsUnreadInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutClientBillingInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutClinicOrdersInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutCreatedByInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutGroupManagerInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutGroupMembersInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutProviderOrdersInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  shipping?: InputMaybe<ShippingCreateNestedManyWithoutUserGroupInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupCreateWithoutShippingInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadCreateNestedManyWithoutUserGroupInput>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutUserGroupInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutProviderInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityCreateNestedManyWithoutUserGroupInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessCreateNestedManyWithoutClinicInput>;
  chat?: InputMaybe<ChatCreateNestedManyWithoutUserGroupInput>;
  clientBilling?: InputMaybe<ClientBillingCreateNestedOneWithoutUserGroupInput>;
  clinicNumber?: InputMaybe<Scalars['String']['input']>;
  clinicOrders?: InputMaybe<OrderCreateNestedManyWithoutUserGroupInput>;
  createdAt?: InputMaybe<Scalars['Timestamp']['input']>;
  createdBy?: InputMaybe<UserCreateNestedOneWithoutCreatedGroupInput>;
  deliveryCarrier?: InputMaybe<CarrierType>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayPriority?: InputMaybe<Scalars['Int']['input']>;
  exemptOriginalAbutmentCharge?: InputMaybe<Scalars['Boolean']['input']>;
  groupManager?: InputMaybe<UserCreateNestedOneWithoutManagedUserGroupInput>;
  groupMembers?: InputMaybe<UserCreateNestedManyWithoutUserGroupInput>;
  groupType?: InputMaybe<UserGroupType>;
  hidePricesOnPractitionerTraceability?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutUserGroupInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickupCarrier?: InputMaybe<CarrierType>;
  providerOrders?: InputMaybe<OrderCreateNestedManyWithoutProviderInput>;
  status?: InputMaybe<UserGroupStatus>;
  threeDModelPricingType?: InputMaybe<ThreeDModelPricingType>;
  updatedAt?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UserGroupListRelationFilter = {
  every?: InputMaybe<UserGroupWhereInput>;
  none?: InputMaybe<UserGroupWhereInput>;
  some?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupNullableScalarRelationFilter = {
  is?: InputMaybe<UserGroupWhereInput>;
  isNot?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserGroupOrderByWithRelationInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadOrderByRelationAggregateInput>;
  addresses?: InputMaybe<AddressOrderByRelationAggregateInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessOrderByRelationAggregateInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityOrderByRelationAggregateInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessOrderByRelationAggregateInput>;
  chat?: InputMaybe<ChatOrderByRelationAggregateInput>;
  clientBilling?: InputMaybe<ClientBillingOrderByWithRelationInput>;
  clientBillingId?: InputMaybe<SortOrderInput>;
  clinicNumber?: InputMaybe<SortOrderInput>;
  clinicOrders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<UserOrderByWithRelationInput>;
  createdById?: InputMaybe<SortOrderInput>;
  deliveryCarrier?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  displayPriority?: InputMaybe<SortOrderInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<SortOrder>;
  groupManager?: InputMaybe<UserOrderByWithRelationInput>;
  groupManagerId?: InputMaybe<SortOrderInput>;
  groupMembers?: InputMaybe<UserOrderByRelationAggregateInput>;
  groupType?: InputMaybe<SortOrder>;
  hidePricesOnPractitionerTraceability?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  phoneNumber?: InputMaybe<SortOrder>;
  pickupCarrier?: InputMaybe<SortOrder>;
  providerOrders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  shipping?: InputMaybe<ShippingOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  threeDModelPricingType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum UserGroupScalarFieldEnum {
  ClientBillingId = 'clientBillingId',
  ClinicNumber = 'clinicNumber',
  CreatedAt = 'createdAt',
  CreatedById = 'createdById',
  DeliveryCarrier = 'deliveryCarrier',
  Description = 'description',
  DisplayPriority = 'displayPriority',
  ExemptOriginalAbutmentCharge = 'exemptOriginalAbutmentCharge',
  GroupManagerId = 'groupManagerId',
  GroupType = 'groupType',
  HidePricesOnPractitionerTraceability = 'hidePricesOnPractitionerTraceability',
  Id = 'id',
  Name = 'name',
  PhoneNumber = 'phoneNumber',
  PickupCarrier = 'pickupCarrier',
  Status = 'status',
  ThreeDModelPricingType = 'threeDModelPricingType',
  UpdatedAt = 'updatedAt'
}

export type UserGroupScalarRelationFilter = {
  is?: InputMaybe<UserGroupWhereInput>;
  isNot?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupScalarWhereInput = {
  AND?: InputMaybe<Array<UserGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<UserGroupScalarWhereInput>>;
  clientBillingId?: InputMaybe<UuidNullableFilter>;
  clinicNumber?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  displayPriority?: InputMaybe<IntNullableFilter>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFilter>;
  groupManagerId?: InputMaybe<UuidNullableFilter>;
  groupType?: InputMaybe<EnumUserGroupTypeFilter>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFilter>;
  status?: InputMaybe<EnumUserGroupStatusFilter>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum UserGroupStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED'
}

export enum UserGroupType {
  Admin = 'ADMIN',
  Dentist = 'DENTIST',
  Supplier = 'SUPPLIER'
}

export enum UserGroupTypeV2 {
  Admin = 'ADMIN',
  Dentist = 'DENTIST',
  Supplier = 'SUPPLIER'
}

export type UserGroupUpdateInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateManyMutationInput = {
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateManyWithWhereWithoutClientBillingInput = {
  data: UserGroupUpdateManyMutationInput;
  where: UserGroupScalarWhereInput;
};

export type UserGroupUpdateManyWithWhereWithoutCreatedByInput = {
  data: UserGroupUpdateManyMutationInput;
  where: UserGroupScalarWhereInput;
};

export type UserGroupUpdateManyWithoutClientBillingNestedInput = {
  connect?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserGroupCreateOrConnectWithoutClientBillingInput>>;
  create?: InputMaybe<Array<UserGroupCreateWithoutClientBillingInput>>;
  createMany?: InputMaybe<UserGroupCreateManyClientBillingInputEnvelope>;
  delete?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<UserGroupUpdateWithWhereUniqueWithoutClientBillingInput>>;
  updateMany?: InputMaybe<Array<UserGroupUpdateManyWithWhereWithoutClientBillingInput>>;
  upsert?: InputMaybe<Array<UserGroupUpsertWithWhereUniqueWithoutClientBillingInput>>;
};

export type UserGroupUpdateManyWithoutCreatedByNestedInput = {
  connect?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserGroupCreateOrConnectWithoutCreatedByInput>>;
  create?: InputMaybe<Array<UserGroupCreateWithoutCreatedByInput>>;
  createMany?: InputMaybe<UserGroupCreateManyCreatedByInputEnvelope>;
  delete?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<UserGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<UserGroupUpdateWithWhereUniqueWithoutCreatedByInput>>;
  updateMany?: InputMaybe<Array<UserGroupUpdateManyWithWhereWithoutCreatedByInput>>;
  upsert?: InputMaybe<Array<UserGroupUpsertWithWhereUniqueWithoutCreatedByInput>>;
};

export type UserGroupUpdateOneRequiredWithoutAvailableClinicNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAvailableClinicInput>;
  create?: InputMaybe<UserGroupCreateWithoutAvailableClinicInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutAvailableClinicInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutAvailableClinicInput>;
};

export type UserGroupUpdateOneRequiredWithoutAvailableMaterialTraceabilitiesNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAvailableMaterialTraceabilitiesInput>;
  create?: InputMaybe<UserGroupCreateWithoutAvailableMaterialTraceabilitiesInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutAvailableMaterialTraceabilitiesInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutAvailableMaterialTraceabilitiesInput>;
};

export type UserGroupUpdateOneRequiredWithoutAvailableProviderNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAvailableProviderInput>;
  create?: InputMaybe<UserGroupCreateWithoutAvailableProviderInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutAvailableProviderInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutAvailableProviderInput>;
};

export type UserGroupUpdateOneRequiredWithoutShippingNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutShippingInput>;
  create?: InputMaybe<UserGroupCreateWithoutShippingInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutShippingInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutShippingInput>;
};

export type UserGroupUpdateOneWithoutAddressesNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<UserGroupCreateWithoutAddressesInput>;
  delete?: InputMaybe<UserGroupWhereInput>;
  disconnect?: InputMaybe<UserGroupWhereInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutAddressesInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutAddressesInput>;
};

export type UserGroupUpdateOneWithoutChatMarkAsUnreadNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutChatMarkAsUnreadInput>;
  create?: InputMaybe<UserGroupCreateWithoutChatMarkAsUnreadInput>;
  delete?: InputMaybe<UserGroupWhereInput>;
  disconnect?: InputMaybe<UserGroupWhereInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutChatMarkAsUnreadInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutChatMarkAsUnreadInput>;
};

export type UserGroupUpdateOneWithoutChatNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutChatInput>;
  create?: InputMaybe<UserGroupCreateWithoutChatInput>;
  delete?: InputMaybe<UserGroupWhereInput>;
  disconnect?: InputMaybe<UserGroupWhereInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutChatInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutChatInput>;
};

export type UserGroupUpdateOneWithoutClinicOrdersNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutClinicOrdersInput>;
  create?: InputMaybe<UserGroupCreateWithoutClinicOrdersInput>;
  delete?: InputMaybe<UserGroupWhereInput>;
  disconnect?: InputMaybe<UserGroupWhereInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutClinicOrdersInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutClinicOrdersInput>;
};

export type UserGroupUpdateOneWithoutGroupManagerNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutGroupManagerInput>;
  create?: InputMaybe<UserGroupCreateWithoutGroupManagerInput>;
  delete?: InputMaybe<UserGroupWhereInput>;
  disconnect?: InputMaybe<UserGroupWhereInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutGroupManagerInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutGroupManagerInput>;
};

export type UserGroupUpdateOneWithoutGroupMembersNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutGroupMembersInput>;
  create?: InputMaybe<UserGroupCreateWithoutGroupMembersInput>;
  delete?: InputMaybe<UserGroupWhereInput>;
  disconnect?: InputMaybe<UserGroupWhereInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutGroupMembersInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutGroupMembersInput>;
};

export type UserGroupUpdateOneWithoutProviderOrdersNestedInput = {
  connect?: InputMaybe<UserGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserGroupCreateOrConnectWithoutProviderOrdersInput>;
  create?: InputMaybe<UserGroupCreateWithoutProviderOrdersInput>;
  delete?: InputMaybe<UserGroupWhereInput>;
  disconnect?: InputMaybe<UserGroupWhereInput>;
  update?: InputMaybe<UserGroupUpdateToOneWithWhereWithoutProviderOrdersInput>;
  upsert?: InputMaybe<UserGroupUpsertWithoutProviderOrdersInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutAddressesInput = {
  data: UserGroupUpdateWithoutAddressesInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutAvailableClinicInput = {
  data: UserGroupUpdateWithoutAvailableClinicInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutAvailableMaterialTraceabilitiesInput = {
  data: UserGroupUpdateWithoutAvailableMaterialTraceabilitiesInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutAvailableProviderInput = {
  data: UserGroupUpdateWithoutAvailableProviderInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutChatInput = {
  data: UserGroupUpdateWithoutChatInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutChatMarkAsUnreadInput = {
  data: UserGroupUpdateWithoutChatMarkAsUnreadInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutClinicOrdersInput = {
  data: UserGroupUpdateWithoutClinicOrdersInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutGroupManagerInput = {
  data: UserGroupUpdateWithoutGroupManagerInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutGroupMembersInput = {
  data: UserGroupUpdateWithoutGroupMembersInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutProviderOrdersInput = {
  data: UserGroupUpdateWithoutProviderOrdersInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateToOneWithWhereWithoutShippingInput = {
  data: UserGroupUpdateWithoutShippingInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpdateWithWhereUniqueWithoutClientBillingInput = {
  data: UserGroupUpdateWithoutClientBillingInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupUpdateWithWhereUniqueWithoutCreatedByInput = {
  data: UserGroupUpdateWithoutCreatedByInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupUpdateWithoutAddressesInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutAvailableClinicInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutAvailableMaterialTraceabilitiesInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutAvailableProviderInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutChatInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutChatMarkAsUnreadInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutClientBillingInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutClinicOrdersInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutCreatedByInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutGroupManagerInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutGroupMembersInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutProviderOrdersInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  shipping?: InputMaybe<ShippingUpdateManyWithoutUserGroupNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpdateWithoutShippingInput = {
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadUpdateManyWithoutUserGroupNestedInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutUserGroupNestedInput>;
  availableClinic?: InputMaybe<ClinicProviderAccessUpdateManyWithoutProviderNestedInput>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityUpdateManyWithoutUserGroupNestedInput>;
  availableProvider?: InputMaybe<ClinicProviderAccessUpdateManyWithoutClinicNestedInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserGroupNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserGroupNestedInput>;
  clinicNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  clinicOrders?: InputMaybe<OrderUpdateManyWithoutUserGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<UserUpdateOneWithoutCreatedGroupNestedInput>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  displayPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  groupManager?: InputMaybe<UserUpdateOneWithoutManagedUserGroupNestedInput>;
  groupMembers?: InputMaybe<UserUpdateManyWithoutUserGroupNestedInput>;
  groupType?: InputMaybe<EnumUserGroupTypeFieldUpdateOperationsInput>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutUserGroupNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFieldUpdateOperationsInput>;
  providerOrders?: InputMaybe<OrderUpdateManyWithoutProviderNestedInput>;
  status?: InputMaybe<EnumUserGroupStatusFieldUpdateOperationsInput>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserGroupUpsertWithWhereUniqueWithoutClientBillingInput = {
  create: UserGroupCreateWithoutClientBillingInput;
  update: UserGroupUpdateWithoutClientBillingInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupUpsertWithWhereUniqueWithoutCreatedByInput = {
  create: UserGroupCreateWithoutCreatedByInput;
  update: UserGroupUpdateWithoutCreatedByInput;
  where: UserGroupWhereUniqueInput;
};

export type UserGroupUpsertWithoutAddressesInput = {
  create: UserGroupCreateWithoutAddressesInput;
  update: UserGroupUpdateWithoutAddressesInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutAvailableClinicInput = {
  create: UserGroupCreateWithoutAvailableClinicInput;
  update: UserGroupUpdateWithoutAvailableClinicInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutAvailableMaterialTraceabilitiesInput = {
  create: UserGroupCreateWithoutAvailableMaterialTraceabilitiesInput;
  update: UserGroupUpdateWithoutAvailableMaterialTraceabilitiesInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutAvailableProviderInput = {
  create: UserGroupCreateWithoutAvailableProviderInput;
  update: UserGroupUpdateWithoutAvailableProviderInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutChatInput = {
  create: UserGroupCreateWithoutChatInput;
  update: UserGroupUpdateWithoutChatInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutChatMarkAsUnreadInput = {
  create: UserGroupCreateWithoutChatMarkAsUnreadInput;
  update: UserGroupUpdateWithoutChatMarkAsUnreadInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutClinicOrdersInput = {
  create: UserGroupCreateWithoutClinicOrdersInput;
  update: UserGroupUpdateWithoutClinicOrdersInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutGroupManagerInput = {
  create: UserGroupCreateWithoutGroupManagerInput;
  update: UserGroupUpdateWithoutGroupManagerInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutGroupMembersInput = {
  create: UserGroupCreateWithoutGroupMembersInput;
  update: UserGroupUpdateWithoutGroupMembersInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutProviderOrdersInput = {
  create: UserGroupCreateWithoutProviderOrdersInput;
  update: UserGroupUpdateWithoutProviderOrdersInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupUpsertWithoutShippingInput = {
  create: UserGroupCreateWithoutShippingInput;
  update: UserGroupUpdateWithoutShippingInput;
  where?: InputMaybe<UserGroupWhereInput>;
};

export type UserGroupV2 = {
  __typename?: 'UserGroupV2';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: UserGroupTypeV2;
  users: Array<UserV2>;
};

export type UserGroupWhereInput = {
  AND?: InputMaybe<Array<UserGroupWhereInput>>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadListRelationFilter>;
  NOT?: InputMaybe<Array<UserGroupWhereInput>>;
  OR?: InputMaybe<Array<UserGroupWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  availableClinic?: InputMaybe<ClinicProviderAccessListRelationFilter>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityListRelationFilter>;
  availableProvider?: InputMaybe<ClinicProviderAccessListRelationFilter>;
  chat?: InputMaybe<ChatListRelationFilter>;
  clientBilling?: InputMaybe<ClientBillingNullableScalarRelationFilter>;
  clientBillingId?: InputMaybe<UuidNullableFilter>;
  clinicNumber?: InputMaybe<StringNullableFilter>;
  clinicOrders?: InputMaybe<OrderListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  displayPriority?: InputMaybe<IntNullableFilter>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFilter>;
  groupManager?: InputMaybe<UserNullableScalarRelationFilter>;
  groupManagerId?: InputMaybe<UuidNullableFilter>;
  groupMembers?: InputMaybe<UserListRelationFilter>;
  groupType?: InputMaybe<EnumUserGroupTypeFilter>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFilter>;
  providerOrders?: InputMaybe<OrderListRelationFilter>;
  shipping?: InputMaybe<ShippingListRelationFilter>;
  status?: InputMaybe<EnumUserGroupStatusFilter>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UserGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<UserGroupWhereInput>>;
  ChatMarkAsUnread?: InputMaybe<ChatMarkAsUnreadListRelationFilter>;
  NOT?: InputMaybe<Array<UserGroupWhereInput>>;
  OR?: InputMaybe<Array<UserGroupWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  availableClinic?: InputMaybe<ClinicProviderAccessListRelationFilter>;
  availableMaterialTraceabilities?: InputMaybe<ProviderMaterialTraceabilityListRelationFilter>;
  availableProvider?: InputMaybe<ClinicProviderAccessListRelationFilter>;
  chat?: InputMaybe<ChatListRelationFilter>;
  clientBilling?: InputMaybe<ClientBillingNullableScalarRelationFilter>;
  clientBillingId?: InputMaybe<UuidNullableFilter>;
  clinicNumber?: InputMaybe<StringNullableFilter>;
  clinicOrders?: InputMaybe<OrderListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<UserNullableScalarRelationFilter>;
  createdById?: InputMaybe<UuidNullableFilter>;
  deliveryCarrier?: InputMaybe<EnumCarrierTypeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  displayPriority?: InputMaybe<IntNullableFilter>;
  exemptOriginalAbutmentCharge?: InputMaybe<BoolFilter>;
  groupManager?: InputMaybe<UserNullableScalarRelationFilter>;
  groupManagerId?: InputMaybe<Scalars['String']['input']>;
  groupMembers?: InputMaybe<UserListRelationFilter>;
  groupType?: InputMaybe<EnumUserGroupTypeFilter>;
  hidePricesOnPractitionerTraceability?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  pickupCarrier?: InputMaybe<EnumCarrierTypeFilter>;
  providerOrders?: InputMaybe<OrderListRelationFilter>;
  shipping?: InputMaybe<ShippingListRelationFilter>;
  status?: InputMaybe<EnumUserGroupStatusFilter>;
  threeDModelPricingType?: InputMaybe<EnumThreeDModelPricingTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserNullableScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  addresses?: InputMaybe<AddressOrderByRelationAggregateInput>;
  allowPhysicalPrint?: InputMaybe<SortOrder>;
  allowedToEditProviderAccess?: InputMaybe<SortOrder>;
  chat?: InputMaybe<ChatOrderByRelationAggregateInput>;
  clientBilling?: InputMaybe<ClientBillingOrderByWithRelationInput>;
  clientBillingId?: InputMaybe<SortOrderInput>;
  communicateAccount?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdGroup?: InputMaybe<UserGroupOrderByRelationAggregateInput>;
  customDeliveryDateEnabled?: InputMaybe<SortOrder>;
  directConnectName?: InputMaybe<SortOrderInput>;
  directConnectPath?: InputMaybe<SortOrderInput>;
  dsCoreAccount?: InputMaybe<SortOrderInput>;
  email?: InputMaybe<SortOrder>;
  externalCase?: InputMaybe<ExternalCaseOrderByRelationAggregateInput>;
  files?: InputMaybe<FileOrderByRelationAggregateInput>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isManager?: InputMaybe<SortOrder>;
  isServer?: InputMaybe<SortOrder>;
  itemPrice?: InputMaybe<ItemPriceOrderByRelationAggregateInput>;
  lastName?: InputMaybe<SortOrder>;
  login?: InputMaybe<LoginOrderByRelationAggregateInput>;
  macAddressComputer?: InputMaybe<SortOrderInput>;
  managedUserGroup?: InputMaybe<UserGroupOrderByWithRelationInput>;
  meditAccount?: InputMaybe<SortOrderInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingOrderByRelationAggregateInput>;
  orderBillingUser?: InputMaybe<OrderBillingOrderByRelationAggregateInput>;
  orderHistory?: InputMaybe<OrderHistoryOrderByRelationAggregateInput>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  password?: InputMaybe<SortOrder>;
  patients?: InputMaybe<PatientOrderByRelationAggregateInput>;
  phoneNumber?: InputMaybe<SortOrder>;
  productPreferences?: InputMaybe<ProductPreferencesOrderByRelationAggregateInput>;
  role?: InputMaybe<SortOrder>;
  shining3dAccount?: InputMaybe<SortOrderInput>;
  shining3dDoctorId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userGroup?: InputMaybe<UserGroupOrderByWithRelationInput>;
  userGroupId?: InputMaybe<SortOrderInput>;
  userReference?: InputMaybe<SortOrderInput>;
  usernameComputer?: InputMaybe<SortOrderInput>;
};

export type UserProfileInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Staff = 'STAFF',
  User = 'USER'
}

export enum UserRoleV2 {
  Admin = 'ADMIN',
  Staff = 'STAFF',
  User = 'USER'
}

export enum UserScalarFieldEnum {
  AllowPhysicalPrint = 'allowPhysicalPrint',
  AllowedToEditProviderAccess = 'allowedToEditProviderAccess',
  ClientBillingId = 'clientBillingId',
  CommunicateAccount = 'communicateAccount',
  CreatedAt = 'createdAt',
  CustomDeliveryDateEnabled = 'customDeliveryDateEnabled',
  DirectConnectName = 'directConnectName',
  DirectConnectPath = 'directConnectPath',
  DsCoreAccount = 'dsCoreAccount',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  IsManager = 'isManager',
  IsServer = 'isServer',
  LastName = 'lastName',
  MacAddressComputer = 'macAddressComputer',
  MeditAccount = 'meditAccount',
  MustChangePassword = 'mustChangePassword',
  Password = 'password',
  PhoneNumber = 'phoneNumber',
  Role = 'role',
  Shining3dAccount = 'shining3dAccount',
  Shining3dDoctorId = 'shining3dDoctorId',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserGroupId = 'userGroupId',
  UserReference = 'userReference',
  UsernameComputer = 'usernameComputer'
}

export type UserScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  allowPhysicalPrint?: InputMaybe<BoolFilter>;
  allowedToEditProviderAccess?: InputMaybe<BoolFilter>;
  clientBillingId?: InputMaybe<UuidNullableFilter>;
  communicateAccount?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customDeliveryDateEnabled?: InputMaybe<BoolFilter>;
  directConnectName?: InputMaybe<StringNullableFilter>;
  directConnectPath?: InputMaybe<StringNullableFilter>;
  dsCoreAccount?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isManager?: InputMaybe<BoolFilter>;
  isServer?: InputMaybe<BoolFilter>;
  lastName?: InputMaybe<StringFilter>;
  macAddressComputer?: InputMaybe<StringNullableFilter>;
  meditAccount?: InputMaybe<StringNullableFilter>;
  password?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumUserRoleFilter>;
  shining3dAccount?: InputMaybe<StringNullableFilter>;
  shining3dDoctorId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumUserStatusFilter>;
  type?: InputMaybe<EnumUserTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userReference?: InputMaybe<StringNullableFilter>;
  usernameComputer?: InputMaybe<StringNullableFilter>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED'
}

export enum UserType {
  Dentist = 'DENTIST',
  Jasper = 'JASPER',
  Supplier = 'SUPPLIER'
}

export enum UserTypeV2 {
  Dentist = 'DENTIST',
  Jasper = 'JASPER',
  Supplier = 'SUPPLIER'
}

export type UserUpdateInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateManyMutationInput = {
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutClientBillingInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutUserGroupInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutClientBillingNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutClientBillingInput>>;
  create?: InputMaybe<Array<UserCreateWithoutClientBillingInput>>;
  createMany?: InputMaybe<UserCreateManyClientBillingInputEnvelope>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutClientBillingInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutClientBillingInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutClientBillingInput>>;
};

export type UserUpdateManyWithoutUserGroupNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutUserGroupInput>>;
  create?: InputMaybe<Array<UserCreateWithoutUserGroupInput>>;
  createMany?: InputMaybe<UserCreateManyUserGroupInputEnvelope>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutUserGroupInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutUserGroupInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutUserGroupInput>>;
};

export type UserUpdateOneRequiredWithoutOrderBillingUserNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderBillingUserInput>;
  create?: InputMaybe<UserCreateWithoutOrderBillingUserInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrderBillingUserInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrderBillingUserInput>;
};

export type UserUpdateOneRequiredWithoutOrdersNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<UserCreateWithoutOrdersInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrdersInput>;
};

export type UserUpdateOneRequiredWithoutPatientsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPatientsInput>;
  create?: InputMaybe<UserCreateWithoutPatientsInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutPatientsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPatientsInput>;
};

export type UserUpdateOneRequiredWithoutProductPreferencesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutProductPreferencesInput>;
  create?: InputMaybe<UserCreateWithoutProductPreferencesInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutProductPreferencesInput>;
  upsert?: InputMaybe<UserUpsertWithoutProductPreferencesInput>;
};

export type UserUpdateOneWithoutAddressesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<UserCreateWithoutAddressesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAddressesInput>;
  upsert?: InputMaybe<UserUpsertWithoutAddressesInput>;
};

export type UserUpdateOneWithoutChatNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutChatInput>;
  create?: InputMaybe<UserCreateWithoutChatInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutChatInput>;
  upsert?: InputMaybe<UserUpsertWithoutChatInput>;
};

export type UserUpdateOneWithoutCreatedGroupNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCreatedGroupInput>;
  create?: InputMaybe<UserCreateWithoutCreatedGroupInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutCreatedGroupInput>;
  upsert?: InputMaybe<UserUpsertWithoutCreatedGroupInput>;
};

export type UserUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserCreateWithoutFilesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutFilesInput>;
  upsert?: InputMaybe<UserUpsertWithoutFilesInput>;
};

export type UserUpdateOneWithoutItemPriceNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutItemPriceInput>;
  create?: InputMaybe<UserCreateWithoutItemPriceInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutItemPriceInput>;
  upsert?: InputMaybe<UserUpsertWithoutItemPriceInput>;
};

export type UserUpdateOneWithoutManagedUserGroupNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutManagedUserGroupInput>;
  create?: InputMaybe<UserCreateWithoutManagedUserGroupInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutManagedUserGroupInput>;
  upsert?: InputMaybe<UserUpsertWithoutManagedUserGroupInput>;
};

export type UserUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<UserCreateWithoutNotificationsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutNotificationsInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotificationsInput>;
};

export type UserUpdateOneWithoutOrderBillingManufacturerNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderBillingManufacturerInput>;
  create?: InputMaybe<UserCreateWithoutOrderBillingManufacturerInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrderBillingManufacturerInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrderBillingManufacturerInput>;
};

export type UserUpdateOneWithoutOrderHistoryNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutOrderHistoryInput>;
  create?: InputMaybe<UserCreateWithoutOrderHistoryInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutOrderHistoryInput>;
  upsert?: InputMaybe<UserUpsertWithoutOrderHistoryInput>;
};

export type UserUpdateToOneWithWhereWithoutAddressesInput = {
  data: UserUpdateWithoutAddressesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutChatInput = {
  data: UserUpdateWithoutChatInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutCreatedGroupInput = {
  data: UserUpdateWithoutCreatedGroupInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutFilesInput = {
  data: UserUpdateWithoutFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutItemPriceInput = {
  data: UserUpdateWithoutItemPriceInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutManagedUserGroupInput = {
  data: UserUpdateWithoutManagedUserGroupInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutNotificationsInput = {
  data: UserUpdateWithoutNotificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrderBillingManufacturerInput = {
  data: UserUpdateWithoutOrderBillingManufacturerInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrderBillingUserInput = {
  data: UserUpdateWithoutOrderBillingUserInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrderHistoryInput = {
  data: UserUpdateWithoutOrderHistoryInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutOrdersInput = {
  data: UserUpdateWithoutOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutPatientsInput = {
  data: UserUpdateWithoutPatientsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutProductPreferencesInput = {
  data: UserUpdateWithoutProductPreferencesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutClientBillingInput = {
  data: UserUpdateWithoutClientBillingInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutUserGroupInput = {
  data: UserUpdateWithoutUserGroupInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutAddressesInput = {
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutChatInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutClientBillingInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutCreatedGroupInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutFilesInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutItemPriceInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutManagedUserGroupInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutNotificationsInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutOrderBillingManufacturerInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutOrderBillingUserInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutOrderHistoryInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutOrdersInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutPatientsInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutProductPreferencesInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupMembersNestedInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateWithoutUserGroupInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutUserNestedInput>;
  allowPhysicalPrint?: InputMaybe<BoolFieldUpdateOperationsInput>;
  allowedToEditProviderAccess?: InputMaybe<BoolFieldUpdateOperationsInput>;
  chat?: InputMaybe<ChatUpdateManyWithoutUserNestedInput>;
  clientBilling?: InputMaybe<ClientBillingUpdateOneWithoutUserNestedInput>;
  communicateAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdGroup?: InputMaybe<UserGroupUpdateManyWithoutCreatedByNestedInput>;
  customDeliveryDateEnabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  directConnectName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  directConnectPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dsCoreAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  externalCase?: InputMaybe<ExternalCaseUpdateManyWithoutUserNestedInput>;
  files?: InputMaybe<FileUpdateManyWithoutUserNestedInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isManager?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isServer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemPrice?: InputMaybe<ItemPriceUpdateManyWithoutSupplierNestedInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  login?: InputMaybe<LoginUpdateManyWithoutUserNestedInput>;
  macAddressComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  managedUserGroup?: InputMaybe<UserGroupUpdateOneWithoutGroupManagerNestedInput>;
  meditAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderBillingManufacturer?: InputMaybe<OrderBillingUpdateManyWithoutProviderNestedInput>;
  orderBillingUser?: InputMaybe<OrderBillingUpdateManyWithoutUserNestedInput>;
  orderHistory?: InputMaybe<OrderHistoryUpdateManyWithoutUserNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutUserNestedInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  patients?: InputMaybe<PatientUpdateManyWithoutDentistNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPreferences?: InputMaybe<ProductPreferencesUpdateManyWithoutDentistNestedInput>;
  role?: InputMaybe<EnumUserRoleFieldUpdateOperationsInput>;
  shining3dAccount?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shining3dDoctorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumUserStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumUserTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  userReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameComputer?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpsertWithWhereUniqueWithoutClientBillingInput = {
  create: UserCreateWithoutClientBillingInput;
  update: UserUpdateWithoutClientBillingInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutUserGroupInput = {
  create: UserCreateWithoutUserGroupInput;
  update: UserUpdateWithoutUserGroupInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAddressesInput = {
  create: UserCreateWithoutAddressesInput;
  update: UserUpdateWithoutAddressesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutChatInput = {
  create: UserCreateWithoutChatInput;
  update: UserUpdateWithoutChatInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutCreatedGroupInput = {
  create: UserCreateWithoutCreatedGroupInput;
  update: UserUpdateWithoutCreatedGroupInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutFilesInput = {
  create: UserCreateWithoutFilesInput;
  update: UserUpdateWithoutFilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutItemPriceInput = {
  create: UserCreateWithoutItemPriceInput;
  update: UserUpdateWithoutItemPriceInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutManagedUserGroupInput = {
  create: UserCreateWithoutManagedUserGroupInput;
  update: UserUpdateWithoutManagedUserGroupInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutNotificationsInput = {
  create: UserCreateWithoutNotificationsInput;
  update: UserUpdateWithoutNotificationsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrderBillingManufacturerInput = {
  create: UserCreateWithoutOrderBillingManufacturerInput;
  update: UserUpdateWithoutOrderBillingManufacturerInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrderBillingUserInput = {
  create: UserCreateWithoutOrderBillingUserInput;
  update: UserUpdateWithoutOrderBillingUserInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrderHistoryInput = {
  create: UserCreateWithoutOrderHistoryInput;
  update: UserUpdateWithoutOrderHistoryInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutOrdersInput = {
  create: UserCreateWithoutOrdersInput;
  update: UserUpdateWithoutOrdersInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutPatientsInput = {
  create: UserCreateWithoutPatientsInput;
  update: UserUpdateWithoutPatientsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutProductPreferencesInput = {
  create: UserCreateWithoutProductPreferencesInput;
  update: UserUpdateWithoutProductPreferencesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserV2 = {
  __typename?: 'UserV2';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role: UserRoleV2;
  type: UserTypeV2;
  userGroup?: Maybe<UserGroupV2>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  allowPhysicalPrint?: InputMaybe<BoolFilter>;
  allowedToEditProviderAccess?: InputMaybe<BoolFilter>;
  chat?: InputMaybe<ChatListRelationFilter>;
  clientBilling?: InputMaybe<ClientBillingNullableScalarRelationFilter>;
  clientBillingId?: InputMaybe<UuidNullableFilter>;
  communicateAccount?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdGroup?: InputMaybe<UserGroupListRelationFilter>;
  customDeliveryDateEnabled?: InputMaybe<BoolFilter>;
  directConnectName?: InputMaybe<StringNullableFilter>;
  directConnectPath?: InputMaybe<StringNullableFilter>;
  dsCoreAccount?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  externalCase?: InputMaybe<ExternalCaseListRelationFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isManager?: InputMaybe<BoolFilter>;
  isServer?: InputMaybe<BoolFilter>;
  itemPrice?: InputMaybe<ItemPriceListRelationFilter>;
  lastName?: InputMaybe<StringFilter>;
  login?: InputMaybe<LoginListRelationFilter>;
  macAddressComputer?: InputMaybe<StringNullableFilter>;
  managedUserGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  meditAccount?: InputMaybe<StringNullableFilter>;
  orderBillingManufacturer?: InputMaybe<OrderBillingListRelationFilter>;
  orderBillingUser?: InputMaybe<OrderBillingListRelationFilter>;
  orderHistory?: InputMaybe<OrderHistoryListRelationFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  password?: InputMaybe<StringFilter>;
  patients?: InputMaybe<PatientListRelationFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  productPreferences?: InputMaybe<ProductPreferencesListRelationFilter>;
  role?: InputMaybe<EnumUserRoleFilter>;
  shining3dAccount?: InputMaybe<StringNullableFilter>;
  shining3dDoctorId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumUserStatusFilter>;
  type?: InputMaybe<EnumUserTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userReference?: InputMaybe<StringNullableFilter>;
  usernameComputer?: InputMaybe<StringNullableFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  allowPhysicalPrint?: InputMaybe<BoolFilter>;
  allowedToEditProviderAccess?: InputMaybe<BoolFilter>;
  chat?: InputMaybe<ChatListRelationFilter>;
  clientBilling?: InputMaybe<ClientBillingNullableScalarRelationFilter>;
  clientBillingId?: InputMaybe<UuidNullableFilter>;
  communicateAccount?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdGroup?: InputMaybe<UserGroupListRelationFilter>;
  customDeliveryDateEnabled?: InputMaybe<BoolFilter>;
  directConnectName?: InputMaybe<Scalars['String']['input']>;
  directConnectPath?: InputMaybe<StringNullableFilter>;
  dsCoreAccount?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalCase?: InputMaybe<ExternalCaseListRelationFilter>;
  files?: InputMaybe<FileListRelationFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<BoolFilter>;
  isServer?: InputMaybe<BoolFilter>;
  itemPrice?: InputMaybe<ItemPriceListRelationFilter>;
  lastName?: InputMaybe<StringFilter>;
  login?: InputMaybe<LoginListRelationFilter>;
  macAddressComputer?: InputMaybe<Scalars['String']['input']>;
  managedUserGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  meditAccount?: InputMaybe<Scalars['String']['input']>;
  orderBillingManufacturer?: InputMaybe<OrderBillingListRelationFilter>;
  orderBillingUser?: InputMaybe<OrderBillingListRelationFilter>;
  orderHistory?: InputMaybe<OrderHistoryListRelationFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  password?: InputMaybe<StringFilter>;
  patients?: InputMaybe<PatientListRelationFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  productPreferences?: InputMaybe<ProductPreferencesListRelationFilter>;
  role?: InputMaybe<EnumUserRoleFilter>;
  shining3dAccount?: InputMaybe<Scalars['String']['input']>;
  shining3dDoctorId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumUserStatusFilter>;
  type?: InputMaybe<EnumUserTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userGroup?: InputMaybe<UserGroupNullableScalarRelationFilter>;
  userGroupId?: InputMaybe<UuidNullableFilter>;
  userReference?: InputMaybe<Scalars['String']['input']>;
  usernameComputer?: InputMaybe<Scalars['String']['input']>;
};

export type UuidFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UuidNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedUuidNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum WaxUpTypeV2 {
  Numerical = 'NUMERICAL',
  Physical = 'PHYSICAL'
}

export enum WorkflowType {
  OneAppointmentDirect = 'ONE_APPOINTMENT_DIRECT',
  WaxRim = 'WAX_RIM',
  WithFitting = 'WITH_FITTING'
}

export enum WaxUpType {
  Numerical = 'NUMERICAL',
  NumericalAndPhysical = 'NUMERICAL_AND_PHYSICAL',
  Physical = 'PHYSICAL'
}

export type GetAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalyticsQuery = { __typename?: 'Query', getAnalytics: { __typename?: 'GET_ANALYTICS_DTO', orderByWeek: Array<{ __typename?: 'OrderByWeek', week: string, total: number }>, orderByMonth: Array<{ __typename?: 'OrderByMonth', month: string, total: number }> } };

export type SendMessageMutationVariables = Exact<{
  args: ChatCreateInput;
  supplier: Scalars['String']['input'];
  olderChatRead: Scalars['Boolean']['input'];
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'Chat', id: string, createdAt: any, orderId: string, updatedAt: any, userGroupId?: string | null, message: string, files?: Array<{ __typename?: 'File', id: string }> | null, userGroup?: { __typename?: 'UserGroup', name: string, groupType: UserGroupType, id: string } | null, user?: { __typename?: 'User', firstName: string } | null } };

export type GetAllChatsOfOrderQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatWhereInput>;
}>;


export type GetAllChatsOfOrderQuery = { __typename?: 'Query', getAllChatsOfOrder: { __typename?: 'ChatResponse', count: number, notification: Array<{ __typename?: 'Chat', createdAt: any, id: string, orderId: string, userGroupId?: string | null, message: string, read: boolean, isNotification: boolean, files?: Array<{ __typename?: 'File', fileType: FileType, key: string, keyCompressed?: string | null, createdAt: any, userId?: string | null, orderId?: string | null }> | null, userGroup?: { __typename?: 'UserGroup', name: string, groupType: UserGroupType, id: string } | null, user?: { __typename?: 'User', firstName: string } | null }> } };

export type GetLastUnreadOfEachOrderQueryVariables = Exact<{
  args: ChatInput;
}>;


export type GetLastUnreadOfEachOrderQuery = { __typename?: 'Query', getLastUnreadOfEachOrder?: { __typename?: 'ChatResponse', count: number, notification: Array<{ __typename?: 'Chat', id: string, createdAt: any, message: string, read: boolean, userGroup?: { __typename?: 'UserGroup', name: string, groupType: UserGroupType, id: string } | null, user?: { __typename?: 'User', firstName: string } | null, order?: { __typename?: 'Order', orderReference: string, id: string, status: OrderStatus, patient?: { __typename?: 'Patient', firstName: string, lastName: string } | null, provider?: { __typename?: 'UserGroup', id: string } | null } | null, files?: Array<{ __typename?: 'File', key: string }> | null }> } | null };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  data: ChatUpdateManyMutationInput;
  where: ChatWhereInput;
  supplier: Scalars['String']['input'];
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead: boolean };

export type MarkMessagesOfChatAsReadMutationVariables = Exact<{
  data: ChatUpdateManyMutationInput;
  where: ChatWhereInput;
  supplier: Scalars['String']['input'];
}>;


export type MarkMessagesOfChatAsReadMutation = { __typename?: 'Mutation', markMessagesOfChatAsRead: boolean };

export type MarkLastMessageAsUnreadMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  supplier: Scalars['String']['input'];
}>;


export type MarkLastMessageAsUnreadMutation = { __typename?: 'Mutation', markLastMessageAsUnread: boolean };

export type GetDesignReviewNotificationsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDesignReviewNotificationsQuery = { __typename?: 'Query', getDesignReviewNotifications: { __typename?: 'DesignReviewNotificationsResponse', totalCount: number, notifications: Array<{ __typename?: 'DesignReviewNotification', id: string, orderDesignId: string, orderId?: string | null, orderReference?: string | null, patientName?: string | null, status?: string | null, doctorName?: string | null, providerName?: string | null, isRead: boolean, createdAt: any }> } };

export type MarkDesignReviewNotificationAsReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkDesignReviewNotificationAsReadMutation = { __typename?: 'Mutation', markDesignReviewNotificationAsRead: boolean };

export type MarkDesignReviewNotificationAsUnreadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkDesignReviewNotificationAsUnreadMutation = { __typename?: 'Mutation', markDesignReviewNotificationAsUnread: boolean };

export type DsCoreAuthorizationUrlQueryVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  codeChallenge: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;


export type DsCoreAuthorizationUrlQuery = { __typename?: 'Query', dsCoreAuthorizationUrl: string };

export type RegenerateDsCoreTokensMutationVariables = Exact<{
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;


export type RegenerateDsCoreTokensMutation = { __typename?: 'Mutation', regenerateDsCoreTokens: boolean };

export type MarkFileAsReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkFileAsReadMutation = { __typename?: 'Mutation', markFileAsRead: boolean };

export type GetUserGroupsWhereQueryVariables = Exact<{
  where?: InputMaybe<UserGroupWhereInput>;
}>;


export type GetUserGroupsWhereQuery = { __typename?: 'Query', getUserGroupsWhere: Array<{ __typename?: 'UserGroup', id: string, name: string }> };

export type GetAllGroupsQueryVariables = Exact<{
  where?: InputMaybe<UserGroupWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupOrderByWithRelationInput> | UserGroupOrderByWithRelationInput>;
}>;


export type GetAllGroupsQuery = { __typename?: 'Query', getAllGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> };

export type GetUserGroupsWhereUniqueQueryVariables = Exact<{
  where: UserGroupWhereUniqueInput;
}>;


export type GetUserGroupsWhereUniqueQuery = { __typename?: 'Query', getUserGroupsWhereUnique: { __typename?: 'UserGroup', id: string, name: string, groupType: UserGroupType, status: UserGroupStatus, clinicNumber?: string | null, pickupCarrier: CarrierType, deliveryCarrier: CarrierType, phoneNumber: string, description?: string | null, threeDModelPricingType: ThreeDModelPricingType, exemptOriginalAbutmentCharge: boolean, hidePricesOnPractitionerTraceability: boolean, createdBy?: { __typename?: 'User', firstName: string, lastName: string } | null, clientBilling?: { __typename?: 'ClientBilling', id: string, pricingType: PricingType } | null, availableProvider?: Array<{ __typename?: 'ClinicProviderAccess', id: string, provider: { __typename?: 'UserGroup', id: string, name: string } }> | null, groupMembers?: Array<{ __typename?: 'User', email: string, firstName: string, lastName: string, id: string, isManager: boolean }> | null, addresses?: Array<{ __typename?: 'Address', city: string, name: string, country?: string | null, id: string, streetName: string, streetNumber?: string | null, details?: string | null, postcode: string }> | null } };

export type CreateUserGroupMutationVariables = Exact<{
  args: UserGroupCreateInput;
  providerGroupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutation', createUserGroup: { __typename?: 'UserGroup', id: string } };

export type UpdateUserGroupMutationVariables = Exact<{
  data: UserGroupUpdateInput;
  where: UserGroupWhereUniqueInput;
  providerGroupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateUserGroupMutation = { __typename?: 'Mutation', updateUserGroup: { __typename?: 'UserGroup', id: string } };

export type CheckBipConfigurationQueryVariables = Exact<{
  clinicNumber: Scalars['String']['input'];
}>;


export type CheckBipConfigurationQuery = { __typename?: 'Query', checkBipConfiguration: boolean };

export type GetHelpMsgSliceByOrderQueryVariables = Exact<{
  args: HelpMessageInput;
}>;


export type GetHelpMsgSliceByOrderQuery = { __typename?: 'Query', getHelpMsgSliceByOrder: { __typename?: 'HelpMessageResponse', count: number, notification: Array<{ __typename?: 'OrderComment', id: string, createdAt: any, comment: string, read: boolean, order: { __typename?: 'Order', orderReference: string, id: string, status: OrderStatus, patient?: { __typename?: 'Patient', firstName: string, lastName: string } | null }, files?: Array<{ __typename?: 'File', key: string }> | null }> } };

export type GetNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationCountQuery = { __typename?: 'Query', getNotificationCount?: { __typename?: 'NotificationResponse', helpNotification: number, chatNotification: number, orderDesignNotification: number, designReviewNotification: number } | null };

export type MarkHelpMessagesAsReadMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type MarkHelpMessagesAsReadMutation = { __typename?: 'Mutation', markHelpMessagesAsRead: boolean };

export type CreateAnatomyItemMutationVariables = Exact<{
  args: AnatomyItemCreateInput;
}>;


export type CreateAnatomyItemMutation = { __typename?: 'Mutation', createAnatomyItem: { __typename?: 'AnatomyItem', id: string } };

export type DeleteManyAnatomyItemMutationVariables = Exact<{
  where?: InputMaybe<AnatomyItemWhereInput>;
}>;


export type DeleteManyAnatomyItemMutation = { __typename?: 'Mutation', deleteManyAnatomyItem: boolean };

export type UpdateAnatomyItemMutationVariables = Exact<{
  data: AnatomyItemUpdateInput;
  where: AnatomyItemWhereUniqueInput;
}>;


export type UpdateAnatomyItemMutation = { __typename?: 'Mutation', updateAnatomyItem: { __typename?: 'AnatomyItem', id: string } };

export type CreateRemovableItemMutationVariables = Exact<{
  args: RemovableItemCreateInput;
}>;


export type CreateRemovableItemMutation = { __typename?: 'Mutation', createRemovableItem: { __typename?: 'RemovableItem', id: string } };

export type DeleteManyRemovableItemMutationVariables = Exact<{
  where?: InputMaybe<RemovableItemWhereInput>;
}>;


export type DeleteManyRemovableItemMutation = { __typename?: 'Mutation', deleteManyRemovableItems: boolean };

export type UpdateRemovableItemMutationVariables = Exact<{
  data: RemovableItemUpdateInput;
  where: RemovableItemWhereUniqueInput;
}>;


export type UpdateRemovableItemMutation = { __typename?: 'Mutation', updateRemovableItem: { __typename?: 'RemovableItem', id: string } };

export type GetAllImplantReferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllImplantReferencesQuery = { __typename?: 'Query', getAllImplantReferences: Array<{ __typename?: 'ImplantReference', id: string, label: string }> };

export type CreateImplantItemMutationVariables = Exact<{
  args: ImplantItemCreateInput;
}>;


export type CreateImplantItemMutation = { __typename?: 'Mutation', createImplantItem: { __typename?: 'ImplantItem', id: string } };

export type DeleteManyImplantItemMutationVariables = Exact<{
  where?: InputMaybe<ImplantItemWhereInput>;
}>;


export type DeleteManyImplantItemMutation = { __typename?: 'Mutation', deleteManyImplantItem: boolean };

export type UpdateImplantItemMutationVariables = Exact<{
  data: ImplantItemUpdateInput;
  where: ImplantItemWhereUniqueInput;
}>;


export type UpdateImplantItemMutation = { __typename?: 'Mutation', updateImplantItem: { __typename?: 'ImplantItem', id: string } };

export type GetAllItemMaterialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllItemMaterialsQuery = { __typename?: 'Query', getAllItemMaterials: Array<{ __typename?: 'ItemMaterial', id: string, label: string, crown: boolean }> };

export type GetCountNumberOfNewCasesForStaffQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
}>;


export type GetCountNumberOfNewCasesForStaffQuery = { __typename?: 'Query', getAllOrdersForStaff: { __typename?: 'OrderResponse', totalCount: number } };

export type GetAllOrdersForStaffQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllOrdersForStaffQuery = { __typename?: 'Query', getAllOrdersForStaff: { __typename?: 'OrderResponse', totalCount: number, orders: Array<{ __typename?: 'Order', id: string, orderReference: string, isRush: boolean, comment?: string | null, deliveryDate?: any | null, lastShippingDate?: any | null, status: OrderStatus, updatedAt: any, createdAt: any, isPhysicalPrint: boolean, patientId?: string | null, userId: string, addressId?: string | null, providerGroupId?: string | null, integrationType?: IntegrationType | null, provider?: { __typename?: 'UserGroup', id: string, name: string } | null, patient?: { __typename?: 'Patient', firstName: string, lastName: string } | null, files?: Array<{ __typename?: 'File', id: string, fileType: FileType, read: boolean }> | null, user: { __typename?: 'User', lastName: string, firstName: string }, redo?: Array<{ __typename?: 'Redo', id: string }> | null, orderComment?: Array<{ __typename?: 'OrderComment', translatedComment?: string | null, comment: string }> | null, products?: Array<{ __typename?: 'Product', productType: ItemType, implantItem?: Array<{ __typename?: 'ImplantItem', itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, itemShade?: { __typename?: 'ItemShade', id: string, label: string } | null }> | null, anatomyItem?: Array<{ __typename?: 'AnatomyItem', inlayCoreScanPost?: string | null, itemShade?: { __typename?: 'ItemShade', id: string, label: string } | null, itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, inlayCoreMaterial?: { __typename?: 'ItemMaterial', label: string } | null }> | null, removableItem?: Array<{ __typename?: 'RemovableItem', itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, teethShade?: { __typename?: 'ItemShade', id: string, label: string } | null, gingivaShade?: { __typename?: 'ItemShade', id: string, label: string } | null }> | null }> | null }> } };

export type GetOrdersShippedBackToChinaQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
}>;


export type GetOrdersShippedBackToChinaQuery = { __typename?: 'Query', getAllOrdersForStaff: { __typename?: 'OrderResponse', totalCount: number, orders: Array<{ __typename?: 'Order', id: string, orderReference: string, shippedBackToProviderDate?: any | null }> } };

export type CreateProductManualMutationVariables = Exact<{
  args: ProductCreateInput;
  omitItems?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateProductManualMutation = { __typename?: 'Mutation', createProductManual: { __typename?: 'Product', id: string, orderId: string, productType: ItemType, teeth?: any | null, itemPreferences?: any | null, hasIndividualItemCaracteristics: boolean, createdAt: any, implantItem?: Array<{ __typename?: 'ImplantItem', id: string, itemType?: ItemType | null, teeth?: any | null, abutmentType?: AbutmentType | null, implantPlatform?: string | null, retentionType?: RetentionType | null, scanBodySuggestion?: string | null, standardAbutmentSuggestion?: string | null, implantReferenceSuggestion?: string | null, teethshadeType: TeethShadeType, itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, itemShade?: { __typename?: 'ItemShade', id: string, label: string } | null, itemBilling?: Array<{ __typename?: 'ItemBilling', firstMaterialLotNumber?: string | null, firstMaterialTraceabilityId?: string | null, secondMaterialLotNumber?: string | null, id: string }> | null, abutmentMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, implantReference?: { __typename?: 'ImplantReference', brand: string, label: string, id: string, platforms?: Array<string> | null } | null, multiShadeInfo?: Array<{ __typename?: 'MultiShadeInfo', id: string, teethShadeSide: TeethShadeSide, itemShade: { __typename?: 'ItemShade', id: string, label: string, shadeType?: ItemShadeType | null } }> | null }> | null, anatomyItem?: Array<{ __typename?: 'AnatomyItem', id: string, itemType?: ItemType | null, teeth?: any | null, inlayCoreHasClavette?: boolean | null, inlayCoreScanPost?: string | null, teethshadeType: TeethShadeType, itemShade?: { __typename?: 'ItemShade', id: string, label: string } | null, itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, inlayCoreMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, itemBilling?: Array<{ __typename?: 'ItemBilling', firstMaterialLotNumber?: string | null, secondMaterialLotNumber?: string | null, firstMaterialTraceabilityId?: string | null, id: string }> | null, multiShadeInfo?: Array<{ __typename?: 'MultiShadeInfo', teethShadeSide: TeethShadeSide, itemShade: { __typename?: 'ItemShade', id: string, shadeType?: ItemShadeType | null, label: string } }> | null }> | null, removableItem?: Array<{ __typename?: 'RemovableItem', id: string, itemType?: ItemType | null, teeth?: any | null, teethToManufacture?: Array<number> | null, workflowType?: WorkflowType | null, dentistNotes?: string | null, isReplacement: boolean, waxUpType?: WaxUpType | null, fullDentureOrderType?: RemovableItemOrderType | null, partialDentureOrderType?: RemovableItemOrderType | null, imprintType?: ImprintType | null, rdvNumber?: number | null, rdv2Choice?: string | null, returnMethod?: string | null, itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, teethShade?: { __typename?: 'ItemShade', id: string, label: string } | null, gingivaShade?: { __typename?: 'ItemShade', id: string, label: string } | null, itemBilling?: Array<{ __typename?: 'ItemBilling', firstMaterialLotNumber?: string | null, firstMaterialTraceabilityId?: string | null, secondMaterialLotNumber?: string | null, id: string }> | null, partialDenture?: { __typename?: 'PartialDenture', id: string, missingTeeth?: Array<number> | null, palatalMetalBand: boolean, metalMesh: boolean, lingualMetalBand: boolean, customTray: boolean, hooks?: Array<{ __typename?: 'PartialDentureHook', id: string, hooksPosition?: Array<number> | null, hooksMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null }> | null } | null }> | null } };

export type DeleteManyProductMutationVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
}>;


export type DeleteManyProductMutation = { __typename?: 'Mutation', deleteManyProduct: boolean };

export type UpdateProductMutationVariables = Exact<{
  data: ProductUpdateInput;
  where: ProductWhereUniqueInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, orderId: string, productType: ItemType, teeth?: any | null, itemPreferences?: any | null, hasIndividualItemCaracteristics: boolean, createdAt: any, implantItem?: Array<{ __typename?: 'ImplantItem', id: string, itemType?: ItemType | null, teeth?: any | null, abutmentType?: AbutmentType | null, implantPlatform?: string | null, retentionType?: RetentionType | null, scanBodySuggestion?: string | null, standardAbutmentSuggestion?: string | null, implantReferenceSuggestion?: string | null, teethshadeType: TeethShadeType, itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, itemShade?: { __typename?: 'ItemShade', id: string, label: string } | null, itemBilling?: Array<{ __typename?: 'ItemBilling', firstMaterialLotNumber?: string | null, firstMaterialTraceabilityId?: string | null, secondMaterialLotNumber?: string | null, id: string }> | null, abutmentMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, implantReference?: { __typename?: 'ImplantReference', brand: string, label: string, id: string, platforms?: Array<string> | null } | null, multiShadeInfo?: Array<{ __typename?: 'MultiShadeInfo', id: string, teethShadeSide: TeethShadeSide, itemShade: { __typename?: 'ItemShade', id: string, label: string, shadeType?: ItemShadeType | null } }> | null }> | null, anatomyItem?: Array<{ __typename?: 'AnatomyItem', id: string, itemType?: ItemType | null, teeth?: any | null, inlayCoreHasClavette?: boolean | null, inlayCoreScanPost?: string | null, teethshadeType: TeethShadeType, itemShade?: { __typename?: 'ItemShade', id: string, label: string } | null, itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, inlayCoreMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, itemBilling?: Array<{ __typename?: 'ItemBilling', firstMaterialLotNumber?: string | null, secondMaterialLotNumber?: string | null, firstMaterialTraceabilityId?: string | null, id: string }> | null, multiShadeInfo?: Array<{ __typename?: 'MultiShadeInfo', teethShadeSide: TeethShadeSide, itemShade: { __typename?: 'ItemShade', id: string, shadeType?: ItemShadeType | null, label: string } }> | null }> | null, removableItem?: Array<{ __typename?: 'RemovableItem', id: string, itemType?: ItemType | null, teeth?: any | null, teethToManufacture?: Array<number> | null, workflowType?: WorkflowType | null, dentistNotes?: string | null, isReplacement: boolean, waxUpType?: WaxUpType | null, fullDentureOrderType?: RemovableItemOrderType | null, partialDentureOrderType?: RemovableItemOrderType | null, imprintType?: ImprintType | null, rdvNumber?: number | null, rdv2Choice?: string | null, returnMethod?: string | null, itemMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null, teethShade?: { __typename?: 'ItemShade', id: string, label: string } | null, gingivaShade?: { __typename?: 'ItemShade', id: string, label: string } | null, itemBilling?: Array<{ __typename?: 'ItemBilling', firstMaterialLotNumber?: string | null, firstMaterialTraceabilityId?: string | null, secondMaterialLotNumber?: string | null, id: string }> | null, partialDenture?: { __typename?: 'PartialDenture', id: string, missingTeeth?: Array<number> | null, palatalMetalBand: boolean, metalMesh: boolean, lingualMetalBand: boolean, customTray: boolean, hooks?: Array<{ __typename?: 'PartialDentureHook', id: string, hooksPosition?: Array<number> | null, hooksMaterial?: { __typename?: 'ItemMaterial', id: string, label: string } | null }> | null } | null }> | null } };

export type UpdateAllItemTeethOfProductMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  teeth: Scalars['String']['input'];
}>;


export type UpdateAllItemTeethOfProductMutation = { __typename?: 'Mutation', updateAllItemTeethOfProduct: boolean };

export type QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuery = { __typename?: 'Query', getScanPostsData: any };

export type GetAllItemShadesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllItemShadesQuery = { __typename?: 'Query', getAllItemShades: Array<{ __typename?: 'ItemShade', id: string, label: string, gingiva: boolean, crown: boolean }> };

export type RegenerateThreeshapeTokensMutationVariables = Exact<{
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;


export type RegenerateThreeshapeTokensMutation = { __typename?: 'Mutation', regenerateThreeshapeTokens: boolean };

export type SyncThreeshapeOrdersMutationVariables = Exact<{
  fromDate: Scalars['Timestamp']['input'];
  toDate: Scalars['Timestamp']['input'];
}>;


export type SyncThreeshapeOrdersMutation = { __typename?: 'Mutation', syncExternalCasesFrom3Shape: Array<{ __typename?: 'ExternalCase', id: string }> };

export type MutationMutationVariables = Exact<{
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
}>;


export type MutationMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };


export const GetAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnalytics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAnalytics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderByWeek"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"week"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderByMonth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetAnalyticsQuery, GetAnalyticsQueryVariables>;
export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"olderChatRead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}}},{"kind":"Argument","name":{"kind":"Name","value":"olderChatRead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"olderChatRead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const GetAllChatsOfOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllChatsOfOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllChatsOfOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"keyCompressed"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"isNotification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetAllChatsOfOrderQuery, GetAllChatsOfOrderQueryVariables>;
export const GetLastUnreadOfEachOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastUnreadOfEachOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLastUnreadOfEachOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"read"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetLastUnreadOfEachOrderQuery, GetLastUnreadOfEachOrderQueryVariables>;
export const MarkNotificationsAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationsAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatUpdateManyMutationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationsAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}}}]}]}}]} as unknown as DocumentNode<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const MarkMessagesOfChatAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkMessagesOfChatAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatUpdateManyMutationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markMessagesOfChatAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}}}]}]}}]} as unknown as DocumentNode<MarkMessagesOfChatAsReadMutation, MarkMessagesOfChatAsReadMutationVariables>;
export const MarkLastMessageAsUnreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkLastMessageAsUnread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markLastMessageAsUnread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier"}}}]}]}}]} as unknown as DocumentNode<MarkLastMessageAsUnreadMutation, MarkLastMessageAsUnreadMutationVariables>;
export const GetDesignReviewNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDesignReviewNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showRead"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDesignReviewNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"showRead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showRead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderDesignId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"doctorName"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetDesignReviewNotificationsQuery, GetDesignReviewNotificationsQueryVariables>;
export const MarkDesignReviewNotificationAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkDesignReviewNotificationAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markDesignReviewNotificationAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<MarkDesignReviewNotificationAsReadMutation, MarkDesignReviewNotificationAsReadMutationVariables>;
export const MarkDesignReviewNotificationAsUnreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkDesignReviewNotificationAsUnread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markDesignReviewNotificationAsUnread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<MarkDesignReviewNotificationAsUnreadMutation, MarkDesignReviewNotificationAsUnreadMutationVariables>;
export const DsCoreAuthorizationUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DsCoreAuthorizationUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeChallenge"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dsCoreAuthorizationUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"redirectUri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}}},{"kind":"Argument","name":{"kind":"Name","value":"codeChallenge"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeChallenge"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}]}}]} as unknown as DocumentNode<DsCoreAuthorizationUrlQuery, DsCoreAuthorizationUrlQueryVariables>;
export const RegenerateDsCoreTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegenerateDsCoreTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeVerifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regenerateDsCoreTokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"codeVerifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeVerifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}}}]}]}}]} as unknown as DocumentNode<RegenerateDsCoreTokensMutation, RegenerateDsCoreTokensMutationVariables>;
export const MarkFileAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markFileAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markFileAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<MarkFileAsReadMutation, MarkFileAsReadMutationVariables>;
export const GetUserGroupsWhereDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserGroupsWhere"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserGroupsWhere"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUserGroupsWhereQuery, GetUserGroupsWhereQueryVariables>;
export const GetAllGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAllGroupsQuery, GetAllGroupsQueryVariables>;
export const GetUserGroupsWhereUniqueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserGroupsWhereUnique"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserGroupsWhereUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"clinicNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pickupCarrier"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryCarrier"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"threeDModelPricingType"}},{"kind":"Field","name":{"kind":"Name","value":"exemptOriginalAbutmentCharge"}},{"kind":"Field","name":{"kind":"Name","value":"hidePricesOnPractitionerTraceability"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isManager"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"streetNumber"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserGroupsWhereUniqueQuery, GetUserGroupsWhereUniqueQueryVariables>;
export const CreateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}},{"kind":"Argument","name":{"kind":"Name","value":"providerGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const UpdateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"providerGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerGroupIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const CheckBipConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckBipConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkBipConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicNumber"}}}]}]}}]} as unknown as DocumentNode<CheckBipConfigurationQuery, CheckBipConfigurationQueryVariables>;
export const GetHelpMsgSliceByOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHelpMsgSliceByOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HelpMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHelpMsgSliceByOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"read"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<GetHelpMsgSliceByOrderQuery, GetHelpMsgSliceByOrderQueryVariables>;
export const GetNotificationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotificationCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpNotification"}},{"kind":"Field","name":{"kind":"Name","value":"chatNotification"}},{"kind":"Field","name":{"kind":"Name","value":"orderDesignNotification"}},{"kind":"Field","name":{"kind":"Name","value":"designReviewNotification"}}]}}]}}]} as unknown as DocumentNode<GetNotificationCountQuery, GetNotificationCountQueryVariables>;
export const MarkHelpMessagesAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkHelpMessagesAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markHelpMessagesAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}]}}]} as unknown as DocumentNode<MarkHelpMessagesAsReadMutation, MarkHelpMessagesAsReadMutationVariables>;
export const CreateAnatomyItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnatomyItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnatomyItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnatomyItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAnatomyItemMutation, CreateAnatomyItemMutationVariables>;
export const DeleteManyAnatomyItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyAnatomyItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnatomyItemWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyAnatomyItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<DeleteManyAnatomyItemMutation, DeleteManyAnatomyItemMutationVariables>;
export const UpdateAnatomyItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAnatomyItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnatomyItemUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnatomyItemWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnatomyItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAnatomyItemMutation, UpdateAnatomyItemMutationVariables>;
export const CreateRemovableItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRemovableItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovableItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRemovableItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRemovableItemMutation, CreateRemovableItemMutationVariables>;
export const DeleteManyRemovableItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyRemovableItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovableItemWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyRemovableItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<DeleteManyRemovableItemMutation, DeleteManyRemovableItemMutationVariables>;
export const UpdateRemovableItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRemovableItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovableItemUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemovableItemWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRemovableItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateRemovableItemMutation, UpdateRemovableItemMutationVariables>;
export const GetAllImplantReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllImplantReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllImplantReferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetAllImplantReferencesQuery, GetAllImplantReferencesQueryVariables>;
export const CreateImplantItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateImplantItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImplantItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createImplantItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateImplantItemMutation, CreateImplantItemMutationVariables>;
export const DeleteManyImplantItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyImplantItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImplantItemWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyImplantItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<DeleteManyImplantItemMutation, DeleteManyImplantItemMutationVariables>;
export const UpdateImplantItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateImplantItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImplantItemUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImplantItemWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateImplantItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateImplantItemMutation, UpdateImplantItemMutationVariables>;
export const GetAllItemMaterialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllItemMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllItemMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"crown"}}]}}]}}]} as unknown as DocumentNode<GetAllItemMaterialsQuery, GetAllItemMaterialsQueryVariables>;
export const GetCountNumberOfNewCasesForStaffDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountNumberOfNewCasesForStaff"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllOrdersForStaff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetCountNumberOfNewCasesForStaffQuery, GetCountNumberOfNewCasesForStaffQueryVariables>;
export const GetAllOrdersForStaffDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllOrdersForStaff"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllOrdersForStaff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"isRush"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastShippingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isPhysicalPrint"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"providerGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"read"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"redo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderComment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedComment"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"implantItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anatomyItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreScanPost"}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"removableItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teethShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gingivaShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAllOrdersForStaffQuery, GetAllOrdersForStaffQueryVariables>;
export const GetOrdersShippedBackToChinaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrdersShippedBackToChina"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllOrdersForStaff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"shippedBackToProviderDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetOrdersShippedBackToChinaQuery, GetOrdersShippedBackToChinaQueryVariables>;
export const CreateProductManualDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProductManual"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"omitItems"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProductManual"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}},{"kind":"Argument","name":{"kind":"Name","value":"omitItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"omitItems"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"itemPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"hasIndividualItemCaracteristics"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"implantItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstMaterialTraceabilityId"}},{"kind":"Field","name":{"kind":"Name","value":"secondMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abutmentMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abutmentType"}},{"kind":"Field","name":{"kind":"Name","value":"implantPlatform"}},{"kind":"Field","name":{"kind":"Name","value":"implantReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"platforms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retentionType"}},{"kind":"Field","name":{"kind":"Name","value":"scanBodySuggestion"}},{"kind":"Field","name":{"kind":"Name","value":"standardAbutmentSuggestion"}},{"kind":"Field","name":{"kind":"Name","value":"implantReferenceSuggestion"}},{"kind":"Field","name":{"kind":"Name","value":"teethshadeType"}},{"kind":"Field","name":{"kind":"Name","value":"multiShadeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teethShadeSide"}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"shadeType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anatomyItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreHasClavette"}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreScanPost"}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"secondMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstMaterialTraceabilityId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teethshadeType"}},{"kind":"Field","name":{"kind":"Name","value":"multiShadeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teethShadeSide"}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shadeType"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"removableItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"teethToManufacture"}},{"kind":"Field","name":{"kind":"Name","value":"workflowType"}},{"kind":"Field","name":{"kind":"Name","value":"dentistNotes"}},{"kind":"Field","name":{"kind":"Name","value":"isReplacement"}},{"kind":"Field","name":{"kind":"Name","value":"waxUpType"}},{"kind":"Field","name":{"kind":"Name","value":"fullDentureOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"partialDentureOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"imprintType"}},{"kind":"Field","name":{"kind":"Name","value":"rdvNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rdv2Choice"}},{"kind":"Field","name":{"kind":"Name","value":"returnMethod"}},{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teethShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gingivaShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstMaterialTraceabilityId"}},{"kind":"Field","name":{"kind":"Name","value":"secondMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partialDenture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"missingTeeth"}},{"kind":"Field","name":{"kind":"Name","value":"hooks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hooksMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hooksPosition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"palatalMetalBand"}},{"kind":"Field","name":{"kind":"Name","value":"metalMesh"}},{"kind":"Field","name":{"kind":"Name","value":"lingualMetalBand"}},{"kind":"Field","name":{"kind":"Name","value":"customTray"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateProductManualMutation, CreateProductManualMutationVariables>;
export const DeleteManyProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<DeleteManyProductMutation, DeleteManyProductMutationVariables>;
export const UpdateProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"itemPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"hasIndividualItemCaracteristics"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"implantItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstMaterialTraceabilityId"}},{"kind":"Field","name":{"kind":"Name","value":"secondMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abutmentMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abutmentType"}},{"kind":"Field","name":{"kind":"Name","value":"implantPlatform"}},{"kind":"Field","name":{"kind":"Name","value":"implantReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"platforms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retentionType"}},{"kind":"Field","name":{"kind":"Name","value":"scanBodySuggestion"}},{"kind":"Field","name":{"kind":"Name","value":"standardAbutmentSuggestion"}},{"kind":"Field","name":{"kind":"Name","value":"implantReferenceSuggestion"}},{"kind":"Field","name":{"kind":"Name","value":"teethshadeType"}},{"kind":"Field","name":{"kind":"Name","value":"multiShadeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teethShadeSide"}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"shadeType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anatomyItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreHasClavette"}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreScanPost"}},{"kind":"Field","name":{"kind":"Name","value":"inlayCoreMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"secondMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstMaterialTraceabilityId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teethshadeType"}},{"kind":"Field","name":{"kind":"Name","value":"multiShadeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teethShadeSide"}},{"kind":"Field","name":{"kind":"Name","value":"itemShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shadeType"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"removableItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemType"}},{"kind":"Field","name":{"kind":"Name","value":"teeth"}},{"kind":"Field","name":{"kind":"Name","value":"teethToManufacture"}},{"kind":"Field","name":{"kind":"Name","value":"workflowType"}},{"kind":"Field","name":{"kind":"Name","value":"dentistNotes"}},{"kind":"Field","name":{"kind":"Name","value":"isReplacement"}},{"kind":"Field","name":{"kind":"Name","value":"waxUpType"}},{"kind":"Field","name":{"kind":"Name","value":"fullDentureOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"partialDentureOrderType"}},{"kind":"Field","name":{"kind":"Name","value":"imprintType"}},{"kind":"Field","name":{"kind":"Name","value":"rdvNumber"}},{"kind":"Field","name":{"kind":"Name","value":"rdv2Choice"}},{"kind":"Field","name":{"kind":"Name","value":"returnMethod"}},{"kind":"Field","name":{"kind":"Name","value":"itemMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teethShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gingivaShade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstMaterialTraceabilityId"}},{"kind":"Field","name":{"kind":"Name","value":"secondMaterialLotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partialDenture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"missingTeeth"}},{"kind":"Field","name":{"kind":"Name","value":"hooks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hooksMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hooksPosition"}}]}},{"kind":"Field","name":{"kind":"Name","value":"palatalMetalBand"}},{"kind":"Field","name":{"kind":"Name","value":"metalMesh"}},{"kind":"Field","name":{"kind":"Name","value":"lingualMetalBand"}},{"kind":"Field","name":{"kind":"Name","value":"customTray"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateAllItemTeethOfProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAllItemTeethOfProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teeth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAllItemTeethOfProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"teeth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teeth"}}}]}]}}]} as unknown as DocumentNode<UpdateAllItemTeethOfProductMutation, UpdateAllItemTeethOfProductMutationVariables>;
export const QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getScanPostsData"}}]}}]} as unknown as DocumentNode<QueryQuery, QueryQueryVariables>;
export const GetAllItemShadesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllItemShades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllItemShades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"gingiva"}},{"kind":"Field","name":{"kind":"Name","value":"crown"}}]}}]}}]} as unknown as DocumentNode<GetAllItemShadesQuery, GetAllItemShadesQueryVariables>;
export const RegenerateThreeshapeTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegenerateThreeshapeTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeVerifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regenerateThreeshapeTokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"codeVerifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeVerifier"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectUri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectUri"}}}]}]}}]} as unknown as DocumentNode<RegenerateThreeshapeTokensMutation, RegenerateThreeshapeTokensMutationVariables>;
export const SyncThreeshapeOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"syncThreeshapeOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Timestamp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncExternalCasesFrom3Shape"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"tryOrdersCreation"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SyncThreeshapeOrdersMutation, SyncThreeshapeOrdersMutationVariables>;
export const MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MutationMutation, MutationMutationVariables>;